// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v5.27.2
// source: agents/agents.proto

/* eslint-disable */
import Long from 'long'
import _m0 from 'protobufjs/minimal'
import { Observable } from 'rxjs'
import { map } from 'rxjs/operators'

export const protobufPackage = 'agents'

export enum ChatSelectionMode {
  CHAT_SELECTION_MODE_UNKNOWN = 0,
  SINGLE_SELECT = 1,
  MULTI_SELECT = 2,
  UNRECOGNIZED = -1
}

export function chatSelectionModeFromJSON(object: any): ChatSelectionMode {
  switch (object) {
    case 0:
    case 'CHAT_SELECTION_MODE_UNKNOWN':
      return ChatSelectionMode.CHAT_SELECTION_MODE_UNKNOWN
    case 1:
    case 'SINGLE_SELECT':
      return ChatSelectionMode.SINGLE_SELECT
    case 2:
    case 'MULTI_SELECT':
      return ChatSelectionMode.MULTI_SELECT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ChatSelectionMode.UNRECOGNIZED
  }
}

export function chatSelectionModeToJSON(object: ChatSelectionMode): string {
  switch (object) {
    case ChatSelectionMode.CHAT_SELECTION_MODE_UNKNOWN:
      return 'CHAT_SELECTION_MODE_UNKNOWN'
    case ChatSelectionMode.SINGLE_SELECT:
      return 'SINGLE_SELECT'
    case ChatSelectionMode.MULTI_SELECT:
      return 'MULTI_SELECT'
    case ChatSelectionMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum AgentTaskStatus {
  /** NONE_TASK_STATUS - Default status */
  NONE_TASK_STATUS = 0,
  /** SUBMITTED - User has submitted the task */
  SUBMITTED = 1,
  /** IN_PROGRESS - Agent is working on the task */
  IN_PROGRESS = 2,
  /** COMPLETED - Agent has completed the task */
  COMPLETED = 3,
  /** ARCHIVED - User has archived the task */
  ARCHIVED = 4,
  /** ERRORED - Agent has errored out */
  ERRORED = 5,
  /** PLANNING_COMPLETED - Agent has completed the planning */
  PLANNING_COMPLETED = 6,
  /** DIFF_GENERATED - Agent has generated the diff */
  DIFF_GENERATED = 7,
  /** HUMAN_DIFF_UPDATED - User has updated the diff */
  HUMAN_DIFF_UPDATED = 8,
  /** DATAWEAVE_DATA_CREATION_ASST_DATA_TYPE_REQUESTED - User has requested the data type for data creation */
  DATAWEAVE_DATA_CREATION_ASST_DATA_TYPE_REQUESTED = 9,
  /** PLANNING_UPDATED - User has approved the planning */
  PLANNING_UPDATED = 10,
  /** DOCUMENT_GENERATED - Agent has generated the documentation */
  DOCUMENT_GENERATED = 11,
  /** DOCUMENT_UPDATED - User has updated the documentation */
  DOCUMENT_UPDATED = 12,
  /** MUNIT_SCENARIO_GENERATED - Agent has generated the Munit scenarios */
  MUNIT_SCENARIO_GENERATED = 13,
  /** PLANNING_REREQUESTED - User requested changes in the planning */
  PLANNING_REREQUESTED = 14,
  /** DIFF_COMMENT_ADDED - User requested changes in the diff */
  DIFF_COMMENT_ADDED = 15,
  /** STOPPED - User has stopped the task */
  STOPPED = 16,
  /** AGENT_INTERNAL_STATUS - PLANNING_UPDATED -> AGENT_INTERNAL_STATUS [loop] -> DIFF_GENERATED */
  AGENT_INTERNAL_STATUS = 17,
  /** STEPS_GENERATED - STEPS_GENERATED -> STEPS_UPDATED -> PLANNING_COMPLETED -> PLANNING_REREQUESTED [loop] -> PLANNING_UPDATED */
  STEPS_GENERATED = 18,
  STEPS_UPDATED = 19,
  QUESTION_ASKED = 20,
  QUESTION_ANSWERED = 21,
  FINAL_SPECIFICATION_GENERATED = 22,
  FINAL_SPECIFICATION_UPDATED = 23,
  IMAGE_GENERATED = 24,
  GENERAL_TXT_FEEDBACK_PROVIDED = 25,
  MIGRATION_DOCUMENT_GENERATED = 26,
  MIGRATION_API_SPEC_GENERATED = 27,
  MIGRATION_CODE_GENERATED = 28,
  MIGRATION_ENDPOINTS_IDENTIFIED = 29,
  MIGRATION_ENDPOINTS_SELECTED = 30,
  INIT = 31,
  REFACTOR_EXISTING_DOCS_GENERATED = 32,
  REFACTOR_USER_NOTES_ADDED = 33,
  /** REFACTOR_SYS_API_STARTED - >> start Legacy */
  REFACTOR_SYS_API_STARTED = 34,
  REFACTOR_SYS_API_PROPOSED = 35,
  REFACTOR_SYS_API_REVIEWED = 36,
  REFACTOR_SYS_API_DOCS_GENERATING = 37,
  REFACTOR_PRC_API_STARTED = 38,
  REFACTOR_PRC_API_PROPOSED = 39,
  REFACTOR_PRC_API_REVIEWED = 40,
  REFACTOR_PRC_API_DOCS_GENERATING = 41,
  REFACTOR_EXP_API_STARTED = 42,
  /** REFACTOR_API_SPECS_GENERATED - << end Legacy */
  REFACTOR_API_SPECS_GENERATED = 43,
  REFACTOR_CODE_GENERATED = 44,
  REFACTOR_API_PROPOSING = 45,
  REFACTOR_API_PROPOSED = 46,
  REFACTOR_API_FEEDBACK_PROVIDED = 47,
  REFACTOR_DOCS_GENERATING = 48,
  REFACTOR_DOCS_GENERATED = 49,
  REFACTOR_PROCESSING_ENDPOINTS = 50,
  /** DRAFT_GENERATED - Agent has generated the draft */
  DRAFT_GENERATED = 51,
  /** MUNIT_DIFF_GENERATED - Agent has generated the munit diff */
  MUNIT_DIFF_GENERATED = 52,
  /** INTEGRATION_TEST_DIFF_GENERATED - Agent has generated the integration test diff */
  INTEGRATION_TEST_DIFF_GENERATED = 53,
  /** MIGRATION_REFACTOR_ACCELERATOR_DIFF_GENERATED - Agent has generated the migration refactor or accelerator diff */
  MIGRATION_REFACTOR_ACCELERATOR_DIFF_GENERATED = 54,
  /** MIGRATION_RISKS_REVIEWED - User has reviewed risks (optionally submitted feedback) after MIGRATION_DOCUMENT_GENERATED */
  MIGRATION_RISKS_REVIEWED = 55,
  /** MIGRATION_AWAITING_RISK_REVIEW - Non-pollable pause: agent has emitted DOC_GENERATED with risks and is waiting for the user to review / submit feedback. Transitions to MIGRATION_RISKS_REVIEWED when the user acts. */
  MIGRATION_AWAITING_RISK_REVIEW = 56,
  /** MIGRATION_AWAITING_DEPLOY_INPUT - Non-pollable pause: the agent-driven Azure deploy needs input (a value or a confirm) before the next phase can run. Transitions to MIGRATION_DEPLOY_INPUT_PROVIDED when the user submits. */
  MIGRATION_AWAITING_DEPLOY_INPUT = 57,
  /** MIGRATION_DEPLOYING - The agent is actively running a deploy phase (az / setup.sh) via the runner; the terminal log streams to the deploy modal. */
  MIGRATION_DEPLOYING = 58,
  /** MIGRATION_DEPLOY_INPUT_PROVIDED - User submitted the requested deploy input; the agent resumes the next phase. */
  MIGRATION_DEPLOY_INPUT_PROVIDED = 59,
  /** MIGRATION_DEPLOYED - Terminal: the agent-driven Azure deploy succeeded (the deploy modal shows the trigger URL). */
  MIGRATION_DEPLOYED = 60,
  /** MIGRATION_DEPLOY_FAILED - Terminal: the agent-driven Azure deploy failed (the deploy modal shows the final log). */
  MIGRATION_DEPLOY_FAILED = 61,
  UNRECOGNIZED = -1
}

export function agentTaskStatusFromJSON(object: any): AgentTaskStatus {
  switch (object) {
    case 0:
    case 'NONE_TASK_STATUS':
      return AgentTaskStatus.NONE_TASK_STATUS
    case 1:
    case 'SUBMITTED':
      return AgentTaskStatus.SUBMITTED
    case 2:
    case 'IN_PROGRESS':
      return AgentTaskStatus.IN_PROGRESS
    case 3:
    case 'COMPLETED':
      return AgentTaskStatus.COMPLETED
    case 4:
    case 'ARCHIVED':
      return AgentTaskStatus.ARCHIVED
    case 5:
    case 'ERRORED':
      return AgentTaskStatus.ERRORED
    case 6:
    case 'PLANNING_COMPLETED':
      return AgentTaskStatus.PLANNING_COMPLETED
    case 7:
    case 'DIFF_GENERATED':
      return AgentTaskStatus.DIFF_GENERATED
    case 8:
    case 'HUMAN_DIFF_UPDATED':
      return AgentTaskStatus.HUMAN_DIFF_UPDATED
    case 9:
    case 'DATAWEAVE_DATA_CREATION_ASST_DATA_TYPE_REQUESTED':
      return AgentTaskStatus.DATAWEAVE_DATA_CREATION_ASST_DATA_TYPE_REQUESTED
    case 10:
    case 'PLANNING_UPDATED':
      return AgentTaskStatus.PLANNING_UPDATED
    case 11:
    case 'DOCUMENT_GENERATED':
      return AgentTaskStatus.DOCUMENT_GENERATED
    case 12:
    case 'DOCUMENT_UPDATED':
      return AgentTaskStatus.DOCUMENT_UPDATED
    case 13:
    case 'MUNIT_SCENARIO_GENERATED':
      return AgentTaskStatus.MUNIT_SCENARIO_GENERATED
    case 14:
    case 'PLANNING_REREQUESTED':
      return AgentTaskStatus.PLANNING_REREQUESTED
    case 15:
    case 'DIFF_COMMENT_ADDED':
      return AgentTaskStatus.DIFF_COMMENT_ADDED
    case 16:
    case 'STOPPED':
      return AgentTaskStatus.STOPPED
    case 17:
    case 'AGENT_INTERNAL_STATUS':
      return AgentTaskStatus.AGENT_INTERNAL_STATUS
    case 18:
    case 'STEPS_GENERATED':
      return AgentTaskStatus.STEPS_GENERATED
    case 19:
    case 'STEPS_UPDATED':
      return AgentTaskStatus.STEPS_UPDATED
    case 20:
    case 'QUESTION_ASKED':
      return AgentTaskStatus.QUESTION_ASKED
    case 21:
    case 'QUESTION_ANSWERED':
      return AgentTaskStatus.QUESTION_ANSWERED
    case 22:
    case 'FINAL_SPECIFICATION_GENERATED':
      return AgentTaskStatus.FINAL_SPECIFICATION_GENERATED
    case 23:
    case 'FINAL_SPECIFICATION_UPDATED':
      return AgentTaskStatus.FINAL_SPECIFICATION_UPDATED
    case 24:
    case 'IMAGE_GENERATED':
      return AgentTaskStatus.IMAGE_GENERATED
    case 25:
    case 'GENERAL_TXT_FEEDBACK_PROVIDED':
      return AgentTaskStatus.GENERAL_TXT_FEEDBACK_PROVIDED
    case 26:
    case 'MIGRATION_DOCUMENT_GENERATED':
      return AgentTaskStatus.MIGRATION_DOCUMENT_GENERATED
    case 27:
    case 'MIGRATION_API_SPEC_GENERATED':
      return AgentTaskStatus.MIGRATION_API_SPEC_GENERATED
    case 28:
    case 'MIGRATION_CODE_GENERATED':
      return AgentTaskStatus.MIGRATION_CODE_GENERATED
    case 29:
    case 'MIGRATION_ENDPOINTS_IDENTIFIED':
      return AgentTaskStatus.MIGRATION_ENDPOINTS_IDENTIFIED
    case 30:
    case 'MIGRATION_ENDPOINTS_SELECTED':
      return AgentTaskStatus.MIGRATION_ENDPOINTS_SELECTED
    case 31:
    case 'INIT':
      return AgentTaskStatus.INIT
    case 32:
    case 'REFACTOR_EXISTING_DOCS_GENERATED':
      return AgentTaskStatus.REFACTOR_EXISTING_DOCS_GENERATED
    case 33:
    case 'REFACTOR_USER_NOTES_ADDED':
      return AgentTaskStatus.REFACTOR_USER_NOTES_ADDED
    case 34:
    case 'REFACTOR_SYS_API_STARTED':
      return AgentTaskStatus.REFACTOR_SYS_API_STARTED
    case 35:
    case 'REFACTOR_SYS_API_PROPOSED':
      return AgentTaskStatus.REFACTOR_SYS_API_PROPOSED
    case 36:
    case 'REFACTOR_SYS_API_REVIEWED':
      return AgentTaskStatus.REFACTOR_SYS_API_REVIEWED
    case 37:
    case 'REFACTOR_SYS_API_DOCS_GENERATING':
      return AgentTaskStatus.REFACTOR_SYS_API_DOCS_GENERATING
    case 38:
    case 'REFACTOR_PRC_API_STARTED':
      return AgentTaskStatus.REFACTOR_PRC_API_STARTED
    case 39:
    case 'REFACTOR_PRC_API_PROPOSED':
      return AgentTaskStatus.REFACTOR_PRC_API_PROPOSED
    case 40:
    case 'REFACTOR_PRC_API_REVIEWED':
      return AgentTaskStatus.REFACTOR_PRC_API_REVIEWED
    case 41:
    case 'REFACTOR_PRC_API_DOCS_GENERATING':
      return AgentTaskStatus.REFACTOR_PRC_API_DOCS_GENERATING
    case 42:
    case 'REFACTOR_EXP_API_STARTED':
      return AgentTaskStatus.REFACTOR_EXP_API_STARTED
    case 43:
    case 'REFACTOR_API_SPECS_GENERATED':
      return AgentTaskStatus.REFACTOR_API_SPECS_GENERATED
    case 44:
    case 'REFACTOR_CODE_GENERATED':
      return AgentTaskStatus.REFACTOR_CODE_GENERATED
    case 45:
    case 'REFACTOR_API_PROPOSING':
      return AgentTaskStatus.REFACTOR_API_PROPOSING
    case 46:
    case 'REFACTOR_API_PROPOSED':
      return AgentTaskStatus.REFACTOR_API_PROPOSED
    case 47:
    case 'REFACTOR_API_FEEDBACK_PROVIDED':
      return AgentTaskStatus.REFACTOR_API_FEEDBACK_PROVIDED
    case 48:
    case 'REFACTOR_DOCS_GENERATING':
      return AgentTaskStatus.REFACTOR_DOCS_GENERATING
    case 49:
    case 'REFACTOR_DOCS_GENERATED':
      return AgentTaskStatus.REFACTOR_DOCS_GENERATED
    case 50:
    case 'REFACTOR_PROCESSING_ENDPOINTS':
      return AgentTaskStatus.REFACTOR_PROCESSING_ENDPOINTS
    case 51:
    case 'DRAFT_GENERATED':
      return AgentTaskStatus.DRAFT_GENERATED
    case 52:
    case 'MUNIT_DIFF_GENERATED':
      return AgentTaskStatus.MUNIT_DIFF_GENERATED
    case 53:
    case 'INTEGRATION_TEST_DIFF_GENERATED':
      return AgentTaskStatus.INTEGRATION_TEST_DIFF_GENERATED
    case 54:
    case 'MIGRATION_REFACTOR_ACCELERATOR_DIFF_GENERATED':
      return AgentTaskStatus.MIGRATION_REFACTOR_ACCELERATOR_DIFF_GENERATED
    case 55:
    case 'MIGRATION_RISKS_REVIEWED':
      return AgentTaskStatus.MIGRATION_RISKS_REVIEWED
    case 56:
    case 'MIGRATION_AWAITING_RISK_REVIEW':
      return AgentTaskStatus.MIGRATION_AWAITING_RISK_REVIEW
    case 57:
    case 'MIGRATION_AWAITING_DEPLOY_INPUT':
      return AgentTaskStatus.MIGRATION_AWAITING_DEPLOY_INPUT
    case 58:
    case 'MIGRATION_DEPLOYING':
      return AgentTaskStatus.MIGRATION_DEPLOYING
    case 59:
    case 'MIGRATION_DEPLOY_INPUT_PROVIDED':
      return AgentTaskStatus.MIGRATION_DEPLOY_INPUT_PROVIDED
    case 60:
    case 'MIGRATION_DEPLOYED':
      return AgentTaskStatus.MIGRATION_DEPLOYED
    case 61:
    case 'MIGRATION_DEPLOY_FAILED':
      return AgentTaskStatus.MIGRATION_DEPLOY_FAILED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AgentTaskStatus.UNRECOGNIZED
  }
}

export function agentTaskStatusToJSON(object: AgentTaskStatus): string {
  switch (object) {
    case AgentTaskStatus.NONE_TASK_STATUS:
      return 'NONE_TASK_STATUS'
    case AgentTaskStatus.SUBMITTED:
      return 'SUBMITTED'
    case AgentTaskStatus.IN_PROGRESS:
      return 'IN_PROGRESS'
    case AgentTaskStatus.COMPLETED:
      return 'COMPLETED'
    case AgentTaskStatus.ARCHIVED:
      return 'ARCHIVED'
    case AgentTaskStatus.ERRORED:
      return 'ERRORED'
    case AgentTaskStatus.PLANNING_COMPLETED:
      return 'PLANNING_COMPLETED'
    case AgentTaskStatus.DIFF_GENERATED:
      return 'DIFF_GENERATED'
    case AgentTaskStatus.HUMAN_DIFF_UPDATED:
      return 'HUMAN_DIFF_UPDATED'
    case AgentTaskStatus.DATAWEAVE_DATA_CREATION_ASST_DATA_TYPE_REQUESTED:
      return 'DATAWEAVE_DATA_CREATION_ASST_DATA_TYPE_REQUESTED'
    case AgentTaskStatus.PLANNING_UPDATED:
      return 'PLANNING_UPDATED'
    case AgentTaskStatus.DOCUMENT_GENERATED:
      return 'DOCUMENT_GENERATED'
    case AgentTaskStatus.DOCUMENT_UPDATED:
      return 'DOCUMENT_UPDATED'
    case AgentTaskStatus.MUNIT_SCENARIO_GENERATED:
      return 'MUNIT_SCENARIO_GENERATED'
    case AgentTaskStatus.PLANNING_REREQUESTED:
      return 'PLANNING_REREQUESTED'
    case AgentTaskStatus.DIFF_COMMENT_ADDED:
      return 'DIFF_COMMENT_ADDED'
    case AgentTaskStatus.STOPPED:
      return 'STOPPED'
    case AgentTaskStatus.AGENT_INTERNAL_STATUS:
      return 'AGENT_INTERNAL_STATUS'
    case AgentTaskStatus.STEPS_GENERATED:
      return 'STEPS_GENERATED'
    case AgentTaskStatus.STEPS_UPDATED:
      return 'STEPS_UPDATED'
    case AgentTaskStatus.QUESTION_ASKED:
      return 'QUESTION_ASKED'
    case AgentTaskStatus.QUESTION_ANSWERED:
      return 'QUESTION_ANSWERED'
    case AgentTaskStatus.FINAL_SPECIFICATION_GENERATED:
      return 'FINAL_SPECIFICATION_GENERATED'
    case AgentTaskStatus.FINAL_SPECIFICATION_UPDATED:
      return 'FINAL_SPECIFICATION_UPDATED'
    case AgentTaskStatus.IMAGE_GENERATED:
      return 'IMAGE_GENERATED'
    case AgentTaskStatus.GENERAL_TXT_FEEDBACK_PROVIDED:
      return 'GENERAL_TXT_FEEDBACK_PROVIDED'
    case AgentTaskStatus.MIGRATION_DOCUMENT_GENERATED:
      return 'MIGRATION_DOCUMENT_GENERATED'
    case AgentTaskStatus.MIGRATION_API_SPEC_GENERATED:
      return 'MIGRATION_API_SPEC_GENERATED'
    case AgentTaskStatus.MIGRATION_CODE_GENERATED:
      return 'MIGRATION_CODE_GENERATED'
    case AgentTaskStatus.MIGRATION_ENDPOINTS_IDENTIFIED:
      return 'MIGRATION_ENDPOINTS_IDENTIFIED'
    case AgentTaskStatus.MIGRATION_ENDPOINTS_SELECTED:
      return 'MIGRATION_ENDPOINTS_SELECTED'
    case AgentTaskStatus.INIT:
      return 'INIT'
    case AgentTaskStatus.REFACTOR_EXISTING_DOCS_GENERATED:
      return 'REFACTOR_EXISTING_DOCS_GENERATED'
    case AgentTaskStatus.REFACTOR_USER_NOTES_ADDED:
      return 'REFACTOR_USER_NOTES_ADDED'
    case AgentTaskStatus.REFACTOR_SYS_API_STARTED:
      return 'REFACTOR_SYS_API_STARTED'
    case AgentTaskStatus.REFACTOR_SYS_API_PROPOSED:
      return 'REFACTOR_SYS_API_PROPOSED'
    case AgentTaskStatus.REFACTOR_SYS_API_REVIEWED:
      return 'REFACTOR_SYS_API_REVIEWED'
    case AgentTaskStatus.REFACTOR_SYS_API_DOCS_GENERATING:
      return 'REFACTOR_SYS_API_DOCS_GENERATING'
    case AgentTaskStatus.REFACTOR_PRC_API_STARTED:
      return 'REFACTOR_PRC_API_STARTED'
    case AgentTaskStatus.REFACTOR_PRC_API_PROPOSED:
      return 'REFACTOR_PRC_API_PROPOSED'
    case AgentTaskStatus.REFACTOR_PRC_API_REVIEWED:
      return 'REFACTOR_PRC_API_REVIEWED'
    case AgentTaskStatus.REFACTOR_PRC_API_DOCS_GENERATING:
      return 'REFACTOR_PRC_API_DOCS_GENERATING'
    case AgentTaskStatus.REFACTOR_EXP_API_STARTED:
      return 'REFACTOR_EXP_API_STARTED'
    case AgentTaskStatus.REFACTOR_API_SPECS_GENERATED:
      return 'REFACTOR_API_SPECS_GENERATED'
    case AgentTaskStatus.REFACTOR_CODE_GENERATED:
      return 'REFACTOR_CODE_GENERATED'
    case AgentTaskStatus.REFACTOR_API_PROPOSING:
      return 'REFACTOR_API_PROPOSING'
    case AgentTaskStatus.REFACTOR_API_PROPOSED:
      return 'REFACTOR_API_PROPOSED'
    case AgentTaskStatus.REFACTOR_API_FEEDBACK_PROVIDED:
      return 'REFACTOR_API_FEEDBACK_PROVIDED'
    case AgentTaskStatus.REFACTOR_DOCS_GENERATING:
      return 'REFACTOR_DOCS_GENERATING'
    case AgentTaskStatus.REFACTOR_DOCS_GENERATED:
      return 'REFACTOR_DOCS_GENERATED'
    case AgentTaskStatus.REFACTOR_PROCESSING_ENDPOINTS:
      return 'REFACTOR_PROCESSING_ENDPOINTS'
    case AgentTaskStatus.DRAFT_GENERATED:
      return 'DRAFT_GENERATED'
    case AgentTaskStatus.MUNIT_DIFF_GENERATED:
      return 'MUNIT_DIFF_GENERATED'
    case AgentTaskStatus.INTEGRATION_TEST_DIFF_GENERATED:
      return 'INTEGRATION_TEST_DIFF_GENERATED'
    case AgentTaskStatus.MIGRATION_REFACTOR_ACCELERATOR_DIFF_GENERATED:
      return 'MIGRATION_REFACTOR_ACCELERATOR_DIFF_GENERATED'
    case AgentTaskStatus.MIGRATION_RISKS_REVIEWED:
      return 'MIGRATION_RISKS_REVIEWED'
    case AgentTaskStatus.MIGRATION_AWAITING_RISK_REVIEW:
      return 'MIGRATION_AWAITING_RISK_REVIEW'
    case AgentTaskStatus.MIGRATION_AWAITING_DEPLOY_INPUT:
      return 'MIGRATION_AWAITING_DEPLOY_INPUT'
    case AgentTaskStatus.MIGRATION_DEPLOYING:
      return 'MIGRATION_DEPLOYING'
    case AgentTaskStatus.MIGRATION_DEPLOY_INPUT_PROVIDED:
      return 'MIGRATION_DEPLOY_INPUT_PROVIDED'
    case AgentTaskStatus.MIGRATION_DEPLOYED:
      return 'MIGRATION_DEPLOYED'
    case AgentTaskStatus.MIGRATION_DEPLOY_FAILED:
      return 'MIGRATION_DEPLOY_FAILED'
    case AgentTaskStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum AgentInternalEnum {
  /** NONE_AGENT_INTERNAL_STATUS - Default status */
  NONE_AGENT_INTERNAL_STATUS = 0,
  /** BEGAN_TESTING - Agent has started testing */
  BEGAN_TESTING = 1,
  /** FIXING_CODE - Agent is fixing the code */
  FIXING_CODE = 2,
  DONE = 3,
  UNRECOGNIZED = -1
}

export function agentInternalEnumFromJSON(object: any): AgentInternalEnum {
  switch (object) {
    case 0:
    case 'NONE_AGENT_INTERNAL_STATUS':
      return AgentInternalEnum.NONE_AGENT_INTERNAL_STATUS
    case 1:
    case 'BEGAN_TESTING':
      return AgentInternalEnum.BEGAN_TESTING
    case 2:
    case 'FIXING_CODE':
      return AgentInternalEnum.FIXING_CODE
    case 3:
    case 'DONE':
      return AgentInternalEnum.DONE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return AgentInternalEnum.UNRECOGNIZED
  }
}

export function agentInternalEnumToJSON(object: AgentInternalEnum): string {
  switch (object) {
    case AgentInternalEnum.NONE_AGENT_INTERNAL_STATUS:
      return 'NONE_AGENT_INTERNAL_STATUS'
    case AgentInternalEnum.BEGAN_TESTING:
      return 'BEGAN_TESTING'
    case AgentInternalEnum.FIXING_CODE:
      return 'FIXING_CODE'
    case AgentInternalEnum.DONE:
      return 'DONE'
    case AgentInternalEnum.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum EnvType {
  LOCAL_APP = 0,
  LOCAL_CAMPAIGN = 1,
  DEV_APP = 2,
  DEV_CAMPAIGN = 3,
  PROD_APP = 4,
  PROD_CAMPAIGN = 5,
  UNRECOGNIZED = -1
}

export function envTypeFromJSON(object: any): EnvType {
  switch (object) {
    case 0:
    case 'LOCAL_APP':
      return EnvType.LOCAL_APP
    case 1:
    case 'LOCAL_CAMPAIGN':
      return EnvType.LOCAL_CAMPAIGN
    case 2:
    case 'DEV_APP':
      return EnvType.DEV_APP
    case 3:
    case 'DEV_CAMPAIGN':
      return EnvType.DEV_CAMPAIGN
    case 4:
    case 'PROD_APP':
      return EnvType.PROD_APP
    case 5:
    case 'PROD_CAMPAIGN':
      return EnvType.PROD_CAMPAIGN
    case -1:
    case 'UNRECOGNIZED':
    default:
      return EnvType.UNRECOGNIZED
  }
}

export function envTypeToJSON(object: EnvType): string {
  switch (object) {
    case EnvType.LOCAL_APP:
      return 'LOCAL_APP'
    case EnvType.LOCAL_CAMPAIGN:
      return 'LOCAL_CAMPAIGN'
    case EnvType.DEV_APP:
      return 'DEV_APP'
    case EnvType.DEV_CAMPAIGN:
      return 'DEV_CAMPAIGN'
    case EnvType.PROD_APP:
      return 'PROD_APP'
    case EnvType.PROD_CAMPAIGN:
      return 'PROD_CAMPAIGN'
    case EnvType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum CodeEnhancerTaskType {
  ACC = 0,
  CVC = 1,
  REF = 2,
  CDL = 3,
  LOG = 4,
  CPC = 5,
  GEN = 6,
  UNRECOGNIZED = -1
}

export function codeEnhancerTaskTypeFromJSON(object: any): CodeEnhancerTaskType {
  switch (object) {
    case 0:
    case 'ACC':
      return CodeEnhancerTaskType.ACC
    case 1:
    case 'CVC':
      return CodeEnhancerTaskType.CVC
    case 2:
    case 'REF':
      return CodeEnhancerTaskType.REF
    case 3:
    case 'CDL':
      return CodeEnhancerTaskType.CDL
    case 4:
    case 'LOG':
      return CodeEnhancerTaskType.LOG
    case 5:
    case 'CPC':
      return CodeEnhancerTaskType.CPC
    case 6:
    case 'GEN':
      return CodeEnhancerTaskType.GEN
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CodeEnhancerTaskType.UNRECOGNIZED
  }
}

export function codeEnhancerTaskTypeToJSON(object: CodeEnhancerTaskType): string {
  switch (object) {
    case CodeEnhancerTaskType.ACC:
      return 'ACC'
    case CodeEnhancerTaskType.CVC:
      return 'CVC'
    case CodeEnhancerTaskType.REF:
      return 'REF'
    case CodeEnhancerTaskType.CDL:
      return 'CDL'
    case CodeEnhancerTaskType.LOG:
      return 'LOG'
    case CodeEnhancerTaskType.CPC:
      return 'CPC'
    case CodeEnhancerTaskType.GEN:
      return 'GEN'
    case CodeEnhancerTaskType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ExecutionMode {
  CONVO_MODE_UNKNOWN = 0,
  ASK = 1,
  AGENT = 2,
  UNRECOGNIZED = -1
}

export function executionModeFromJSON(object: any): ExecutionMode {
  switch (object) {
    case 0:
    case 'CONVO_MODE_UNKNOWN':
      return ExecutionMode.CONVO_MODE_UNKNOWN
    case 1:
    case 'ASK':
      return ExecutionMode.ASK
    case 2:
    case 'AGENT':
      return ExecutionMode.AGENT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ExecutionMode.UNRECOGNIZED
  }
}

export function executionModeToJSON(object: ExecutionMode): string {
  switch (object) {
    case ExecutionMode.CONVO_MODE_UNKNOWN:
      return 'CONVO_MODE_UNKNOWN'
    case ExecutionMode.ASK:
      return 'ASK'
    case ExecutionMode.AGENT:
      return 'AGENT'
    case ExecutionMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum VerificationMode {
  VERIFICATION_MODE_UNKNOWN = 0,
  AUTO = 1,
  FAST = 2,
  VERIFY = 3,
  UNRECOGNIZED = -1
}

export function verificationModeFromJSON(object: any): VerificationMode {
  switch (object) {
    case 0:
    case 'VERIFICATION_MODE_UNKNOWN':
      return VerificationMode.VERIFICATION_MODE_UNKNOWN
    case 1:
    case 'AUTO':
      return VerificationMode.AUTO
    case 2:
    case 'FAST':
      return VerificationMode.FAST
    case 3:
    case 'VERIFY':
      return VerificationMode.VERIFY
    case -1:
    case 'UNRECOGNIZED':
    default:
      return VerificationMode.UNRECOGNIZED
  }
}

export function verificationModeToJSON(object: VerificationMode): string {
  switch (object) {
    case VerificationMode.VERIFICATION_MODE_UNKNOWN:
      return 'VERIFICATION_MODE_UNKNOWN'
    case VerificationMode.AUTO:
      return 'AUTO'
    case VerificationMode.FAST:
      return 'FAST'
    case VerificationMode.VERIFY:
      return 'VERIFY'
    case VerificationMode.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ProgressMessageType {
  PROGRESS_MESSAGE_TYPE_UNKNOWN = 0,
  INTERNAL_PROGRESS = 1,
  CHECKPOINT = 2,
  SUMMARY = 3,
  TODO_LIST = 4,
  UNRECOGNIZED = -1
}

export function progressMessageTypeFromJSON(object: any): ProgressMessageType {
  switch (object) {
    case 0:
    case 'PROGRESS_MESSAGE_TYPE_UNKNOWN':
      return ProgressMessageType.PROGRESS_MESSAGE_TYPE_UNKNOWN
    case 1:
    case 'INTERNAL_PROGRESS':
      return ProgressMessageType.INTERNAL_PROGRESS
    case 2:
    case 'CHECKPOINT':
      return ProgressMessageType.CHECKPOINT
    case 3:
    case 'SUMMARY':
      return ProgressMessageType.SUMMARY
    case 4:
    case 'TODO_LIST':
      return ProgressMessageType.TODO_LIST
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ProgressMessageType.UNRECOGNIZED
  }
}

export function progressMessageTypeToJSON(object: ProgressMessageType): string {
  switch (object) {
    case ProgressMessageType.PROGRESS_MESSAGE_TYPE_UNKNOWN:
      return 'PROGRESS_MESSAGE_TYPE_UNKNOWN'
    case ProgressMessageType.INTERNAL_PROGRESS:
      return 'INTERNAL_PROGRESS'
    case ProgressMessageType.CHECKPOINT:
      return 'CHECKPOINT'
    case ProgressMessageType.SUMMARY:
      return 'SUMMARY'
    case ProgressMessageType.TODO_LIST:
      return 'TODO_LIST'
    case ProgressMessageType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ProgressMessageTodoListStatus {
  TODO_PENDING = 0,
  TODO_IN_PROGRESS = 1,
  TODO_COMPLETED = 2,
  UNRECOGNIZED = -1
}

export function progressMessageTodoListStatusFromJSON(object: any): ProgressMessageTodoListStatus {
  switch (object) {
    case 0:
    case 'TODO_PENDING':
      return ProgressMessageTodoListStatus.TODO_PENDING
    case 1:
    case 'TODO_IN_PROGRESS':
      return ProgressMessageTodoListStatus.TODO_IN_PROGRESS
    case 2:
    case 'TODO_COMPLETED':
      return ProgressMessageTodoListStatus.TODO_COMPLETED
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ProgressMessageTodoListStatus.UNRECOGNIZED
  }
}

export function progressMessageTodoListStatusToJSON(object: ProgressMessageTodoListStatus): string {
  switch (object) {
    case ProgressMessageTodoListStatus.TODO_PENDING:
      return 'TODO_PENDING'
    case ProgressMessageTodoListStatus.TODO_IN_PROGRESS:
      return 'TODO_IN_PROGRESS'
    case ProgressMessageTodoListStatus.TODO_COMPLETED:
      return 'TODO_COMPLETED'
    case ProgressMessageTodoListStatus.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum BlockType {
  TEXT_WITH_ATTACHMENT = 0,
  DROPDOWN = 1,
  VALIDATED_INPUT_OUTPUT = 2,
  UNRECOGNIZED = -1
}

export function blockTypeFromJSON(object: any): BlockType {
  switch (object) {
    case 0:
    case 'TEXT_WITH_ATTACHMENT':
      return BlockType.TEXT_WITH_ATTACHMENT
    case 1:
    case 'DROPDOWN':
      return BlockType.DROPDOWN
    case 2:
    case 'VALIDATED_INPUT_OUTPUT':
      return BlockType.VALIDATED_INPUT_OUTPUT
    case -1:
    case 'UNRECOGNIZED':
    default:
      return BlockType.UNRECOGNIZED
  }
}

export function blockTypeToJSON(object: BlockType): string {
  switch (object) {
    case BlockType.TEXT_WITH_ATTACHMENT:
      return 'TEXT_WITH_ATTACHMENT'
    case BlockType.DROPDOWN:
      return 'DROPDOWN'
    case BlockType.VALIDATED_INPUT_OUTPUT:
      return 'VALIDATED_INPUT_OUTPUT'
    case BlockType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ApiSpecType {
  UNKNOWN_API_SPEC_TYPE = 0,
  OAS_3 = 1,
  RAML_1_0 = 2,
  UNRECOGNIZED = -1
}

export function apiSpecTypeFromJSON(object: any): ApiSpecType {
  switch (object) {
    case 0:
    case 'UNKNOWN_API_SPEC_TYPE':
      return ApiSpecType.UNKNOWN_API_SPEC_TYPE
    case 1:
    case 'OAS_3':
      return ApiSpecType.OAS_3
    case 2:
    case 'RAML_1_0':
      return ApiSpecType.RAML_1_0
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ApiSpecType.UNRECOGNIZED
  }
}

export function apiSpecTypeToJSON(object: ApiSpecType): string {
  switch (object) {
    case ApiSpecType.UNKNOWN_API_SPEC_TYPE:
      return 'UNKNOWN_API_SPEC_TYPE'
    case ApiSpecType.OAS_3:
      return 'OAS_3'
    case ApiSpecType.RAML_1_0:
      return 'RAML_1_0'
    case ApiSpecType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum ConnectionType {
  UNKNOWN = 0,
  GITHUB = 1,
  JIRA = 2,
  SLACK = 3,
  ECLIPSE_PLUGIN = 4,
  CURIE_UI = 5,
  PLUGIN_VSCODE = 6,
  UNRECOGNIZED = -1
}

export function connectionTypeFromJSON(object: any): ConnectionType {
  switch (object) {
    case 0:
    case 'UNKNOWN':
      return ConnectionType.UNKNOWN
    case 1:
    case 'GITHUB':
      return ConnectionType.GITHUB
    case 2:
    case 'JIRA':
      return ConnectionType.JIRA
    case 3:
    case 'SLACK':
      return ConnectionType.SLACK
    case 4:
    case 'ECLIPSE_PLUGIN':
      return ConnectionType.ECLIPSE_PLUGIN
    case 5:
    case 'CURIE_UI':
      return ConnectionType.CURIE_UI
    case 6:
    case 'PLUGIN_VSCODE':
      return ConnectionType.PLUGIN_VSCODE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return ConnectionType.UNRECOGNIZED
  }
}

export function connectionTypeToJSON(object: ConnectionType): string {
  switch (object) {
    case ConnectionType.UNKNOWN:
      return 'UNKNOWN'
    case ConnectionType.GITHUB:
      return 'GITHUB'
    case ConnectionType.JIRA:
      return 'JIRA'
    case ConnectionType.SLACK:
      return 'SLACK'
    case ConnectionType.ECLIPSE_PLUGIN:
      return 'ECLIPSE_PLUGIN'
    case ConnectionType.CURIE_UI:
      return 'CURIE_UI'
    case ConnectionType.PLUGIN_VSCODE:
      return 'PLUGIN_VSCODE'
    case ConnectionType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum MessageType {
  UNDEFINED = 0,
  PR = 1,
  IMAGE_BASE64 = 2,
  TEXT = 3,
  DIFF = 4,
  DOCUMENTATION = 5,
  TASK = 6,
  THINKING = 7,
  CONVO_TITLE = 8,
  AGENT_TRACE = 9,
  FORM_WIDGET = 10,
  CANVAS = 11,
  /** PING - Internal heartbeat — signals gRPC is alive during long processing. Not stored or forwarded to clients. */
  PING = 12,
  CODER_SUMMARY = 13,
  CHAT_SELECTION = 14,
  UNRECOGNIZED = -1
}

export function messageTypeFromJSON(object: any): MessageType {
  switch (object) {
    case 0:
    case 'UNDEFINED':
      return MessageType.UNDEFINED
    case 1:
    case 'PR':
      return MessageType.PR
    case 2:
    case 'IMAGE_BASE64':
      return MessageType.IMAGE_BASE64
    case 3:
    case 'TEXT':
      return MessageType.TEXT
    case 4:
    case 'DIFF':
      return MessageType.DIFF
    case 5:
    case 'DOCUMENTATION':
      return MessageType.DOCUMENTATION
    case 6:
    case 'TASK':
      return MessageType.TASK
    case 7:
    case 'THINKING':
      return MessageType.THINKING
    case 8:
    case 'CONVO_TITLE':
      return MessageType.CONVO_TITLE
    case 9:
    case 'AGENT_TRACE':
      return MessageType.AGENT_TRACE
    case 10:
    case 'FORM_WIDGET':
      return MessageType.FORM_WIDGET
    case 11:
    case 'CANVAS':
      return MessageType.CANVAS
    case 12:
    case 'PING':
      return MessageType.PING
    case 13:
    case 'CODER_SUMMARY':
      return MessageType.CODER_SUMMARY
    case 14:
    case 'CHAT_SELECTION':
      return MessageType.CHAT_SELECTION
    case -1:
    case 'UNRECOGNIZED':
    default:
      return MessageType.UNRECOGNIZED
  }
}

export function messageTypeToJSON(object: MessageType): string {
  switch (object) {
    case MessageType.UNDEFINED:
      return 'UNDEFINED'
    case MessageType.PR:
      return 'PR'
    case MessageType.IMAGE_BASE64:
      return 'IMAGE_BASE64'
    case MessageType.TEXT:
      return 'TEXT'
    case MessageType.DIFF:
      return 'DIFF'
    case MessageType.DOCUMENTATION:
      return 'DOCUMENTATION'
    case MessageType.TASK:
      return 'TASK'
    case MessageType.THINKING:
      return 'THINKING'
    case MessageType.CONVO_TITLE:
      return 'CONVO_TITLE'
    case MessageType.AGENT_TRACE:
      return 'AGENT_TRACE'
    case MessageType.FORM_WIDGET:
      return 'FORM_WIDGET'
    case MessageType.CANVAS:
      return 'CANVAS'
    case MessageType.PING:
      return 'PING'
    case MessageType.CODER_SUMMARY:
      return 'CODER_SUMMARY'
    case MessageType.CHAT_SELECTION:
      return 'CHAT_SELECTION'
    case MessageType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum CanvasType {
  CANVAS_TYPE_UNKNOWN = 0,
  CANVAS_TYPE_MARKDOWN = 1,
  CANVAS_TYPE_IMAGE = 2,
  CANVAS_TYPE_S3_FILE = 3,
  UNRECOGNIZED = -1
}

export function canvasTypeFromJSON(object: any): CanvasType {
  switch (object) {
    case 0:
    case 'CANVAS_TYPE_UNKNOWN':
      return CanvasType.CANVAS_TYPE_UNKNOWN
    case 1:
    case 'CANVAS_TYPE_MARKDOWN':
      return CanvasType.CANVAS_TYPE_MARKDOWN
    case 2:
    case 'CANVAS_TYPE_IMAGE':
      return CanvasType.CANVAS_TYPE_IMAGE
    case 3:
    case 'CANVAS_TYPE_S3_FILE':
      return CanvasType.CANVAS_TYPE_S3_FILE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CanvasType.UNRECOGNIZED
  }
}

export function canvasTypeToJSON(object: CanvasType): string {
  switch (object) {
    case CanvasType.CANVAS_TYPE_UNKNOWN:
      return 'CANVAS_TYPE_UNKNOWN'
    case CanvasType.CANVAS_TYPE_MARKDOWN:
      return 'CANVAS_TYPE_MARKDOWN'
    case CanvasType.CANVAS_TYPE_IMAGE:
      return 'CANVAS_TYPE_IMAGE'
    case CanvasType.CANVAS_TYPE_S3_FILE:
      return 'CANVAS_TYPE_S3_FILE'
    case CanvasType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum CommandType {
  NONE = 0,
  QUESTION_ANSWERING = 1,
  GENERATE_IMAGE = 2,
  GENERATE_SIMPLE_CODE_PR = 3,
  FIX_PR = 4,
  GENERATE_DOCUMENTATION = 5,
  GENERATE_FULL_REPO_TECH_MANIFEST_DOCUMENTATION = 6,
  AUTODESK_MULE_TO_NODE_JS_MIGRATION = 7,
  GENERATE_MAPPING_TABLE = 8,
  GENERATE_MULTI_REPO_FLOW_DIAGRAM = 9,
  GENERATE_ADD_FLOW_CODE_PR = 10,
  DATAWEAVE_TO_DATA_CREATION = 11,
  MUNIT_TEST_CREATION = 12,
  GENERATE_DATAWEAVE = 13,
  MULTI_REPO_QA = 14,
  GENERAL_MULTI_REPO_QA_DEBUG_AGENT = 15,
  INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION = 16,
  MIGRATION_DOCUMENT = 17,
  GENERATE_REPO_ADD_FLOW_CODE_PR = 18,
  INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION_REPO_AWARE = 19,
  GENERATE_DATAWEAVE_REPO_AWARE = 20,
  DATAWEAVE_TO_DATA_CREATION_REPO_AWARE = 21,
  CODE_REVIEW = 22,
  MULESOFT_TO_CAMEL_MIGRATION = 23,
  MIGRATION_QUESTION_ANSWERING = 24,
  /** NON_REPO_AWARE_QA - Deprecated - was used by alternate chat interface which no longer exists, replaced by MEGA_QA_AGENT_V1 */
  NON_REPO_AWARE_QA = 25,
  MULE_3_TO_MULE_4_MIGRATION = 26,
  BILLABLE_FLOW_DOCUMENTATION = 27,
  MIGRATION_ACCELERATOR = 28,
  MEGA_QA_AGENT_V1 = 29,
  CODE_REVIEW_API = 30,
  MULE_REFACTORING = 31,
  INTEGRATION_TEST = 32,
  MULE_VERSION_UPGRADE = 33,
  NON_MULE_DOCUMENTATION = 34,
  MVN_CMD = 35,
  SPRING_INTEGRATION_REFACTORING = 36,
  /** AZURE_DEPLOY_TEST - Test-only migration task that drives the Azure deploy status sequence in isolation (CUR-1476) */
  AZURE_DEPLOY_TEST = 37,
  UNRECOGNIZED = -1
}

export function commandTypeFromJSON(object: any): CommandType {
  switch (object) {
    case 0:
    case 'NONE':
      return CommandType.NONE
    case 1:
    case 'QUESTION_ANSWERING':
      return CommandType.QUESTION_ANSWERING
    case 2:
    case 'GENERATE_IMAGE':
      return CommandType.GENERATE_IMAGE
    case 3:
    case 'GENERATE_SIMPLE_CODE_PR':
      return CommandType.GENERATE_SIMPLE_CODE_PR
    case 4:
    case 'FIX_PR':
      return CommandType.FIX_PR
    case 5:
    case 'GENERATE_DOCUMENTATION':
      return CommandType.GENERATE_DOCUMENTATION
    case 6:
    case 'GENERATE_FULL_REPO_TECH_MANIFEST_DOCUMENTATION':
      return CommandType.GENERATE_FULL_REPO_TECH_MANIFEST_DOCUMENTATION
    case 7:
    case 'AUTODESK_MULE_TO_NODE_JS_MIGRATION':
      return CommandType.AUTODESK_MULE_TO_NODE_JS_MIGRATION
    case 8:
    case 'GENERATE_MAPPING_TABLE':
      return CommandType.GENERATE_MAPPING_TABLE
    case 9:
    case 'GENERATE_MULTI_REPO_FLOW_DIAGRAM':
      return CommandType.GENERATE_MULTI_REPO_FLOW_DIAGRAM
    case 10:
    case 'GENERATE_ADD_FLOW_CODE_PR':
      return CommandType.GENERATE_ADD_FLOW_CODE_PR
    case 11:
    case 'DATAWEAVE_TO_DATA_CREATION':
      return CommandType.DATAWEAVE_TO_DATA_CREATION
    case 12:
    case 'MUNIT_TEST_CREATION':
      return CommandType.MUNIT_TEST_CREATION
    case 13:
    case 'GENERATE_DATAWEAVE':
      return CommandType.GENERATE_DATAWEAVE
    case 14:
    case 'MULTI_REPO_QA':
      return CommandType.MULTI_REPO_QA
    case 15:
    case 'GENERAL_MULTI_REPO_QA_DEBUG_AGENT':
      return CommandType.GENERAL_MULTI_REPO_QA_DEBUG_AGENT
    case 16:
    case 'INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION':
      return CommandType.INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION
    case 17:
    case 'MIGRATION_DOCUMENT':
      return CommandType.MIGRATION_DOCUMENT
    case 18:
    case 'GENERATE_REPO_ADD_FLOW_CODE_PR':
      return CommandType.GENERATE_REPO_ADD_FLOW_CODE_PR
    case 19:
    case 'INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION_REPO_AWARE':
      return CommandType.INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION_REPO_AWARE
    case 20:
    case 'GENERATE_DATAWEAVE_REPO_AWARE':
      return CommandType.GENERATE_DATAWEAVE_REPO_AWARE
    case 21:
    case 'DATAWEAVE_TO_DATA_CREATION_REPO_AWARE':
      return CommandType.DATAWEAVE_TO_DATA_CREATION_REPO_AWARE
    case 22:
    case 'CODE_REVIEW':
      return CommandType.CODE_REVIEW
    case 23:
    case 'MULESOFT_TO_CAMEL_MIGRATION':
      return CommandType.MULESOFT_TO_CAMEL_MIGRATION
    case 24:
    case 'MIGRATION_QUESTION_ANSWERING':
      return CommandType.MIGRATION_QUESTION_ANSWERING
    case 25:
    case 'NON_REPO_AWARE_QA':
      return CommandType.NON_REPO_AWARE_QA
    case 26:
    case 'MULE_3_TO_MULE_4_MIGRATION':
      return CommandType.MULE_3_TO_MULE_4_MIGRATION
    case 27:
    case 'BILLABLE_FLOW_DOCUMENTATION':
      return CommandType.BILLABLE_FLOW_DOCUMENTATION
    case 28:
    case 'MIGRATION_ACCELERATOR':
      return CommandType.MIGRATION_ACCELERATOR
    case 29:
    case 'MEGA_QA_AGENT_V1':
      return CommandType.MEGA_QA_AGENT_V1
    case 30:
    case 'CODE_REVIEW_API':
      return CommandType.CODE_REVIEW_API
    case 31:
    case 'MULE_REFACTORING':
      return CommandType.MULE_REFACTORING
    case 32:
    case 'INTEGRATION_TEST':
      return CommandType.INTEGRATION_TEST
    case 33:
    case 'MULE_VERSION_UPGRADE':
      return CommandType.MULE_VERSION_UPGRADE
    case 34:
    case 'NON_MULE_DOCUMENTATION':
      return CommandType.NON_MULE_DOCUMENTATION
    case 35:
    case 'MVN_CMD':
      return CommandType.MVN_CMD
    case 36:
    case 'SPRING_INTEGRATION_REFACTORING':
      return CommandType.SPRING_INTEGRATION_REFACTORING
    case 37:
    case 'AZURE_DEPLOY_TEST':
      return CommandType.AZURE_DEPLOY_TEST
    case -1:
    case 'UNRECOGNIZED':
    default:
      return CommandType.UNRECOGNIZED
  }
}

export function commandTypeToJSON(object: CommandType): string {
  switch (object) {
    case CommandType.NONE:
      return 'NONE'
    case CommandType.QUESTION_ANSWERING:
      return 'QUESTION_ANSWERING'
    case CommandType.GENERATE_IMAGE:
      return 'GENERATE_IMAGE'
    case CommandType.GENERATE_SIMPLE_CODE_PR:
      return 'GENERATE_SIMPLE_CODE_PR'
    case CommandType.FIX_PR:
      return 'FIX_PR'
    case CommandType.GENERATE_DOCUMENTATION:
      return 'GENERATE_DOCUMENTATION'
    case CommandType.GENERATE_FULL_REPO_TECH_MANIFEST_DOCUMENTATION:
      return 'GENERATE_FULL_REPO_TECH_MANIFEST_DOCUMENTATION'
    case CommandType.AUTODESK_MULE_TO_NODE_JS_MIGRATION:
      return 'AUTODESK_MULE_TO_NODE_JS_MIGRATION'
    case CommandType.GENERATE_MAPPING_TABLE:
      return 'GENERATE_MAPPING_TABLE'
    case CommandType.GENERATE_MULTI_REPO_FLOW_DIAGRAM:
      return 'GENERATE_MULTI_REPO_FLOW_DIAGRAM'
    case CommandType.GENERATE_ADD_FLOW_CODE_PR:
      return 'GENERATE_ADD_FLOW_CODE_PR'
    case CommandType.DATAWEAVE_TO_DATA_CREATION:
      return 'DATAWEAVE_TO_DATA_CREATION'
    case CommandType.MUNIT_TEST_CREATION:
      return 'MUNIT_TEST_CREATION'
    case CommandType.GENERATE_DATAWEAVE:
      return 'GENERATE_DATAWEAVE'
    case CommandType.MULTI_REPO_QA:
      return 'MULTI_REPO_QA'
    case CommandType.GENERAL_MULTI_REPO_QA_DEBUG_AGENT:
      return 'GENERAL_MULTI_REPO_QA_DEBUG_AGENT'
    case CommandType.INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION:
      return 'INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION'
    case CommandType.MIGRATION_DOCUMENT:
      return 'MIGRATION_DOCUMENT'
    case CommandType.GENERATE_REPO_ADD_FLOW_CODE_PR:
      return 'GENERATE_REPO_ADD_FLOW_CODE_PR'
    case CommandType.INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION_REPO_AWARE:
      return 'INPUT_OUTPUT_EXAMPLE_TO_DWL_GENERATION_REPO_AWARE'
    case CommandType.GENERATE_DATAWEAVE_REPO_AWARE:
      return 'GENERATE_DATAWEAVE_REPO_AWARE'
    case CommandType.DATAWEAVE_TO_DATA_CREATION_REPO_AWARE:
      return 'DATAWEAVE_TO_DATA_CREATION_REPO_AWARE'
    case CommandType.CODE_REVIEW:
      return 'CODE_REVIEW'
    case CommandType.MULESOFT_TO_CAMEL_MIGRATION:
      return 'MULESOFT_TO_CAMEL_MIGRATION'
    case CommandType.MIGRATION_QUESTION_ANSWERING:
      return 'MIGRATION_QUESTION_ANSWERING'
    case CommandType.NON_REPO_AWARE_QA:
      return 'NON_REPO_AWARE_QA'
    case CommandType.MULE_3_TO_MULE_4_MIGRATION:
      return 'MULE_3_TO_MULE_4_MIGRATION'
    case CommandType.BILLABLE_FLOW_DOCUMENTATION:
      return 'BILLABLE_FLOW_DOCUMENTATION'
    case CommandType.MIGRATION_ACCELERATOR:
      return 'MIGRATION_ACCELERATOR'
    case CommandType.MEGA_QA_AGENT_V1:
      return 'MEGA_QA_AGENT_V1'
    case CommandType.CODE_REVIEW_API:
      return 'CODE_REVIEW_API'
    case CommandType.MULE_REFACTORING:
      return 'MULE_REFACTORING'
    case CommandType.INTEGRATION_TEST:
      return 'INTEGRATION_TEST'
    case CommandType.MULE_VERSION_UPGRADE:
      return 'MULE_VERSION_UPGRADE'
    case CommandType.NON_MULE_DOCUMENTATION:
      return 'NON_MULE_DOCUMENTATION'
    case CommandType.MVN_CMD:
      return 'MVN_CMD'
    case CommandType.SPRING_INTEGRATION_REFACTORING:
      return 'SPRING_INTEGRATION_REFACTORING'
    case CommandType.AZURE_DEPLOY_TEST:
      return 'AZURE_DEPLOY_TEST'
    case CommandType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum MegaQAgentTaskType {
  UNKNOWN_MEGA_QA_TASK_TYPE = 0,
  MEGA_QA = 1,
  MEGA_QA_CODING = 2,
  MEGA_QA_DATAWEAVE = 3,
  MEGA_QA_TESTING = 4,
  MEGA_QA_DOCUMENTATION = 5,
  UNRECOGNIZED = -1
}

export function megaQAgentTaskTypeFromJSON(object: any): MegaQAgentTaskType {
  switch (object) {
    case 0:
    case 'UNKNOWN_MEGA_QA_TASK_TYPE':
      return MegaQAgentTaskType.UNKNOWN_MEGA_QA_TASK_TYPE
    case 1:
    case 'MEGA_QA':
      return MegaQAgentTaskType.MEGA_QA
    case 2:
    case 'MEGA_QA_CODING':
      return MegaQAgentTaskType.MEGA_QA_CODING
    case 3:
    case 'MEGA_QA_DATAWEAVE':
      return MegaQAgentTaskType.MEGA_QA_DATAWEAVE
    case 4:
    case 'MEGA_QA_TESTING':
      return MegaQAgentTaskType.MEGA_QA_TESTING
    case 5:
    case 'MEGA_QA_DOCUMENTATION':
      return MegaQAgentTaskType.MEGA_QA_DOCUMENTATION
    case -1:
    case 'UNRECOGNIZED':
    default:
      return MegaQAgentTaskType.UNRECOGNIZED
  }
}

export function megaQAgentTaskTypeToJSON(object: MegaQAgentTaskType): string {
  switch (object) {
    case MegaQAgentTaskType.UNKNOWN_MEGA_QA_TASK_TYPE:
      return 'UNKNOWN_MEGA_QA_TASK_TYPE'
    case MegaQAgentTaskType.MEGA_QA:
      return 'MEGA_QA'
    case MegaQAgentTaskType.MEGA_QA_CODING:
      return 'MEGA_QA_CODING'
    case MegaQAgentTaskType.MEGA_QA_DATAWEAVE:
      return 'MEGA_QA_DATAWEAVE'
    case MegaQAgentTaskType.MEGA_QA_TESTING:
      return 'MEGA_QA_TESTING'
    case MegaQAgentTaskType.MEGA_QA_DOCUMENTATION:
      return 'MEGA_QA_DOCUMENTATION'
    case MegaQAgentTaskType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum IntegrationPlatform {
  UNKNOW_INTEGRATION_PLATFORM = 0,
  MULESOFT = 1,
  IBM_APP_CONNECT_ENTERPRISE = 2,
  JAVA_SPRING_BOOT = 3,
  TIBCO = 4,
  NODE_JS = 5,
  MICROSOFT_BIZTALK = 6,
  WEB_METHODS_CLOUD = 7,
  WEB_METHODS_CODE_BASED = 8,
  ORACLE_SERVICES_BUS = 9,
  TIBCO_6 = 11,
  MULESOFT_3 = 12,
  DOT_NET = 13,
  CAMEL = 14,
  INFORMATICA = 15,
  UIPATH = 16,
  BOOMI = 17,
  SAP_PI_PO = 18,
  APIGEE_POLICY_V1 = 19,
  UI_PATH_EXP_V1 = 20,
  AZURE_INTEGRATION_SERVICES = 21,
  FLEX_GATEWAY_RUST_POLICY = 22,
  UNRECOGNIZED = -1
}

export function integrationPlatformFromJSON(object: any): IntegrationPlatform {
  switch (object) {
    case 0:
    case 'UNKNOW_INTEGRATION_PLATFORM':
      return IntegrationPlatform.UNKNOW_INTEGRATION_PLATFORM
    case 1:
    case 'MULESOFT':
      return IntegrationPlatform.MULESOFT
    case 2:
    case 'IBM_APP_CONNECT_ENTERPRISE':
      return IntegrationPlatform.IBM_APP_CONNECT_ENTERPRISE
    case 3:
    case 'JAVA_SPRING_BOOT':
      return IntegrationPlatform.JAVA_SPRING_BOOT
    case 4:
    case 'TIBCO':
      return IntegrationPlatform.TIBCO
    case 5:
    case 'NODE_JS':
      return IntegrationPlatform.NODE_JS
    case 6:
    case 'MICROSOFT_BIZTALK':
      return IntegrationPlatform.MICROSOFT_BIZTALK
    case 7:
    case 'WEB_METHODS_CLOUD':
      return IntegrationPlatform.WEB_METHODS_CLOUD
    case 8:
    case 'WEB_METHODS_CODE_BASED':
      return IntegrationPlatform.WEB_METHODS_CODE_BASED
    case 9:
    case 'ORACLE_SERVICES_BUS':
      return IntegrationPlatform.ORACLE_SERVICES_BUS
    case 11:
    case 'TIBCO_6':
      return IntegrationPlatform.TIBCO_6
    case 12:
    case 'MULESOFT_3':
      return IntegrationPlatform.MULESOFT_3
    case 13:
    case 'DOT_NET':
      return IntegrationPlatform.DOT_NET
    case 14:
    case 'CAMEL':
      return IntegrationPlatform.CAMEL
    case 15:
    case 'INFORMATICA':
      return IntegrationPlatform.INFORMATICA
    case 16:
    case 'UIPATH':
      return IntegrationPlatform.UIPATH
    case 17:
    case 'BOOMI':
      return IntegrationPlatform.BOOMI
    case 18:
    case 'SAP_PI_PO':
      return IntegrationPlatform.SAP_PI_PO
    case 19:
    case 'APIGEE_POLICY_V1':
      return IntegrationPlatform.APIGEE_POLICY_V1
    case 20:
    case 'UI_PATH_EXP_V1':
      return IntegrationPlatform.UI_PATH_EXP_V1
    case 21:
    case 'AZURE_INTEGRATION_SERVICES':
      return IntegrationPlatform.AZURE_INTEGRATION_SERVICES
    case 22:
    case 'FLEX_GATEWAY_RUST_POLICY':
      return IntegrationPlatform.FLEX_GATEWAY_RUST_POLICY
    case -1:
    case 'UNRECOGNIZED':
    default:
      return IntegrationPlatform.UNRECOGNIZED
  }
}

export function integrationPlatformToJSON(object: IntegrationPlatform): string {
  switch (object) {
    case IntegrationPlatform.UNKNOW_INTEGRATION_PLATFORM:
      return 'UNKNOW_INTEGRATION_PLATFORM'
    case IntegrationPlatform.MULESOFT:
      return 'MULESOFT'
    case IntegrationPlatform.IBM_APP_CONNECT_ENTERPRISE:
      return 'IBM_APP_CONNECT_ENTERPRISE'
    case IntegrationPlatform.JAVA_SPRING_BOOT:
      return 'JAVA_SPRING_BOOT'
    case IntegrationPlatform.TIBCO:
      return 'TIBCO'
    case IntegrationPlatform.NODE_JS:
      return 'NODE_JS'
    case IntegrationPlatform.MICROSOFT_BIZTALK:
      return 'MICROSOFT_BIZTALK'
    case IntegrationPlatform.WEB_METHODS_CLOUD:
      return 'WEB_METHODS_CLOUD'
    case IntegrationPlatform.WEB_METHODS_CODE_BASED:
      return 'WEB_METHODS_CODE_BASED'
    case IntegrationPlatform.ORACLE_SERVICES_BUS:
      return 'ORACLE_SERVICES_BUS'
    case IntegrationPlatform.TIBCO_6:
      return 'TIBCO_6'
    case IntegrationPlatform.MULESOFT_3:
      return 'MULESOFT_3'
    case IntegrationPlatform.DOT_NET:
      return 'DOT_NET'
    case IntegrationPlatform.CAMEL:
      return 'CAMEL'
    case IntegrationPlatform.INFORMATICA:
      return 'INFORMATICA'
    case IntegrationPlatform.UIPATH:
      return 'UIPATH'
    case IntegrationPlatform.BOOMI:
      return 'BOOMI'
    case IntegrationPlatform.SAP_PI_PO:
      return 'SAP_PI_PO'
    case IntegrationPlatform.APIGEE_POLICY_V1:
      return 'APIGEE_POLICY_V1'
    case IntegrationPlatform.UI_PATH_EXP_V1:
      return 'UI_PATH_EXP_V1'
    case IntegrationPlatform.AZURE_INTEGRATION_SERVICES:
      return 'AZURE_INTEGRATION_SERVICES'
    case IntegrationPlatform.FLEX_GATEWAY_RUST_POLICY:
      return 'FLEX_GATEWAY_RUST_POLICY'
    case IntegrationPlatform.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum SourceOutputExampleType {
  DATA_TYPE_UNKNOWN = 0,
  DATA_TYPE_XML = 1,
  DATA_TYPE_YAML = 2,
  DATA_TYPE_JSON = 3,
  DATA_TYPE_CSV = 4,
  DATA_TYPE_MULTIPART = 5,
  DATA_TYPE_TEXT = 6,
  DATA_TYPE_EDI = 7,
  DATA_TYPE_EDIFACT = 8,
  DATA_TYPE_HL7 = 9,
  UNRECOGNIZED = -1
}

export function sourceOutputExampleTypeFromJSON(object: any): SourceOutputExampleType {
  switch (object) {
    case 0:
    case 'DATA_TYPE_UNKNOWN':
      return SourceOutputExampleType.DATA_TYPE_UNKNOWN
    case 1:
    case 'DATA_TYPE_XML':
      return SourceOutputExampleType.DATA_TYPE_XML
    case 2:
    case 'DATA_TYPE_YAML':
      return SourceOutputExampleType.DATA_TYPE_YAML
    case 3:
    case 'DATA_TYPE_JSON':
      return SourceOutputExampleType.DATA_TYPE_JSON
    case 4:
    case 'DATA_TYPE_CSV':
      return SourceOutputExampleType.DATA_TYPE_CSV
    case 5:
    case 'DATA_TYPE_MULTIPART':
      return SourceOutputExampleType.DATA_TYPE_MULTIPART
    case 6:
    case 'DATA_TYPE_TEXT':
      return SourceOutputExampleType.DATA_TYPE_TEXT
    case 7:
    case 'DATA_TYPE_EDI':
      return SourceOutputExampleType.DATA_TYPE_EDI
    case 8:
    case 'DATA_TYPE_EDIFACT':
      return SourceOutputExampleType.DATA_TYPE_EDIFACT
    case 9:
    case 'DATA_TYPE_HL7':
      return SourceOutputExampleType.DATA_TYPE_HL7
    case -1:
    case 'UNRECOGNIZED':
    default:
      return SourceOutputExampleType.UNRECOGNIZED
  }
}

export function sourceOutputExampleTypeToJSON(object: SourceOutputExampleType): string {
  switch (object) {
    case SourceOutputExampleType.DATA_TYPE_UNKNOWN:
      return 'DATA_TYPE_UNKNOWN'
    case SourceOutputExampleType.DATA_TYPE_XML:
      return 'DATA_TYPE_XML'
    case SourceOutputExampleType.DATA_TYPE_YAML:
      return 'DATA_TYPE_YAML'
    case SourceOutputExampleType.DATA_TYPE_JSON:
      return 'DATA_TYPE_JSON'
    case SourceOutputExampleType.DATA_TYPE_CSV:
      return 'DATA_TYPE_CSV'
    case SourceOutputExampleType.DATA_TYPE_MULTIPART:
      return 'DATA_TYPE_MULTIPART'
    case SourceOutputExampleType.DATA_TYPE_TEXT:
      return 'DATA_TYPE_TEXT'
    case SourceOutputExampleType.DATA_TYPE_EDI:
      return 'DATA_TYPE_EDI'
    case SourceOutputExampleType.DATA_TYPE_EDIFACT:
      return 'DATA_TYPE_EDIFACT'
    case SourceOutputExampleType.DATA_TYPE_HL7:
      return 'DATA_TYPE_HL7'
    case SourceOutputExampleType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum DiffType {
  DIFF_UNKNOWN_TYPE = 0,
  MODIFY = 1,
  ADD = 2,
  DELETE = 3,
  UNRECOGNIZED = -1
}

export function diffTypeFromJSON(object: any): DiffType {
  switch (object) {
    case 0:
    case 'DIFF_UNKNOWN_TYPE':
      return DiffType.DIFF_UNKNOWN_TYPE
    case 1:
    case 'MODIFY':
      return DiffType.MODIFY
    case 2:
    case 'ADD':
      return DiffType.ADD
    case 3:
    case 'DELETE':
      return DiffType.DELETE
    case -1:
    case 'UNRECOGNIZED':
    default:
      return DiffType.UNRECOGNIZED
  }
}

export function diffTypeToJSON(object: DiffType): string {
  switch (object) {
    case DiffType.DIFF_UNKNOWN_TYPE:
      return 'DIFF_UNKNOWN_TYPE'
    case DiffType.MODIFY:
      return 'MODIFY'
    case DiffType.ADD:
      return 'ADD'
    case DiffType.DELETE:
      return 'DELETE'
    case DiffType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum QuestionAnsweringType {
  QA_UNKNOWN = 0,
  GENERAL = 1,
  TROUBLESHOOT = 2,
  SECURITY = 3,
  BEST_PRACTICES = 4,
  BILLING = 5,
  /** API_SPEC_GEN - Deprecated as standalone chat — now handled via MEGA_QA_AGENT_V1. Still used internally by migration/refactor pipelines. */
  API_SPEC_GEN = 6,
  REVIEW_PR = 7,
  UNRECOGNIZED = -1
}

export function questionAnsweringTypeFromJSON(object: any): QuestionAnsweringType {
  switch (object) {
    case 0:
    case 'QA_UNKNOWN':
      return QuestionAnsweringType.QA_UNKNOWN
    case 1:
    case 'GENERAL':
      return QuestionAnsweringType.GENERAL
    case 2:
    case 'TROUBLESHOOT':
      return QuestionAnsweringType.TROUBLESHOOT
    case 3:
    case 'SECURITY':
      return QuestionAnsweringType.SECURITY
    case 4:
    case 'BEST_PRACTICES':
      return QuestionAnsweringType.BEST_PRACTICES
    case 5:
    case 'BILLING':
      return QuestionAnsweringType.BILLING
    case 6:
    case 'API_SPEC_GEN':
      return QuestionAnsweringType.API_SPEC_GEN
    case 7:
    case 'REVIEW_PR':
      return QuestionAnsweringType.REVIEW_PR
    case -1:
    case 'UNRECOGNIZED':
    default:
      return QuestionAnsweringType.UNRECOGNIZED
  }
}

export function questionAnsweringTypeToJSON(object: QuestionAnsweringType): string {
  switch (object) {
    case QuestionAnsweringType.QA_UNKNOWN:
      return 'QA_UNKNOWN'
    case QuestionAnsweringType.GENERAL:
      return 'GENERAL'
    case QuestionAnsweringType.TROUBLESHOOT:
      return 'TROUBLESHOOT'
    case QuestionAnsweringType.SECURITY:
      return 'SECURITY'
    case QuestionAnsweringType.BEST_PRACTICES:
      return 'BEST_PRACTICES'
    case QuestionAnsweringType.BILLING:
      return 'BILLING'
    case QuestionAnsweringType.API_SPEC_GEN:
      return 'API_SPEC_GEN'
    case QuestionAnsweringType.REVIEW_PR:
      return 'REVIEW_PR'
    case QuestionAnsweringType.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export enum TraceEvent {
  /** campaign_task_exposure - Task */
  campaign_task_exposure = 0,
  campaign_task_submit = 1,
  campaign_task_submitted = 2,
  campaign_task_completed = 3,
  /** signup_modal_exposure - Signup Wall */
  signup_modal_exposure = 4,
  signup_exposure = 5,
  signup_click = 6,
  signup_completed = 7,
  /** waitlist_exposure - Waitlist Wall */
  waitlist_exposure = 8,
  waitlist_send_verification_code = 9,
  waitlist_click_register = 10,
  waitlist_register_success = 11,
  waitlist_register_failure = 12,
  waitlist_pre_exposure = 13,
  /** user_guide_closed - User Guide Banner */
  user_guide_closed = 14,
  /** feedback_click - Feedback */
  feedback_click = 15,
  campaign_task_fields_not_filled = 16,
  campaign_task_submit_failed = 17,
  copy_to_clipboard = 18,
  /** ws_open - WebSocket */
  ws_open = 19,
  ws_message = 20,
  ws_close = 21,
  ws_error = 22,
  thumb_up_clicked = 23,
  thumb_down_clicked = 24,
  upgrade_plan = 25,
  /** campaign_trial_exposure - Campaign */
  campaign_trial_exposure = 26,
  campaign_trial_click_submit = 27,
  campaign_trial_submit_success = 28,
  tutorial_started = 29,
  tutorial_in_progress = 30,
  tutorial_end = 31,
  repo_setup = 32,
  try_builtin_example = 33,
  try_own_example = 34,
  campaign_register_email = 35,
  UNRECOGNIZED = -1
}

export function traceEventFromJSON(object: any): TraceEvent {
  switch (object) {
    case 0:
    case 'campaign_task_exposure':
      return TraceEvent.campaign_task_exposure
    case 1:
    case 'campaign_task_submit':
      return TraceEvent.campaign_task_submit
    case 2:
    case 'campaign_task_submitted':
      return TraceEvent.campaign_task_submitted
    case 3:
    case 'campaign_task_completed':
      return TraceEvent.campaign_task_completed
    case 4:
    case 'signup_modal_exposure':
      return TraceEvent.signup_modal_exposure
    case 5:
    case 'signup_exposure':
      return TraceEvent.signup_exposure
    case 6:
    case 'signup_click':
      return TraceEvent.signup_click
    case 7:
    case 'signup_completed':
      return TraceEvent.signup_completed
    case 8:
    case 'waitlist_exposure':
      return TraceEvent.waitlist_exposure
    case 9:
    case 'waitlist_send_verification_code':
      return TraceEvent.waitlist_send_verification_code
    case 10:
    case 'waitlist_click_register':
      return TraceEvent.waitlist_click_register
    case 11:
    case 'waitlist_register_success':
      return TraceEvent.waitlist_register_success
    case 12:
    case 'waitlist_register_failure':
      return TraceEvent.waitlist_register_failure
    case 13:
    case 'waitlist_pre_exposure':
      return TraceEvent.waitlist_pre_exposure
    case 14:
    case 'user_guide_closed':
      return TraceEvent.user_guide_closed
    case 15:
    case 'feedback_click':
      return TraceEvent.feedback_click
    case 16:
    case 'campaign_task_fields_not_filled':
      return TraceEvent.campaign_task_fields_not_filled
    case 17:
    case 'campaign_task_submit_failed':
      return TraceEvent.campaign_task_submit_failed
    case 18:
    case 'copy_to_clipboard':
      return TraceEvent.copy_to_clipboard
    case 19:
    case 'ws_open':
      return TraceEvent.ws_open
    case 20:
    case 'ws_message':
      return TraceEvent.ws_message
    case 21:
    case 'ws_close':
      return TraceEvent.ws_close
    case 22:
    case 'ws_error':
      return TraceEvent.ws_error
    case 23:
    case 'thumb_up_clicked':
      return TraceEvent.thumb_up_clicked
    case 24:
    case 'thumb_down_clicked':
      return TraceEvent.thumb_down_clicked
    case 25:
    case 'upgrade_plan':
      return TraceEvent.upgrade_plan
    case 26:
    case 'campaign_trial_exposure':
      return TraceEvent.campaign_trial_exposure
    case 27:
    case 'campaign_trial_click_submit':
      return TraceEvent.campaign_trial_click_submit
    case 28:
    case 'campaign_trial_submit_success':
      return TraceEvent.campaign_trial_submit_success
    case 29:
    case 'tutorial_started':
      return TraceEvent.tutorial_started
    case 30:
    case 'tutorial_in_progress':
      return TraceEvent.tutorial_in_progress
    case 31:
    case 'tutorial_end':
      return TraceEvent.tutorial_end
    case 32:
    case 'repo_setup':
      return TraceEvent.repo_setup
    case 33:
    case 'try_builtin_example':
      return TraceEvent.try_builtin_example
    case 34:
    case 'try_own_example':
      return TraceEvent.try_own_example
    case 35:
    case 'campaign_register_email':
      return TraceEvent.campaign_register_email
    case -1:
    case 'UNRECOGNIZED':
    default:
      return TraceEvent.UNRECOGNIZED
  }
}

export function traceEventToJSON(object: TraceEvent): string {
  switch (object) {
    case TraceEvent.campaign_task_exposure:
      return 'campaign_task_exposure'
    case TraceEvent.campaign_task_submit:
      return 'campaign_task_submit'
    case TraceEvent.campaign_task_submitted:
      return 'campaign_task_submitted'
    case TraceEvent.campaign_task_completed:
      return 'campaign_task_completed'
    case TraceEvent.signup_modal_exposure:
      return 'signup_modal_exposure'
    case TraceEvent.signup_exposure:
      return 'signup_exposure'
    case TraceEvent.signup_click:
      return 'signup_click'
    case TraceEvent.signup_completed:
      return 'signup_completed'
    case TraceEvent.waitlist_exposure:
      return 'waitlist_exposure'
    case TraceEvent.waitlist_send_verification_code:
      return 'waitlist_send_verification_code'
    case TraceEvent.waitlist_click_register:
      return 'waitlist_click_register'
    case TraceEvent.waitlist_register_success:
      return 'waitlist_register_success'
    case TraceEvent.waitlist_register_failure:
      return 'waitlist_register_failure'
    case TraceEvent.waitlist_pre_exposure:
      return 'waitlist_pre_exposure'
    case TraceEvent.user_guide_closed:
      return 'user_guide_closed'
    case TraceEvent.feedback_click:
      return 'feedback_click'
    case TraceEvent.campaign_task_fields_not_filled:
      return 'campaign_task_fields_not_filled'
    case TraceEvent.campaign_task_submit_failed:
      return 'campaign_task_submit_failed'
    case TraceEvent.copy_to_clipboard:
      return 'copy_to_clipboard'
    case TraceEvent.ws_open:
      return 'ws_open'
    case TraceEvent.ws_message:
      return 'ws_message'
    case TraceEvent.ws_close:
      return 'ws_close'
    case TraceEvent.ws_error:
      return 'ws_error'
    case TraceEvent.thumb_up_clicked:
      return 'thumb_up_clicked'
    case TraceEvent.thumb_down_clicked:
      return 'thumb_down_clicked'
    case TraceEvent.upgrade_plan:
      return 'upgrade_plan'
    case TraceEvent.campaign_trial_exposure:
      return 'campaign_trial_exposure'
    case TraceEvent.campaign_trial_click_submit:
      return 'campaign_trial_click_submit'
    case TraceEvent.campaign_trial_submit_success:
      return 'campaign_trial_submit_success'
    case TraceEvent.tutorial_started:
      return 'tutorial_started'
    case TraceEvent.tutorial_in_progress:
      return 'tutorial_in_progress'
    case TraceEvent.tutorial_end:
      return 'tutorial_end'
    case TraceEvent.repo_setup:
      return 'repo_setup'
    case TraceEvent.try_builtin_example:
      return 'try_builtin_example'
    case TraceEvent.try_own_example:
      return 'try_own_example'
    case TraceEvent.campaign_register_email:
      return 'campaign_register_email'
    case TraceEvent.UNRECOGNIZED:
    default:
      return 'UNRECOGNIZED'
  }
}

export interface RadioButton {
  label: string
  value: string
  rawData: string
}

export interface RadioGroup {
  groupName: string
  options: RadioButton[]
  selectedValue: string
  defaultSelectedValue: string
  label: string
}

export interface MultiSelectOption {
  fileName: string
  plan: string
  detailedPlan: string
  fileChangeType: DiffType
  label: string
  value: string
  rawData: string
}

export interface MultiSelect {
  groupName: string
  options: MultiSelectOption[]
  selectedFileNames: string[]
  selectedValues: string[]
  label: string
  defaultSelectedValues: string[]
}

export interface TextBarInput {
  groupName: string
  label: string
  input: string
  hintText: string
}

export interface ListSelectOption {
  label: string
  value: string
  rawData: string
}

export interface ListSelect {
  groupName: string
  options: ListSelectOption[]
  selectedValue: string
  defaultSelectedValue: string
  label: string
}

export interface ChatSelectionOption {
  label: string
  value: string
  description: string
}

export interface ChatSelectionWidget {
  widgetId: string
  selectionMode: ChatSelectionMode
  label: string
  options: ChatSelectionOption[]
  defaultSelectedValues: string[]
  placeholder: string
  inputPrefix: string
}

export interface Form {
  groupName: string
  formId: string
  radioGroups: RadioGroup[]
  multiSelects: MultiSelect[]
  textBarInputs: TextBarInput[]
  listSelects: ListSelect[]
  rawData: string
}

export interface FormWidget {
  groupName: string
  formId: string
  radioGroups: RadioGroup[]
  multiSelects: MultiSelect[]
  textBarInputs: TextBarInput[]
  listSelects: ListSelect[]
  rawData: string
  label: string
}

export interface AgentInternalStatus {
  agentInternalStatus: AgentInternalEnum
  agentInternalStatusMsg: string
  internalProgressMsg: string[]
}

export interface Step {
  stepDescription: string
  mappingSheet: MappingSheet | undefined
}

export interface AddFlowSpec {
  base64EncodedSequenceDiagrams: string[]
  description: string
  systemDetails: string
  messageProcessingSteps: Step[]
  generalComments: string
}

export interface Image {
  imageExtension: string
  imageBase64Content: string
}

export interface FileUpload {
  fileName: string
  fileS3Path: string
}

export interface DirectoryUpload {
  directoryName: string
  directoryS3Path: string
}

export interface ContextUpload {
  instructions: string
  files: FileUpload[]
  directories: DirectoryUpload[]
}

export interface Env {
  url: string
  envType: EnvType
}

export interface QuestionAskingInput {
  questionAskingInputs: Block[]
}

export interface IntegrationTestInputOutputExample {
  /** input example */
  inputExample: string
  /** output example */
  outputExample: string
}

export interface IntegrationTestFlow {
  /** Unique flow identifier */
  flowId: string
  /** Input/output examples for this flow */
  examples: IntegrationTestInputOutputExample[]
}

export interface IntegrationTestConfig {
  /** All available flows with their configurations */
  flows: IntegrationTestFlow[]
  /** Global flag to enable/disable comparison testing */
  enableComparisonTesting: boolean
  /** Schema references for integration testing */
  schemas: string[]
  /** Flag to enable auto-generation of test data */
  enableAutoGenerateTestData: boolean
  /** Deployment URL for integration testing */
  deploymentUrl: string
}

export interface ProgressMessageTodoListMsg {
  todo: string
  status: ProgressMessageTodoListStatus
}

export interface ProgressMessage {
  taskStatus: AgentTaskStatus
  messageType: ProgressMessageType
  title: string
  internalMsgs: string[]
  toolOutputs: string[]
  checkpointMsg: string
  msgHash: string
  createdTsNs: number
  /** Preview snippet to show when collapsed (before expansion) */
  preview: string
  todoList: ProgressMessageTodoListMsg[]
}

export interface AgentRequest {
  connectionType: ConnectionType
  connectionDetail: ConnectionDetail | undefined
  command: Command | undefined
  metadata: Metadata | undefined
  isStream: boolean
  jsonMetadata: string
  /** User ID */
  userId: number
  diff: Diff[]
  codePlan: CodePlan | undefined
  form: Form[]
  document: Documentation | undefined
  munitScenarios: MunitScenarios | undefined
  mappingSheet: MappingSheet[]
  sourceOutputExamples: SourceOutputExamples[]
  diffComments: DiffComment[]
  generalDiffComment: string
  documentInlineComments: DocumentInlineComment[]
  inputOutputNotes: string
  /** Organization ID */
  orgId: number
  /** User name */
  userName: string
  addFlowSpec: AddFlowSpec | undefined
  /** Device ID */
  deviceId: string
  enableWebSearch: boolean
  vmArgs: string
  /** Is this a campaign task */
  isCampaign: boolean
  /** Environment details */
  env: Env | undefined
  /** Additional user notes for a task */
  userNotes: string
  /** Migration document input */
  migrationDocInput: MigrationDocumentInput | undefined
  /** DataWeave to Input/Output example */
  dwlToInputOutputExample: DwlToInputOutputExample | undefined
  /** Conversation UUID */
  uuid: string
  munitNotes: string
  runtimeSettings: RuntimeSettings | undefined
  qaType: QuestionAnsweringType
  codeEnhancerTaskType: CodeEnhancerTaskType
  questionAskingInput: QuestionAskingInput | undefined
  munitNumScenarios: number
  munitEnableCoverage: boolean
  agenticUiTesting: boolean
  generateSeqDiag: boolean
  generateFlowDiag: boolean
  userSelectedEntities: { [key: string]: StringList }
  apiSpecType: ApiSpecType
  runTests: boolean
  selectedEndpoints: MigrationSelectedEndpoint[]
  usageData: UsageData | undefined
  initConversationId: number
  megaQaTaskType: MegaQAgentTaskType
  runDeploy: boolean
  refactorStartUserComments: RefactorStartUserComments | undefined
  landingPageAgentTrace: string
  conversationId: number
  parentTaskId: number
  branchName: string
  pluginContext: PluginContext | undefined
  /** Integration test configuration with flows and examples */
  integrationTestConfig: IntegrationTestConfig | undefined
  /** Source/current runtime settings for upgrades */
  oldRuntimeSettings: RuntimeSettings | undefined
  /** Canvas selection context for feedback */
  canvasContextInfo: CanvasContextInfo[]
  /** Explicit platform (from UI autodetection) */
  platform: IntegrationPlatform
  requestFromApi: boolean
  toPlatform: IntegrationPlatform
  isSpeechInput: boolean
  /** Whole-level risk-review feedback (single text + uploads) submitted by the user during the DOC_GENERATED risk review pause */
  migrationRiskReviewFeedback: MigrationRiskReviewFeedback | undefined
  /** Answer to a deploy input request, submitted during the MIGRATION_AWAITING_DEPLOY_INPUT pause */
  migrationDeployInput: MigrationDeployInput | undefined
}

export interface AgentRequest_UserSelectedEntitiesEntry {
  key: string
  value: StringList | undefined
}

export interface RuntimeSettings {
  javaVersion: string
  mavenVersion: string
  muleRuntimeVersion: string
  settingsXmlRawTxt: string
  settingsSecurityXmlRawTxt: string
}

export interface DwlToInputOutputExample {
  commandString: string
  exampleType: SourceOutputExampleType
}

export interface ValidatedInputOutputBlock {
  type: BlockType
  blockTitle: string
  inputExample: string
  inputValidationType: string
  outputExample: string
  outputValidationType: string
}

export interface AttachmentBlock {
  type: BlockType
  blockTitle: string
  attachmentUrl: string
}

export interface MultiSelectOptions {
  type: BlockType
  options: string[]
  selectedOptions: string[]
}

export interface TextBlockWithAttachment {
  type: BlockType
  text: string
  base64EncodedImages: string[]
  mappingSheets: MappingSheet[]
  multiSelectOptions: MultiSelectOptions | undefined
}

export interface DropdownBlock {
  type: BlockType
  blockTitle: string
  dropdownOptions: string[]
  selectedOption: string
}

export interface Block {
  textBlockWithAttachment?: TextBlockWithAttachment | undefined
  dropdownBlock?: DropdownBlock | undefined
  validatedInputOutputBlock?: ValidatedInputOutputBlock | undefined
}

export interface QuestionAskingOutput {
  questionAskingInputs: Block[]
  finalSpecificationInputs: Block[]
}

export interface ResponseContentStream {
  messageType: MessageType
  deltaContent: string
  jsonMetadata: string
  taskMetadata: string
  diff: Diff[]
  codePlan: CodePlan | undefined
  form: Form[]
  document: Documentation | undefined
  munitScenarios: MunitScenarios | undefined
  dataweaveOutput: DataWeaveGenCodeOutput | undefined
  agentInternalStatus: AgentInternalStatus | undefined
  addFlowSpec: AddFlowSpec | undefined
  migrationDocOutput: MigrationDocumentOutput | undefined
  questionAskingOutput: QuestionAskingOutput | undefined
  waitForResponseDeltaContent: string
  taskId: number
  thinkingContent: string
  formWidget: FormWidget | undefined
  progressMessage: ProgressMessage | undefined
  /** S3 path for heavy metadata (replaces json_metadata for large objects) */
  jsonMetadataS3Path: string
  identifiedEndpoints: MigrationSelectedEndpoint[]
  canvasData: CanvasData[]
  coderSummary: CoderSummary | undefined
  assetIds: string[]
  chatSelectionWidget: ChatSelectionWidget | undefined
  /** Current state of the agent-driven Azure deploy (phase, accumulated log, optional input request / trigger URL) — drives the deploy modal */
  migrationDeployState: MigrationDeployState | undefined
}

export interface RefactorStartUserComments {
  generalComments: string
  skipPrcApi: boolean
}

export interface MigrationSelectedEndpoint {
  category: string
  name: string
  filePath: string
}

export interface CoderSummary {
  taskId: number
  summary: string
}

export interface CanvasData {
  canvasType: CanvasType
  content: string
  s3FilePath: string
  title: string
  base64EncodedImage: string
  fileExt: string
  editable: boolean
}

/**
 * Context information for canvas selection feedback
 * Used when user provides feedback on selected text within an editable canvas
 */
export interface CanvasContextInfo {
  /** Unique identifier for the canvas (e.g., s3 file path) */
  canvasHash: string
  /** Human-readable title of the canvas */
  canvasTitle: string
  /** The exact selected text */
  contextText: string
  /** Text before the selection (~100 chars) */
  contextBefore: string
  /** Text after the selection (~100 chars) */
  contextAfter: string
  /** Selection start position */
  contextStartLine: number
  /** Selection end position */
  contextEndLine: number
}

export interface MigrationDocumentInput {
  platform: IntegrationPlatform
  endpointDesc: string
  generateForAll: boolean
  migDocs: string[]
}

export interface MigrationDocumentOutput {
  docMd: string
  migDocs: string[]
  apiSpec: string[]
  diffs: Diff[]
  endpointsMd: string
  migDocsMap: { [key: string]: string }
  migDocsRiskMap: { [key: string]: string }
  codeGenSummary: string
  codeGenSummaryMap: { [key: string]: string }
}

export interface MigrationDocumentOutput_MigDocsMapEntry {
  key: string
  value: string
}

export interface MigrationDocumentOutput_MigDocsRiskMapEntry {
  key: string
  value: string
}

export interface MigrationDocumentOutput_CodeGenSummaryMapEntry {
  key: string
  value: string
}

/**
 * Submitted by the user during the MIGRATION_AWAITING_RISK_REVIEW pause as a
 * SINGLE whole-review feedback message — not per-risk and not per-endpoint.
 * The user reviews all risks across all endpoints and then writes one
 * consolidated note (optionally attaching supporting documents) describing
 * what the agent should change when regenerating the migration documents.
 *
 * The agent treats the text + attachments as a single instruction set: it
 * runs the per-endpoint risk-section regen for every endpoint that has
 * risks, passing this same global feedback into each prompt. The LLM is
 * expected to apply the feedback only where it is relevant to that
 * endpoint's risks and leave the rest untouched.
 */
export interface MigrationRiskReviewFeedback {
  /**
   * Verbatim free-text feedback the user typed in the review chatbox. May
   * be empty when the user only attached files. Empty AND no uploads means
   * "no feedback was submitted" — handled identically to "Continue without
   * feedback" upstream.
   */
  feedback: string
  /**
   * Optional supporting documents (schemas, sample payloads, runbooks,
   * etc.) the user wants the agent to consider when revising the risks.
   * Files are uploaded to S3 ahead of submission via the standard
   * context-upload pipeline; the agent downloads them by `file_s3_path`,
   * validates them against the attachment policy (allowed extensions /
   * size cap), and inlines their content into the regen prompt alongside
   * the feedback text.
   */
  uploadedFiles: FileUpload[]
}

/**
 * One thing the running Azure deploy needs from the user. Emitted inside
 * MigrationDeployState when a phase cannot proceed without input (the
 * risks/assumptions pause pattern, applied to deploy). The frontend renders
 * either a text field or a confirm (yes/no) below the terminal.
 */
export interface MigrationDeployInputRequest {
  /** Stable id; echoed back in MigrationDeployInput.request_id */
  id: string
  /** "text" | "confirm" */
  kind: string
  /** Prompt shown above the controls, e.g. "Storage account name" */
  label: string
  /** text kind only */
  placeholder: string
  /** text kind only */
  defaultValue: string
  /** text kind only — mask the value (e.g. an API key) */
  isSecret: boolean
  /** confirm kind only — defaults to "Yes" */
  confirmLabel: string
  /** confirm kind only — defaults to "No" */
  denyLabel: string
}

/**
 * Current state of the agent-driven Azure deploy, surfaced in the deploy modal.
 * Emitted on the ResponseContentStream as the deploy progresses.
 */
export interface MigrationDeployState {
  /** "deploying" | "awaiting_input" | "done" | "failed" */
  phase: string
  /** Accumulated terminal log (stdout/stderr) for the run */
  log: string
  /** Present when phase == "awaiting_input" */
  inputRequest: MigrationDeployInputRequest | undefined
  /** Present when phase == "done" — the deployed workflow's trigger URL */
  triggerUrl: string
}

/**
 * The user's answer to a MigrationDeployInputRequest, submitted during the
 * MIGRATION_AWAITING_DEPLOY_INPUT pause (status MIGRATION_DEPLOY_INPUT_PROVIDED).
 */
export interface MigrationDeployInput {
  /** Echoes MigrationDeployInputRequest.id being answered */
  requestId: string
  /** text kind — the value the user typed */
  value: string
  /** confirm kind — true for yes, false for no */
  approved: boolean
}

export interface MappingSheet {
  id: string
  base64EncodedXlsx: string
  csv: string
}

export interface SourceOutputExamples {
  sourceData: string
  outputData: string
  sourceDataType: SourceOutputExampleType
  outputDataType: SourceOutputExampleType
  outputEdiSchemaType: EdiSchemaType | undefined
  inputEdiSchemaType: EdiSchemaType | undefined
  outputEdiFactSchemaType: EdiFactSchemaType | undefined
  inputEdiFactSchemaType: EdiFactSchemaType | undefined
  outputHl7SchemaType: HL7SchemaType | undefined
  inputHl7SchemaType: HL7SchemaType | undefined
}

export interface EdiSchemaType {
  transactionVersion: string
  transactionType: string
  interchangeIdSelf: string
  interchangeIdQualifierSelf: string
  interchangeIdPartner: string
  interchangeIdQualifierPartner: string
  groupIdPartner: string
  groupIdSelf: string
  sendUniqueGroupNumbers: string
  lineEnding: string
}

export interface EdiFactSchemaType {
  version: string
  message: string
  interchangeIdSelf: string
  interchangeIdQualifierSelf: string
  interchangeIdPartner: string
  interchangeIdQualifierPartner: string
  customEslSchema: string
}

export interface HL7SchemaType {
  version: string
  message: string
  segmentTerminator: string
  schemaType: string
}

export interface JiraDetail {
  issueKey: string
  accessToken: string
  title: string
  description: string
}

export interface SlackDetail {
  convoKey: string
}

export interface EclipseDetail {
  diffs: EclipseDiffsData | undefined
}

export interface EclipseDiffsData {}

export interface GithubDetail {
  accessToken: string
  orgName: string
  repoName: string
  branchName: string
  commitId: string
  issueId: string
}

export interface ConnectionDetail {
  githubDetail?: GithubDetail | undefined
  jiraDetail?: JiraDetail | undefined
  slackDetail?: SlackDetail | undefined
  eclipseDetail?: EclipseDetail | undefined
}

export interface InputOutputTokens {
  inputTokens: number
  outputTokens: number
}

export interface UsageData {
  modelUsage: { [key: string]: InputOutputTokens }
  metadata: string
}

export interface UsageData_ModelUsageEntry {
  key: string
  value: InputOutputTokens | undefined
}

export interface CodeContext {
  /** Connections.TYPE_GITHUB | Connections.TYPE_BITBUCKET ... */
  connType: string
  /** Organization name */
  orgName: string
  /** Repository name */
  repoName: string
  /** Branch name */
  branchName: string
  commitId: string
  /** S3 path to the tar file */
  s3TarFilePath: string
}

export interface PluginContext {
  pluginName: string
  pluginVersion: string
  openedFilePaths: string[]
  attachedFilePaths: string[]
  activeFilePath: string
  selectedContent: string
  repoStateChanged: boolean
  enableFormWidgets: boolean
  prevCodeContext: CodeContext | undefined
}

export interface Metadata {
  /** Connection details to fetch the code */
  codeConnectionDetail: ConnectionDetail | undefined
  messages: Message[]
  /** Code context */
  codeContext: CodeContext | undefined
  /** Multiple code contexts */
  multiRepoCodeContext: CodeContext[]
  /** Additional code contexts */
  auxiliaryCodeContext: CodeContext[]
}

export interface Message {
  role: string
  userName: string
  content: string
  messageType: MessageType
  timestampMs: number
  formWidget: FormWidget[]
  chatSelectionWidget: ChatSelectionWidget[]
}

export interface Command {
  commandType: CommandType
  commandString: string
  images: Image[]
  formWidget: FormWidget[]
  fileUploads: FileUpload[]
  contextUpload: ContextUpload | undefined
  projectName: string
  executionMode: ExecutionMode
  verificationMode: VerificationMode
}

export interface CodePlan {
  rawTxt: string
  fileMultiSelect: MultiSelect | undefined
  svgFlows: string[]
}

export interface MunitScenarios {
  mdText: string
  rawData: string
}

export interface DataWeaveGenCodeOutput {
  code: string
  errorMsg: string
  sourceData: string
  outputData: string
  userMarkdownMsg: string
}

export interface Diff {
  diffType: DiffType
  aFilePath: string
  bFilePath: string
  aFileContent: string
  bFileContent: string
  patchBA: string
  aCommitId: string
}

export interface DiffComment {
  comment: string
  filePath: string
  startLineNumber: number
  endLineNumber: number
  fileContent: string
}

export interface DocumentInlineComment {
  comment: string
  startLineNumber: number
  endLineNumber: number
}

export interface Documentation {
  flowDocMdTxt: string
  flowDocMdHtmlPrLink: string
  mappingSheetCsv: string
  mappingSheetHtmlPrLink: string
  mappingSheetMd: string
  dwlMd: string
  fullRepoMd: string
  addFlowCode: string
  addFlowSvgDiagram: string
  migrationDocMd: string
}

export interface AgentStreamingResponse {
  responseContentStream: ResponseContentStream | undefined
}

export interface SpeechToTextRequest {
  /**
   * If false, the first request chunk contains the full batch input and the
   * server returns the complete transcript in the first response chunk.
   * If true, audio_content is treated as a stream of audio chunks.
   */
  isStream: boolean
  audioContent: Uint8Array
  /** Optional remote URI, for example gs://bucket/audio.wav. */
  audioUri: string
  languageCodes: string[]
  model: string
  enableAutomaticPunctuation: boolean
  enableWordTimeOffsets: boolean
  mimeType: string
  audioEncoding: string
  sampleRateHertz: number
  recognitionConfigJson: string
  requestId: string
  isLastChunk: boolean
}

export interface SpeechToTextResponse {
  isStream: boolean
  transcript: string
  isFinal: boolean
  confidence: number
  languageCode: string
  jsonMetadata: string
  errorMessage: string
}

export interface TextToSpeechRequest {
  /**
   * If false, the first request chunk contains the full text and the server
   * returns the complete audio in the first response chunk. If true, text is
   * treated as a stream of text chunks.
   */
  isStream: boolean
  text: string
  languageCode: string
  voiceName: string
  audioEncoding: string
  speakingRate: number
  pitch: number
  volumeGainDb: number
  sampleRateHertz: number
  effectsProfileId: string[]
  model: string
  synthesisConfigJson: string
  requestId: string
  isLastChunk: boolean
}

export interface TextToSpeechResponse {
  isStream: boolean
  audioContent: Uint8Array
  audioEncoding: string
  isFinal: boolean
  jsonMetadata: string
  errorMessage: string
}

export interface GetIndexReposRequest {
  userId: number
}

export interface GetIndexReposResponse {
  githubDetails: GithubDetail[]
}

export interface AgentTaskRequest {
  taskId: number
  agentRequest: AgentRequest | undefined
  runSync: boolean
}

export interface AgentTaskResponse {
  taskId: number
  taskStatus: AgentTaskStatus
  metadata: string
}

export interface TaskStatusAndRequestResponseTuple {
  request: AgentRequest | undefined
  response: AgentStreamingResponse[]
  taskStatus: AgentTaskStatus
  createdTsSec: number
}

export interface DBAgentTaskRequestResponse {
  originalRequest: AgentRequest | undefined
  orderedStateResponses: TaskStatusAndRequestResponseTuple[]
  usageData: UsageData | undefined
}

export interface ConnectorKbAnnotationInputRequest {
  pomDep: string
  configCode: string
  actionCode: string
  actionType: string
  actionDescription: string
  creatorEmail: string
  snippetDescription: string
}

export interface ConnectorKbAnnotationInputResponse {
  result: string
}

export interface ConnectorKbAnnotationDisplayTaskRequest {}

export interface ConnectorKbAnnotationDisplayTaskTuple {
  pomDep: string
  configKey: string
  opKey: string
  srcKey: string
}

export interface ConnectorKbAnnotationDisplayTaskResponse {
  tasks: ConnectorKbAnnotationDisplayTaskTuple[]
}

export interface RepoMetadataRequest {
  userId: number
  orgId: number
  codeContext: CodeContext | undefined
  platform: IntegrationPlatform
  includeSuggestedVmArgs: boolean
}

export interface GetEndSystemSchemaInfoRequest {
  userId: number
  orgId: number
  codeContext: CodeContext | undefined
  platform: IntegrationPlatform
  flowNames: string[]
  includeSuggestedSchemaInfo: boolean
}

export interface SuggestedEndSystemInfo {
  systemObjectName: string
  suggestedSchemaInfo: string
}

export interface GetEndSystemSchemaInfoResponse {
  suggestedEndSystemInfo: SuggestedEndSystemInfo[]
}

export interface StringList {
  values: string[]
}

export interface RepoMetadataResponse {
  muleAllFlowNames: string[]
  muleApiFlowNames: string[]
  muleEventFlowNames: string[]
  entities: { [key: string]: StringList }
  suggestedVmArgs: string
  suggestedMinMuleRuntimeVersion: string
  suggestedMvnVersion: string
  suggestedJavaVersion: string
  /** Platform detected from repo contents */
  detectedPlatform: IntegrationPlatform
}

export interface RepoMetadataResponse_EntitiesEntry {
  key: string
  value: StringList | undefined
}

/** Deletion request and response messages */
export interface DeleteRepoRequest {
  orgId: number
  orgName: string
  repoName: string
  /** optional, for local sync repos */
  localSyncUserId: string
  /** optional, for local sync repos */
  localSyncDeviceId: string
}

export interface DeleteRepoResponse {
  success: boolean
  errorMessage: string
}

export interface DeleteConversationRequest {
  /** Conversation UUID */
  uuid: string
}

export interface DeleteConversationResponse {
  success: boolean
  errorMessage: string
}

export interface DeleteWorkspaceRequest {
  orgId: number
}

export interface DeleteWorkspaceResponse {
  success: boolean
  errorMessage: string
}

export interface DeleteAllReposInConnectionRequest {
  orgId: number
  /** Valid values: "github", "bitbucket", "gitlab", "gitlab_custom", "azure_devops", "local_sync" */
  connType: string
  /** e.g., github org name, bitbucket workspace, local sync device id, etc. */
  connectionIdentifier: string
}

export interface DeleteAllReposInConnectionResponse {
  success: boolean
  errorMessage: string
}

export interface DeleteAccountRequest {
  userId: number
  orgId: number
}

export interface DeleteAccountResponse {
  success: boolean
  errorMessage: string
}

export interface KnowledgeBaseQueryRequest {
  query: string
  orgId: number
  userId: number
  platform: string
  apiTokenId: number
  surface: string
  requestId: string
}

export interface KnowledgeBaseQueryResponse {
  answer: string
}

export interface CancelTaskConversationRequest {
  taskId: number
  conversationId: number
}

export interface CancelTaskConversationResponse {
  isSuccess: boolean
  errMsg: string
}

function createBaseRadioButton(): RadioButton {
  return { label: '', value: '', rawData: '' }
}

export const RadioButton = {
  encode(message: RadioButton, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    if (message.rawData !== '') {
      writer.uint32(26).string(message.rawData)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RadioButton {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRadioButton()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.rawData = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RadioButton {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      rawData: isSet(object.rawData) ? globalThis.String(object.rawData) : ''
    }
  },

  toJSON(message: RadioButton): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.rawData !== '') {
      obj.rawData = message.rawData
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RadioButton>, I>>(base?: I): RadioButton {
    return RadioButton.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RadioButton>, I>>(object: I): RadioButton {
    const message = createBaseRadioButton()
    message.label = object.label ?? ''
    message.value = object.value ?? ''
    message.rawData = object.rawData ?? ''
    return message
  }
}

function createBaseRadioGroup(): RadioGroup {
  return { groupName: '', options: [], selectedValue: '', defaultSelectedValue: '', label: '' }
}

export const RadioGroup = {
  encode(message: RadioGroup, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.groupName !== '') {
      writer.uint32(10).string(message.groupName)
    }
    for (const v of message.options) {
      RadioButton.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    if (message.selectedValue !== '') {
      writer.uint32(26).string(message.selectedValue)
    }
    if (message.defaultSelectedValue !== '') {
      writer.uint32(34).string(message.defaultSelectedValue)
    }
    if (message.label !== '') {
      writer.uint32(42).string(message.label)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RadioGroup {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRadioGroup()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.groupName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.options.push(RadioButton.decode(reader, reader.uint32()))
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.selectedValue = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.defaultSelectedValue = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.label = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RadioGroup {
    return {
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : '',
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => RadioButton.fromJSON(e))
        : [],
      selectedValue: isSet(object.selectedValue) ? globalThis.String(object.selectedValue) : '',
      defaultSelectedValue: isSet(object.defaultSelectedValue)
        ? globalThis.String(object.defaultSelectedValue)
        : '',
      label: isSet(object.label) ? globalThis.String(object.label) : ''
    }
  },

  toJSON(message: RadioGroup): unknown {
    const obj: any = {}
    if (message.groupName !== '') {
      obj.groupName = message.groupName
    }
    if (message.options?.length) {
      obj.options = message.options.map(e => RadioButton.toJSON(e))
    }
    if (message.selectedValue !== '') {
      obj.selectedValue = message.selectedValue
    }
    if (message.defaultSelectedValue !== '') {
      obj.defaultSelectedValue = message.defaultSelectedValue
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RadioGroup>, I>>(base?: I): RadioGroup {
    return RadioGroup.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RadioGroup>, I>>(object: I): RadioGroup {
    const message = createBaseRadioGroup()
    message.groupName = object.groupName ?? ''
    message.options = object.options?.map(e => RadioButton.fromPartial(e)) || []
    message.selectedValue = object.selectedValue ?? ''
    message.defaultSelectedValue = object.defaultSelectedValue ?? ''
    message.label = object.label ?? ''
    return message
  }
}

function createBaseMultiSelectOption(): MultiSelectOption {
  return {
    fileName: '',
    plan: '',
    detailedPlan: '',
    fileChangeType: 0,
    label: '',
    value: '',
    rawData: ''
  }
}

export const MultiSelectOption = {
  encode(message: MultiSelectOption, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.fileName !== '') {
      writer.uint32(10).string(message.fileName)
    }
    if (message.plan !== '') {
      writer.uint32(18).string(message.plan)
    }
    if (message.detailedPlan !== '') {
      writer.uint32(26).string(message.detailedPlan)
    }
    if (message.fileChangeType !== 0) {
      writer.uint32(32).int32(message.fileChangeType)
    }
    if (message.label !== '') {
      writer.uint32(42).string(message.label)
    }
    if (message.value !== '') {
      writer.uint32(50).string(message.value)
    }
    if (message.rawData !== '') {
      writer.uint32(58).string(message.rawData)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MultiSelectOption {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMultiSelectOption()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.fileName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.plan = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.detailedPlan = reader.string()
          continue
        case 4:
          if (tag !== 32) {
            break
          }

          message.fileChangeType = reader.int32() as any
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.label = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.value = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.rawData = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MultiSelectOption {
    return {
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : '',
      plan: isSet(object.plan) ? globalThis.String(object.plan) : '',
      detailedPlan: isSet(object.detailedPlan) ? globalThis.String(object.detailedPlan) : '',
      fileChangeType: isSet(object.fileChangeType) ? diffTypeFromJSON(object.fileChangeType) : 0,
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      rawData: isSet(object.rawData) ? globalThis.String(object.rawData) : ''
    }
  },

  toJSON(message: MultiSelectOption): unknown {
    const obj: any = {}
    if (message.fileName !== '') {
      obj.fileName = message.fileName
    }
    if (message.plan !== '') {
      obj.plan = message.plan
    }
    if (message.detailedPlan !== '') {
      obj.detailedPlan = message.detailedPlan
    }
    if (message.fileChangeType !== 0) {
      obj.fileChangeType = diffTypeToJSON(message.fileChangeType)
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.rawData !== '') {
      obj.rawData = message.rawData
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MultiSelectOption>, I>>(base?: I): MultiSelectOption {
    return MultiSelectOption.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MultiSelectOption>, I>>(object: I): MultiSelectOption {
    const message = createBaseMultiSelectOption()
    message.fileName = object.fileName ?? ''
    message.plan = object.plan ?? ''
    message.detailedPlan = object.detailedPlan ?? ''
    message.fileChangeType = object.fileChangeType ?? 0
    message.label = object.label ?? ''
    message.value = object.value ?? ''
    message.rawData = object.rawData ?? ''
    return message
  }
}

function createBaseMultiSelect(): MultiSelect {
  return {
    groupName: '',
    options: [],
    selectedFileNames: [],
    selectedValues: [],
    label: '',
    defaultSelectedValues: []
  }
}

export const MultiSelect = {
  encode(message: MultiSelect, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.groupName !== '') {
      writer.uint32(10).string(message.groupName)
    }
    for (const v of message.options) {
      MultiSelectOption.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    for (const v of message.selectedFileNames) {
      writer.uint32(26).string(v!)
    }
    for (const v of message.selectedValues) {
      writer.uint32(34).string(v!)
    }
    if (message.label !== '') {
      writer.uint32(42).string(message.label)
    }
    for (const v of message.defaultSelectedValues) {
      writer.uint32(50).string(v!)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MultiSelect {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMultiSelect()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.groupName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.options.push(MultiSelectOption.decode(reader, reader.uint32()))
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.selectedFileNames.push(reader.string())
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.selectedValues.push(reader.string())
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.label = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.defaultSelectedValues.push(reader.string())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MultiSelect {
    return {
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : '',
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => MultiSelectOption.fromJSON(e))
        : [],
      selectedFileNames: globalThis.Array.isArray(object?.selectedFileNames)
        ? object.selectedFileNames.map((e: any) => globalThis.String(e))
        : [],
      selectedValues: globalThis.Array.isArray(object?.selectedValues)
        ? object.selectedValues.map((e: any) => globalThis.String(e))
        : [],
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      defaultSelectedValues: globalThis.Array.isArray(object?.defaultSelectedValues)
        ? object.defaultSelectedValues.map((e: any) => globalThis.String(e))
        : []
    }
  },

  toJSON(message: MultiSelect): unknown {
    const obj: any = {}
    if (message.groupName !== '') {
      obj.groupName = message.groupName
    }
    if (message.options?.length) {
      obj.options = message.options.map(e => MultiSelectOption.toJSON(e))
    }
    if (message.selectedFileNames?.length) {
      obj.selectedFileNames = message.selectedFileNames
    }
    if (message.selectedValues?.length) {
      obj.selectedValues = message.selectedValues
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.defaultSelectedValues?.length) {
      obj.defaultSelectedValues = message.defaultSelectedValues
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MultiSelect>, I>>(base?: I): MultiSelect {
    return MultiSelect.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MultiSelect>, I>>(object: I): MultiSelect {
    const message = createBaseMultiSelect()
    message.groupName = object.groupName ?? ''
    message.options = object.options?.map(e => MultiSelectOption.fromPartial(e)) || []
    message.selectedFileNames = object.selectedFileNames?.map(e => e) || []
    message.selectedValues = object.selectedValues?.map(e => e) || []
    message.label = object.label ?? ''
    message.defaultSelectedValues = object.defaultSelectedValues?.map(e => e) || []
    return message
  }
}

function createBaseTextBarInput(): TextBarInput {
  return { groupName: '', label: '', input: '', hintText: '' }
}

export const TextBarInput = {
  encode(message: TextBarInput, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.groupName !== '') {
      writer.uint32(10).string(message.groupName)
    }
    if (message.label !== '') {
      writer.uint32(18).string(message.label)
    }
    if (message.input !== '') {
      writer.uint32(26).string(message.input)
    }
    if (message.hintText !== '') {
      writer.uint32(34).string(message.hintText)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TextBarInput {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTextBarInput()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.groupName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.label = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.input = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.hintText = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TextBarInput {
    return {
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : '',
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      input: isSet(object.input) ? globalThis.String(object.input) : '',
      hintText: isSet(object.hintText) ? globalThis.String(object.hintText) : ''
    }
  },

  toJSON(message: TextBarInput): unknown {
    const obj: any = {}
    if (message.groupName !== '') {
      obj.groupName = message.groupName
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.input !== '') {
      obj.input = message.input
    }
    if (message.hintText !== '') {
      obj.hintText = message.hintText
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TextBarInput>, I>>(base?: I): TextBarInput {
    return TextBarInput.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TextBarInput>, I>>(object: I): TextBarInput {
    const message = createBaseTextBarInput()
    message.groupName = object.groupName ?? ''
    message.label = object.label ?? ''
    message.input = object.input ?? ''
    message.hintText = object.hintText ?? ''
    return message
  }
}

function createBaseListSelectOption(): ListSelectOption {
  return { label: '', value: '', rawData: '' }
}

export const ListSelectOption = {
  encode(message: ListSelectOption, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    if (message.rawData !== '') {
      writer.uint32(26).string(message.rawData)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ListSelectOption {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListSelectOption()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.rawData = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListSelectOption {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      rawData: isSet(object.rawData) ? globalThis.String(object.rawData) : ''
    }
  },

  toJSON(message: ListSelectOption): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.rawData !== '') {
      obj.rawData = message.rawData
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListSelectOption>, I>>(base?: I): ListSelectOption {
    return ListSelectOption.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListSelectOption>, I>>(object: I): ListSelectOption {
    const message = createBaseListSelectOption()
    message.label = object.label ?? ''
    message.value = object.value ?? ''
    message.rawData = object.rawData ?? ''
    return message
  }
}

function createBaseListSelect(): ListSelect {
  return { groupName: '', options: [], selectedValue: '', defaultSelectedValue: '', label: '' }
}

export const ListSelect = {
  encode(message: ListSelect, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.groupName !== '') {
      writer.uint32(10).string(message.groupName)
    }
    for (const v of message.options) {
      ListSelectOption.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    if (message.selectedValue !== '') {
      writer.uint32(26).string(message.selectedValue)
    }
    if (message.defaultSelectedValue !== '') {
      writer.uint32(34).string(message.defaultSelectedValue)
    }
    if (message.label !== '') {
      writer.uint32(42).string(message.label)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ListSelect {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseListSelect()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.groupName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.options.push(ListSelectOption.decode(reader, reader.uint32()))
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.selectedValue = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.defaultSelectedValue = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.label = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ListSelect {
    return {
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : '',
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => ListSelectOption.fromJSON(e))
        : [],
      selectedValue: isSet(object.selectedValue) ? globalThis.String(object.selectedValue) : '',
      defaultSelectedValue: isSet(object.defaultSelectedValue)
        ? globalThis.String(object.defaultSelectedValue)
        : '',
      label: isSet(object.label) ? globalThis.String(object.label) : ''
    }
  },

  toJSON(message: ListSelect): unknown {
    const obj: any = {}
    if (message.groupName !== '') {
      obj.groupName = message.groupName
    }
    if (message.options?.length) {
      obj.options = message.options.map(e => ListSelectOption.toJSON(e))
    }
    if (message.selectedValue !== '') {
      obj.selectedValue = message.selectedValue
    }
    if (message.defaultSelectedValue !== '') {
      obj.defaultSelectedValue = message.defaultSelectedValue
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ListSelect>, I>>(base?: I): ListSelect {
    return ListSelect.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ListSelect>, I>>(object: I): ListSelect {
    const message = createBaseListSelect()
    message.groupName = object.groupName ?? ''
    message.options = object.options?.map(e => ListSelectOption.fromPartial(e)) || []
    message.selectedValue = object.selectedValue ?? ''
    message.defaultSelectedValue = object.defaultSelectedValue ?? ''
    message.label = object.label ?? ''
    return message
  }
}

function createBaseChatSelectionOption(): ChatSelectionOption {
  return { label: '', value: '', description: '' }
}

export const ChatSelectionOption = {
  encode(message: ChatSelectionOption, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.label !== '') {
      writer.uint32(10).string(message.label)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    if (message.description !== '') {
      writer.uint32(26).string(message.description)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChatSelectionOption {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChatSelectionOption()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.label = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.description = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChatSelectionOption {
    return {
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      description: isSet(object.description) ? globalThis.String(object.description) : ''
    }
  },

  toJSON(message: ChatSelectionOption): unknown {
    const obj: any = {}
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.description !== '') {
      obj.description = message.description
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChatSelectionOption>, I>>(base?: I): ChatSelectionOption {
    return ChatSelectionOption.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChatSelectionOption>, I>>(
    object: I
  ): ChatSelectionOption {
    const message = createBaseChatSelectionOption()
    message.label = object.label ?? ''
    message.value = object.value ?? ''
    message.description = object.description ?? ''
    return message
  }
}

function createBaseChatSelectionWidget(): ChatSelectionWidget {
  return {
    widgetId: '',
    selectionMode: 0,
    label: '',
    options: [],
    defaultSelectedValues: [],
    placeholder: '',
    inputPrefix: ''
  }
}

export const ChatSelectionWidget = {
  encode(message: ChatSelectionWidget, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.widgetId !== '') {
      writer.uint32(10).string(message.widgetId)
    }
    if (message.selectionMode !== 0) {
      writer.uint32(16).int32(message.selectionMode)
    }
    if (message.label !== '') {
      writer.uint32(26).string(message.label)
    }
    for (const v of message.options) {
      ChatSelectionOption.encode(v!, writer.uint32(34).fork()).ldelim()
    }
    for (const v of message.defaultSelectedValues) {
      writer.uint32(42).string(v!)
    }
    if (message.placeholder !== '') {
      writer.uint32(50).string(message.placeholder)
    }
    if (message.inputPrefix !== '') {
      writer.uint32(58).string(message.inputPrefix)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ChatSelectionWidget {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseChatSelectionWidget()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.widgetId = reader.string()
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.selectionMode = reader.int32() as any
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.label = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.options.push(ChatSelectionOption.decode(reader, reader.uint32()))
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.defaultSelectedValues.push(reader.string())
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.placeholder = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.inputPrefix = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ChatSelectionWidget {
    return {
      widgetId: isSet(object.widgetId) ? globalThis.String(object.widgetId) : '',
      selectionMode: isSet(object.selectionMode)
        ? chatSelectionModeFromJSON(object.selectionMode)
        : 0,
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => ChatSelectionOption.fromJSON(e))
        : [],
      defaultSelectedValues: globalThis.Array.isArray(object?.defaultSelectedValues)
        ? object.defaultSelectedValues.map((e: any) => globalThis.String(e))
        : [],
      placeholder: isSet(object.placeholder) ? globalThis.String(object.placeholder) : '',
      inputPrefix: isSet(object.inputPrefix) ? globalThis.String(object.inputPrefix) : ''
    }
  },

  toJSON(message: ChatSelectionWidget): unknown {
    const obj: any = {}
    if (message.widgetId !== '') {
      obj.widgetId = message.widgetId
    }
    if (message.selectionMode !== 0) {
      obj.selectionMode = chatSelectionModeToJSON(message.selectionMode)
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.options?.length) {
      obj.options = message.options.map(e => ChatSelectionOption.toJSON(e))
    }
    if (message.defaultSelectedValues?.length) {
      obj.defaultSelectedValues = message.defaultSelectedValues
    }
    if (message.placeholder !== '') {
      obj.placeholder = message.placeholder
    }
    if (message.inputPrefix !== '') {
      obj.inputPrefix = message.inputPrefix
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ChatSelectionWidget>, I>>(base?: I): ChatSelectionWidget {
    return ChatSelectionWidget.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ChatSelectionWidget>, I>>(
    object: I
  ): ChatSelectionWidget {
    const message = createBaseChatSelectionWidget()
    message.widgetId = object.widgetId ?? ''
    message.selectionMode = object.selectionMode ?? 0
    message.label = object.label ?? ''
    message.options = object.options?.map(e => ChatSelectionOption.fromPartial(e)) || []
    message.defaultSelectedValues = object.defaultSelectedValues?.map(e => e) || []
    message.placeholder = object.placeholder ?? ''
    message.inputPrefix = object.inputPrefix ?? ''
    return message
  }
}

function createBaseForm(): Form {
  return {
    groupName: '',
    formId: '',
    radioGroups: [],
    multiSelects: [],
    textBarInputs: [],
    listSelects: [],
    rawData: ''
  }
}

export const Form = {
  encode(message: Form, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.groupName !== '') {
      writer.uint32(10).string(message.groupName)
    }
    if (message.formId !== '') {
      writer.uint32(18).string(message.formId)
    }
    for (const v of message.radioGroups) {
      RadioGroup.encode(v!, writer.uint32(26).fork()).ldelim()
    }
    for (const v of message.multiSelects) {
      MultiSelect.encode(v!, writer.uint32(34).fork()).ldelim()
    }
    for (const v of message.textBarInputs) {
      TextBarInput.encode(v!, writer.uint32(42).fork()).ldelim()
    }
    for (const v of message.listSelects) {
      ListSelect.encode(v!, writer.uint32(50).fork()).ldelim()
    }
    if (message.rawData !== '') {
      writer.uint32(58).string(message.rawData)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Form {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseForm()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.groupName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.formId = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.radioGroups.push(RadioGroup.decode(reader, reader.uint32()))
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.multiSelects.push(MultiSelect.decode(reader, reader.uint32()))
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.textBarInputs.push(TextBarInput.decode(reader, reader.uint32()))
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.listSelects.push(ListSelect.decode(reader, reader.uint32()))
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.rawData = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Form {
    return {
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : '',
      formId: isSet(object.formId) ? globalThis.String(object.formId) : '',
      radioGroups: globalThis.Array.isArray(object?.radioGroups)
        ? object.radioGroups.map((e: any) => RadioGroup.fromJSON(e))
        : [],
      multiSelects: globalThis.Array.isArray(object?.multiSelects)
        ? object.multiSelects.map((e: any) => MultiSelect.fromJSON(e))
        : [],
      textBarInputs: globalThis.Array.isArray(object?.textBarInputs)
        ? object.textBarInputs.map((e: any) => TextBarInput.fromJSON(e))
        : [],
      listSelects: globalThis.Array.isArray(object?.listSelects)
        ? object.listSelects.map((e: any) => ListSelect.fromJSON(e))
        : [],
      rawData: isSet(object.rawData) ? globalThis.String(object.rawData) : ''
    }
  },

  toJSON(message: Form): unknown {
    const obj: any = {}
    if (message.groupName !== '') {
      obj.groupName = message.groupName
    }
    if (message.formId !== '') {
      obj.formId = message.formId
    }
    if (message.radioGroups?.length) {
      obj.radioGroups = message.radioGroups.map(e => RadioGroup.toJSON(e))
    }
    if (message.multiSelects?.length) {
      obj.multiSelects = message.multiSelects.map(e => MultiSelect.toJSON(e))
    }
    if (message.textBarInputs?.length) {
      obj.textBarInputs = message.textBarInputs.map(e => TextBarInput.toJSON(e))
    }
    if (message.listSelects?.length) {
      obj.listSelects = message.listSelects.map(e => ListSelect.toJSON(e))
    }
    if (message.rawData !== '') {
      obj.rawData = message.rawData
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Form>, I>>(base?: I): Form {
    return Form.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Form>, I>>(object: I): Form {
    const message = createBaseForm()
    message.groupName = object.groupName ?? ''
    message.formId = object.formId ?? ''
    message.radioGroups = object.radioGroups?.map(e => RadioGroup.fromPartial(e)) || []
    message.multiSelects = object.multiSelects?.map(e => MultiSelect.fromPartial(e)) || []
    message.textBarInputs = object.textBarInputs?.map(e => TextBarInput.fromPartial(e)) || []
    message.listSelects = object.listSelects?.map(e => ListSelect.fromPartial(e)) || []
    message.rawData = object.rawData ?? ''
    return message
  }
}

function createBaseFormWidget(): FormWidget {
  return {
    groupName: '',
    formId: '',
    radioGroups: [],
    multiSelects: [],
    textBarInputs: [],
    listSelects: [],
    rawData: '',
    label: ''
  }
}

export const FormWidget = {
  encode(message: FormWidget, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.groupName !== '') {
      writer.uint32(10).string(message.groupName)
    }
    if (message.formId !== '') {
      writer.uint32(18).string(message.formId)
    }
    for (const v of message.radioGroups) {
      RadioGroup.encode(v!, writer.uint32(26).fork()).ldelim()
    }
    for (const v of message.multiSelects) {
      MultiSelect.encode(v!, writer.uint32(34).fork()).ldelim()
    }
    for (const v of message.textBarInputs) {
      TextBarInput.encode(v!, writer.uint32(42).fork()).ldelim()
    }
    for (const v of message.listSelects) {
      ListSelect.encode(v!, writer.uint32(50).fork()).ldelim()
    }
    if (message.rawData !== '') {
      writer.uint32(58).string(message.rawData)
    }
    if (message.label !== '') {
      writer.uint32(66).string(message.label)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FormWidget {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFormWidget()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.groupName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.formId = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.radioGroups.push(RadioGroup.decode(reader, reader.uint32()))
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.multiSelects.push(MultiSelect.decode(reader, reader.uint32()))
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.textBarInputs.push(TextBarInput.decode(reader, reader.uint32()))
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.listSelects.push(ListSelect.decode(reader, reader.uint32()))
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.rawData = reader.string()
          continue
        case 8:
          if (tag !== 66) {
            break
          }

          message.label = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): FormWidget {
    return {
      groupName: isSet(object.groupName) ? globalThis.String(object.groupName) : '',
      formId: isSet(object.formId) ? globalThis.String(object.formId) : '',
      radioGroups: globalThis.Array.isArray(object?.radioGroups)
        ? object.radioGroups.map((e: any) => RadioGroup.fromJSON(e))
        : [],
      multiSelects: globalThis.Array.isArray(object?.multiSelects)
        ? object.multiSelects.map((e: any) => MultiSelect.fromJSON(e))
        : [],
      textBarInputs: globalThis.Array.isArray(object?.textBarInputs)
        ? object.textBarInputs.map((e: any) => TextBarInput.fromJSON(e))
        : [],
      listSelects: globalThis.Array.isArray(object?.listSelects)
        ? object.listSelects.map((e: any) => ListSelect.fromJSON(e))
        : [],
      rawData: isSet(object.rawData) ? globalThis.String(object.rawData) : '',
      label: isSet(object.label) ? globalThis.String(object.label) : ''
    }
  },

  toJSON(message: FormWidget): unknown {
    const obj: any = {}
    if (message.groupName !== '') {
      obj.groupName = message.groupName
    }
    if (message.formId !== '') {
      obj.formId = message.formId
    }
    if (message.radioGroups?.length) {
      obj.radioGroups = message.radioGroups.map(e => RadioGroup.toJSON(e))
    }
    if (message.multiSelects?.length) {
      obj.multiSelects = message.multiSelects.map(e => MultiSelect.toJSON(e))
    }
    if (message.textBarInputs?.length) {
      obj.textBarInputs = message.textBarInputs.map(e => TextBarInput.toJSON(e))
    }
    if (message.listSelects?.length) {
      obj.listSelects = message.listSelects.map(e => ListSelect.toJSON(e))
    }
    if (message.rawData !== '') {
      obj.rawData = message.rawData
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    return obj
  },

  create<I extends Exact<DeepPartial<FormWidget>, I>>(base?: I): FormWidget {
    return FormWidget.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<FormWidget>, I>>(object: I): FormWidget {
    const message = createBaseFormWidget()
    message.groupName = object.groupName ?? ''
    message.formId = object.formId ?? ''
    message.radioGroups = object.radioGroups?.map(e => RadioGroup.fromPartial(e)) || []
    message.multiSelects = object.multiSelects?.map(e => MultiSelect.fromPartial(e)) || []
    message.textBarInputs = object.textBarInputs?.map(e => TextBarInput.fromPartial(e)) || []
    message.listSelects = object.listSelects?.map(e => ListSelect.fromPartial(e)) || []
    message.rawData = object.rawData ?? ''
    message.label = object.label ?? ''
    return message
  }
}

function createBaseAgentInternalStatus(): AgentInternalStatus {
  return { agentInternalStatus: 0, agentInternalStatusMsg: '', internalProgressMsg: [] }
}

export const AgentInternalStatus = {
  encode(message: AgentInternalStatus, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.agentInternalStatus !== 0) {
      writer.uint32(8).int32(message.agentInternalStatus)
    }
    if (message.agentInternalStatusMsg !== '') {
      writer.uint32(18).string(message.agentInternalStatusMsg)
    }
    for (const v of message.internalProgressMsg) {
      writer.uint32(26).string(v!)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgentInternalStatus {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAgentInternalStatus()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.agentInternalStatus = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.agentInternalStatusMsg = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.internalProgressMsg.push(reader.string())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AgentInternalStatus {
    return {
      agentInternalStatus: isSet(object.agentInternalStatus)
        ? agentInternalEnumFromJSON(object.agentInternalStatus)
        : 0,
      agentInternalStatusMsg: isSet(object.agentInternalStatusMsg)
        ? globalThis.String(object.agentInternalStatusMsg)
        : '',
      internalProgressMsg: globalThis.Array.isArray(object?.internalProgressMsg)
        ? object.internalProgressMsg.map((e: any) => globalThis.String(e))
        : []
    }
  },

  toJSON(message: AgentInternalStatus): unknown {
    const obj: any = {}
    if (message.agentInternalStatus !== 0) {
      obj.agentInternalStatus = agentInternalEnumToJSON(message.agentInternalStatus)
    }
    if (message.agentInternalStatusMsg !== '') {
      obj.agentInternalStatusMsg = message.agentInternalStatusMsg
    }
    if (message.internalProgressMsg?.length) {
      obj.internalProgressMsg = message.internalProgressMsg
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AgentInternalStatus>, I>>(base?: I): AgentInternalStatus {
    return AgentInternalStatus.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AgentInternalStatus>, I>>(
    object: I
  ): AgentInternalStatus {
    const message = createBaseAgentInternalStatus()
    message.agentInternalStatus = object.agentInternalStatus ?? 0
    message.agentInternalStatusMsg = object.agentInternalStatusMsg ?? ''
    message.internalProgressMsg = object.internalProgressMsg?.map(e => e) || []
    return message
  }
}

function createBaseStep(): Step {
  return { stepDescription: '', mappingSheet: undefined }
}

export const Step = {
  encode(message: Step, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.stepDescription !== '') {
      writer.uint32(10).string(message.stepDescription)
    }
    if (message.mappingSheet !== undefined) {
      MappingSheet.encode(message.mappingSheet, writer.uint32(18).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Step {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseStep()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.stepDescription = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.mappingSheet = MappingSheet.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Step {
    return {
      stepDescription: isSet(object.stepDescription)
        ? globalThis.String(object.stepDescription)
        : '',
      mappingSheet: isSet(object.mappingSheet)
        ? MappingSheet.fromJSON(object.mappingSheet)
        : undefined
    }
  },

  toJSON(message: Step): unknown {
    const obj: any = {}
    if (message.stepDescription !== '') {
      obj.stepDescription = message.stepDescription
    }
    if (message.mappingSheet !== undefined) {
      obj.mappingSheet = MappingSheet.toJSON(message.mappingSheet)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Step>, I>>(base?: I): Step {
    return Step.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Step>, I>>(object: I): Step {
    const message = createBaseStep()
    message.stepDescription = object.stepDescription ?? ''
    message.mappingSheet =
      object.mappingSheet !== undefined && object.mappingSheet !== null
        ? MappingSheet.fromPartial(object.mappingSheet)
        : undefined
    return message
  }
}

function createBaseAddFlowSpec(): AddFlowSpec {
  return {
    base64EncodedSequenceDiagrams: [],
    description: '',
    systemDetails: '',
    messageProcessingSteps: [],
    generalComments: ''
  }
}

export const AddFlowSpec = {
  encode(message: AddFlowSpec, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.base64EncodedSequenceDiagrams) {
      writer.uint32(10).string(v!)
    }
    if (message.description !== '') {
      writer.uint32(18).string(message.description)
    }
    if (message.systemDetails !== '') {
      writer.uint32(26).string(message.systemDetails)
    }
    for (const v of message.messageProcessingSteps) {
      Step.encode(v!, writer.uint32(34).fork()).ldelim()
    }
    if (message.generalComments !== '') {
      writer.uint32(42).string(message.generalComments)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AddFlowSpec {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAddFlowSpec()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.base64EncodedSequenceDiagrams.push(reader.string())
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.description = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.systemDetails = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.messageProcessingSteps.push(Step.decode(reader, reader.uint32()))
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.generalComments = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AddFlowSpec {
    return {
      base64EncodedSequenceDiagrams: globalThis.Array.isArray(object?.base64EncodedSequenceDiagrams)
        ? object.base64EncodedSequenceDiagrams.map((e: any) => globalThis.String(e))
        : [],
      description: isSet(object.description) ? globalThis.String(object.description) : '',
      systemDetails: isSet(object.systemDetails) ? globalThis.String(object.systemDetails) : '',
      messageProcessingSteps: globalThis.Array.isArray(object?.messageProcessingSteps)
        ? object.messageProcessingSteps.map((e: any) => Step.fromJSON(e))
        : [],
      generalComments: isSet(object.generalComments)
        ? globalThis.String(object.generalComments)
        : ''
    }
  },

  toJSON(message: AddFlowSpec): unknown {
    const obj: any = {}
    if (message.base64EncodedSequenceDiagrams?.length) {
      obj.base64EncodedSequenceDiagrams = message.base64EncodedSequenceDiagrams
    }
    if (message.description !== '') {
      obj.description = message.description
    }
    if (message.systemDetails !== '') {
      obj.systemDetails = message.systemDetails
    }
    if (message.messageProcessingSteps?.length) {
      obj.messageProcessingSteps = message.messageProcessingSteps.map(e => Step.toJSON(e))
    }
    if (message.generalComments !== '') {
      obj.generalComments = message.generalComments
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AddFlowSpec>, I>>(base?: I): AddFlowSpec {
    return AddFlowSpec.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AddFlowSpec>, I>>(object: I): AddFlowSpec {
    const message = createBaseAddFlowSpec()
    message.base64EncodedSequenceDiagrams = object.base64EncodedSequenceDiagrams?.map(e => e) || []
    message.description = object.description ?? ''
    message.systemDetails = object.systemDetails ?? ''
    message.messageProcessingSteps =
      object.messageProcessingSteps?.map(e => Step.fromPartial(e)) || []
    message.generalComments = object.generalComments ?? ''
    return message
  }
}

function createBaseImage(): Image {
  return { imageExtension: '', imageBase64Content: '' }
}

export const Image = {
  encode(message: Image, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.imageExtension !== '') {
      writer.uint32(10).string(message.imageExtension)
    }
    if (message.imageBase64Content !== '') {
      writer.uint32(18).string(message.imageBase64Content)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Image {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseImage()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.imageExtension = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.imageBase64Content = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Image {
    return {
      imageExtension: isSet(object.imageExtension) ? globalThis.String(object.imageExtension) : '',
      imageBase64Content: isSet(object.imageBase64Content)
        ? globalThis.String(object.imageBase64Content)
        : ''
    }
  },

  toJSON(message: Image): unknown {
    const obj: any = {}
    if (message.imageExtension !== '') {
      obj.imageExtension = message.imageExtension
    }
    if (message.imageBase64Content !== '') {
      obj.imageBase64Content = message.imageBase64Content
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Image>, I>>(base?: I): Image {
    return Image.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Image>, I>>(object: I): Image {
    const message = createBaseImage()
    message.imageExtension = object.imageExtension ?? ''
    message.imageBase64Content = object.imageBase64Content ?? ''
    return message
  }
}

function createBaseFileUpload(): FileUpload {
  return { fileName: '', fileS3Path: '' }
}

export const FileUpload = {
  encode(message: FileUpload, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.fileName !== '') {
      writer.uint32(10).string(message.fileName)
    }
    if (message.fileS3Path !== '') {
      writer.uint32(18).string(message.fileS3Path)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): FileUpload {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseFileUpload()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.fileName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.fileS3Path = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): FileUpload {
    return {
      fileName: isSet(object.fileName) ? globalThis.String(object.fileName) : '',
      fileS3Path: isSet(object.fileS3Path) ? globalThis.String(object.fileS3Path) : ''
    }
  },

  toJSON(message: FileUpload): unknown {
    const obj: any = {}
    if (message.fileName !== '') {
      obj.fileName = message.fileName
    }
    if (message.fileS3Path !== '') {
      obj.fileS3Path = message.fileS3Path
    }
    return obj
  },

  create<I extends Exact<DeepPartial<FileUpload>, I>>(base?: I): FileUpload {
    return FileUpload.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<FileUpload>, I>>(object: I): FileUpload {
    const message = createBaseFileUpload()
    message.fileName = object.fileName ?? ''
    message.fileS3Path = object.fileS3Path ?? ''
    return message
  }
}

function createBaseDirectoryUpload(): DirectoryUpload {
  return { directoryName: '', directoryS3Path: '' }
}

export const DirectoryUpload = {
  encode(message: DirectoryUpload, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.directoryName !== '') {
      writer.uint32(10).string(message.directoryName)
    }
    if (message.directoryS3Path !== '') {
      writer.uint32(18).string(message.directoryS3Path)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DirectoryUpload {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDirectoryUpload()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.directoryName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.directoryS3Path = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DirectoryUpload {
    return {
      directoryName: isSet(object.directoryName) ? globalThis.String(object.directoryName) : '',
      directoryS3Path: isSet(object.directoryS3Path)
        ? globalThis.String(object.directoryS3Path)
        : ''
    }
  },

  toJSON(message: DirectoryUpload): unknown {
    const obj: any = {}
    if (message.directoryName !== '') {
      obj.directoryName = message.directoryName
    }
    if (message.directoryS3Path !== '') {
      obj.directoryS3Path = message.directoryS3Path
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DirectoryUpload>, I>>(base?: I): DirectoryUpload {
    return DirectoryUpload.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DirectoryUpload>, I>>(object: I): DirectoryUpload {
    const message = createBaseDirectoryUpload()
    message.directoryName = object.directoryName ?? ''
    message.directoryS3Path = object.directoryS3Path ?? ''
    return message
  }
}

function createBaseContextUpload(): ContextUpload {
  return { instructions: '', files: [], directories: [] }
}

export const ContextUpload = {
  encode(message: ContextUpload, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.instructions !== '') {
      writer.uint32(10).string(message.instructions)
    }
    for (const v of message.files) {
      FileUpload.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    for (const v of message.directories) {
      DirectoryUpload.encode(v!, writer.uint32(26).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ContextUpload {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseContextUpload()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.instructions = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.files.push(FileUpload.decode(reader, reader.uint32()))
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.directories.push(DirectoryUpload.decode(reader, reader.uint32()))
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ContextUpload {
    return {
      instructions: isSet(object.instructions) ? globalThis.String(object.instructions) : '',
      files: globalThis.Array.isArray(object?.files)
        ? object.files.map((e: any) => FileUpload.fromJSON(e))
        : [],
      directories: globalThis.Array.isArray(object?.directories)
        ? object.directories.map((e: any) => DirectoryUpload.fromJSON(e))
        : []
    }
  },

  toJSON(message: ContextUpload): unknown {
    const obj: any = {}
    if (message.instructions !== '') {
      obj.instructions = message.instructions
    }
    if (message.files?.length) {
      obj.files = message.files.map(e => FileUpload.toJSON(e))
    }
    if (message.directories?.length) {
      obj.directories = message.directories.map(e => DirectoryUpload.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ContextUpload>, I>>(base?: I): ContextUpload {
    return ContextUpload.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ContextUpload>, I>>(object: I): ContextUpload {
    const message = createBaseContextUpload()
    message.instructions = object.instructions ?? ''
    message.files = object.files?.map(e => FileUpload.fromPartial(e)) || []
    message.directories = object.directories?.map(e => DirectoryUpload.fromPartial(e)) || []
    return message
  }
}

function createBaseEnv(): Env {
  return { url: '', envType: 0 }
}

export const Env = {
  encode(message: Env, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.url !== '') {
      writer.uint32(10).string(message.url)
    }
    if (message.envType !== 0) {
      writer.uint32(16).int32(message.envType)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Env {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEnv()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.url = reader.string()
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.envType = reader.int32() as any
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Env {
    return {
      url: isSet(object.url) ? globalThis.String(object.url) : '',
      envType: isSet(object.envType) ? envTypeFromJSON(object.envType) : 0
    }
  },

  toJSON(message: Env): unknown {
    const obj: any = {}
    if (message.url !== '') {
      obj.url = message.url
    }
    if (message.envType !== 0) {
      obj.envType = envTypeToJSON(message.envType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Env>, I>>(base?: I): Env {
    return Env.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Env>, I>>(object: I): Env {
    const message = createBaseEnv()
    message.url = object.url ?? ''
    message.envType = object.envType ?? 0
    return message
  }
}

function createBaseQuestionAskingInput(): QuestionAskingInput {
  return { questionAskingInputs: [] }
}

export const QuestionAskingInput = {
  encode(message: QuestionAskingInput, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.questionAskingInputs) {
      Block.encode(v!, writer.uint32(34).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): QuestionAskingInput {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseQuestionAskingInput()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 4:
          if (tag !== 34) {
            break
          }

          message.questionAskingInputs.push(Block.decode(reader, reader.uint32()))
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): QuestionAskingInput {
    return {
      questionAskingInputs: globalThis.Array.isArray(object?.questionAskingInputs)
        ? object.questionAskingInputs.map((e: any) => Block.fromJSON(e))
        : []
    }
  },

  toJSON(message: QuestionAskingInput): unknown {
    const obj: any = {}
    if (message.questionAskingInputs?.length) {
      obj.questionAskingInputs = message.questionAskingInputs.map(e => Block.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<QuestionAskingInput>, I>>(base?: I): QuestionAskingInput {
    return QuestionAskingInput.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<QuestionAskingInput>, I>>(
    object: I
  ): QuestionAskingInput {
    const message = createBaseQuestionAskingInput()
    message.questionAskingInputs = object.questionAskingInputs?.map(e => Block.fromPartial(e)) || []
    return message
  }
}

function createBaseIntegrationTestInputOutputExample(): IntegrationTestInputOutputExample {
  return { inputExample: '', outputExample: '' }
}

export const IntegrationTestInputOutputExample = {
  encode(
    message: IntegrationTestInputOutputExample,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.inputExample !== '') {
      writer.uint32(10).string(message.inputExample)
    }
    if (message.outputExample !== '') {
      writer.uint32(18).string(message.outputExample)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IntegrationTestInputOutputExample {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseIntegrationTestInputOutputExample()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.inputExample = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.outputExample = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): IntegrationTestInputOutputExample {
    return {
      inputExample: isSet(object.inputExample) ? globalThis.String(object.inputExample) : '',
      outputExample: isSet(object.outputExample) ? globalThis.String(object.outputExample) : ''
    }
  },

  toJSON(message: IntegrationTestInputOutputExample): unknown {
    const obj: any = {}
    if (message.inputExample !== '') {
      obj.inputExample = message.inputExample
    }
    if (message.outputExample !== '') {
      obj.outputExample = message.outputExample
    }
    return obj
  },

  create<I extends Exact<DeepPartial<IntegrationTestInputOutputExample>, I>>(
    base?: I
  ): IntegrationTestInputOutputExample {
    return IntegrationTestInputOutputExample.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<IntegrationTestInputOutputExample>, I>>(
    object: I
  ): IntegrationTestInputOutputExample {
    const message = createBaseIntegrationTestInputOutputExample()
    message.inputExample = object.inputExample ?? ''
    message.outputExample = object.outputExample ?? ''
    return message
  }
}

function createBaseIntegrationTestFlow(): IntegrationTestFlow {
  return { flowId: '', examples: [] }
}

export const IntegrationTestFlow = {
  encode(message: IntegrationTestFlow, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.flowId !== '') {
      writer.uint32(10).string(message.flowId)
    }
    for (const v of message.examples) {
      IntegrationTestInputOutputExample.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IntegrationTestFlow {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseIntegrationTestFlow()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.flowId = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.examples.push(IntegrationTestInputOutputExample.decode(reader, reader.uint32()))
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): IntegrationTestFlow {
    return {
      flowId: isSet(object.flowId) ? globalThis.String(object.flowId) : '',
      examples: globalThis.Array.isArray(object?.examples)
        ? object.examples.map((e: any) => IntegrationTestInputOutputExample.fromJSON(e))
        : []
    }
  },

  toJSON(message: IntegrationTestFlow): unknown {
    const obj: any = {}
    if (message.flowId !== '') {
      obj.flowId = message.flowId
    }
    if (message.examples?.length) {
      obj.examples = message.examples.map(e => IntegrationTestInputOutputExample.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<IntegrationTestFlow>, I>>(base?: I): IntegrationTestFlow {
    return IntegrationTestFlow.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<IntegrationTestFlow>, I>>(
    object: I
  ): IntegrationTestFlow {
    const message = createBaseIntegrationTestFlow()
    message.flowId = object.flowId ?? ''
    message.examples =
      object.examples?.map(e => IntegrationTestInputOutputExample.fromPartial(e)) || []
    return message
  }
}

function createBaseIntegrationTestConfig(): IntegrationTestConfig {
  return {
    flows: [],
    enableComparisonTesting: false,
    schemas: [],
    enableAutoGenerateTestData: false,
    deploymentUrl: ''
  }
}

export const IntegrationTestConfig = {
  encode(message: IntegrationTestConfig, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.flows) {
      IntegrationTestFlow.encode(v!, writer.uint32(10).fork()).ldelim()
    }
    if (message.enableComparisonTesting !== false) {
      writer.uint32(16).bool(message.enableComparisonTesting)
    }
    for (const v of message.schemas) {
      writer.uint32(26).string(v!)
    }
    if (message.enableAutoGenerateTestData !== false) {
      writer.uint32(32).bool(message.enableAutoGenerateTestData)
    }
    if (message.deploymentUrl !== '') {
      writer.uint32(42).string(message.deploymentUrl)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): IntegrationTestConfig {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseIntegrationTestConfig()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.flows.push(IntegrationTestFlow.decode(reader, reader.uint32()))
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.enableComparisonTesting = reader.bool()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.schemas.push(reader.string())
          continue
        case 4:
          if (tag !== 32) {
            break
          }

          message.enableAutoGenerateTestData = reader.bool()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.deploymentUrl = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): IntegrationTestConfig {
    return {
      flows: globalThis.Array.isArray(object?.flows)
        ? object.flows.map((e: any) => IntegrationTestFlow.fromJSON(e))
        : [],
      enableComparisonTesting: isSet(object.enableComparisonTesting)
        ? globalThis.Boolean(object.enableComparisonTesting)
        : false,
      schemas: globalThis.Array.isArray(object?.schemas)
        ? object.schemas.map((e: any) => globalThis.String(e))
        : [],
      enableAutoGenerateTestData: isSet(object.enableAutoGenerateTestData)
        ? globalThis.Boolean(object.enableAutoGenerateTestData)
        : false,
      deploymentUrl: isSet(object.deploymentUrl) ? globalThis.String(object.deploymentUrl) : ''
    }
  },

  toJSON(message: IntegrationTestConfig): unknown {
    const obj: any = {}
    if (message.flows?.length) {
      obj.flows = message.flows.map(e => IntegrationTestFlow.toJSON(e))
    }
    if (message.enableComparisonTesting !== false) {
      obj.enableComparisonTesting = message.enableComparisonTesting
    }
    if (message.schemas?.length) {
      obj.schemas = message.schemas
    }
    if (message.enableAutoGenerateTestData !== false) {
      obj.enableAutoGenerateTestData = message.enableAutoGenerateTestData
    }
    if (message.deploymentUrl !== '') {
      obj.deploymentUrl = message.deploymentUrl
    }
    return obj
  },

  create<I extends Exact<DeepPartial<IntegrationTestConfig>, I>>(base?: I): IntegrationTestConfig {
    return IntegrationTestConfig.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<IntegrationTestConfig>, I>>(
    object: I
  ): IntegrationTestConfig {
    const message = createBaseIntegrationTestConfig()
    message.flows = object.flows?.map(e => IntegrationTestFlow.fromPartial(e)) || []
    message.enableComparisonTesting = object.enableComparisonTesting ?? false
    message.schemas = object.schemas?.map(e => e) || []
    message.enableAutoGenerateTestData = object.enableAutoGenerateTestData ?? false
    message.deploymentUrl = object.deploymentUrl ?? ''
    return message
  }
}

function createBaseProgressMessageTodoListMsg(): ProgressMessageTodoListMsg {
  return { todo: '', status: 0 }
}

export const ProgressMessageTodoListMsg = {
  encode(
    message: ProgressMessageTodoListMsg,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.todo !== '') {
      writer.uint32(10).string(message.todo)
    }
    if (message.status !== 0) {
      writer.uint32(16).int32(message.status)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ProgressMessageTodoListMsg {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseProgressMessageTodoListMsg()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.todo = reader.string()
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.status = reader.int32() as any
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ProgressMessageTodoListMsg {
    return {
      todo: isSet(object.todo) ? globalThis.String(object.todo) : '',
      status: isSet(object.status) ? progressMessageTodoListStatusFromJSON(object.status) : 0
    }
  },

  toJSON(message: ProgressMessageTodoListMsg): unknown {
    const obj: any = {}
    if (message.todo !== '') {
      obj.todo = message.todo
    }
    if (message.status !== 0) {
      obj.status = progressMessageTodoListStatusToJSON(message.status)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ProgressMessageTodoListMsg>, I>>(
    base?: I
  ): ProgressMessageTodoListMsg {
    return ProgressMessageTodoListMsg.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ProgressMessageTodoListMsg>, I>>(
    object: I
  ): ProgressMessageTodoListMsg {
    const message = createBaseProgressMessageTodoListMsg()
    message.todo = object.todo ?? ''
    message.status = object.status ?? 0
    return message
  }
}

function createBaseProgressMessage(): ProgressMessage {
  return {
    taskStatus: 0,
    messageType: 0,
    title: '',
    internalMsgs: [],
    toolOutputs: [],
    checkpointMsg: '',
    msgHash: '',
    createdTsNs: 0,
    preview: '',
    todoList: []
  }
}

export const ProgressMessage = {
  encode(message: ProgressMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.taskStatus !== 0) {
      writer.uint32(8).int32(message.taskStatus)
    }
    if (message.messageType !== 0) {
      writer.uint32(16).int32(message.messageType)
    }
    if (message.title !== '') {
      writer.uint32(26).string(message.title)
    }
    for (const v of message.internalMsgs) {
      writer.uint32(34).string(v!)
    }
    for (const v of message.toolOutputs) {
      writer.uint32(42).string(v!)
    }
    if (message.checkpointMsg !== '') {
      writer.uint32(50).string(message.checkpointMsg)
    }
    if (message.msgHash !== '') {
      writer.uint32(58).string(message.msgHash)
    }
    if (message.createdTsNs !== 0) {
      writer.uint32(64).int64(message.createdTsNs)
    }
    if (message.preview !== '') {
      writer.uint32(74).string(message.preview)
    }
    for (const v of message.todoList) {
      ProgressMessageTodoListMsg.encode(v!, writer.uint32(82).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ProgressMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseProgressMessage()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.taskStatus = reader.int32() as any
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.messageType = reader.int32() as any
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.title = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.internalMsgs.push(reader.string())
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.toolOutputs.push(reader.string())
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.checkpointMsg = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.msgHash = reader.string()
          continue
        case 8:
          if (tag !== 64) {
            break
          }

          message.createdTsNs = longToNumber(reader.int64() as Long)
          continue
        case 9:
          if (tag !== 74) {
            break
          }

          message.preview = reader.string()
          continue
        case 10:
          if (tag !== 82) {
            break
          }

          message.todoList.push(ProgressMessageTodoListMsg.decode(reader, reader.uint32()))
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ProgressMessage {
    return {
      taskStatus: isSet(object.taskStatus) ? agentTaskStatusFromJSON(object.taskStatus) : 0,
      messageType: isSet(object.messageType) ? progressMessageTypeFromJSON(object.messageType) : 0,
      title: isSet(object.title) ? globalThis.String(object.title) : '',
      internalMsgs: globalThis.Array.isArray(object?.internalMsgs)
        ? object.internalMsgs.map((e: any) => globalThis.String(e))
        : [],
      toolOutputs: globalThis.Array.isArray(object?.toolOutputs)
        ? object.toolOutputs.map((e: any) => globalThis.String(e))
        : [],
      checkpointMsg: isSet(object.checkpointMsg) ? globalThis.String(object.checkpointMsg) : '',
      msgHash: isSet(object.msgHash) ? globalThis.String(object.msgHash) : '',
      createdTsNs: isSet(object.createdTsNs) ? globalThis.Number(object.createdTsNs) : 0,
      preview: isSet(object.preview) ? globalThis.String(object.preview) : '',
      todoList: globalThis.Array.isArray(object?.todoList)
        ? object.todoList.map((e: any) => ProgressMessageTodoListMsg.fromJSON(e))
        : []
    }
  },

  toJSON(message: ProgressMessage): unknown {
    const obj: any = {}
    if (message.taskStatus !== 0) {
      obj.taskStatus = agentTaskStatusToJSON(message.taskStatus)
    }
    if (message.messageType !== 0) {
      obj.messageType = progressMessageTypeToJSON(message.messageType)
    }
    if (message.title !== '') {
      obj.title = message.title
    }
    if (message.internalMsgs?.length) {
      obj.internalMsgs = message.internalMsgs
    }
    if (message.toolOutputs?.length) {
      obj.toolOutputs = message.toolOutputs
    }
    if (message.checkpointMsg !== '') {
      obj.checkpointMsg = message.checkpointMsg
    }
    if (message.msgHash !== '') {
      obj.msgHash = message.msgHash
    }
    if (message.createdTsNs !== 0) {
      obj.createdTsNs = Math.round(message.createdTsNs)
    }
    if (message.preview !== '') {
      obj.preview = message.preview
    }
    if (message.todoList?.length) {
      obj.todoList = message.todoList.map(e => ProgressMessageTodoListMsg.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ProgressMessage>, I>>(base?: I): ProgressMessage {
    return ProgressMessage.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ProgressMessage>, I>>(object: I): ProgressMessage {
    const message = createBaseProgressMessage()
    message.taskStatus = object.taskStatus ?? 0
    message.messageType = object.messageType ?? 0
    message.title = object.title ?? ''
    message.internalMsgs = object.internalMsgs?.map(e => e) || []
    message.toolOutputs = object.toolOutputs?.map(e => e) || []
    message.checkpointMsg = object.checkpointMsg ?? ''
    message.msgHash = object.msgHash ?? ''
    message.createdTsNs = object.createdTsNs ?? 0
    message.preview = object.preview ?? ''
    message.todoList = object.todoList?.map(e => ProgressMessageTodoListMsg.fromPartial(e)) || []
    return message
  }
}

function createBaseAgentRequest(): AgentRequest {
  return {
    connectionType: 0,
    connectionDetail: undefined,
    command: undefined,
    metadata: undefined,
    isStream: false,
    jsonMetadata: '',
    userId: 0,
    diff: [],
    codePlan: undefined,
    form: [],
    document: undefined,
    munitScenarios: undefined,
    mappingSheet: [],
    sourceOutputExamples: [],
    diffComments: [],
    generalDiffComment: '',
    documentInlineComments: [],
    inputOutputNotes: '',
    orgId: 0,
    userName: '',
    addFlowSpec: undefined,
    deviceId: '',
    enableWebSearch: false,
    vmArgs: '',
    isCampaign: false,
    env: undefined,
    userNotes: '',
    migrationDocInput: undefined,
    dwlToInputOutputExample: undefined,
    uuid: '',
    munitNotes: '',
    runtimeSettings: undefined,
    qaType: 0,
    codeEnhancerTaskType: 0,
    questionAskingInput: undefined,
    munitNumScenarios: 0,
    munitEnableCoverage: false,
    agenticUiTesting: false,
    generateSeqDiag: false,
    generateFlowDiag: false,
    userSelectedEntities: {},
    apiSpecType: 0,
    runTests: false,
    selectedEndpoints: [],
    usageData: undefined,
    initConversationId: 0,
    megaQaTaskType: 0,
    runDeploy: false,
    refactorStartUserComments: undefined,
    landingPageAgentTrace: '',
    conversationId: 0,
    parentTaskId: 0,
    branchName: '',
    pluginContext: undefined,
    integrationTestConfig: undefined,
    oldRuntimeSettings: undefined,
    canvasContextInfo: [],
    platform: 0,
    requestFromApi: false,
    toPlatform: 0,
    isSpeechInput: false,
    migrationRiskReviewFeedback: undefined,
    migrationDeployInput: undefined
  }
}

export const AgentRequest = {
  encode(message: AgentRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.connectionType !== 0) {
      writer.uint32(8).int32(message.connectionType)
    }
    if (message.connectionDetail !== undefined) {
      ConnectionDetail.encode(message.connectionDetail, writer.uint32(18).fork()).ldelim()
    }
    if (message.command !== undefined) {
      Command.encode(message.command, writer.uint32(26).fork()).ldelim()
    }
    if (message.metadata !== undefined) {
      Metadata.encode(message.metadata, writer.uint32(34).fork()).ldelim()
    }
    if (message.isStream !== false) {
      writer.uint32(40).bool(message.isStream)
    }
    if (message.jsonMetadata !== '') {
      writer.uint32(50).string(message.jsonMetadata)
    }
    if (message.userId !== 0) {
      writer.uint32(56).int64(message.userId)
    }
    for (const v of message.diff) {
      Diff.encode(v!, writer.uint32(66).fork()).ldelim()
    }
    if (message.codePlan !== undefined) {
      CodePlan.encode(message.codePlan, writer.uint32(74).fork()).ldelim()
    }
    for (const v of message.form) {
      Form.encode(v!, writer.uint32(82).fork()).ldelim()
    }
    if (message.document !== undefined) {
      Documentation.encode(message.document, writer.uint32(98).fork()).ldelim()
    }
    if (message.munitScenarios !== undefined) {
      MunitScenarios.encode(message.munitScenarios, writer.uint32(106).fork()).ldelim()
    }
    for (const v of message.mappingSheet) {
      MappingSheet.encode(v!, writer.uint32(114).fork()).ldelim()
    }
    for (const v of message.sourceOutputExamples) {
      SourceOutputExamples.encode(v!, writer.uint32(122).fork()).ldelim()
    }
    for (const v of message.diffComments) {
      DiffComment.encode(v!, writer.uint32(130).fork()).ldelim()
    }
    if (message.generalDiffComment !== '') {
      writer.uint32(138).string(message.generalDiffComment)
    }
    for (const v of message.documentInlineComments) {
      DocumentInlineComment.encode(v!, writer.uint32(146).fork()).ldelim()
    }
    if (message.inputOutputNotes !== '') {
      writer.uint32(154).string(message.inputOutputNotes)
    }
    if (message.orgId !== 0) {
      writer.uint32(160).int64(message.orgId)
    }
    if (message.userName !== '') {
      writer.uint32(170).string(message.userName)
    }
    if (message.addFlowSpec !== undefined) {
      AddFlowSpec.encode(message.addFlowSpec, writer.uint32(178).fork()).ldelim()
    }
    if (message.deviceId !== '') {
      writer.uint32(186).string(message.deviceId)
    }
    if (message.enableWebSearch !== false) {
      writer.uint32(192).bool(message.enableWebSearch)
    }
    if (message.vmArgs !== '') {
      writer.uint32(202).string(message.vmArgs)
    }
    if (message.isCampaign !== false) {
      writer.uint32(208).bool(message.isCampaign)
    }
    if (message.env !== undefined) {
      Env.encode(message.env, writer.uint32(218).fork()).ldelim()
    }
    if (message.userNotes !== '') {
      writer.uint32(226).string(message.userNotes)
    }
    if (message.migrationDocInput !== undefined) {
      MigrationDocumentInput.encode(message.migrationDocInput, writer.uint32(234).fork()).ldelim()
    }
    if (message.dwlToInputOutputExample !== undefined) {
      DwlToInputOutputExample.encode(
        message.dwlToInputOutputExample,
        writer.uint32(242).fork()
      ).ldelim()
    }
    if (message.uuid !== '') {
      writer.uint32(250).string(message.uuid)
    }
    if (message.munitNotes !== '') {
      writer.uint32(258).string(message.munitNotes)
    }
    if (message.runtimeSettings !== undefined) {
      RuntimeSettings.encode(message.runtimeSettings, writer.uint32(266).fork()).ldelim()
    }
    if (message.qaType !== 0) {
      writer.uint32(272).int32(message.qaType)
    }
    if (message.codeEnhancerTaskType !== 0) {
      writer.uint32(280).int32(message.codeEnhancerTaskType)
    }
    if (message.questionAskingInput !== undefined) {
      QuestionAskingInput.encode(message.questionAskingInput, writer.uint32(290).fork()).ldelim()
    }
    if (message.munitNumScenarios !== 0) {
      writer.uint32(296).int64(message.munitNumScenarios)
    }
    if (message.munitEnableCoverage !== false) {
      writer.uint32(304).bool(message.munitEnableCoverage)
    }
    if (message.agenticUiTesting !== false) {
      writer.uint32(312).bool(message.agenticUiTesting)
    }
    if (message.generateSeqDiag !== false) {
      writer.uint32(320).bool(message.generateSeqDiag)
    }
    if (message.generateFlowDiag !== false) {
      writer.uint32(328).bool(message.generateFlowDiag)
    }
    Object.entries(message.userSelectedEntities).forEach(([key, value]) => {
      AgentRequest_UserSelectedEntitiesEntry.encode(
        { key: key as any, value },
        writer.uint32(338).fork()
      ).ldelim()
    })
    if (message.apiSpecType !== 0) {
      writer.uint32(344).int32(message.apiSpecType)
    }
    if (message.runTests !== false) {
      writer.uint32(352).bool(message.runTests)
    }
    for (const v of message.selectedEndpoints) {
      MigrationSelectedEndpoint.encode(v!, writer.uint32(362).fork()).ldelim()
    }
    if (message.usageData !== undefined) {
      UsageData.encode(message.usageData, writer.uint32(370).fork()).ldelim()
    }
    if (message.initConversationId !== 0) {
      writer.uint32(376).int64(message.initConversationId)
    }
    if (message.megaQaTaskType !== 0) {
      writer.uint32(384).int32(message.megaQaTaskType)
    }
    if (message.runDeploy !== false) {
      writer.uint32(392).bool(message.runDeploy)
    }
    if (message.refactorStartUserComments !== undefined) {
      RefactorStartUserComments.encode(
        message.refactorStartUserComments,
        writer.uint32(402).fork()
      ).ldelim()
    }
    if (message.landingPageAgentTrace !== '') {
      writer.uint32(410).string(message.landingPageAgentTrace)
    }
    if (message.conversationId !== 0) {
      writer.uint32(416).int64(message.conversationId)
    }
    if (message.parentTaskId !== 0) {
      writer.uint32(424).int64(message.parentTaskId)
    }
    if (message.branchName !== '') {
      writer.uint32(434).string(message.branchName)
    }
    if (message.pluginContext !== undefined) {
      PluginContext.encode(message.pluginContext, writer.uint32(442).fork()).ldelim()
    }
    if (message.integrationTestConfig !== undefined) {
      IntegrationTestConfig.encode(
        message.integrationTestConfig,
        writer.uint32(450).fork()
      ).ldelim()
    }
    if (message.oldRuntimeSettings !== undefined) {
      RuntimeSettings.encode(message.oldRuntimeSettings, writer.uint32(458).fork()).ldelim()
    }
    for (const v of message.canvasContextInfo) {
      CanvasContextInfo.encode(v!, writer.uint32(466).fork()).ldelim()
    }
    if (message.platform !== 0) {
      writer.uint32(472).int32(message.platform)
    }
    if (message.requestFromApi !== false) {
      writer.uint32(480).bool(message.requestFromApi)
    }
    if (message.toPlatform !== 0) {
      writer.uint32(488).int32(message.toPlatform)
    }
    if (message.isSpeechInput !== false) {
      writer.uint32(496).bool(message.isSpeechInput)
    }
    if (message.migrationRiskReviewFeedback !== undefined) {
      MigrationRiskReviewFeedback.encode(
        message.migrationRiskReviewFeedback,
        writer.uint32(506).fork()
      ).ldelim()
    }
    if (message.migrationDeployInput !== undefined) {
      MigrationDeployInput.encode(message.migrationDeployInput, writer.uint32(514).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgentRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAgentRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.connectionType = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.connectionDetail = ConnectionDetail.decode(reader, reader.uint32())
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.command = Command.decode(reader, reader.uint32())
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.metadata = Metadata.decode(reader, reader.uint32())
          continue
        case 5:
          if (tag !== 40) {
            break
          }

          message.isStream = reader.bool()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.jsonMetadata = reader.string()
          continue
        case 7:
          if (tag !== 56) {
            break
          }

          message.userId = longToNumber(reader.int64() as Long)
          continue
        case 8:
          if (tag !== 66) {
            break
          }

          message.diff.push(Diff.decode(reader, reader.uint32()))
          continue
        case 9:
          if (tag !== 74) {
            break
          }

          message.codePlan = CodePlan.decode(reader, reader.uint32())
          continue
        case 10:
          if (tag !== 82) {
            break
          }

          message.form.push(Form.decode(reader, reader.uint32()))
          continue
        case 12:
          if (tag !== 98) {
            break
          }

          message.document = Documentation.decode(reader, reader.uint32())
          continue
        case 13:
          if (tag !== 106) {
            break
          }

          message.munitScenarios = MunitScenarios.decode(reader, reader.uint32())
          continue
        case 14:
          if (tag !== 114) {
            break
          }

          message.mappingSheet.push(MappingSheet.decode(reader, reader.uint32()))
          continue
        case 15:
          if (tag !== 122) {
            break
          }

          message.sourceOutputExamples.push(SourceOutputExamples.decode(reader, reader.uint32()))
          continue
        case 16:
          if (tag !== 130) {
            break
          }

          message.diffComments.push(DiffComment.decode(reader, reader.uint32()))
          continue
        case 17:
          if (tag !== 138) {
            break
          }

          message.generalDiffComment = reader.string()
          continue
        case 18:
          if (tag !== 146) {
            break
          }

          message.documentInlineComments.push(DocumentInlineComment.decode(reader, reader.uint32()))
          continue
        case 19:
          if (tag !== 154) {
            break
          }

          message.inputOutputNotes = reader.string()
          continue
        case 20:
          if (tag !== 160) {
            break
          }

          message.orgId = longToNumber(reader.int64() as Long)
          continue
        case 21:
          if (tag !== 170) {
            break
          }

          message.userName = reader.string()
          continue
        case 22:
          if (tag !== 178) {
            break
          }

          message.addFlowSpec = AddFlowSpec.decode(reader, reader.uint32())
          continue
        case 23:
          if (tag !== 186) {
            break
          }

          message.deviceId = reader.string()
          continue
        case 24:
          if (tag !== 192) {
            break
          }

          message.enableWebSearch = reader.bool()
          continue
        case 25:
          if (tag !== 202) {
            break
          }

          message.vmArgs = reader.string()
          continue
        case 26:
          if (tag !== 208) {
            break
          }

          message.isCampaign = reader.bool()
          continue
        case 27:
          if (tag !== 218) {
            break
          }

          message.env = Env.decode(reader, reader.uint32())
          continue
        case 28:
          if (tag !== 226) {
            break
          }

          message.userNotes = reader.string()
          continue
        case 29:
          if (tag !== 234) {
            break
          }

          message.migrationDocInput = MigrationDocumentInput.decode(reader, reader.uint32())
          continue
        case 30:
          if (tag !== 242) {
            break
          }

          message.dwlToInputOutputExample = DwlToInputOutputExample.decode(reader, reader.uint32())
          continue
        case 31:
          if (tag !== 250) {
            break
          }

          message.uuid = reader.string()
          continue
        case 32:
          if (tag !== 258) {
            break
          }

          message.munitNotes = reader.string()
          continue
        case 33:
          if (tag !== 266) {
            break
          }

          message.runtimeSettings = RuntimeSettings.decode(reader, reader.uint32())
          continue
        case 34:
          if (tag !== 272) {
            break
          }

          message.qaType = reader.int32() as any
          continue
        case 35:
          if (tag !== 280) {
            break
          }

          message.codeEnhancerTaskType = reader.int32() as any
          continue
        case 36:
          if (tag !== 290) {
            break
          }

          message.questionAskingInput = QuestionAskingInput.decode(reader, reader.uint32())
          continue
        case 37:
          if (tag !== 296) {
            break
          }

          message.munitNumScenarios = longToNumber(reader.int64() as Long)
          continue
        case 38:
          if (tag !== 304) {
            break
          }

          message.munitEnableCoverage = reader.bool()
          continue
        case 39:
          if (tag !== 312) {
            break
          }

          message.agenticUiTesting = reader.bool()
          continue
        case 40:
          if (tag !== 320) {
            break
          }

          message.generateSeqDiag = reader.bool()
          continue
        case 41:
          if (tag !== 328) {
            break
          }

          message.generateFlowDiag = reader.bool()
          continue
        case 42:
          if (tag !== 338) {
            break
          }

          const entry42 = AgentRequest_UserSelectedEntitiesEntry.decode(reader, reader.uint32())
          if (entry42.value !== undefined) {
            message.userSelectedEntities[entry42.key] = entry42.value
          }
          continue
        case 43:
          if (tag !== 344) {
            break
          }

          message.apiSpecType = reader.int32() as any
          continue
        case 44:
          if (tag !== 352) {
            break
          }

          message.runTests = reader.bool()
          continue
        case 45:
          if (tag !== 362) {
            break
          }

          message.selectedEndpoints.push(MigrationSelectedEndpoint.decode(reader, reader.uint32()))
          continue
        case 46:
          if (tag !== 370) {
            break
          }

          message.usageData = UsageData.decode(reader, reader.uint32())
          continue
        case 47:
          if (tag !== 376) {
            break
          }

          message.initConversationId = longToNumber(reader.int64() as Long)
          continue
        case 48:
          if (tag !== 384) {
            break
          }

          message.megaQaTaskType = reader.int32() as any
          continue
        case 49:
          if (tag !== 392) {
            break
          }

          message.runDeploy = reader.bool()
          continue
        case 50:
          if (tag !== 402) {
            break
          }

          message.refactorStartUserComments = RefactorStartUserComments.decode(
            reader,
            reader.uint32()
          )
          continue
        case 51:
          if (tag !== 410) {
            break
          }

          message.landingPageAgentTrace = reader.string()
          continue
        case 52:
          if (tag !== 416) {
            break
          }

          message.conversationId = longToNumber(reader.int64() as Long)
          continue
        case 53:
          if (tag !== 424) {
            break
          }

          message.parentTaskId = longToNumber(reader.int64() as Long)
          continue
        case 54:
          if (tag !== 434) {
            break
          }

          message.branchName = reader.string()
          continue
        case 55:
          if (tag !== 442) {
            break
          }

          message.pluginContext = PluginContext.decode(reader, reader.uint32())
          continue
        case 56:
          if (tag !== 450) {
            break
          }

          message.integrationTestConfig = IntegrationTestConfig.decode(reader, reader.uint32())
          continue
        case 57:
          if (tag !== 458) {
            break
          }

          message.oldRuntimeSettings = RuntimeSettings.decode(reader, reader.uint32())
          continue
        case 58:
          if (tag !== 466) {
            break
          }

          message.canvasContextInfo.push(CanvasContextInfo.decode(reader, reader.uint32()))
          continue
        case 59:
          if (tag !== 472) {
            break
          }

          message.platform = reader.int32() as any
          continue
        case 60:
          if (tag !== 480) {
            break
          }

          message.requestFromApi = reader.bool()
          continue
        case 61:
          if (tag !== 488) {
            break
          }

          message.toPlatform = reader.int32() as any
          continue
        case 62:
          if (tag !== 496) {
            break
          }

          message.isSpeechInput = reader.bool()
          continue
        case 63:
          if (tag !== 506) {
            break
          }

          message.migrationRiskReviewFeedback = MigrationRiskReviewFeedback.decode(
            reader,
            reader.uint32()
          )
          continue
        case 64:
          if (tag !== 514) {
            break
          }

          message.migrationDeployInput = MigrationDeployInput.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AgentRequest {
    return {
      connectionType: isSet(object.connectionType)
        ? connectionTypeFromJSON(object.connectionType)
        : 0,
      connectionDetail: isSet(object.connectionDetail)
        ? ConnectionDetail.fromJSON(object.connectionDetail)
        : undefined,
      command: isSet(object.command) ? Command.fromJSON(object.command) : undefined,
      metadata: isSet(object.metadata) ? Metadata.fromJSON(object.metadata) : undefined,
      isStream: isSet(object.isStream) ? globalThis.Boolean(object.isStream) : false,
      jsonMetadata: isSet(object.jsonMetadata) ? globalThis.String(object.jsonMetadata) : '',
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      diff: globalThis.Array.isArray(object?.diff)
        ? object.diff.map((e: any) => Diff.fromJSON(e))
        : [],
      codePlan: isSet(object.codePlan) ? CodePlan.fromJSON(object.codePlan) : undefined,
      form: globalThis.Array.isArray(object?.form)
        ? object.form.map((e: any) => Form.fromJSON(e))
        : [],
      document: isSet(object.document) ? Documentation.fromJSON(object.document) : undefined,
      munitScenarios: isSet(object.munitScenarios)
        ? MunitScenarios.fromJSON(object.munitScenarios)
        : undefined,
      mappingSheet: globalThis.Array.isArray(object?.mappingSheet)
        ? object.mappingSheet.map((e: any) => MappingSheet.fromJSON(e))
        : [],
      sourceOutputExamples: globalThis.Array.isArray(object?.sourceOutputExamples)
        ? object.sourceOutputExamples.map((e: any) => SourceOutputExamples.fromJSON(e))
        : [],
      diffComments: globalThis.Array.isArray(object?.diffComments)
        ? object.diffComments.map((e: any) => DiffComment.fromJSON(e))
        : [],
      generalDiffComment: isSet(object.generalDiffComment)
        ? globalThis.String(object.generalDiffComment)
        : '',
      documentInlineComments: globalThis.Array.isArray(object?.documentInlineComments)
        ? object.documentInlineComments.map((e: any) => DocumentInlineComment.fromJSON(e))
        : [],
      inputOutputNotes: isSet(object.inputOutputNotes)
        ? globalThis.String(object.inputOutputNotes)
        : '',
      orgId: isSet(object.orgId) ? globalThis.Number(object.orgId) : 0,
      userName: isSet(object.userName) ? globalThis.String(object.userName) : '',
      addFlowSpec: isSet(object.addFlowSpec) ? AddFlowSpec.fromJSON(object.addFlowSpec) : undefined,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : '',
      enableWebSearch: isSet(object.enableWebSearch)
        ? globalThis.Boolean(object.enableWebSearch)
        : false,
      vmArgs: isSet(object.vmArgs) ? globalThis.String(object.vmArgs) : '',
      isCampaign: isSet(object.isCampaign) ? globalThis.Boolean(object.isCampaign) : false,
      env: isSet(object.env) ? Env.fromJSON(object.env) : undefined,
      userNotes: isSet(object.userNotes) ? globalThis.String(object.userNotes) : '',
      migrationDocInput: isSet(object.migrationDocInput)
        ? MigrationDocumentInput.fromJSON(object.migrationDocInput)
        : undefined,
      dwlToInputOutputExample: isSet(object.dwlToInputOutputExample)
        ? DwlToInputOutputExample.fromJSON(object.dwlToInputOutputExample)
        : undefined,
      uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : '',
      munitNotes: isSet(object.munitNotes) ? globalThis.String(object.munitNotes) : '',
      runtimeSettings: isSet(object.runtimeSettings)
        ? RuntimeSettings.fromJSON(object.runtimeSettings)
        : undefined,
      qaType: isSet(object.qaType) ? questionAnsweringTypeFromJSON(object.qaType) : 0,
      codeEnhancerTaskType: isSet(object.codeEnhancerTaskType)
        ? codeEnhancerTaskTypeFromJSON(object.codeEnhancerTaskType)
        : 0,
      questionAskingInput: isSet(object.questionAskingInput)
        ? QuestionAskingInput.fromJSON(object.questionAskingInput)
        : undefined,
      munitNumScenarios: isSet(object.munitNumScenarios)
        ? globalThis.Number(object.munitNumScenarios)
        : 0,
      munitEnableCoverage: isSet(object.munitEnableCoverage)
        ? globalThis.Boolean(object.munitEnableCoverage)
        : false,
      agenticUiTesting: isSet(object.agenticUiTesting)
        ? globalThis.Boolean(object.agenticUiTesting)
        : false,
      generateSeqDiag: isSet(object.generateSeqDiag)
        ? globalThis.Boolean(object.generateSeqDiag)
        : false,
      generateFlowDiag: isSet(object.generateFlowDiag)
        ? globalThis.Boolean(object.generateFlowDiag)
        : false,
      userSelectedEntities: isObject(object.userSelectedEntities)
        ? Object.entries(object.userSelectedEntities).reduce<{ [key: string]: StringList }>(
            (acc, [key, value]) => {
              acc[key] = StringList.fromJSON(value)
              return acc
            },
            {}
          )
        : {},
      apiSpecType: isSet(object.apiSpecType) ? apiSpecTypeFromJSON(object.apiSpecType) : 0,
      runTests: isSet(object.runTests) ? globalThis.Boolean(object.runTests) : false,
      selectedEndpoints: globalThis.Array.isArray(object?.selectedEndpoints)
        ? object.selectedEndpoints.map((e: any) => MigrationSelectedEndpoint.fromJSON(e))
        : [],
      usageData: isSet(object.usageData) ? UsageData.fromJSON(object.usageData) : undefined,
      initConversationId: isSet(object.initConversationId)
        ? globalThis.Number(object.initConversationId)
        : 0,
      megaQaTaskType: isSet(object.megaQaTaskType)
        ? megaQAgentTaskTypeFromJSON(object.megaQaTaskType)
        : 0,
      runDeploy: isSet(object.runDeploy) ? globalThis.Boolean(object.runDeploy) : false,
      refactorStartUserComments: isSet(object.refactorStartUserComments)
        ? RefactorStartUserComments.fromJSON(object.refactorStartUserComments)
        : undefined,
      landingPageAgentTrace: isSet(object.landingPageAgentTrace)
        ? globalThis.String(object.landingPageAgentTrace)
        : '',
      conversationId: isSet(object.conversationId) ? globalThis.Number(object.conversationId) : 0,
      parentTaskId: isSet(object.parentTaskId) ? globalThis.Number(object.parentTaskId) : 0,
      branchName: isSet(object.branchName) ? globalThis.String(object.branchName) : '',
      pluginContext: isSet(object.pluginContext)
        ? PluginContext.fromJSON(object.pluginContext)
        : undefined,
      integrationTestConfig: isSet(object.integrationTestConfig)
        ? IntegrationTestConfig.fromJSON(object.integrationTestConfig)
        : undefined,
      oldRuntimeSettings: isSet(object.oldRuntimeSettings)
        ? RuntimeSettings.fromJSON(object.oldRuntimeSettings)
        : undefined,
      canvasContextInfo: globalThis.Array.isArray(object?.canvasContextInfo)
        ? object.canvasContextInfo.map((e: any) => CanvasContextInfo.fromJSON(e))
        : [],
      platform: isSet(object.platform) ? integrationPlatformFromJSON(object.platform) : 0,
      requestFromApi: isSet(object.requestFromApi)
        ? globalThis.Boolean(object.requestFromApi)
        : false,
      toPlatform: isSet(object.toPlatform) ? integrationPlatformFromJSON(object.toPlatform) : 0,
      isSpeechInput: isSet(object.isSpeechInput) ? globalThis.Boolean(object.isSpeechInput) : false,
      migrationRiskReviewFeedback: isSet(object.migrationRiskReviewFeedback)
        ? MigrationRiskReviewFeedback.fromJSON(object.migrationRiskReviewFeedback)
        : undefined,
      migrationDeployInput: isSet(object.migrationDeployInput)
        ? MigrationDeployInput.fromJSON(object.migrationDeployInput)
        : undefined
    }
  },

  toJSON(message: AgentRequest): unknown {
    const obj: any = {}
    if (message.connectionType !== 0) {
      obj.connectionType = connectionTypeToJSON(message.connectionType)
    }
    if (message.connectionDetail !== undefined) {
      obj.connectionDetail = ConnectionDetail.toJSON(message.connectionDetail)
    }
    if (message.command !== undefined) {
      obj.command = Command.toJSON(message.command)
    }
    if (message.metadata !== undefined) {
      obj.metadata = Metadata.toJSON(message.metadata)
    }
    if (message.isStream !== false) {
      obj.isStream = message.isStream
    }
    if (message.jsonMetadata !== '') {
      obj.jsonMetadata = message.jsonMetadata
    }
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId)
    }
    if (message.diff?.length) {
      obj.diff = message.diff.map(e => Diff.toJSON(e))
    }
    if (message.codePlan !== undefined) {
      obj.codePlan = CodePlan.toJSON(message.codePlan)
    }
    if (message.form?.length) {
      obj.form = message.form.map(e => Form.toJSON(e))
    }
    if (message.document !== undefined) {
      obj.document = Documentation.toJSON(message.document)
    }
    if (message.munitScenarios !== undefined) {
      obj.munitScenarios = MunitScenarios.toJSON(message.munitScenarios)
    }
    if (message.mappingSheet?.length) {
      obj.mappingSheet = message.mappingSheet.map(e => MappingSheet.toJSON(e))
    }
    if (message.sourceOutputExamples?.length) {
      obj.sourceOutputExamples = message.sourceOutputExamples.map(e =>
        SourceOutputExamples.toJSON(e)
      )
    }
    if (message.diffComments?.length) {
      obj.diffComments = message.diffComments.map(e => DiffComment.toJSON(e))
    }
    if (message.generalDiffComment !== '') {
      obj.generalDiffComment = message.generalDiffComment
    }
    if (message.documentInlineComments?.length) {
      obj.documentInlineComments = message.documentInlineComments.map(e =>
        DocumentInlineComment.toJSON(e)
      )
    }
    if (message.inputOutputNotes !== '') {
      obj.inputOutputNotes = message.inputOutputNotes
    }
    if (message.orgId !== 0) {
      obj.orgId = Math.round(message.orgId)
    }
    if (message.userName !== '') {
      obj.userName = message.userName
    }
    if (message.addFlowSpec !== undefined) {
      obj.addFlowSpec = AddFlowSpec.toJSON(message.addFlowSpec)
    }
    if (message.deviceId !== '') {
      obj.deviceId = message.deviceId
    }
    if (message.enableWebSearch !== false) {
      obj.enableWebSearch = message.enableWebSearch
    }
    if (message.vmArgs !== '') {
      obj.vmArgs = message.vmArgs
    }
    if (message.isCampaign !== false) {
      obj.isCampaign = message.isCampaign
    }
    if (message.env !== undefined) {
      obj.env = Env.toJSON(message.env)
    }
    if (message.userNotes !== '') {
      obj.userNotes = message.userNotes
    }
    if (message.migrationDocInput !== undefined) {
      obj.migrationDocInput = MigrationDocumentInput.toJSON(message.migrationDocInput)
    }
    if (message.dwlToInputOutputExample !== undefined) {
      obj.dwlToInputOutputExample = DwlToInputOutputExample.toJSON(message.dwlToInputOutputExample)
    }
    if (message.uuid !== '') {
      obj.uuid = message.uuid
    }
    if (message.munitNotes !== '') {
      obj.munitNotes = message.munitNotes
    }
    if (message.runtimeSettings !== undefined) {
      obj.runtimeSettings = RuntimeSettings.toJSON(message.runtimeSettings)
    }
    if (message.qaType !== 0) {
      obj.qaType = questionAnsweringTypeToJSON(message.qaType)
    }
    if (message.codeEnhancerTaskType !== 0) {
      obj.codeEnhancerTaskType = codeEnhancerTaskTypeToJSON(message.codeEnhancerTaskType)
    }
    if (message.questionAskingInput !== undefined) {
      obj.questionAskingInput = QuestionAskingInput.toJSON(message.questionAskingInput)
    }
    if (message.munitNumScenarios !== 0) {
      obj.munitNumScenarios = Math.round(message.munitNumScenarios)
    }
    if (message.munitEnableCoverage !== false) {
      obj.munitEnableCoverage = message.munitEnableCoverage
    }
    if (message.agenticUiTesting !== false) {
      obj.agenticUiTesting = message.agenticUiTesting
    }
    if (message.generateSeqDiag !== false) {
      obj.generateSeqDiag = message.generateSeqDiag
    }
    if (message.generateFlowDiag !== false) {
      obj.generateFlowDiag = message.generateFlowDiag
    }
    if (message.userSelectedEntities) {
      const entries = Object.entries(message.userSelectedEntities)
      if (entries.length > 0) {
        obj.userSelectedEntities = {}
        entries.forEach(([k, v]) => {
          obj.userSelectedEntities[k] = StringList.toJSON(v)
        })
      }
    }
    if (message.apiSpecType !== 0) {
      obj.apiSpecType = apiSpecTypeToJSON(message.apiSpecType)
    }
    if (message.runTests !== false) {
      obj.runTests = message.runTests
    }
    if (message.selectedEndpoints?.length) {
      obj.selectedEndpoints = message.selectedEndpoints.map(e =>
        MigrationSelectedEndpoint.toJSON(e)
      )
    }
    if (message.usageData !== undefined) {
      obj.usageData = UsageData.toJSON(message.usageData)
    }
    if (message.initConversationId !== 0) {
      obj.initConversationId = Math.round(message.initConversationId)
    }
    if (message.megaQaTaskType !== 0) {
      obj.megaQaTaskType = megaQAgentTaskTypeToJSON(message.megaQaTaskType)
    }
    if (message.runDeploy !== false) {
      obj.runDeploy = message.runDeploy
    }
    if (message.refactorStartUserComments !== undefined) {
      obj.refactorStartUserComments = RefactorStartUserComments.toJSON(
        message.refactorStartUserComments
      )
    }
    if (message.landingPageAgentTrace !== '') {
      obj.landingPageAgentTrace = message.landingPageAgentTrace
    }
    if (message.conversationId !== 0) {
      obj.conversationId = Math.round(message.conversationId)
    }
    if (message.parentTaskId !== 0) {
      obj.parentTaskId = Math.round(message.parentTaskId)
    }
    if (message.branchName !== '') {
      obj.branchName = message.branchName
    }
    if (message.pluginContext !== undefined) {
      obj.pluginContext = PluginContext.toJSON(message.pluginContext)
    }
    if (message.integrationTestConfig !== undefined) {
      obj.integrationTestConfig = IntegrationTestConfig.toJSON(message.integrationTestConfig)
    }
    if (message.oldRuntimeSettings !== undefined) {
      obj.oldRuntimeSettings = RuntimeSettings.toJSON(message.oldRuntimeSettings)
    }
    if (message.canvasContextInfo?.length) {
      obj.canvasContextInfo = message.canvasContextInfo.map(e => CanvasContextInfo.toJSON(e))
    }
    if (message.platform !== 0) {
      obj.platform = integrationPlatformToJSON(message.platform)
    }
    if (message.requestFromApi !== false) {
      obj.requestFromApi = message.requestFromApi
    }
    if (message.toPlatform !== 0) {
      obj.toPlatform = integrationPlatformToJSON(message.toPlatform)
    }
    if (message.isSpeechInput !== false) {
      obj.isSpeechInput = message.isSpeechInput
    }
    if (message.migrationRiskReviewFeedback !== undefined) {
      obj.migrationRiskReviewFeedback = MigrationRiskReviewFeedback.toJSON(
        message.migrationRiskReviewFeedback
      )
    }
    if (message.migrationDeployInput !== undefined) {
      obj.migrationDeployInput = MigrationDeployInput.toJSON(message.migrationDeployInput)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AgentRequest>, I>>(base?: I): AgentRequest {
    return AgentRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AgentRequest>, I>>(object: I): AgentRequest {
    const message = createBaseAgentRequest()
    message.connectionType = object.connectionType ?? 0
    message.connectionDetail =
      object.connectionDetail !== undefined && object.connectionDetail !== null
        ? ConnectionDetail.fromPartial(object.connectionDetail)
        : undefined
    message.command =
      object.command !== undefined && object.command !== null
        ? Command.fromPartial(object.command)
        : undefined
    message.metadata =
      object.metadata !== undefined && object.metadata !== null
        ? Metadata.fromPartial(object.metadata)
        : undefined
    message.isStream = object.isStream ?? false
    message.jsonMetadata = object.jsonMetadata ?? ''
    message.userId = object.userId ?? 0
    message.diff = object.diff?.map(e => Diff.fromPartial(e)) || []
    message.codePlan =
      object.codePlan !== undefined && object.codePlan !== null
        ? CodePlan.fromPartial(object.codePlan)
        : undefined
    message.form = object.form?.map(e => Form.fromPartial(e)) || []
    message.document =
      object.document !== undefined && object.document !== null
        ? Documentation.fromPartial(object.document)
        : undefined
    message.munitScenarios =
      object.munitScenarios !== undefined && object.munitScenarios !== null
        ? MunitScenarios.fromPartial(object.munitScenarios)
        : undefined
    message.mappingSheet = object.mappingSheet?.map(e => MappingSheet.fromPartial(e)) || []
    message.sourceOutputExamples =
      object.sourceOutputExamples?.map(e => SourceOutputExamples.fromPartial(e)) || []
    message.diffComments = object.diffComments?.map(e => DiffComment.fromPartial(e)) || []
    message.generalDiffComment = object.generalDiffComment ?? ''
    message.documentInlineComments =
      object.documentInlineComments?.map(e => DocumentInlineComment.fromPartial(e)) || []
    message.inputOutputNotes = object.inputOutputNotes ?? ''
    message.orgId = object.orgId ?? 0
    message.userName = object.userName ?? ''
    message.addFlowSpec =
      object.addFlowSpec !== undefined && object.addFlowSpec !== null
        ? AddFlowSpec.fromPartial(object.addFlowSpec)
        : undefined
    message.deviceId = object.deviceId ?? ''
    message.enableWebSearch = object.enableWebSearch ?? false
    message.vmArgs = object.vmArgs ?? ''
    message.isCampaign = object.isCampaign ?? false
    message.env =
      object.env !== undefined && object.env !== null ? Env.fromPartial(object.env) : undefined
    message.userNotes = object.userNotes ?? ''
    message.migrationDocInput =
      object.migrationDocInput !== undefined && object.migrationDocInput !== null
        ? MigrationDocumentInput.fromPartial(object.migrationDocInput)
        : undefined
    message.dwlToInputOutputExample =
      object.dwlToInputOutputExample !== undefined && object.dwlToInputOutputExample !== null
        ? DwlToInputOutputExample.fromPartial(object.dwlToInputOutputExample)
        : undefined
    message.uuid = object.uuid ?? ''
    message.munitNotes = object.munitNotes ?? ''
    message.runtimeSettings =
      object.runtimeSettings !== undefined && object.runtimeSettings !== null
        ? RuntimeSettings.fromPartial(object.runtimeSettings)
        : undefined
    message.qaType = object.qaType ?? 0
    message.codeEnhancerTaskType = object.codeEnhancerTaskType ?? 0
    message.questionAskingInput =
      object.questionAskingInput !== undefined && object.questionAskingInput !== null
        ? QuestionAskingInput.fromPartial(object.questionAskingInput)
        : undefined
    message.munitNumScenarios = object.munitNumScenarios ?? 0
    message.munitEnableCoverage = object.munitEnableCoverage ?? false
    message.agenticUiTesting = object.agenticUiTesting ?? false
    message.generateSeqDiag = object.generateSeqDiag ?? false
    message.generateFlowDiag = object.generateFlowDiag ?? false
    message.userSelectedEntities = Object.entries(object.userSelectedEntities ?? {}).reduce<{
      [key: string]: StringList
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = StringList.fromPartial(value)
      }
      return acc
    }, {})
    message.apiSpecType = object.apiSpecType ?? 0
    message.runTests = object.runTests ?? false
    message.selectedEndpoints =
      object.selectedEndpoints?.map(e => MigrationSelectedEndpoint.fromPartial(e)) || []
    message.usageData =
      object.usageData !== undefined && object.usageData !== null
        ? UsageData.fromPartial(object.usageData)
        : undefined
    message.initConversationId = object.initConversationId ?? 0
    message.megaQaTaskType = object.megaQaTaskType ?? 0
    message.runDeploy = object.runDeploy ?? false
    message.refactorStartUserComments =
      object.refactorStartUserComments !== undefined && object.refactorStartUserComments !== null
        ? RefactorStartUserComments.fromPartial(object.refactorStartUserComments)
        : undefined
    message.landingPageAgentTrace = object.landingPageAgentTrace ?? ''
    message.conversationId = object.conversationId ?? 0
    message.parentTaskId = object.parentTaskId ?? 0
    message.branchName = object.branchName ?? ''
    message.pluginContext =
      object.pluginContext !== undefined && object.pluginContext !== null
        ? PluginContext.fromPartial(object.pluginContext)
        : undefined
    message.integrationTestConfig =
      object.integrationTestConfig !== undefined && object.integrationTestConfig !== null
        ? IntegrationTestConfig.fromPartial(object.integrationTestConfig)
        : undefined
    message.oldRuntimeSettings =
      object.oldRuntimeSettings !== undefined && object.oldRuntimeSettings !== null
        ? RuntimeSettings.fromPartial(object.oldRuntimeSettings)
        : undefined
    message.canvasContextInfo =
      object.canvasContextInfo?.map(e => CanvasContextInfo.fromPartial(e)) || []
    message.platform = object.platform ?? 0
    message.requestFromApi = object.requestFromApi ?? false
    message.toPlatform = object.toPlatform ?? 0
    message.isSpeechInput = object.isSpeechInput ?? false
    message.migrationRiskReviewFeedback =
      object.migrationRiskReviewFeedback !== undefined &&
      object.migrationRiskReviewFeedback !== null
        ? MigrationRiskReviewFeedback.fromPartial(object.migrationRiskReviewFeedback)
        : undefined
    message.migrationDeployInput =
      object.migrationDeployInput !== undefined && object.migrationDeployInput !== null
        ? MigrationDeployInput.fromPartial(object.migrationDeployInput)
        : undefined
    return message
  }
}

function createBaseAgentRequest_UserSelectedEntitiesEntry(): AgentRequest_UserSelectedEntitiesEntry {
  return { key: '', value: undefined }
}

export const AgentRequest_UserSelectedEntitiesEntry = {
  encode(
    message: AgentRequest_UserSelectedEntitiesEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== undefined) {
      StringList.encode(message.value, writer.uint32(18).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgentRequest_UserSelectedEntitiesEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAgentRequest_UserSelectedEntitiesEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.value = StringList.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AgentRequest_UserSelectedEntitiesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? StringList.fromJSON(object.value) : undefined
    }
  },

  toJSON(message: AgentRequest_UserSelectedEntitiesEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== undefined) {
      obj.value = StringList.toJSON(message.value)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AgentRequest_UserSelectedEntitiesEntry>, I>>(
    base?: I
  ): AgentRequest_UserSelectedEntitiesEntry {
    return AgentRequest_UserSelectedEntitiesEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AgentRequest_UserSelectedEntitiesEntry>, I>>(
    object: I
  ): AgentRequest_UserSelectedEntitiesEntry {
    const message = createBaseAgentRequest_UserSelectedEntitiesEntry()
    message.key = object.key ?? ''
    message.value =
      object.value !== undefined && object.value !== null
        ? StringList.fromPartial(object.value)
        : undefined
    return message
  }
}

function createBaseRuntimeSettings(): RuntimeSettings {
  return {
    javaVersion: '',
    mavenVersion: '',
    muleRuntimeVersion: '',
    settingsXmlRawTxt: '',
    settingsSecurityXmlRawTxt: ''
  }
}

export const RuntimeSettings = {
  encode(message: RuntimeSettings, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.javaVersion !== '') {
      writer.uint32(10).string(message.javaVersion)
    }
    if (message.mavenVersion !== '') {
      writer.uint32(18).string(message.mavenVersion)
    }
    if (message.muleRuntimeVersion !== '') {
      writer.uint32(26).string(message.muleRuntimeVersion)
    }
    if (message.settingsXmlRawTxt !== '') {
      writer.uint32(34).string(message.settingsXmlRawTxt)
    }
    if (message.settingsSecurityXmlRawTxt !== '') {
      writer.uint32(42).string(message.settingsSecurityXmlRawTxt)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RuntimeSettings {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRuntimeSettings()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.javaVersion = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.mavenVersion = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.muleRuntimeVersion = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.settingsXmlRawTxt = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.settingsSecurityXmlRawTxt = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RuntimeSettings {
    return {
      javaVersion: isSet(object.javaVersion) ? globalThis.String(object.javaVersion) : '',
      mavenVersion: isSet(object.mavenVersion) ? globalThis.String(object.mavenVersion) : '',
      muleRuntimeVersion: isSet(object.muleRuntimeVersion)
        ? globalThis.String(object.muleRuntimeVersion)
        : '',
      settingsXmlRawTxt: isSet(object.settingsXmlRawTxt)
        ? globalThis.String(object.settingsXmlRawTxt)
        : '',
      settingsSecurityXmlRawTxt: isSet(object.settingsSecurityXmlRawTxt)
        ? globalThis.String(object.settingsSecurityXmlRawTxt)
        : ''
    }
  },

  toJSON(message: RuntimeSettings): unknown {
    const obj: any = {}
    if (message.javaVersion !== '') {
      obj.javaVersion = message.javaVersion
    }
    if (message.mavenVersion !== '') {
      obj.mavenVersion = message.mavenVersion
    }
    if (message.muleRuntimeVersion !== '') {
      obj.muleRuntimeVersion = message.muleRuntimeVersion
    }
    if (message.settingsXmlRawTxt !== '') {
      obj.settingsXmlRawTxt = message.settingsXmlRawTxt
    }
    if (message.settingsSecurityXmlRawTxt !== '') {
      obj.settingsSecurityXmlRawTxt = message.settingsSecurityXmlRawTxt
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RuntimeSettings>, I>>(base?: I): RuntimeSettings {
    return RuntimeSettings.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RuntimeSettings>, I>>(object: I): RuntimeSettings {
    const message = createBaseRuntimeSettings()
    message.javaVersion = object.javaVersion ?? ''
    message.mavenVersion = object.mavenVersion ?? ''
    message.muleRuntimeVersion = object.muleRuntimeVersion ?? ''
    message.settingsXmlRawTxt = object.settingsXmlRawTxt ?? ''
    message.settingsSecurityXmlRawTxt = object.settingsSecurityXmlRawTxt ?? ''
    return message
  }
}

function createBaseDwlToInputOutputExample(): DwlToInputOutputExample {
  return { commandString: '', exampleType: 0 }
}

export const DwlToInputOutputExample = {
  encode(message: DwlToInputOutputExample, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.commandString !== '') {
      writer.uint32(10).string(message.commandString)
    }
    if (message.exampleType !== 0) {
      writer.uint32(16).int32(message.exampleType)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DwlToInputOutputExample {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDwlToInputOutputExample()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.commandString = reader.string()
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.exampleType = reader.int32() as any
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DwlToInputOutputExample {
    return {
      commandString: isSet(object.commandString) ? globalThis.String(object.commandString) : '',
      exampleType: isSet(object.exampleType)
        ? sourceOutputExampleTypeFromJSON(object.exampleType)
        : 0
    }
  },

  toJSON(message: DwlToInputOutputExample): unknown {
    const obj: any = {}
    if (message.commandString !== '') {
      obj.commandString = message.commandString
    }
    if (message.exampleType !== 0) {
      obj.exampleType = sourceOutputExampleTypeToJSON(message.exampleType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DwlToInputOutputExample>, I>>(
    base?: I
  ): DwlToInputOutputExample {
    return DwlToInputOutputExample.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DwlToInputOutputExample>, I>>(
    object: I
  ): DwlToInputOutputExample {
    const message = createBaseDwlToInputOutputExample()
    message.commandString = object.commandString ?? ''
    message.exampleType = object.exampleType ?? 0
    return message
  }
}

function createBaseValidatedInputOutputBlock(): ValidatedInputOutputBlock {
  return {
    type: 0,
    blockTitle: '',
    inputExample: '',
    inputValidationType: '',
    outputExample: '',
    outputValidationType: ''
  }
}

export const ValidatedInputOutputBlock = {
  encode(message: ValidatedInputOutputBlock, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type)
    }
    if (message.blockTitle !== '') {
      writer.uint32(18).string(message.blockTitle)
    }
    if (message.inputExample !== '') {
      writer.uint32(26).string(message.inputExample)
    }
    if (message.inputValidationType !== '') {
      writer.uint32(34).string(message.inputValidationType)
    }
    if (message.outputExample !== '') {
      writer.uint32(42).string(message.outputExample)
    }
    if (message.outputValidationType !== '') {
      writer.uint32(50).string(message.outputValidationType)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ValidatedInputOutputBlock {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseValidatedInputOutputBlock()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.type = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.blockTitle = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.inputExample = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.inputValidationType = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.outputExample = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.outputValidationType = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ValidatedInputOutputBlock {
    return {
      type: isSet(object.type) ? blockTypeFromJSON(object.type) : 0,
      blockTitle: isSet(object.blockTitle) ? globalThis.String(object.blockTitle) : '',
      inputExample: isSet(object.inputExample) ? globalThis.String(object.inputExample) : '',
      inputValidationType: isSet(object.inputValidationType)
        ? globalThis.String(object.inputValidationType)
        : '',
      outputExample: isSet(object.outputExample) ? globalThis.String(object.outputExample) : '',
      outputValidationType: isSet(object.outputValidationType)
        ? globalThis.String(object.outputValidationType)
        : ''
    }
  },

  toJSON(message: ValidatedInputOutputBlock): unknown {
    const obj: any = {}
    if (message.type !== 0) {
      obj.type = blockTypeToJSON(message.type)
    }
    if (message.blockTitle !== '') {
      obj.blockTitle = message.blockTitle
    }
    if (message.inputExample !== '') {
      obj.inputExample = message.inputExample
    }
    if (message.inputValidationType !== '') {
      obj.inputValidationType = message.inputValidationType
    }
    if (message.outputExample !== '') {
      obj.outputExample = message.outputExample
    }
    if (message.outputValidationType !== '') {
      obj.outputValidationType = message.outputValidationType
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ValidatedInputOutputBlock>, I>>(
    base?: I
  ): ValidatedInputOutputBlock {
    return ValidatedInputOutputBlock.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ValidatedInputOutputBlock>, I>>(
    object: I
  ): ValidatedInputOutputBlock {
    const message = createBaseValidatedInputOutputBlock()
    message.type = object.type ?? 0
    message.blockTitle = object.blockTitle ?? ''
    message.inputExample = object.inputExample ?? ''
    message.inputValidationType = object.inputValidationType ?? ''
    message.outputExample = object.outputExample ?? ''
    message.outputValidationType = object.outputValidationType ?? ''
    return message
  }
}

function createBaseAttachmentBlock(): AttachmentBlock {
  return { type: 0, blockTitle: '', attachmentUrl: '' }
}

export const AttachmentBlock = {
  encode(message: AttachmentBlock, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type)
    }
    if (message.blockTitle !== '') {
      writer.uint32(18).string(message.blockTitle)
    }
    if (message.attachmentUrl !== '') {
      writer.uint32(26).string(message.attachmentUrl)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AttachmentBlock {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAttachmentBlock()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.type = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.blockTitle = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.attachmentUrl = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AttachmentBlock {
    return {
      type: isSet(object.type) ? blockTypeFromJSON(object.type) : 0,
      blockTitle: isSet(object.blockTitle) ? globalThis.String(object.blockTitle) : '',
      attachmentUrl: isSet(object.attachmentUrl) ? globalThis.String(object.attachmentUrl) : ''
    }
  },

  toJSON(message: AttachmentBlock): unknown {
    const obj: any = {}
    if (message.type !== 0) {
      obj.type = blockTypeToJSON(message.type)
    }
    if (message.blockTitle !== '') {
      obj.blockTitle = message.blockTitle
    }
    if (message.attachmentUrl !== '') {
      obj.attachmentUrl = message.attachmentUrl
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AttachmentBlock>, I>>(base?: I): AttachmentBlock {
    return AttachmentBlock.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AttachmentBlock>, I>>(object: I): AttachmentBlock {
    const message = createBaseAttachmentBlock()
    message.type = object.type ?? 0
    message.blockTitle = object.blockTitle ?? ''
    message.attachmentUrl = object.attachmentUrl ?? ''
    return message
  }
}

function createBaseMultiSelectOptions(): MultiSelectOptions {
  return { type: 0, options: [], selectedOptions: [] }
}

export const MultiSelectOptions = {
  encode(message: MultiSelectOptions, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type)
    }
    for (const v of message.options) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.selectedOptions) {
      writer.uint32(26).string(v!)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MultiSelectOptions {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMultiSelectOptions()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.type = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.options.push(reader.string())
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.selectedOptions.push(reader.string())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MultiSelectOptions {
    return {
      type: isSet(object.type) ? blockTypeFromJSON(object.type) : 0,
      options: globalThis.Array.isArray(object?.options)
        ? object.options.map((e: any) => globalThis.String(e))
        : [],
      selectedOptions: globalThis.Array.isArray(object?.selectedOptions)
        ? object.selectedOptions.map((e: any) => globalThis.String(e))
        : []
    }
  },

  toJSON(message: MultiSelectOptions): unknown {
    const obj: any = {}
    if (message.type !== 0) {
      obj.type = blockTypeToJSON(message.type)
    }
    if (message.options?.length) {
      obj.options = message.options
    }
    if (message.selectedOptions?.length) {
      obj.selectedOptions = message.selectedOptions
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MultiSelectOptions>, I>>(base?: I): MultiSelectOptions {
    return MultiSelectOptions.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MultiSelectOptions>, I>>(object: I): MultiSelectOptions {
    const message = createBaseMultiSelectOptions()
    message.type = object.type ?? 0
    message.options = object.options?.map(e => e) || []
    message.selectedOptions = object.selectedOptions?.map(e => e) || []
    return message
  }
}

function createBaseTextBlockWithAttachment(): TextBlockWithAttachment {
  return {
    type: 0,
    text: '',
    base64EncodedImages: [],
    mappingSheets: [],
    multiSelectOptions: undefined
  }
}

export const TextBlockWithAttachment = {
  encode(message: TextBlockWithAttachment, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type)
    }
    if (message.text !== '') {
      writer.uint32(18).string(message.text)
    }
    for (const v of message.base64EncodedImages) {
      writer.uint32(26).string(v!)
    }
    for (const v of message.mappingSheets) {
      MappingSheet.encode(v!, writer.uint32(34).fork()).ldelim()
    }
    if (message.multiSelectOptions !== undefined) {
      MultiSelectOptions.encode(message.multiSelectOptions, writer.uint32(42).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TextBlockWithAttachment {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTextBlockWithAttachment()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.type = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.text = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.base64EncodedImages.push(reader.string())
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.mappingSheets.push(MappingSheet.decode(reader, reader.uint32()))
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.multiSelectOptions = MultiSelectOptions.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TextBlockWithAttachment {
    return {
      type: isSet(object.type) ? blockTypeFromJSON(object.type) : 0,
      text: isSet(object.text) ? globalThis.String(object.text) : '',
      base64EncodedImages: globalThis.Array.isArray(object?.base64EncodedImages)
        ? object.base64EncodedImages.map((e: any) => globalThis.String(e))
        : [],
      mappingSheets: globalThis.Array.isArray(object?.mappingSheets)
        ? object.mappingSheets.map((e: any) => MappingSheet.fromJSON(e))
        : [],
      multiSelectOptions: isSet(object.multiSelectOptions)
        ? MultiSelectOptions.fromJSON(object.multiSelectOptions)
        : undefined
    }
  },

  toJSON(message: TextBlockWithAttachment): unknown {
    const obj: any = {}
    if (message.type !== 0) {
      obj.type = blockTypeToJSON(message.type)
    }
    if (message.text !== '') {
      obj.text = message.text
    }
    if (message.base64EncodedImages?.length) {
      obj.base64EncodedImages = message.base64EncodedImages
    }
    if (message.mappingSheets?.length) {
      obj.mappingSheets = message.mappingSheets.map(e => MappingSheet.toJSON(e))
    }
    if (message.multiSelectOptions !== undefined) {
      obj.multiSelectOptions = MultiSelectOptions.toJSON(message.multiSelectOptions)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TextBlockWithAttachment>, I>>(
    base?: I
  ): TextBlockWithAttachment {
    return TextBlockWithAttachment.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TextBlockWithAttachment>, I>>(
    object: I
  ): TextBlockWithAttachment {
    const message = createBaseTextBlockWithAttachment()
    message.type = object.type ?? 0
    message.text = object.text ?? ''
    message.base64EncodedImages = object.base64EncodedImages?.map(e => e) || []
    message.mappingSheets = object.mappingSheets?.map(e => MappingSheet.fromPartial(e)) || []
    message.multiSelectOptions =
      object.multiSelectOptions !== undefined && object.multiSelectOptions !== null
        ? MultiSelectOptions.fromPartial(object.multiSelectOptions)
        : undefined
    return message
  }
}

function createBaseDropdownBlock(): DropdownBlock {
  return { type: 0, blockTitle: '', dropdownOptions: [], selectedOption: '' }
}

export const DropdownBlock = {
  encode(message: DropdownBlock, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type)
    }
    if (message.blockTitle !== '') {
      writer.uint32(18).string(message.blockTitle)
    }
    for (const v of message.dropdownOptions) {
      writer.uint32(26).string(v!)
    }
    if (message.selectedOption !== '') {
      writer.uint32(34).string(message.selectedOption)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DropdownBlock {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDropdownBlock()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.type = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.blockTitle = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.dropdownOptions.push(reader.string())
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.selectedOption = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DropdownBlock {
    return {
      type: isSet(object.type) ? blockTypeFromJSON(object.type) : 0,
      blockTitle: isSet(object.blockTitle) ? globalThis.String(object.blockTitle) : '',
      dropdownOptions: globalThis.Array.isArray(object?.dropdownOptions)
        ? object.dropdownOptions.map((e: any) => globalThis.String(e))
        : [],
      selectedOption: isSet(object.selectedOption) ? globalThis.String(object.selectedOption) : ''
    }
  },

  toJSON(message: DropdownBlock): unknown {
    const obj: any = {}
    if (message.type !== 0) {
      obj.type = blockTypeToJSON(message.type)
    }
    if (message.blockTitle !== '') {
      obj.blockTitle = message.blockTitle
    }
    if (message.dropdownOptions?.length) {
      obj.dropdownOptions = message.dropdownOptions
    }
    if (message.selectedOption !== '') {
      obj.selectedOption = message.selectedOption
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DropdownBlock>, I>>(base?: I): DropdownBlock {
    return DropdownBlock.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DropdownBlock>, I>>(object: I): DropdownBlock {
    const message = createBaseDropdownBlock()
    message.type = object.type ?? 0
    message.blockTitle = object.blockTitle ?? ''
    message.dropdownOptions = object.dropdownOptions?.map(e => e) || []
    message.selectedOption = object.selectedOption ?? ''
    return message
  }
}

function createBaseBlock(): Block {
  return {
    textBlockWithAttachment: undefined,
    dropdownBlock: undefined,
    validatedInputOutputBlock: undefined
  }
}

export const Block = {
  encode(message: Block, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.textBlockWithAttachment !== undefined) {
      TextBlockWithAttachment.encode(
        message.textBlockWithAttachment,
        writer.uint32(10).fork()
      ).ldelim()
    }
    if (message.dropdownBlock !== undefined) {
      DropdownBlock.encode(message.dropdownBlock, writer.uint32(18).fork()).ldelim()
    }
    if (message.validatedInputOutputBlock !== undefined) {
      ValidatedInputOutputBlock.encode(
        message.validatedInputOutputBlock,
        writer.uint32(26).fork()
      ).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Block {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseBlock()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.textBlockWithAttachment = TextBlockWithAttachment.decode(reader, reader.uint32())
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.dropdownBlock = DropdownBlock.decode(reader, reader.uint32())
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.validatedInputOutputBlock = ValidatedInputOutputBlock.decode(
            reader,
            reader.uint32()
          )
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Block {
    return {
      textBlockWithAttachment: isSet(object.textBlockWithAttachment)
        ? TextBlockWithAttachment.fromJSON(object.textBlockWithAttachment)
        : undefined,
      dropdownBlock: isSet(object.dropdownBlock)
        ? DropdownBlock.fromJSON(object.dropdownBlock)
        : undefined,
      validatedInputOutputBlock: isSet(object.validatedInputOutputBlock)
        ? ValidatedInputOutputBlock.fromJSON(object.validatedInputOutputBlock)
        : undefined
    }
  },

  toJSON(message: Block): unknown {
    const obj: any = {}
    if (message.textBlockWithAttachment !== undefined) {
      obj.textBlockWithAttachment = TextBlockWithAttachment.toJSON(message.textBlockWithAttachment)
    }
    if (message.dropdownBlock !== undefined) {
      obj.dropdownBlock = DropdownBlock.toJSON(message.dropdownBlock)
    }
    if (message.validatedInputOutputBlock !== undefined) {
      obj.validatedInputOutputBlock = ValidatedInputOutputBlock.toJSON(
        message.validatedInputOutputBlock
      )
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Block>, I>>(base?: I): Block {
    return Block.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Block>, I>>(object: I): Block {
    const message = createBaseBlock()
    message.textBlockWithAttachment =
      object.textBlockWithAttachment !== undefined && object.textBlockWithAttachment !== null
        ? TextBlockWithAttachment.fromPartial(object.textBlockWithAttachment)
        : undefined
    message.dropdownBlock =
      object.dropdownBlock !== undefined && object.dropdownBlock !== null
        ? DropdownBlock.fromPartial(object.dropdownBlock)
        : undefined
    message.validatedInputOutputBlock =
      object.validatedInputOutputBlock !== undefined && object.validatedInputOutputBlock !== null
        ? ValidatedInputOutputBlock.fromPartial(object.validatedInputOutputBlock)
        : undefined
    return message
  }
}

function createBaseQuestionAskingOutput(): QuestionAskingOutput {
  return { questionAskingInputs: [], finalSpecificationInputs: [] }
}

export const QuestionAskingOutput = {
  encode(message: QuestionAskingOutput, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.questionAskingInputs) {
      Block.encode(v!, writer.uint32(10).fork()).ldelim()
    }
    for (const v of message.finalSpecificationInputs) {
      Block.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): QuestionAskingOutput {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseQuestionAskingOutput()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.questionAskingInputs.push(Block.decode(reader, reader.uint32()))
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.finalSpecificationInputs.push(Block.decode(reader, reader.uint32()))
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): QuestionAskingOutput {
    return {
      questionAskingInputs: globalThis.Array.isArray(object?.questionAskingInputs)
        ? object.questionAskingInputs.map((e: any) => Block.fromJSON(e))
        : [],
      finalSpecificationInputs: globalThis.Array.isArray(object?.finalSpecificationInputs)
        ? object.finalSpecificationInputs.map((e: any) => Block.fromJSON(e))
        : []
    }
  },

  toJSON(message: QuestionAskingOutput): unknown {
    const obj: any = {}
    if (message.questionAskingInputs?.length) {
      obj.questionAskingInputs = message.questionAskingInputs.map(e => Block.toJSON(e))
    }
    if (message.finalSpecificationInputs?.length) {
      obj.finalSpecificationInputs = message.finalSpecificationInputs.map(e => Block.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<QuestionAskingOutput>, I>>(base?: I): QuestionAskingOutput {
    return QuestionAskingOutput.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<QuestionAskingOutput>, I>>(
    object: I
  ): QuestionAskingOutput {
    const message = createBaseQuestionAskingOutput()
    message.questionAskingInputs = object.questionAskingInputs?.map(e => Block.fromPartial(e)) || []
    message.finalSpecificationInputs =
      object.finalSpecificationInputs?.map(e => Block.fromPartial(e)) || []
    return message
  }
}

function createBaseResponseContentStream(): ResponseContentStream {
  return {
    messageType: 0,
    deltaContent: '',
    jsonMetadata: '',
    taskMetadata: '',
    diff: [],
    codePlan: undefined,
    form: [],
    document: undefined,
    munitScenarios: undefined,
    dataweaveOutput: undefined,
    agentInternalStatus: undefined,
    addFlowSpec: undefined,
    migrationDocOutput: undefined,
    questionAskingOutput: undefined,
    waitForResponseDeltaContent: '',
    taskId: 0,
    thinkingContent: '',
    formWidget: undefined,
    progressMessage: undefined,
    jsonMetadataS3Path: '',
    identifiedEndpoints: [],
    canvasData: [],
    coderSummary: undefined,
    assetIds: [],
    chatSelectionWidget: undefined,
    migrationDeployState: undefined
  }
}

export const ResponseContentStream = {
  encode(message: ResponseContentStream, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.messageType !== 0) {
      writer.uint32(8).int32(message.messageType)
    }
    if (message.deltaContent !== '') {
      writer.uint32(18).string(message.deltaContent)
    }
    if (message.jsonMetadata !== '') {
      writer.uint32(26).string(message.jsonMetadata)
    }
    if (message.taskMetadata !== '') {
      writer.uint32(34).string(message.taskMetadata)
    }
    for (const v of message.diff) {
      Diff.encode(v!, writer.uint32(42).fork()).ldelim()
    }
    if (message.codePlan !== undefined) {
      CodePlan.encode(message.codePlan, writer.uint32(50).fork()).ldelim()
    }
    for (const v of message.form) {
      Form.encode(v!, writer.uint32(82).fork()).ldelim()
    }
    if (message.document !== undefined) {
      Documentation.encode(message.document, writer.uint32(90).fork()).ldelim()
    }
    if (message.munitScenarios !== undefined) {
      MunitScenarios.encode(message.munitScenarios, writer.uint32(98).fork()).ldelim()
    }
    if (message.dataweaveOutput !== undefined) {
      DataWeaveGenCodeOutput.encode(message.dataweaveOutput, writer.uint32(106).fork()).ldelim()
    }
    if (message.agentInternalStatus !== undefined) {
      AgentInternalStatus.encode(message.agentInternalStatus, writer.uint32(114).fork()).ldelim()
    }
    if (message.addFlowSpec !== undefined) {
      AddFlowSpec.encode(message.addFlowSpec, writer.uint32(122).fork()).ldelim()
    }
    if (message.migrationDocOutput !== undefined) {
      MigrationDocumentOutput.encode(message.migrationDocOutput, writer.uint32(130).fork()).ldelim()
    }
    if (message.questionAskingOutput !== undefined) {
      QuestionAskingOutput.encode(message.questionAskingOutput, writer.uint32(138).fork()).ldelim()
    }
    if (message.waitForResponseDeltaContent !== '') {
      writer.uint32(146).string(message.waitForResponseDeltaContent)
    }
    if (message.taskId !== 0) {
      writer.uint32(152).int64(message.taskId)
    }
    if (message.thinkingContent !== '') {
      writer.uint32(162).string(message.thinkingContent)
    }
    if (message.formWidget !== undefined) {
      FormWidget.encode(message.formWidget, writer.uint32(170).fork()).ldelim()
    }
    if (message.progressMessage !== undefined) {
      ProgressMessage.encode(message.progressMessage, writer.uint32(178).fork()).ldelim()
    }
    if (message.jsonMetadataS3Path !== '') {
      writer.uint32(186).string(message.jsonMetadataS3Path)
    }
    for (const v of message.identifiedEndpoints) {
      MigrationSelectedEndpoint.encode(v!, writer.uint32(194).fork()).ldelim()
    }
    for (const v of message.canvasData) {
      CanvasData.encode(v!, writer.uint32(202).fork()).ldelim()
    }
    if (message.coderSummary !== undefined) {
      CoderSummary.encode(message.coderSummary, writer.uint32(210).fork()).ldelim()
    }
    for (const v of message.assetIds) {
      writer.uint32(218).string(v!)
    }
    if (message.chatSelectionWidget !== undefined) {
      ChatSelectionWidget.encode(message.chatSelectionWidget, writer.uint32(226).fork()).ldelim()
    }
    if (message.migrationDeployState !== undefined) {
      MigrationDeployState.encode(message.migrationDeployState, writer.uint32(234).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ResponseContentStream {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseResponseContentStream()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.messageType = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.deltaContent = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.jsonMetadata = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.taskMetadata = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.diff.push(Diff.decode(reader, reader.uint32()))
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.codePlan = CodePlan.decode(reader, reader.uint32())
          continue
        case 10:
          if (tag !== 82) {
            break
          }

          message.form.push(Form.decode(reader, reader.uint32()))
          continue
        case 11:
          if (tag !== 90) {
            break
          }

          message.document = Documentation.decode(reader, reader.uint32())
          continue
        case 12:
          if (tag !== 98) {
            break
          }

          message.munitScenarios = MunitScenarios.decode(reader, reader.uint32())
          continue
        case 13:
          if (tag !== 106) {
            break
          }

          message.dataweaveOutput = DataWeaveGenCodeOutput.decode(reader, reader.uint32())
          continue
        case 14:
          if (tag !== 114) {
            break
          }

          message.agentInternalStatus = AgentInternalStatus.decode(reader, reader.uint32())
          continue
        case 15:
          if (tag !== 122) {
            break
          }

          message.addFlowSpec = AddFlowSpec.decode(reader, reader.uint32())
          continue
        case 16:
          if (tag !== 130) {
            break
          }

          message.migrationDocOutput = MigrationDocumentOutput.decode(reader, reader.uint32())
          continue
        case 17:
          if (tag !== 138) {
            break
          }

          message.questionAskingOutput = QuestionAskingOutput.decode(reader, reader.uint32())
          continue
        case 18:
          if (tag !== 146) {
            break
          }

          message.waitForResponseDeltaContent = reader.string()
          continue
        case 19:
          if (tag !== 152) {
            break
          }

          message.taskId = longToNumber(reader.int64() as Long)
          continue
        case 20:
          if (tag !== 162) {
            break
          }

          message.thinkingContent = reader.string()
          continue
        case 21:
          if (tag !== 170) {
            break
          }

          message.formWidget = FormWidget.decode(reader, reader.uint32())
          continue
        case 22:
          if (tag !== 178) {
            break
          }

          message.progressMessage = ProgressMessage.decode(reader, reader.uint32())
          continue
        case 23:
          if (tag !== 186) {
            break
          }

          message.jsonMetadataS3Path = reader.string()
          continue
        case 24:
          if (tag !== 194) {
            break
          }

          message.identifiedEndpoints.push(
            MigrationSelectedEndpoint.decode(reader, reader.uint32())
          )
          continue
        case 25:
          if (tag !== 202) {
            break
          }

          message.canvasData.push(CanvasData.decode(reader, reader.uint32()))
          continue
        case 26:
          if (tag !== 210) {
            break
          }

          message.coderSummary = CoderSummary.decode(reader, reader.uint32())
          continue
        case 27:
          if (tag !== 218) {
            break
          }

          message.assetIds.push(reader.string())
          continue
        case 28:
          if (tag !== 226) {
            break
          }

          message.chatSelectionWidget = ChatSelectionWidget.decode(reader, reader.uint32())
          continue
        case 29:
          if (tag !== 234) {
            break
          }

          message.migrationDeployState = MigrationDeployState.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ResponseContentStream {
    return {
      messageType: isSet(object.messageType) ? messageTypeFromJSON(object.messageType) : 0,
      deltaContent: isSet(object.deltaContent) ? globalThis.String(object.deltaContent) : '',
      jsonMetadata: isSet(object.jsonMetadata) ? globalThis.String(object.jsonMetadata) : '',
      taskMetadata: isSet(object.taskMetadata) ? globalThis.String(object.taskMetadata) : '',
      diff: globalThis.Array.isArray(object?.diff)
        ? object.diff.map((e: any) => Diff.fromJSON(e))
        : [],
      codePlan: isSet(object.codePlan) ? CodePlan.fromJSON(object.codePlan) : undefined,
      form: globalThis.Array.isArray(object?.form)
        ? object.form.map((e: any) => Form.fromJSON(e))
        : [],
      document: isSet(object.document) ? Documentation.fromJSON(object.document) : undefined,
      munitScenarios: isSet(object.munitScenarios)
        ? MunitScenarios.fromJSON(object.munitScenarios)
        : undefined,
      dataweaveOutput: isSet(object.dataweaveOutput)
        ? DataWeaveGenCodeOutput.fromJSON(object.dataweaveOutput)
        : undefined,
      agentInternalStatus: isSet(object.agentInternalStatus)
        ? AgentInternalStatus.fromJSON(object.agentInternalStatus)
        : undefined,
      addFlowSpec: isSet(object.addFlowSpec) ? AddFlowSpec.fromJSON(object.addFlowSpec) : undefined,
      migrationDocOutput: isSet(object.migrationDocOutput)
        ? MigrationDocumentOutput.fromJSON(object.migrationDocOutput)
        : undefined,
      questionAskingOutput: isSet(object.questionAskingOutput)
        ? QuestionAskingOutput.fromJSON(object.questionAskingOutput)
        : undefined,
      waitForResponseDeltaContent: isSet(object.waitForResponseDeltaContent)
        ? globalThis.String(object.waitForResponseDeltaContent)
        : '',
      taskId: isSet(object.taskId) ? globalThis.Number(object.taskId) : 0,
      thinkingContent: isSet(object.thinkingContent)
        ? globalThis.String(object.thinkingContent)
        : '',
      formWidget: isSet(object.formWidget) ? FormWidget.fromJSON(object.formWidget) : undefined,
      progressMessage: isSet(object.progressMessage)
        ? ProgressMessage.fromJSON(object.progressMessage)
        : undefined,
      jsonMetadataS3Path: isSet(object.jsonMetadataS3Path)
        ? globalThis.String(object.jsonMetadataS3Path)
        : '',
      identifiedEndpoints: globalThis.Array.isArray(object?.identifiedEndpoints)
        ? object.identifiedEndpoints.map((e: any) => MigrationSelectedEndpoint.fromJSON(e))
        : [],
      canvasData: globalThis.Array.isArray(object?.canvasData)
        ? object.canvasData.map((e: any) => CanvasData.fromJSON(e))
        : [],
      coderSummary: isSet(object.coderSummary)
        ? CoderSummary.fromJSON(object.coderSummary)
        : undefined,
      assetIds: globalThis.Array.isArray(object?.assetIds)
        ? object.assetIds.map((e: any) => globalThis.String(e))
        : [],
      chatSelectionWidget: isSet(object.chatSelectionWidget)
        ? ChatSelectionWidget.fromJSON(object.chatSelectionWidget)
        : undefined,
      migrationDeployState: isSet(object.migrationDeployState)
        ? MigrationDeployState.fromJSON(object.migrationDeployState)
        : undefined
    }
  },

  toJSON(message: ResponseContentStream): unknown {
    const obj: any = {}
    if (message.messageType !== 0) {
      obj.messageType = messageTypeToJSON(message.messageType)
    }
    if (message.deltaContent !== '') {
      obj.deltaContent = message.deltaContent
    }
    if (message.jsonMetadata !== '') {
      obj.jsonMetadata = message.jsonMetadata
    }
    if (message.taskMetadata !== '') {
      obj.taskMetadata = message.taskMetadata
    }
    if (message.diff?.length) {
      obj.diff = message.diff.map(e => Diff.toJSON(e))
    }
    if (message.codePlan !== undefined) {
      obj.codePlan = CodePlan.toJSON(message.codePlan)
    }
    if (message.form?.length) {
      obj.form = message.form.map(e => Form.toJSON(e))
    }
    if (message.document !== undefined) {
      obj.document = Documentation.toJSON(message.document)
    }
    if (message.munitScenarios !== undefined) {
      obj.munitScenarios = MunitScenarios.toJSON(message.munitScenarios)
    }
    if (message.dataweaveOutput !== undefined) {
      obj.dataweaveOutput = DataWeaveGenCodeOutput.toJSON(message.dataweaveOutput)
    }
    if (message.agentInternalStatus !== undefined) {
      obj.agentInternalStatus = AgentInternalStatus.toJSON(message.agentInternalStatus)
    }
    if (message.addFlowSpec !== undefined) {
      obj.addFlowSpec = AddFlowSpec.toJSON(message.addFlowSpec)
    }
    if (message.migrationDocOutput !== undefined) {
      obj.migrationDocOutput = MigrationDocumentOutput.toJSON(message.migrationDocOutput)
    }
    if (message.questionAskingOutput !== undefined) {
      obj.questionAskingOutput = QuestionAskingOutput.toJSON(message.questionAskingOutput)
    }
    if (message.waitForResponseDeltaContent !== '') {
      obj.waitForResponseDeltaContent = message.waitForResponseDeltaContent
    }
    if (message.taskId !== 0) {
      obj.taskId = Math.round(message.taskId)
    }
    if (message.thinkingContent !== '') {
      obj.thinkingContent = message.thinkingContent
    }
    if (message.formWidget !== undefined) {
      obj.formWidget = FormWidget.toJSON(message.formWidget)
    }
    if (message.progressMessage !== undefined) {
      obj.progressMessage = ProgressMessage.toJSON(message.progressMessage)
    }
    if (message.jsonMetadataS3Path !== '') {
      obj.jsonMetadataS3Path = message.jsonMetadataS3Path
    }
    if (message.identifiedEndpoints?.length) {
      obj.identifiedEndpoints = message.identifiedEndpoints.map(e =>
        MigrationSelectedEndpoint.toJSON(e)
      )
    }
    if (message.canvasData?.length) {
      obj.canvasData = message.canvasData.map(e => CanvasData.toJSON(e))
    }
    if (message.coderSummary !== undefined) {
      obj.coderSummary = CoderSummary.toJSON(message.coderSummary)
    }
    if (message.assetIds?.length) {
      obj.assetIds = message.assetIds
    }
    if (message.chatSelectionWidget !== undefined) {
      obj.chatSelectionWidget = ChatSelectionWidget.toJSON(message.chatSelectionWidget)
    }
    if (message.migrationDeployState !== undefined) {
      obj.migrationDeployState = MigrationDeployState.toJSON(message.migrationDeployState)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ResponseContentStream>, I>>(base?: I): ResponseContentStream {
    return ResponseContentStream.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ResponseContentStream>, I>>(
    object: I
  ): ResponseContentStream {
    const message = createBaseResponseContentStream()
    message.messageType = object.messageType ?? 0
    message.deltaContent = object.deltaContent ?? ''
    message.jsonMetadata = object.jsonMetadata ?? ''
    message.taskMetadata = object.taskMetadata ?? ''
    message.diff = object.diff?.map(e => Diff.fromPartial(e)) || []
    message.codePlan =
      object.codePlan !== undefined && object.codePlan !== null
        ? CodePlan.fromPartial(object.codePlan)
        : undefined
    message.form = object.form?.map(e => Form.fromPartial(e)) || []
    message.document =
      object.document !== undefined && object.document !== null
        ? Documentation.fromPartial(object.document)
        : undefined
    message.munitScenarios =
      object.munitScenarios !== undefined && object.munitScenarios !== null
        ? MunitScenarios.fromPartial(object.munitScenarios)
        : undefined
    message.dataweaveOutput =
      object.dataweaveOutput !== undefined && object.dataweaveOutput !== null
        ? DataWeaveGenCodeOutput.fromPartial(object.dataweaveOutput)
        : undefined
    message.agentInternalStatus =
      object.agentInternalStatus !== undefined && object.agentInternalStatus !== null
        ? AgentInternalStatus.fromPartial(object.agentInternalStatus)
        : undefined
    message.addFlowSpec =
      object.addFlowSpec !== undefined && object.addFlowSpec !== null
        ? AddFlowSpec.fromPartial(object.addFlowSpec)
        : undefined
    message.migrationDocOutput =
      object.migrationDocOutput !== undefined && object.migrationDocOutput !== null
        ? MigrationDocumentOutput.fromPartial(object.migrationDocOutput)
        : undefined
    message.questionAskingOutput =
      object.questionAskingOutput !== undefined && object.questionAskingOutput !== null
        ? QuestionAskingOutput.fromPartial(object.questionAskingOutput)
        : undefined
    message.waitForResponseDeltaContent = object.waitForResponseDeltaContent ?? ''
    message.taskId = object.taskId ?? 0
    message.thinkingContent = object.thinkingContent ?? ''
    message.formWidget =
      object.formWidget !== undefined && object.formWidget !== null
        ? FormWidget.fromPartial(object.formWidget)
        : undefined
    message.progressMessage =
      object.progressMessage !== undefined && object.progressMessage !== null
        ? ProgressMessage.fromPartial(object.progressMessage)
        : undefined
    message.jsonMetadataS3Path = object.jsonMetadataS3Path ?? ''
    message.identifiedEndpoints =
      object.identifiedEndpoints?.map(e => MigrationSelectedEndpoint.fromPartial(e)) || []
    message.canvasData = object.canvasData?.map(e => CanvasData.fromPartial(e)) || []
    message.coderSummary =
      object.coderSummary !== undefined && object.coderSummary !== null
        ? CoderSummary.fromPartial(object.coderSummary)
        : undefined
    message.assetIds = object.assetIds?.map(e => e) || []
    message.chatSelectionWidget =
      object.chatSelectionWidget !== undefined && object.chatSelectionWidget !== null
        ? ChatSelectionWidget.fromPartial(object.chatSelectionWidget)
        : undefined
    message.migrationDeployState =
      object.migrationDeployState !== undefined && object.migrationDeployState !== null
        ? MigrationDeployState.fromPartial(object.migrationDeployState)
        : undefined
    return message
  }
}

function createBaseRefactorStartUserComments(): RefactorStartUserComments {
  return { generalComments: '', skipPrcApi: false }
}

export const RefactorStartUserComments = {
  encode(message: RefactorStartUserComments, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.generalComments !== '') {
      writer.uint32(10).string(message.generalComments)
    }
    if (message.skipPrcApi !== false) {
      writer.uint32(16).bool(message.skipPrcApi)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RefactorStartUserComments {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRefactorStartUserComments()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.generalComments = reader.string()
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.skipPrcApi = reader.bool()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RefactorStartUserComments {
    return {
      generalComments: isSet(object.generalComments)
        ? globalThis.String(object.generalComments)
        : '',
      skipPrcApi: isSet(object.skipPrcApi) ? globalThis.Boolean(object.skipPrcApi) : false
    }
  },

  toJSON(message: RefactorStartUserComments): unknown {
    const obj: any = {}
    if (message.generalComments !== '') {
      obj.generalComments = message.generalComments
    }
    if (message.skipPrcApi !== false) {
      obj.skipPrcApi = message.skipPrcApi
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RefactorStartUserComments>, I>>(
    base?: I
  ): RefactorStartUserComments {
    return RefactorStartUserComments.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RefactorStartUserComments>, I>>(
    object: I
  ): RefactorStartUserComments {
    const message = createBaseRefactorStartUserComments()
    message.generalComments = object.generalComments ?? ''
    message.skipPrcApi = object.skipPrcApi ?? false
    return message
  }
}

function createBaseMigrationSelectedEndpoint(): MigrationSelectedEndpoint {
  return { category: '', name: '', filePath: '' }
}

export const MigrationSelectedEndpoint = {
  encode(message: MigrationSelectedEndpoint, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.category !== '') {
      writer.uint32(10).string(message.category)
    }
    if (message.name !== '') {
      writer.uint32(18).string(message.name)
    }
    if (message.filePath !== '') {
      writer.uint32(26).string(message.filePath)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MigrationSelectedEndpoint {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMigrationSelectedEndpoint()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.category = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.name = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.filePath = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MigrationSelectedEndpoint {
    return {
      category: isSet(object.category) ? globalThis.String(object.category) : '',
      name: isSet(object.name) ? globalThis.String(object.name) : '',
      filePath: isSet(object.filePath) ? globalThis.String(object.filePath) : ''
    }
  },

  toJSON(message: MigrationSelectedEndpoint): unknown {
    const obj: any = {}
    if (message.category !== '') {
      obj.category = message.category
    }
    if (message.name !== '') {
      obj.name = message.name
    }
    if (message.filePath !== '') {
      obj.filePath = message.filePath
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MigrationSelectedEndpoint>, I>>(
    base?: I
  ): MigrationSelectedEndpoint {
    return MigrationSelectedEndpoint.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MigrationSelectedEndpoint>, I>>(
    object: I
  ): MigrationSelectedEndpoint {
    const message = createBaseMigrationSelectedEndpoint()
    message.category = object.category ?? ''
    message.name = object.name ?? ''
    message.filePath = object.filePath ?? ''
    return message
  }
}

function createBaseCoderSummary(): CoderSummary {
  return { taskId: 0, summary: '' }
}

export const CoderSummary = {
  encode(message: CoderSummary, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.taskId !== 0) {
      writer.uint32(8).int64(message.taskId)
    }
    if (message.summary !== '') {
      writer.uint32(18).string(message.summary)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CoderSummary {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCoderSummary()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.taskId = longToNumber(reader.int64() as Long)
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.summary = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CoderSummary {
    return {
      taskId: isSet(object.taskId) ? globalThis.Number(object.taskId) : 0,
      summary: isSet(object.summary) ? globalThis.String(object.summary) : ''
    }
  },

  toJSON(message: CoderSummary): unknown {
    const obj: any = {}
    if (message.taskId !== 0) {
      obj.taskId = Math.round(message.taskId)
    }
    if (message.summary !== '') {
      obj.summary = message.summary
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CoderSummary>, I>>(base?: I): CoderSummary {
    return CoderSummary.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CoderSummary>, I>>(object: I): CoderSummary {
    const message = createBaseCoderSummary()
    message.taskId = object.taskId ?? 0
    message.summary = object.summary ?? ''
    return message
  }
}

function createBaseCanvasData(): CanvasData {
  return {
    canvasType: 0,
    content: '',
    s3FilePath: '',
    title: '',
    base64EncodedImage: '',
    fileExt: '',
    editable: false
  }
}

export const CanvasData = {
  encode(message: CanvasData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.canvasType !== 0) {
      writer.uint32(8).int32(message.canvasType)
    }
    if (message.content !== '') {
      writer.uint32(18).string(message.content)
    }
    if (message.s3FilePath !== '') {
      writer.uint32(26).string(message.s3FilePath)
    }
    if (message.title !== '') {
      writer.uint32(34).string(message.title)
    }
    if (message.base64EncodedImage !== '') {
      writer.uint32(42).string(message.base64EncodedImage)
    }
    if (message.fileExt !== '') {
      writer.uint32(50).string(message.fileExt)
    }
    if (message.editable !== false) {
      writer.uint32(56).bool(message.editable)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CanvasData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCanvasData()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.canvasType = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.content = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.s3FilePath = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.title = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.base64EncodedImage = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.fileExt = reader.string()
          continue
        case 7:
          if (tag !== 56) {
            break
          }

          message.editable = reader.bool()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CanvasData {
    return {
      canvasType: isSet(object.canvasType) ? canvasTypeFromJSON(object.canvasType) : 0,
      content: isSet(object.content) ? globalThis.String(object.content) : '',
      s3FilePath: isSet(object.s3FilePath) ? globalThis.String(object.s3FilePath) : '',
      title: isSet(object.title) ? globalThis.String(object.title) : '',
      base64EncodedImage: isSet(object.base64EncodedImage)
        ? globalThis.String(object.base64EncodedImage)
        : '',
      fileExt: isSet(object.fileExt) ? globalThis.String(object.fileExt) : '',
      editable: isSet(object.editable) ? globalThis.Boolean(object.editable) : false
    }
  },

  toJSON(message: CanvasData): unknown {
    const obj: any = {}
    if (message.canvasType !== 0) {
      obj.canvasType = canvasTypeToJSON(message.canvasType)
    }
    if (message.content !== '') {
      obj.content = message.content
    }
    if (message.s3FilePath !== '') {
      obj.s3FilePath = message.s3FilePath
    }
    if (message.title !== '') {
      obj.title = message.title
    }
    if (message.base64EncodedImage !== '') {
      obj.base64EncodedImage = message.base64EncodedImage
    }
    if (message.fileExt !== '') {
      obj.fileExt = message.fileExt
    }
    if (message.editable !== false) {
      obj.editable = message.editable
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CanvasData>, I>>(base?: I): CanvasData {
    return CanvasData.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CanvasData>, I>>(object: I): CanvasData {
    const message = createBaseCanvasData()
    message.canvasType = object.canvasType ?? 0
    message.content = object.content ?? ''
    message.s3FilePath = object.s3FilePath ?? ''
    message.title = object.title ?? ''
    message.base64EncodedImage = object.base64EncodedImage ?? ''
    message.fileExt = object.fileExt ?? ''
    message.editable = object.editable ?? false
    return message
  }
}

function createBaseCanvasContextInfo(): CanvasContextInfo {
  return {
    canvasHash: '',
    canvasTitle: '',
    contextText: '',
    contextBefore: '',
    contextAfter: '',
    contextStartLine: 0,
    contextEndLine: 0
  }
}

export const CanvasContextInfo = {
  encode(message: CanvasContextInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.canvasHash !== '') {
      writer.uint32(10).string(message.canvasHash)
    }
    if (message.canvasTitle !== '') {
      writer.uint32(18).string(message.canvasTitle)
    }
    if (message.contextText !== '') {
      writer.uint32(26).string(message.contextText)
    }
    if (message.contextBefore !== '') {
      writer.uint32(34).string(message.contextBefore)
    }
    if (message.contextAfter !== '') {
      writer.uint32(42).string(message.contextAfter)
    }
    if (message.contextStartLine !== 0) {
      writer.uint32(48).int32(message.contextStartLine)
    }
    if (message.contextEndLine !== 0) {
      writer.uint32(56).int32(message.contextEndLine)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CanvasContextInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCanvasContextInfo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.canvasHash = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.canvasTitle = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.contextText = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.contextBefore = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.contextAfter = reader.string()
          continue
        case 6:
          if (tag !== 48) {
            break
          }

          message.contextStartLine = reader.int32()
          continue
        case 7:
          if (tag !== 56) {
            break
          }

          message.contextEndLine = reader.int32()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CanvasContextInfo {
    return {
      canvasHash: isSet(object.canvasHash) ? globalThis.String(object.canvasHash) : '',
      canvasTitle: isSet(object.canvasTitle) ? globalThis.String(object.canvasTitle) : '',
      contextText: isSet(object.contextText) ? globalThis.String(object.contextText) : '',
      contextBefore: isSet(object.contextBefore) ? globalThis.String(object.contextBefore) : '',
      contextAfter: isSet(object.contextAfter) ? globalThis.String(object.contextAfter) : '',
      contextStartLine: isSet(object.contextStartLine)
        ? globalThis.Number(object.contextStartLine)
        : 0,
      contextEndLine: isSet(object.contextEndLine) ? globalThis.Number(object.contextEndLine) : 0
    }
  },

  toJSON(message: CanvasContextInfo): unknown {
    const obj: any = {}
    if (message.canvasHash !== '') {
      obj.canvasHash = message.canvasHash
    }
    if (message.canvasTitle !== '') {
      obj.canvasTitle = message.canvasTitle
    }
    if (message.contextText !== '') {
      obj.contextText = message.contextText
    }
    if (message.contextBefore !== '') {
      obj.contextBefore = message.contextBefore
    }
    if (message.contextAfter !== '') {
      obj.contextAfter = message.contextAfter
    }
    if (message.contextStartLine !== 0) {
      obj.contextStartLine = Math.round(message.contextStartLine)
    }
    if (message.contextEndLine !== 0) {
      obj.contextEndLine = Math.round(message.contextEndLine)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CanvasContextInfo>, I>>(base?: I): CanvasContextInfo {
    return CanvasContextInfo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CanvasContextInfo>, I>>(object: I): CanvasContextInfo {
    const message = createBaseCanvasContextInfo()
    message.canvasHash = object.canvasHash ?? ''
    message.canvasTitle = object.canvasTitle ?? ''
    message.contextText = object.contextText ?? ''
    message.contextBefore = object.contextBefore ?? ''
    message.contextAfter = object.contextAfter ?? ''
    message.contextStartLine = object.contextStartLine ?? 0
    message.contextEndLine = object.contextEndLine ?? 0
    return message
  }
}

function createBaseMigrationDocumentInput(): MigrationDocumentInput {
  return { platform: 0, endpointDesc: '', generateForAll: false, migDocs: [] }
}

export const MigrationDocumentInput = {
  encode(message: MigrationDocumentInput, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.platform !== 0) {
      writer.uint32(8).int32(message.platform)
    }
    if (message.endpointDesc !== '') {
      writer.uint32(18).string(message.endpointDesc)
    }
    if (message.generateForAll !== false) {
      writer.uint32(24).bool(message.generateForAll)
    }
    for (const v of message.migDocs) {
      writer.uint32(34).string(v!)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MigrationDocumentInput {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMigrationDocumentInput()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.platform = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.endpointDesc = reader.string()
          continue
        case 3:
          if (tag !== 24) {
            break
          }

          message.generateForAll = reader.bool()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.migDocs.push(reader.string())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MigrationDocumentInput {
    return {
      platform: isSet(object.platform) ? integrationPlatformFromJSON(object.platform) : 0,
      endpointDesc: isSet(object.endpointDesc) ? globalThis.String(object.endpointDesc) : '',
      generateForAll: isSet(object.generateForAll)
        ? globalThis.Boolean(object.generateForAll)
        : false,
      migDocs: globalThis.Array.isArray(object?.migDocs)
        ? object.migDocs.map((e: any) => globalThis.String(e))
        : []
    }
  },

  toJSON(message: MigrationDocumentInput): unknown {
    const obj: any = {}
    if (message.platform !== 0) {
      obj.platform = integrationPlatformToJSON(message.platform)
    }
    if (message.endpointDesc !== '') {
      obj.endpointDesc = message.endpointDesc
    }
    if (message.generateForAll !== false) {
      obj.generateForAll = message.generateForAll
    }
    if (message.migDocs?.length) {
      obj.migDocs = message.migDocs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MigrationDocumentInput>, I>>(
    base?: I
  ): MigrationDocumentInput {
    return MigrationDocumentInput.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MigrationDocumentInput>, I>>(
    object: I
  ): MigrationDocumentInput {
    const message = createBaseMigrationDocumentInput()
    message.platform = object.platform ?? 0
    message.endpointDesc = object.endpointDesc ?? ''
    message.generateForAll = object.generateForAll ?? false
    message.migDocs = object.migDocs?.map(e => e) || []
    return message
  }
}

function createBaseMigrationDocumentOutput(): MigrationDocumentOutput {
  return {
    docMd: '',
    migDocs: [],
    apiSpec: [],
    diffs: [],
    endpointsMd: '',
    migDocsMap: {},
    migDocsRiskMap: {},
    codeGenSummary: '',
    codeGenSummaryMap: {}
  }
}

export const MigrationDocumentOutput = {
  encode(message: MigrationDocumentOutput, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.docMd !== '') {
      writer.uint32(10).string(message.docMd)
    }
    for (const v of message.migDocs) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.apiSpec) {
      writer.uint32(26).string(v!)
    }
    for (const v of message.diffs) {
      Diff.encode(v!, writer.uint32(34).fork()).ldelim()
    }
    if (message.endpointsMd !== '') {
      writer.uint32(42).string(message.endpointsMd)
    }
    Object.entries(message.migDocsMap).forEach(([key, value]) => {
      MigrationDocumentOutput_MigDocsMapEntry.encode(
        { key: key as any, value },
        writer.uint32(50).fork()
      ).ldelim()
    })
    Object.entries(message.migDocsRiskMap).forEach(([key, value]) => {
      MigrationDocumentOutput_MigDocsRiskMapEntry.encode(
        { key: key as any, value },
        writer.uint32(58).fork()
      ).ldelim()
    })
    if (message.codeGenSummary !== '') {
      writer.uint32(66).string(message.codeGenSummary)
    }
    Object.entries(message.codeGenSummaryMap).forEach(([key, value]) => {
      MigrationDocumentOutput_CodeGenSummaryMapEntry.encode(
        { key: key as any, value },
        writer.uint32(74).fork()
      ).ldelim()
    })
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MigrationDocumentOutput {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMigrationDocumentOutput()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.docMd = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.migDocs.push(reader.string())
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.apiSpec.push(reader.string())
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.diffs.push(Diff.decode(reader, reader.uint32()))
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.endpointsMd = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          const entry6 = MigrationDocumentOutput_MigDocsMapEntry.decode(reader, reader.uint32())
          if (entry6.value !== undefined) {
            message.migDocsMap[entry6.key] = entry6.value
          }
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          const entry7 = MigrationDocumentOutput_MigDocsRiskMapEntry.decode(reader, reader.uint32())
          if (entry7.value !== undefined) {
            message.migDocsRiskMap[entry7.key] = entry7.value
          }
          continue
        case 8:
          if (tag !== 66) {
            break
          }

          message.codeGenSummary = reader.string()
          continue
        case 9:
          if (tag !== 74) {
            break
          }

          const entry9 = MigrationDocumentOutput_CodeGenSummaryMapEntry.decode(
            reader,
            reader.uint32()
          )
          if (entry9.value !== undefined) {
            message.codeGenSummaryMap[entry9.key] = entry9.value
          }
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MigrationDocumentOutput {
    return {
      docMd: isSet(object.docMd) ? globalThis.String(object.docMd) : '',
      migDocs: globalThis.Array.isArray(object?.migDocs)
        ? object.migDocs.map((e: any) => globalThis.String(e))
        : [],
      apiSpec: globalThis.Array.isArray(object?.apiSpec)
        ? object.apiSpec.map((e: any) => globalThis.String(e))
        : [],
      diffs: globalThis.Array.isArray(object?.diffs)
        ? object.diffs.map((e: any) => Diff.fromJSON(e))
        : [],
      endpointsMd: isSet(object.endpointsMd) ? globalThis.String(object.endpointsMd) : '',
      migDocsMap: isObject(object.migDocsMap)
        ? Object.entries(object.migDocsMap).reduce<{ [key: string]: string }>(
            (acc, [key, value]) => {
              acc[key] = String(value)
              return acc
            },
            {}
          )
        : {},
      migDocsRiskMap: isObject(object.migDocsRiskMap)
        ? Object.entries(object.migDocsRiskMap).reduce<{ [key: string]: string }>(
            (acc, [key, value]) => {
              acc[key] = String(value)
              return acc
            },
            {}
          )
        : {},
      codeGenSummary: isSet(object.codeGenSummary) ? globalThis.String(object.codeGenSummary) : '',
      codeGenSummaryMap: isObject(object.codeGenSummaryMap)
        ? Object.entries(object.codeGenSummaryMap).reduce<{ [key: string]: string }>(
            (acc, [key, value]) => {
              acc[key] = String(value)
              return acc
            },
            {}
          )
        : {}
    }
  },

  toJSON(message: MigrationDocumentOutput): unknown {
    const obj: any = {}
    if (message.docMd !== '') {
      obj.docMd = message.docMd
    }
    if (message.migDocs?.length) {
      obj.migDocs = message.migDocs
    }
    if (message.apiSpec?.length) {
      obj.apiSpec = message.apiSpec
    }
    if (message.diffs?.length) {
      obj.diffs = message.diffs.map(e => Diff.toJSON(e))
    }
    if (message.endpointsMd !== '') {
      obj.endpointsMd = message.endpointsMd
    }
    if (message.migDocsMap) {
      const entries = Object.entries(message.migDocsMap)
      if (entries.length > 0) {
        obj.migDocsMap = {}
        entries.forEach(([k, v]) => {
          obj.migDocsMap[k] = v
        })
      }
    }
    if (message.migDocsRiskMap) {
      const entries = Object.entries(message.migDocsRiskMap)
      if (entries.length > 0) {
        obj.migDocsRiskMap = {}
        entries.forEach(([k, v]) => {
          obj.migDocsRiskMap[k] = v
        })
      }
    }
    if (message.codeGenSummary !== '') {
      obj.codeGenSummary = message.codeGenSummary
    }
    if (message.codeGenSummaryMap) {
      const entries = Object.entries(message.codeGenSummaryMap)
      if (entries.length > 0) {
        obj.codeGenSummaryMap = {}
        entries.forEach(([k, v]) => {
          obj.codeGenSummaryMap[k] = v
        })
      }
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MigrationDocumentOutput>, I>>(
    base?: I
  ): MigrationDocumentOutput {
    return MigrationDocumentOutput.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MigrationDocumentOutput>, I>>(
    object: I
  ): MigrationDocumentOutput {
    const message = createBaseMigrationDocumentOutput()
    message.docMd = object.docMd ?? ''
    message.migDocs = object.migDocs?.map(e => e) || []
    message.apiSpec = object.apiSpec?.map(e => e) || []
    message.diffs = object.diffs?.map(e => Diff.fromPartial(e)) || []
    message.endpointsMd = object.endpointsMd ?? ''
    message.migDocsMap = Object.entries(object.migDocsMap ?? {}).reduce<{ [key: string]: string }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = globalThis.String(value)
        }
        return acc
      },
      {}
    )
    message.migDocsRiskMap = Object.entries(object.migDocsRiskMap ?? {}).reduce<{
      [key: string]: string
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value)
      }
      return acc
    }, {})
    message.codeGenSummary = object.codeGenSummary ?? ''
    message.codeGenSummaryMap = Object.entries(object.codeGenSummaryMap ?? {}).reduce<{
      [key: string]: string
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = globalThis.String(value)
      }
      return acc
    }, {})
    return message
  }
}

function createBaseMigrationDocumentOutput_MigDocsMapEntry(): MigrationDocumentOutput_MigDocsMapEntry {
  return { key: '', value: '' }
}

export const MigrationDocumentOutput_MigDocsMapEntry = {
  encode(
    message: MigrationDocumentOutput_MigDocsMapEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MigrationDocumentOutput_MigDocsMapEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMigrationDocumentOutput_MigDocsMapEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MigrationDocumentOutput_MigDocsMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : ''
    }
  },

  toJSON(message: MigrationDocumentOutput_MigDocsMapEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MigrationDocumentOutput_MigDocsMapEntry>, I>>(
    base?: I
  ): MigrationDocumentOutput_MigDocsMapEntry {
    return MigrationDocumentOutput_MigDocsMapEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MigrationDocumentOutput_MigDocsMapEntry>, I>>(
    object: I
  ): MigrationDocumentOutput_MigDocsMapEntry {
    const message = createBaseMigrationDocumentOutput_MigDocsMapEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  }
}

function createBaseMigrationDocumentOutput_MigDocsRiskMapEntry(): MigrationDocumentOutput_MigDocsRiskMapEntry {
  return { key: '', value: '' }
}

export const MigrationDocumentOutput_MigDocsRiskMapEntry = {
  encode(
    message: MigrationDocumentOutput_MigDocsRiskMapEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): MigrationDocumentOutput_MigDocsRiskMapEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMigrationDocumentOutput_MigDocsRiskMapEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MigrationDocumentOutput_MigDocsRiskMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : ''
    }
  },

  toJSON(message: MigrationDocumentOutput_MigDocsRiskMapEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MigrationDocumentOutput_MigDocsRiskMapEntry>, I>>(
    base?: I
  ): MigrationDocumentOutput_MigDocsRiskMapEntry {
    return MigrationDocumentOutput_MigDocsRiskMapEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MigrationDocumentOutput_MigDocsRiskMapEntry>, I>>(
    object: I
  ): MigrationDocumentOutput_MigDocsRiskMapEntry {
    const message = createBaseMigrationDocumentOutput_MigDocsRiskMapEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  }
}

function createBaseMigrationDocumentOutput_CodeGenSummaryMapEntry(): MigrationDocumentOutput_CodeGenSummaryMapEntry {
  return { key: '', value: '' }
}

export const MigrationDocumentOutput_CodeGenSummaryMapEntry = {
  encode(
    message: MigrationDocumentOutput_CodeGenSummaryMapEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    return writer
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): MigrationDocumentOutput_CodeGenSummaryMapEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMigrationDocumentOutput_CodeGenSummaryMapEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MigrationDocumentOutput_CodeGenSummaryMapEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : ''
    }
  },

  toJSON(message: MigrationDocumentOutput_CodeGenSummaryMapEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MigrationDocumentOutput_CodeGenSummaryMapEntry>, I>>(
    base?: I
  ): MigrationDocumentOutput_CodeGenSummaryMapEntry {
    return MigrationDocumentOutput_CodeGenSummaryMapEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MigrationDocumentOutput_CodeGenSummaryMapEntry>, I>>(
    object: I
  ): MigrationDocumentOutput_CodeGenSummaryMapEntry {
    const message = createBaseMigrationDocumentOutput_CodeGenSummaryMapEntry()
    message.key = object.key ?? ''
    message.value = object.value ?? ''
    return message
  }
}

function createBaseMigrationRiskReviewFeedback(): MigrationRiskReviewFeedback {
  return { feedback: '', uploadedFiles: [] }
}

export const MigrationRiskReviewFeedback = {
  encode(
    message: MigrationRiskReviewFeedback,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.feedback !== '') {
      writer.uint32(10).string(message.feedback)
    }
    for (const v of message.uploadedFiles) {
      FileUpload.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MigrationRiskReviewFeedback {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMigrationRiskReviewFeedback()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.feedback = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.uploadedFiles.push(FileUpload.decode(reader, reader.uint32()))
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MigrationRiskReviewFeedback {
    return {
      feedback: isSet(object.feedback) ? globalThis.String(object.feedback) : '',
      uploadedFiles: globalThis.Array.isArray(object?.uploadedFiles)
        ? object.uploadedFiles.map((e: any) => FileUpload.fromJSON(e))
        : []
    }
  },

  toJSON(message: MigrationRiskReviewFeedback): unknown {
    const obj: any = {}
    if (message.feedback !== '') {
      obj.feedback = message.feedback
    }
    if (message.uploadedFiles?.length) {
      obj.uploadedFiles = message.uploadedFiles.map(e => FileUpload.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MigrationRiskReviewFeedback>, I>>(
    base?: I
  ): MigrationRiskReviewFeedback {
    return MigrationRiskReviewFeedback.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MigrationRiskReviewFeedback>, I>>(
    object: I
  ): MigrationRiskReviewFeedback {
    const message = createBaseMigrationRiskReviewFeedback()
    message.feedback = object.feedback ?? ''
    message.uploadedFiles = object.uploadedFiles?.map(e => FileUpload.fromPartial(e)) || []
    return message
  }
}

function createBaseMigrationDeployInputRequest(): MigrationDeployInputRequest {
  return {
    id: '',
    kind: '',
    label: '',
    placeholder: '',
    defaultValue: '',
    isSecret: false,
    confirmLabel: '',
    denyLabel: ''
  }
}

export const MigrationDeployInputRequest = {
  encode(
    message: MigrationDeployInputRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.kind !== '') {
      writer.uint32(18).string(message.kind)
    }
    if (message.label !== '') {
      writer.uint32(26).string(message.label)
    }
    if (message.placeholder !== '') {
      writer.uint32(34).string(message.placeholder)
    }
    if (message.defaultValue !== '') {
      writer.uint32(42).string(message.defaultValue)
    }
    if (message.isSecret !== false) {
      writer.uint32(48).bool(message.isSecret)
    }
    if (message.confirmLabel !== '') {
      writer.uint32(58).string(message.confirmLabel)
    }
    if (message.denyLabel !== '') {
      writer.uint32(66).string(message.denyLabel)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MigrationDeployInputRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMigrationDeployInputRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.kind = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.label = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.placeholder = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.defaultValue = reader.string()
          continue
        case 6:
          if (tag !== 48) {
            break
          }

          message.isSecret = reader.bool()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.confirmLabel = reader.string()
          continue
        case 8:
          if (tag !== 66) {
            break
          }

          message.denyLabel = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MigrationDeployInputRequest {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      kind: isSet(object.kind) ? globalThis.String(object.kind) : '',
      label: isSet(object.label) ? globalThis.String(object.label) : '',
      placeholder: isSet(object.placeholder) ? globalThis.String(object.placeholder) : '',
      defaultValue: isSet(object.defaultValue) ? globalThis.String(object.defaultValue) : '',
      isSecret: isSet(object.isSecret) ? globalThis.Boolean(object.isSecret) : false,
      confirmLabel: isSet(object.confirmLabel) ? globalThis.String(object.confirmLabel) : '',
      denyLabel: isSet(object.denyLabel) ? globalThis.String(object.denyLabel) : ''
    }
  },

  toJSON(message: MigrationDeployInputRequest): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.kind !== '') {
      obj.kind = message.kind
    }
    if (message.label !== '') {
      obj.label = message.label
    }
    if (message.placeholder !== '') {
      obj.placeholder = message.placeholder
    }
    if (message.defaultValue !== '') {
      obj.defaultValue = message.defaultValue
    }
    if (message.isSecret !== false) {
      obj.isSecret = message.isSecret
    }
    if (message.confirmLabel !== '') {
      obj.confirmLabel = message.confirmLabel
    }
    if (message.denyLabel !== '') {
      obj.denyLabel = message.denyLabel
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MigrationDeployInputRequest>, I>>(
    base?: I
  ): MigrationDeployInputRequest {
    return MigrationDeployInputRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MigrationDeployInputRequest>, I>>(
    object: I
  ): MigrationDeployInputRequest {
    const message = createBaseMigrationDeployInputRequest()
    message.id = object.id ?? ''
    message.kind = object.kind ?? ''
    message.label = object.label ?? ''
    message.placeholder = object.placeholder ?? ''
    message.defaultValue = object.defaultValue ?? ''
    message.isSecret = object.isSecret ?? false
    message.confirmLabel = object.confirmLabel ?? ''
    message.denyLabel = object.denyLabel ?? ''
    return message
  }
}

function createBaseMigrationDeployState(): MigrationDeployState {
  return { phase: '', log: '', inputRequest: undefined, triggerUrl: '' }
}

export const MigrationDeployState = {
  encode(message: MigrationDeployState, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.phase !== '') {
      writer.uint32(10).string(message.phase)
    }
    if (message.log !== '') {
      writer.uint32(18).string(message.log)
    }
    if (message.inputRequest !== undefined) {
      MigrationDeployInputRequest.encode(message.inputRequest, writer.uint32(26).fork()).ldelim()
    }
    if (message.triggerUrl !== '') {
      writer.uint32(34).string(message.triggerUrl)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MigrationDeployState {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMigrationDeployState()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.phase = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.log = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.inputRequest = MigrationDeployInputRequest.decode(reader, reader.uint32())
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.triggerUrl = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MigrationDeployState {
    return {
      phase: isSet(object.phase) ? globalThis.String(object.phase) : '',
      log: isSet(object.log) ? globalThis.String(object.log) : '',
      inputRequest: isSet(object.inputRequest)
        ? MigrationDeployInputRequest.fromJSON(object.inputRequest)
        : undefined,
      triggerUrl: isSet(object.triggerUrl) ? globalThis.String(object.triggerUrl) : ''
    }
  },

  toJSON(message: MigrationDeployState): unknown {
    const obj: any = {}
    if (message.phase !== '') {
      obj.phase = message.phase
    }
    if (message.log !== '') {
      obj.log = message.log
    }
    if (message.inputRequest !== undefined) {
      obj.inputRequest = MigrationDeployInputRequest.toJSON(message.inputRequest)
    }
    if (message.triggerUrl !== '') {
      obj.triggerUrl = message.triggerUrl
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MigrationDeployState>, I>>(base?: I): MigrationDeployState {
    return MigrationDeployState.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MigrationDeployState>, I>>(
    object: I
  ): MigrationDeployState {
    const message = createBaseMigrationDeployState()
    message.phase = object.phase ?? ''
    message.log = object.log ?? ''
    message.inputRequest =
      object.inputRequest !== undefined && object.inputRequest !== null
        ? MigrationDeployInputRequest.fromPartial(object.inputRequest)
        : undefined
    message.triggerUrl = object.triggerUrl ?? ''
    return message
  }
}

function createBaseMigrationDeployInput(): MigrationDeployInput {
  return { requestId: '', value: '', approved: false }
}

export const MigrationDeployInput = {
  encode(message: MigrationDeployInput, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.requestId !== '') {
      writer.uint32(10).string(message.requestId)
    }
    if (message.value !== '') {
      writer.uint32(18).string(message.value)
    }
    if (message.approved !== false) {
      writer.uint32(24).bool(message.approved)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MigrationDeployInput {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMigrationDeployInput()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.requestId = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.value = reader.string()
          continue
        case 3:
          if (tag !== 24) {
            break
          }

          message.approved = reader.bool()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MigrationDeployInput {
    return {
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : '',
      value: isSet(object.value) ? globalThis.String(object.value) : '',
      approved: isSet(object.approved) ? globalThis.Boolean(object.approved) : false
    }
  },

  toJSON(message: MigrationDeployInput): unknown {
    const obj: any = {}
    if (message.requestId !== '') {
      obj.requestId = message.requestId
    }
    if (message.value !== '') {
      obj.value = message.value
    }
    if (message.approved !== false) {
      obj.approved = message.approved
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MigrationDeployInput>, I>>(base?: I): MigrationDeployInput {
    return MigrationDeployInput.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MigrationDeployInput>, I>>(
    object: I
  ): MigrationDeployInput {
    const message = createBaseMigrationDeployInput()
    message.requestId = object.requestId ?? ''
    message.value = object.value ?? ''
    message.approved = object.approved ?? false
    return message
  }
}

function createBaseMappingSheet(): MappingSheet {
  return { id: '', base64EncodedXlsx: '', csv: '' }
}

export const MappingSheet = {
  encode(message: MappingSheet, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== '') {
      writer.uint32(10).string(message.id)
    }
    if (message.base64EncodedXlsx !== '') {
      writer.uint32(18).string(message.base64EncodedXlsx)
    }
    if (message.csv !== '') {
      writer.uint32(26).string(message.csv)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MappingSheet {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMappingSheet()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.id = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.base64EncodedXlsx = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.csv = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MappingSheet {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : '',
      base64EncodedXlsx: isSet(object.base64EncodedXlsx)
        ? globalThis.String(object.base64EncodedXlsx)
        : '',
      csv: isSet(object.csv) ? globalThis.String(object.csv) : ''
    }
  },

  toJSON(message: MappingSheet): unknown {
    const obj: any = {}
    if (message.id !== '') {
      obj.id = message.id
    }
    if (message.base64EncodedXlsx !== '') {
      obj.base64EncodedXlsx = message.base64EncodedXlsx
    }
    if (message.csv !== '') {
      obj.csv = message.csv
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MappingSheet>, I>>(base?: I): MappingSheet {
    return MappingSheet.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MappingSheet>, I>>(object: I): MappingSheet {
    const message = createBaseMappingSheet()
    message.id = object.id ?? ''
    message.base64EncodedXlsx = object.base64EncodedXlsx ?? ''
    message.csv = object.csv ?? ''
    return message
  }
}

function createBaseSourceOutputExamples(): SourceOutputExamples {
  return {
    sourceData: '',
    outputData: '',
    sourceDataType: 0,
    outputDataType: 0,
    outputEdiSchemaType: undefined,
    inputEdiSchemaType: undefined,
    outputEdiFactSchemaType: undefined,
    inputEdiFactSchemaType: undefined,
    outputHl7SchemaType: undefined,
    inputHl7SchemaType: undefined
  }
}

export const SourceOutputExamples = {
  encode(message: SourceOutputExamples, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.sourceData !== '') {
      writer.uint32(10).string(message.sourceData)
    }
    if (message.outputData !== '') {
      writer.uint32(18).string(message.outputData)
    }
    if (message.sourceDataType !== 0) {
      writer.uint32(24).int32(message.sourceDataType)
    }
    if (message.outputDataType !== 0) {
      writer.uint32(32).int32(message.outputDataType)
    }
    if (message.outputEdiSchemaType !== undefined) {
      EdiSchemaType.encode(message.outputEdiSchemaType, writer.uint32(42).fork()).ldelim()
    }
    if (message.inputEdiSchemaType !== undefined) {
      EdiSchemaType.encode(message.inputEdiSchemaType, writer.uint32(50).fork()).ldelim()
    }
    if (message.outputEdiFactSchemaType !== undefined) {
      EdiFactSchemaType.encode(message.outputEdiFactSchemaType, writer.uint32(58).fork()).ldelim()
    }
    if (message.inputEdiFactSchemaType !== undefined) {
      EdiFactSchemaType.encode(message.inputEdiFactSchemaType, writer.uint32(66).fork()).ldelim()
    }
    if (message.outputHl7SchemaType !== undefined) {
      HL7SchemaType.encode(message.outputHl7SchemaType, writer.uint32(74).fork()).ldelim()
    }
    if (message.inputHl7SchemaType !== undefined) {
      HL7SchemaType.encode(message.inputHl7SchemaType, writer.uint32(82).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SourceOutputExamples {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSourceOutputExamples()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.sourceData = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.outputData = reader.string()
          continue
        case 3:
          if (tag !== 24) {
            break
          }

          message.sourceDataType = reader.int32() as any
          continue
        case 4:
          if (tag !== 32) {
            break
          }

          message.outputDataType = reader.int32() as any
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.outputEdiSchemaType = EdiSchemaType.decode(reader, reader.uint32())
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.inputEdiSchemaType = EdiSchemaType.decode(reader, reader.uint32())
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.outputEdiFactSchemaType = EdiFactSchemaType.decode(reader, reader.uint32())
          continue
        case 8:
          if (tag !== 66) {
            break
          }

          message.inputEdiFactSchemaType = EdiFactSchemaType.decode(reader, reader.uint32())
          continue
        case 9:
          if (tag !== 74) {
            break
          }

          message.outputHl7SchemaType = HL7SchemaType.decode(reader, reader.uint32())
          continue
        case 10:
          if (tag !== 82) {
            break
          }

          message.inputHl7SchemaType = HL7SchemaType.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SourceOutputExamples {
    return {
      sourceData: isSet(object.sourceData) ? globalThis.String(object.sourceData) : '',
      outputData: isSet(object.outputData) ? globalThis.String(object.outputData) : '',
      sourceDataType: isSet(object.sourceDataType)
        ? sourceOutputExampleTypeFromJSON(object.sourceDataType)
        : 0,
      outputDataType: isSet(object.outputDataType)
        ? sourceOutputExampleTypeFromJSON(object.outputDataType)
        : 0,
      outputEdiSchemaType: isSet(object.outputEdiSchemaType)
        ? EdiSchemaType.fromJSON(object.outputEdiSchemaType)
        : undefined,
      inputEdiSchemaType: isSet(object.inputEdiSchemaType)
        ? EdiSchemaType.fromJSON(object.inputEdiSchemaType)
        : undefined,
      outputEdiFactSchemaType: isSet(object.outputEdiFactSchemaType)
        ? EdiFactSchemaType.fromJSON(object.outputEdiFactSchemaType)
        : undefined,
      inputEdiFactSchemaType: isSet(object.inputEdiFactSchemaType)
        ? EdiFactSchemaType.fromJSON(object.inputEdiFactSchemaType)
        : undefined,
      outputHl7SchemaType: isSet(object.outputHl7SchemaType)
        ? HL7SchemaType.fromJSON(object.outputHl7SchemaType)
        : undefined,
      inputHl7SchemaType: isSet(object.inputHl7SchemaType)
        ? HL7SchemaType.fromJSON(object.inputHl7SchemaType)
        : undefined
    }
  },

  toJSON(message: SourceOutputExamples): unknown {
    const obj: any = {}
    if (message.sourceData !== '') {
      obj.sourceData = message.sourceData
    }
    if (message.outputData !== '') {
      obj.outputData = message.outputData
    }
    if (message.sourceDataType !== 0) {
      obj.sourceDataType = sourceOutputExampleTypeToJSON(message.sourceDataType)
    }
    if (message.outputDataType !== 0) {
      obj.outputDataType = sourceOutputExampleTypeToJSON(message.outputDataType)
    }
    if (message.outputEdiSchemaType !== undefined) {
      obj.outputEdiSchemaType = EdiSchemaType.toJSON(message.outputEdiSchemaType)
    }
    if (message.inputEdiSchemaType !== undefined) {
      obj.inputEdiSchemaType = EdiSchemaType.toJSON(message.inputEdiSchemaType)
    }
    if (message.outputEdiFactSchemaType !== undefined) {
      obj.outputEdiFactSchemaType = EdiFactSchemaType.toJSON(message.outputEdiFactSchemaType)
    }
    if (message.inputEdiFactSchemaType !== undefined) {
      obj.inputEdiFactSchemaType = EdiFactSchemaType.toJSON(message.inputEdiFactSchemaType)
    }
    if (message.outputHl7SchemaType !== undefined) {
      obj.outputHl7SchemaType = HL7SchemaType.toJSON(message.outputHl7SchemaType)
    }
    if (message.inputHl7SchemaType !== undefined) {
      obj.inputHl7SchemaType = HL7SchemaType.toJSON(message.inputHl7SchemaType)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SourceOutputExamples>, I>>(base?: I): SourceOutputExamples {
    return SourceOutputExamples.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SourceOutputExamples>, I>>(
    object: I
  ): SourceOutputExamples {
    const message = createBaseSourceOutputExamples()
    message.sourceData = object.sourceData ?? ''
    message.outputData = object.outputData ?? ''
    message.sourceDataType = object.sourceDataType ?? 0
    message.outputDataType = object.outputDataType ?? 0
    message.outputEdiSchemaType =
      object.outputEdiSchemaType !== undefined && object.outputEdiSchemaType !== null
        ? EdiSchemaType.fromPartial(object.outputEdiSchemaType)
        : undefined
    message.inputEdiSchemaType =
      object.inputEdiSchemaType !== undefined && object.inputEdiSchemaType !== null
        ? EdiSchemaType.fromPartial(object.inputEdiSchemaType)
        : undefined
    message.outputEdiFactSchemaType =
      object.outputEdiFactSchemaType !== undefined && object.outputEdiFactSchemaType !== null
        ? EdiFactSchemaType.fromPartial(object.outputEdiFactSchemaType)
        : undefined
    message.inputEdiFactSchemaType =
      object.inputEdiFactSchemaType !== undefined && object.inputEdiFactSchemaType !== null
        ? EdiFactSchemaType.fromPartial(object.inputEdiFactSchemaType)
        : undefined
    message.outputHl7SchemaType =
      object.outputHl7SchemaType !== undefined && object.outputHl7SchemaType !== null
        ? HL7SchemaType.fromPartial(object.outputHl7SchemaType)
        : undefined
    message.inputHl7SchemaType =
      object.inputHl7SchemaType !== undefined && object.inputHl7SchemaType !== null
        ? HL7SchemaType.fromPartial(object.inputHl7SchemaType)
        : undefined
    return message
  }
}

function createBaseEdiSchemaType(): EdiSchemaType {
  return {
    transactionVersion: '',
    transactionType: '',
    interchangeIdSelf: '',
    interchangeIdQualifierSelf: '',
    interchangeIdPartner: '',
    interchangeIdQualifierPartner: '',
    groupIdPartner: '',
    groupIdSelf: '',
    sendUniqueGroupNumbers: '',
    lineEnding: ''
  }
}

export const EdiSchemaType = {
  encode(message: EdiSchemaType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.transactionVersion !== '') {
      writer.uint32(10).string(message.transactionVersion)
    }
    if (message.transactionType !== '') {
      writer.uint32(18).string(message.transactionType)
    }
    if (message.interchangeIdSelf !== '') {
      writer.uint32(26).string(message.interchangeIdSelf)
    }
    if (message.interchangeIdQualifierSelf !== '') {
      writer.uint32(34).string(message.interchangeIdQualifierSelf)
    }
    if (message.interchangeIdPartner !== '') {
      writer.uint32(42).string(message.interchangeIdPartner)
    }
    if (message.interchangeIdQualifierPartner !== '') {
      writer.uint32(50).string(message.interchangeIdQualifierPartner)
    }
    if (message.groupIdPartner !== '') {
      writer.uint32(58).string(message.groupIdPartner)
    }
    if (message.groupIdSelf !== '') {
      writer.uint32(66).string(message.groupIdSelf)
    }
    if (message.sendUniqueGroupNumbers !== '') {
      writer.uint32(74).string(message.sendUniqueGroupNumbers)
    }
    if (message.lineEnding !== '') {
      writer.uint32(82).string(message.lineEnding)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EdiSchemaType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEdiSchemaType()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.transactionVersion = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.transactionType = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.interchangeIdSelf = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.interchangeIdQualifierSelf = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.interchangeIdPartner = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.interchangeIdQualifierPartner = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.groupIdPartner = reader.string()
          continue
        case 8:
          if (tag !== 66) {
            break
          }

          message.groupIdSelf = reader.string()
          continue
        case 9:
          if (tag !== 74) {
            break
          }

          message.sendUniqueGroupNumbers = reader.string()
          continue
        case 10:
          if (tag !== 82) {
            break
          }

          message.lineEnding = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EdiSchemaType {
    return {
      transactionVersion: isSet(object.transactionVersion)
        ? globalThis.String(object.transactionVersion)
        : '',
      transactionType: isSet(object.transactionType)
        ? globalThis.String(object.transactionType)
        : '',
      interchangeIdSelf: isSet(object.interchangeIdSelf)
        ? globalThis.String(object.interchangeIdSelf)
        : '',
      interchangeIdQualifierSelf: isSet(object.interchangeIdQualifierSelf)
        ? globalThis.String(object.interchangeIdQualifierSelf)
        : '',
      interchangeIdPartner: isSet(object.interchangeIdPartner)
        ? globalThis.String(object.interchangeIdPartner)
        : '',
      interchangeIdQualifierPartner: isSet(object.interchangeIdQualifierPartner)
        ? globalThis.String(object.interchangeIdQualifierPartner)
        : '',
      groupIdPartner: isSet(object.groupIdPartner) ? globalThis.String(object.groupIdPartner) : '',
      groupIdSelf: isSet(object.groupIdSelf) ? globalThis.String(object.groupIdSelf) : '',
      sendUniqueGroupNumbers: isSet(object.sendUniqueGroupNumbers)
        ? globalThis.String(object.sendUniqueGroupNumbers)
        : '',
      lineEnding: isSet(object.lineEnding) ? globalThis.String(object.lineEnding) : ''
    }
  },

  toJSON(message: EdiSchemaType): unknown {
    const obj: any = {}
    if (message.transactionVersion !== '') {
      obj.transactionVersion = message.transactionVersion
    }
    if (message.transactionType !== '') {
      obj.transactionType = message.transactionType
    }
    if (message.interchangeIdSelf !== '') {
      obj.interchangeIdSelf = message.interchangeIdSelf
    }
    if (message.interchangeIdQualifierSelf !== '') {
      obj.interchangeIdQualifierSelf = message.interchangeIdQualifierSelf
    }
    if (message.interchangeIdPartner !== '') {
      obj.interchangeIdPartner = message.interchangeIdPartner
    }
    if (message.interchangeIdQualifierPartner !== '') {
      obj.interchangeIdQualifierPartner = message.interchangeIdQualifierPartner
    }
    if (message.groupIdPartner !== '') {
      obj.groupIdPartner = message.groupIdPartner
    }
    if (message.groupIdSelf !== '') {
      obj.groupIdSelf = message.groupIdSelf
    }
    if (message.sendUniqueGroupNumbers !== '') {
      obj.sendUniqueGroupNumbers = message.sendUniqueGroupNumbers
    }
    if (message.lineEnding !== '') {
      obj.lineEnding = message.lineEnding
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EdiSchemaType>, I>>(base?: I): EdiSchemaType {
    return EdiSchemaType.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EdiSchemaType>, I>>(object: I): EdiSchemaType {
    const message = createBaseEdiSchemaType()
    message.transactionVersion = object.transactionVersion ?? ''
    message.transactionType = object.transactionType ?? ''
    message.interchangeIdSelf = object.interchangeIdSelf ?? ''
    message.interchangeIdQualifierSelf = object.interchangeIdQualifierSelf ?? ''
    message.interchangeIdPartner = object.interchangeIdPartner ?? ''
    message.interchangeIdQualifierPartner = object.interchangeIdQualifierPartner ?? ''
    message.groupIdPartner = object.groupIdPartner ?? ''
    message.groupIdSelf = object.groupIdSelf ?? ''
    message.sendUniqueGroupNumbers = object.sendUniqueGroupNumbers ?? ''
    message.lineEnding = object.lineEnding ?? ''
    return message
  }
}

function createBaseEdiFactSchemaType(): EdiFactSchemaType {
  return {
    version: '',
    message: '',
    interchangeIdSelf: '',
    interchangeIdQualifierSelf: '',
    interchangeIdPartner: '',
    interchangeIdQualifierPartner: '',
    customEslSchema: ''
  }
}

export const EdiFactSchemaType = {
  encode(message: EdiFactSchemaType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.version !== '') {
      writer.uint32(10).string(message.version)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    if (message.interchangeIdSelf !== '') {
      writer.uint32(26).string(message.interchangeIdSelf)
    }
    if (message.interchangeIdQualifierSelf !== '') {
      writer.uint32(34).string(message.interchangeIdQualifierSelf)
    }
    if (message.interchangeIdPartner !== '') {
      writer.uint32(42).string(message.interchangeIdPartner)
    }
    if (message.interchangeIdQualifierPartner !== '') {
      writer.uint32(50).string(message.interchangeIdQualifierPartner)
    }
    if (message.customEslSchema !== '') {
      writer.uint32(58).string(message.customEslSchema)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EdiFactSchemaType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEdiFactSchemaType()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.version = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.interchangeIdSelf = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.interchangeIdQualifierSelf = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.interchangeIdPartner = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.interchangeIdQualifierPartner = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.customEslSchema = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EdiFactSchemaType {
    return {
      version: isSet(object.version) ? globalThis.String(object.version) : '',
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      interchangeIdSelf: isSet(object.interchangeIdSelf)
        ? globalThis.String(object.interchangeIdSelf)
        : '',
      interchangeIdQualifierSelf: isSet(object.interchangeIdQualifierSelf)
        ? globalThis.String(object.interchangeIdQualifierSelf)
        : '',
      interchangeIdPartner: isSet(object.interchangeIdPartner)
        ? globalThis.String(object.interchangeIdPartner)
        : '',
      interchangeIdQualifierPartner: isSet(object.interchangeIdQualifierPartner)
        ? globalThis.String(object.interchangeIdQualifierPartner)
        : '',
      customEslSchema: isSet(object.customEslSchema)
        ? globalThis.String(object.customEslSchema)
        : ''
    }
  },

  toJSON(message: EdiFactSchemaType): unknown {
    const obj: any = {}
    if (message.version !== '') {
      obj.version = message.version
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.interchangeIdSelf !== '') {
      obj.interchangeIdSelf = message.interchangeIdSelf
    }
    if (message.interchangeIdQualifierSelf !== '') {
      obj.interchangeIdQualifierSelf = message.interchangeIdQualifierSelf
    }
    if (message.interchangeIdPartner !== '') {
      obj.interchangeIdPartner = message.interchangeIdPartner
    }
    if (message.interchangeIdQualifierPartner !== '') {
      obj.interchangeIdQualifierPartner = message.interchangeIdQualifierPartner
    }
    if (message.customEslSchema !== '') {
      obj.customEslSchema = message.customEslSchema
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EdiFactSchemaType>, I>>(base?: I): EdiFactSchemaType {
    return EdiFactSchemaType.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EdiFactSchemaType>, I>>(object: I): EdiFactSchemaType {
    const message = createBaseEdiFactSchemaType()
    message.version = object.version ?? ''
    message.message = object.message ?? ''
    message.interchangeIdSelf = object.interchangeIdSelf ?? ''
    message.interchangeIdQualifierSelf = object.interchangeIdQualifierSelf ?? ''
    message.interchangeIdPartner = object.interchangeIdPartner ?? ''
    message.interchangeIdQualifierPartner = object.interchangeIdQualifierPartner ?? ''
    message.customEslSchema = object.customEslSchema ?? ''
    return message
  }
}

function createBaseHL7SchemaType(): HL7SchemaType {
  return { version: '', message: '', segmentTerminator: '', schemaType: '' }
}

export const HL7SchemaType = {
  encode(message: HL7SchemaType, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.version !== '') {
      writer.uint32(10).string(message.version)
    }
    if (message.message !== '') {
      writer.uint32(18).string(message.message)
    }
    if (message.segmentTerminator !== '') {
      writer.uint32(26).string(message.segmentTerminator)
    }
    if (message.schemaType !== '') {
      writer.uint32(34).string(message.schemaType)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): HL7SchemaType {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseHL7SchemaType()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.version = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.message = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.segmentTerminator = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.schemaType = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): HL7SchemaType {
    return {
      version: isSet(object.version) ? globalThis.String(object.version) : '',
      message: isSet(object.message) ? globalThis.String(object.message) : '',
      segmentTerminator: isSet(object.segmentTerminator)
        ? globalThis.String(object.segmentTerminator)
        : '',
      schemaType: isSet(object.schemaType) ? globalThis.String(object.schemaType) : ''
    }
  },

  toJSON(message: HL7SchemaType): unknown {
    const obj: any = {}
    if (message.version !== '') {
      obj.version = message.version
    }
    if (message.message !== '') {
      obj.message = message.message
    }
    if (message.segmentTerminator !== '') {
      obj.segmentTerminator = message.segmentTerminator
    }
    if (message.schemaType !== '') {
      obj.schemaType = message.schemaType
    }
    return obj
  },

  create<I extends Exact<DeepPartial<HL7SchemaType>, I>>(base?: I): HL7SchemaType {
    return HL7SchemaType.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<HL7SchemaType>, I>>(object: I): HL7SchemaType {
    const message = createBaseHL7SchemaType()
    message.version = object.version ?? ''
    message.message = object.message ?? ''
    message.segmentTerminator = object.segmentTerminator ?? ''
    message.schemaType = object.schemaType ?? ''
    return message
  }
}

function createBaseJiraDetail(): JiraDetail {
  return { issueKey: '', accessToken: '', title: '', description: '' }
}

export const JiraDetail = {
  encode(message: JiraDetail, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.issueKey !== '') {
      writer.uint32(10).string(message.issueKey)
    }
    if (message.accessToken !== '') {
      writer.uint32(18).string(message.accessToken)
    }
    if (message.title !== '') {
      writer.uint32(26).string(message.title)
    }
    if (message.description !== '') {
      writer.uint32(34).string(message.description)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): JiraDetail {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseJiraDetail()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.issueKey = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.accessToken = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.title = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.description = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): JiraDetail {
    return {
      issueKey: isSet(object.issueKey) ? globalThis.String(object.issueKey) : '',
      accessToken: isSet(object.accessToken) ? globalThis.String(object.accessToken) : '',
      title: isSet(object.title) ? globalThis.String(object.title) : '',
      description: isSet(object.description) ? globalThis.String(object.description) : ''
    }
  },

  toJSON(message: JiraDetail): unknown {
    const obj: any = {}
    if (message.issueKey !== '') {
      obj.issueKey = message.issueKey
    }
    if (message.accessToken !== '') {
      obj.accessToken = message.accessToken
    }
    if (message.title !== '') {
      obj.title = message.title
    }
    if (message.description !== '') {
      obj.description = message.description
    }
    return obj
  },

  create<I extends Exact<DeepPartial<JiraDetail>, I>>(base?: I): JiraDetail {
    return JiraDetail.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<JiraDetail>, I>>(object: I): JiraDetail {
    const message = createBaseJiraDetail()
    message.issueKey = object.issueKey ?? ''
    message.accessToken = object.accessToken ?? ''
    message.title = object.title ?? ''
    message.description = object.description ?? ''
    return message
  }
}

function createBaseSlackDetail(): SlackDetail {
  return { convoKey: '' }
}

export const SlackDetail = {
  encode(message: SlackDetail, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.convoKey !== '') {
      writer.uint32(10).string(message.convoKey)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SlackDetail {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSlackDetail()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.convoKey = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SlackDetail {
    return { convoKey: isSet(object.convoKey) ? globalThis.String(object.convoKey) : '' }
  },

  toJSON(message: SlackDetail): unknown {
    const obj: any = {}
    if (message.convoKey !== '') {
      obj.convoKey = message.convoKey
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SlackDetail>, I>>(base?: I): SlackDetail {
    return SlackDetail.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SlackDetail>, I>>(object: I): SlackDetail {
    const message = createBaseSlackDetail()
    message.convoKey = object.convoKey ?? ''
    return message
  }
}

function createBaseEclipseDetail(): EclipseDetail {
  return { diffs: undefined }
}

export const EclipseDetail = {
  encode(message: EclipseDetail, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.diffs !== undefined) {
      EclipseDiffsData.encode(message.diffs, writer.uint32(10).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EclipseDetail {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEclipseDetail()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.diffs = EclipseDiffsData.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): EclipseDetail {
    return { diffs: isSet(object.diffs) ? EclipseDiffsData.fromJSON(object.diffs) : undefined }
  },

  toJSON(message: EclipseDetail): unknown {
    const obj: any = {}
    if (message.diffs !== undefined) {
      obj.diffs = EclipseDiffsData.toJSON(message.diffs)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<EclipseDetail>, I>>(base?: I): EclipseDetail {
    return EclipseDetail.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EclipseDetail>, I>>(object: I): EclipseDetail {
    const message = createBaseEclipseDetail()
    message.diffs =
      object.diffs !== undefined && object.diffs !== null
        ? EclipseDiffsData.fromPartial(object.diffs)
        : undefined
    return message
  }
}

function createBaseEclipseDiffsData(): EclipseDiffsData {
  return {}
}

export const EclipseDiffsData = {
  encode(_: EclipseDiffsData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EclipseDiffsData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseEclipseDiffsData()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(_: any): EclipseDiffsData {
    return {}
  },

  toJSON(_: EclipseDiffsData): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<EclipseDiffsData>, I>>(base?: I): EclipseDiffsData {
    return EclipseDiffsData.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<EclipseDiffsData>, I>>(_: I): EclipseDiffsData {
    const message = createBaseEclipseDiffsData()
    return message
  }
}

function createBaseGithubDetail(): GithubDetail {
  return { accessToken: '', orgName: '', repoName: '', branchName: '', commitId: '', issueId: '' }
}

export const GithubDetail = {
  encode(message: GithubDetail, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.accessToken !== '') {
      writer.uint32(10).string(message.accessToken)
    }
    if (message.orgName !== '') {
      writer.uint32(18).string(message.orgName)
    }
    if (message.repoName !== '') {
      writer.uint32(26).string(message.repoName)
    }
    if (message.branchName !== '') {
      writer.uint32(34).string(message.branchName)
    }
    if (message.commitId !== '') {
      writer.uint32(42).string(message.commitId)
    }
    if (message.issueId !== '') {
      writer.uint32(50).string(message.issueId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GithubDetail {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGithubDetail()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.accessToken = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.orgName = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.repoName = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.branchName = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.commitId = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.issueId = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GithubDetail {
    return {
      accessToken: isSet(object.accessToken) ? globalThis.String(object.accessToken) : '',
      orgName: isSet(object.orgName) ? globalThis.String(object.orgName) : '',
      repoName: isSet(object.repoName) ? globalThis.String(object.repoName) : '',
      branchName: isSet(object.branchName) ? globalThis.String(object.branchName) : '',
      commitId: isSet(object.commitId) ? globalThis.String(object.commitId) : '',
      issueId: isSet(object.issueId) ? globalThis.String(object.issueId) : ''
    }
  },

  toJSON(message: GithubDetail): unknown {
    const obj: any = {}
    if (message.accessToken !== '') {
      obj.accessToken = message.accessToken
    }
    if (message.orgName !== '') {
      obj.orgName = message.orgName
    }
    if (message.repoName !== '') {
      obj.repoName = message.repoName
    }
    if (message.branchName !== '') {
      obj.branchName = message.branchName
    }
    if (message.commitId !== '') {
      obj.commitId = message.commitId
    }
    if (message.issueId !== '') {
      obj.issueId = message.issueId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GithubDetail>, I>>(base?: I): GithubDetail {
    return GithubDetail.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GithubDetail>, I>>(object: I): GithubDetail {
    const message = createBaseGithubDetail()
    message.accessToken = object.accessToken ?? ''
    message.orgName = object.orgName ?? ''
    message.repoName = object.repoName ?? ''
    message.branchName = object.branchName ?? ''
    message.commitId = object.commitId ?? ''
    message.issueId = object.issueId ?? ''
    return message
  }
}

function createBaseConnectionDetail(): ConnectionDetail {
  return {
    githubDetail: undefined,
    jiraDetail: undefined,
    slackDetail: undefined,
    eclipseDetail: undefined
  }
}

export const ConnectionDetail = {
  encode(message: ConnectionDetail, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.githubDetail !== undefined) {
      GithubDetail.encode(message.githubDetail, writer.uint32(10).fork()).ldelim()
    }
    if (message.jiraDetail !== undefined) {
      JiraDetail.encode(message.jiraDetail, writer.uint32(18).fork()).ldelim()
    }
    if (message.slackDetail !== undefined) {
      SlackDetail.encode(message.slackDetail, writer.uint32(26).fork()).ldelim()
    }
    if (message.eclipseDetail !== undefined) {
      EclipseDetail.encode(message.eclipseDetail, writer.uint32(34).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConnectionDetail {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConnectionDetail()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.githubDetail = GithubDetail.decode(reader, reader.uint32())
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.jiraDetail = JiraDetail.decode(reader, reader.uint32())
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.slackDetail = SlackDetail.decode(reader, reader.uint32())
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.eclipseDetail = EclipseDetail.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConnectionDetail {
    return {
      githubDetail: isSet(object.githubDetail)
        ? GithubDetail.fromJSON(object.githubDetail)
        : undefined,
      jiraDetail: isSet(object.jiraDetail) ? JiraDetail.fromJSON(object.jiraDetail) : undefined,
      slackDetail: isSet(object.slackDetail) ? SlackDetail.fromJSON(object.slackDetail) : undefined,
      eclipseDetail: isSet(object.eclipseDetail)
        ? EclipseDetail.fromJSON(object.eclipseDetail)
        : undefined
    }
  },

  toJSON(message: ConnectionDetail): unknown {
    const obj: any = {}
    if (message.githubDetail !== undefined) {
      obj.githubDetail = GithubDetail.toJSON(message.githubDetail)
    }
    if (message.jiraDetail !== undefined) {
      obj.jiraDetail = JiraDetail.toJSON(message.jiraDetail)
    }
    if (message.slackDetail !== undefined) {
      obj.slackDetail = SlackDetail.toJSON(message.slackDetail)
    }
    if (message.eclipseDetail !== undefined) {
      obj.eclipseDetail = EclipseDetail.toJSON(message.eclipseDetail)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConnectionDetail>, I>>(base?: I): ConnectionDetail {
    return ConnectionDetail.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConnectionDetail>, I>>(object: I): ConnectionDetail {
    const message = createBaseConnectionDetail()
    message.githubDetail =
      object.githubDetail !== undefined && object.githubDetail !== null
        ? GithubDetail.fromPartial(object.githubDetail)
        : undefined
    message.jiraDetail =
      object.jiraDetail !== undefined && object.jiraDetail !== null
        ? JiraDetail.fromPartial(object.jiraDetail)
        : undefined
    message.slackDetail =
      object.slackDetail !== undefined && object.slackDetail !== null
        ? SlackDetail.fromPartial(object.slackDetail)
        : undefined
    message.eclipseDetail =
      object.eclipseDetail !== undefined && object.eclipseDetail !== null
        ? EclipseDetail.fromPartial(object.eclipseDetail)
        : undefined
    return message
  }
}

function createBaseInputOutputTokens(): InputOutputTokens {
  return { inputTokens: 0, outputTokens: 0 }
}

export const InputOutputTokens = {
  encode(message: InputOutputTokens, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.inputTokens !== 0) {
      writer.uint32(8).int64(message.inputTokens)
    }
    if (message.outputTokens !== 0) {
      writer.uint32(16).int64(message.outputTokens)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): InputOutputTokens {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseInputOutputTokens()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.inputTokens = longToNumber(reader.int64() as Long)
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.outputTokens = longToNumber(reader.int64() as Long)
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): InputOutputTokens {
    return {
      inputTokens: isSet(object.inputTokens) ? globalThis.Number(object.inputTokens) : 0,
      outputTokens: isSet(object.outputTokens) ? globalThis.Number(object.outputTokens) : 0
    }
  },

  toJSON(message: InputOutputTokens): unknown {
    const obj: any = {}
    if (message.inputTokens !== 0) {
      obj.inputTokens = Math.round(message.inputTokens)
    }
    if (message.outputTokens !== 0) {
      obj.outputTokens = Math.round(message.outputTokens)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<InputOutputTokens>, I>>(base?: I): InputOutputTokens {
    return InputOutputTokens.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<InputOutputTokens>, I>>(object: I): InputOutputTokens {
    const message = createBaseInputOutputTokens()
    message.inputTokens = object.inputTokens ?? 0
    message.outputTokens = object.outputTokens ?? 0
    return message
  }
}

function createBaseUsageData(): UsageData {
  return { modelUsage: {}, metadata: '' }
}

export const UsageData = {
  encode(message: UsageData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    Object.entries(message.modelUsage).forEach(([key, value]) => {
      UsageData_ModelUsageEntry.encode(
        { key: key as any, value },
        writer.uint32(10).fork()
      ).ldelim()
    })
    if (message.metadata !== '') {
      writer.uint32(18).string(message.metadata)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UsageData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUsageData()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          const entry1 = UsageData_ModelUsageEntry.decode(reader, reader.uint32())
          if (entry1.value !== undefined) {
            message.modelUsage[entry1.key] = entry1.value
          }
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.metadata = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UsageData {
    return {
      modelUsage: isObject(object.modelUsage)
        ? Object.entries(object.modelUsage).reduce<{ [key: string]: InputOutputTokens }>(
            (acc, [key, value]) => {
              acc[key] = InputOutputTokens.fromJSON(value)
              return acc
            },
            {}
          )
        : {},
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : ''
    }
  },

  toJSON(message: UsageData): unknown {
    const obj: any = {}
    if (message.modelUsage) {
      const entries = Object.entries(message.modelUsage)
      if (entries.length > 0) {
        obj.modelUsage = {}
        entries.forEach(([k, v]) => {
          obj.modelUsage[k] = InputOutputTokens.toJSON(v)
        })
      }
    }
    if (message.metadata !== '') {
      obj.metadata = message.metadata
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UsageData>, I>>(base?: I): UsageData {
    return UsageData.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UsageData>, I>>(object: I): UsageData {
    const message = createBaseUsageData()
    message.modelUsage = Object.entries(object.modelUsage ?? {}).reduce<{
      [key: string]: InputOutputTokens
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = InputOutputTokens.fromPartial(value)
      }
      return acc
    }, {})
    message.metadata = object.metadata ?? ''
    return message
  }
}

function createBaseUsageData_ModelUsageEntry(): UsageData_ModelUsageEntry {
  return { key: '', value: undefined }
}

export const UsageData_ModelUsageEntry = {
  encode(message: UsageData_ModelUsageEntry, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== undefined) {
      InputOutputTokens.encode(message.value, writer.uint32(18).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UsageData_ModelUsageEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseUsageData_ModelUsageEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.value = InputOutputTokens.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): UsageData_ModelUsageEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? InputOutputTokens.fromJSON(object.value) : undefined
    }
  },

  toJSON(message: UsageData_ModelUsageEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== undefined) {
      obj.value = InputOutputTokens.toJSON(message.value)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<UsageData_ModelUsageEntry>, I>>(
    base?: I
  ): UsageData_ModelUsageEntry {
    return UsageData_ModelUsageEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<UsageData_ModelUsageEntry>, I>>(
    object: I
  ): UsageData_ModelUsageEntry {
    const message = createBaseUsageData_ModelUsageEntry()
    message.key = object.key ?? ''
    message.value =
      object.value !== undefined && object.value !== null
        ? InputOutputTokens.fromPartial(object.value)
        : undefined
    return message
  }
}

function createBaseCodeContext(): CodeContext {
  return {
    connType: '',
    orgName: '',
    repoName: '',
    branchName: '',
    commitId: '',
    s3TarFilePath: ''
  }
}

export const CodeContext = {
  encode(message: CodeContext, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.connType !== '') {
      writer.uint32(10).string(message.connType)
    }
    if (message.orgName !== '') {
      writer.uint32(18).string(message.orgName)
    }
    if (message.repoName !== '') {
      writer.uint32(26).string(message.repoName)
    }
    if (message.branchName !== '') {
      writer.uint32(34).string(message.branchName)
    }
    if (message.commitId !== '') {
      writer.uint32(42).string(message.commitId)
    }
    if (message.s3TarFilePath !== '') {
      writer.uint32(50).string(message.s3TarFilePath)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CodeContext {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCodeContext()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.connType = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.orgName = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.repoName = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.branchName = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.commitId = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.s3TarFilePath = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CodeContext {
    return {
      connType: isSet(object.connType) ? globalThis.String(object.connType) : '',
      orgName: isSet(object.orgName) ? globalThis.String(object.orgName) : '',
      repoName: isSet(object.repoName) ? globalThis.String(object.repoName) : '',
      branchName: isSet(object.branchName) ? globalThis.String(object.branchName) : '',
      commitId: isSet(object.commitId) ? globalThis.String(object.commitId) : '',
      s3TarFilePath: isSet(object.s3TarFilePath) ? globalThis.String(object.s3TarFilePath) : ''
    }
  },

  toJSON(message: CodeContext): unknown {
    const obj: any = {}
    if (message.connType !== '') {
      obj.connType = message.connType
    }
    if (message.orgName !== '') {
      obj.orgName = message.orgName
    }
    if (message.repoName !== '') {
      obj.repoName = message.repoName
    }
    if (message.branchName !== '') {
      obj.branchName = message.branchName
    }
    if (message.commitId !== '') {
      obj.commitId = message.commitId
    }
    if (message.s3TarFilePath !== '') {
      obj.s3TarFilePath = message.s3TarFilePath
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CodeContext>, I>>(base?: I): CodeContext {
    return CodeContext.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CodeContext>, I>>(object: I): CodeContext {
    const message = createBaseCodeContext()
    message.connType = object.connType ?? ''
    message.orgName = object.orgName ?? ''
    message.repoName = object.repoName ?? ''
    message.branchName = object.branchName ?? ''
    message.commitId = object.commitId ?? ''
    message.s3TarFilePath = object.s3TarFilePath ?? ''
    return message
  }
}

function createBasePluginContext(): PluginContext {
  return {
    pluginName: '',
    pluginVersion: '',
    openedFilePaths: [],
    attachedFilePaths: [],
    activeFilePath: '',
    selectedContent: '',
    repoStateChanged: false,
    enableFormWidgets: false,
    prevCodeContext: undefined
  }
}

export const PluginContext = {
  encode(message: PluginContext, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.pluginName !== '') {
      writer.uint32(10).string(message.pluginName)
    }
    if (message.pluginVersion !== '') {
      writer.uint32(18).string(message.pluginVersion)
    }
    for (const v of message.openedFilePaths) {
      writer.uint32(26).string(v!)
    }
    for (const v of message.attachedFilePaths) {
      writer.uint32(34).string(v!)
    }
    if (message.activeFilePath !== '') {
      writer.uint32(42).string(message.activeFilePath)
    }
    if (message.selectedContent !== '') {
      writer.uint32(50).string(message.selectedContent)
    }
    if (message.repoStateChanged !== false) {
      writer.uint32(56).bool(message.repoStateChanged)
    }
    if (message.enableFormWidgets !== false) {
      writer.uint32(64).bool(message.enableFormWidgets)
    }
    if (message.prevCodeContext !== undefined) {
      CodeContext.encode(message.prevCodeContext, writer.uint32(74).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): PluginContext {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBasePluginContext()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.pluginName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.pluginVersion = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.openedFilePaths.push(reader.string())
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.attachedFilePaths.push(reader.string())
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.activeFilePath = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.selectedContent = reader.string()
          continue
        case 7:
          if (tag !== 56) {
            break
          }

          message.repoStateChanged = reader.bool()
          continue
        case 8:
          if (tag !== 64) {
            break
          }

          message.enableFormWidgets = reader.bool()
          continue
        case 9:
          if (tag !== 74) {
            break
          }

          message.prevCodeContext = CodeContext.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): PluginContext {
    return {
      pluginName: isSet(object.pluginName) ? globalThis.String(object.pluginName) : '',
      pluginVersion: isSet(object.pluginVersion) ? globalThis.String(object.pluginVersion) : '',
      openedFilePaths: globalThis.Array.isArray(object?.openedFilePaths)
        ? object.openedFilePaths.map((e: any) => globalThis.String(e))
        : [],
      attachedFilePaths: globalThis.Array.isArray(object?.attachedFilePaths)
        ? object.attachedFilePaths.map((e: any) => globalThis.String(e))
        : [],
      activeFilePath: isSet(object.activeFilePath) ? globalThis.String(object.activeFilePath) : '',
      selectedContent: isSet(object.selectedContent)
        ? globalThis.String(object.selectedContent)
        : '',
      repoStateChanged: isSet(object.repoStateChanged)
        ? globalThis.Boolean(object.repoStateChanged)
        : false,
      enableFormWidgets: isSet(object.enableFormWidgets)
        ? globalThis.Boolean(object.enableFormWidgets)
        : false,
      prevCodeContext: isSet(object.prevCodeContext)
        ? CodeContext.fromJSON(object.prevCodeContext)
        : undefined
    }
  },

  toJSON(message: PluginContext): unknown {
    const obj: any = {}
    if (message.pluginName !== '') {
      obj.pluginName = message.pluginName
    }
    if (message.pluginVersion !== '') {
      obj.pluginVersion = message.pluginVersion
    }
    if (message.openedFilePaths?.length) {
      obj.openedFilePaths = message.openedFilePaths
    }
    if (message.attachedFilePaths?.length) {
      obj.attachedFilePaths = message.attachedFilePaths
    }
    if (message.activeFilePath !== '') {
      obj.activeFilePath = message.activeFilePath
    }
    if (message.selectedContent !== '') {
      obj.selectedContent = message.selectedContent
    }
    if (message.repoStateChanged !== false) {
      obj.repoStateChanged = message.repoStateChanged
    }
    if (message.enableFormWidgets !== false) {
      obj.enableFormWidgets = message.enableFormWidgets
    }
    if (message.prevCodeContext !== undefined) {
      obj.prevCodeContext = CodeContext.toJSON(message.prevCodeContext)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<PluginContext>, I>>(base?: I): PluginContext {
    return PluginContext.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<PluginContext>, I>>(object: I): PluginContext {
    const message = createBasePluginContext()
    message.pluginName = object.pluginName ?? ''
    message.pluginVersion = object.pluginVersion ?? ''
    message.openedFilePaths = object.openedFilePaths?.map(e => e) || []
    message.attachedFilePaths = object.attachedFilePaths?.map(e => e) || []
    message.activeFilePath = object.activeFilePath ?? ''
    message.selectedContent = object.selectedContent ?? ''
    message.repoStateChanged = object.repoStateChanged ?? false
    message.enableFormWidgets = object.enableFormWidgets ?? false
    message.prevCodeContext =
      object.prevCodeContext !== undefined && object.prevCodeContext !== null
        ? CodeContext.fromPartial(object.prevCodeContext)
        : undefined
    return message
  }
}

function createBaseMetadata(): Metadata {
  return {
    codeConnectionDetail: undefined,
    messages: [],
    codeContext: undefined,
    multiRepoCodeContext: [],
    auxiliaryCodeContext: []
  }
}

export const Metadata = {
  encode(message: Metadata, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.codeConnectionDetail !== undefined) {
      ConnectionDetail.encode(message.codeConnectionDetail, writer.uint32(10).fork()).ldelim()
    }
    for (const v of message.messages) {
      Message.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    if (message.codeContext !== undefined) {
      CodeContext.encode(message.codeContext, writer.uint32(26).fork()).ldelim()
    }
    for (const v of message.multiRepoCodeContext) {
      CodeContext.encode(v!, writer.uint32(34).fork()).ldelim()
    }
    for (const v of message.auxiliaryCodeContext) {
      CodeContext.encode(v!, writer.uint32(42).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Metadata {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMetadata()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.codeConnectionDetail = ConnectionDetail.decode(reader, reader.uint32())
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.messages.push(Message.decode(reader, reader.uint32()))
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.codeContext = CodeContext.decode(reader, reader.uint32())
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.multiRepoCodeContext.push(CodeContext.decode(reader, reader.uint32()))
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.auxiliaryCodeContext.push(CodeContext.decode(reader, reader.uint32()))
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Metadata {
    return {
      codeConnectionDetail: isSet(object.codeConnectionDetail)
        ? ConnectionDetail.fromJSON(object.codeConnectionDetail)
        : undefined,
      messages: globalThis.Array.isArray(object?.messages)
        ? object.messages.map((e: any) => Message.fromJSON(e))
        : [],
      codeContext: isSet(object.codeContext) ? CodeContext.fromJSON(object.codeContext) : undefined,
      multiRepoCodeContext: globalThis.Array.isArray(object?.multiRepoCodeContext)
        ? object.multiRepoCodeContext.map((e: any) => CodeContext.fromJSON(e))
        : [],
      auxiliaryCodeContext: globalThis.Array.isArray(object?.auxiliaryCodeContext)
        ? object.auxiliaryCodeContext.map((e: any) => CodeContext.fromJSON(e))
        : []
    }
  },

  toJSON(message: Metadata): unknown {
    const obj: any = {}
    if (message.codeConnectionDetail !== undefined) {
      obj.codeConnectionDetail = ConnectionDetail.toJSON(message.codeConnectionDetail)
    }
    if (message.messages?.length) {
      obj.messages = message.messages.map(e => Message.toJSON(e))
    }
    if (message.codeContext !== undefined) {
      obj.codeContext = CodeContext.toJSON(message.codeContext)
    }
    if (message.multiRepoCodeContext?.length) {
      obj.multiRepoCodeContext = message.multiRepoCodeContext.map(e => CodeContext.toJSON(e))
    }
    if (message.auxiliaryCodeContext?.length) {
      obj.auxiliaryCodeContext = message.auxiliaryCodeContext.map(e => CodeContext.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Metadata>, I>>(base?: I): Metadata {
    return Metadata.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Metadata>, I>>(object: I): Metadata {
    const message = createBaseMetadata()
    message.codeConnectionDetail =
      object.codeConnectionDetail !== undefined && object.codeConnectionDetail !== null
        ? ConnectionDetail.fromPartial(object.codeConnectionDetail)
        : undefined
    message.messages = object.messages?.map(e => Message.fromPartial(e)) || []
    message.codeContext =
      object.codeContext !== undefined && object.codeContext !== null
        ? CodeContext.fromPartial(object.codeContext)
        : undefined
    message.multiRepoCodeContext =
      object.multiRepoCodeContext?.map(e => CodeContext.fromPartial(e)) || []
    message.auxiliaryCodeContext =
      object.auxiliaryCodeContext?.map(e => CodeContext.fromPartial(e)) || []
    return message
  }
}

function createBaseMessage(): Message {
  return {
    role: '',
    userName: '',
    content: '',
    messageType: 0,
    timestampMs: 0,
    formWidget: [],
    chatSelectionWidget: []
  }
}

export const Message = {
  encode(message: Message, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.role !== '') {
      writer.uint32(10).string(message.role)
    }
    if (message.userName !== '') {
      writer.uint32(18).string(message.userName)
    }
    if (message.content !== '') {
      writer.uint32(26).string(message.content)
    }
    if (message.messageType !== 0) {
      writer.uint32(32).int32(message.messageType)
    }
    if (message.timestampMs !== 0) {
      writer.uint32(40).int64(message.timestampMs)
    }
    for (const v of message.formWidget) {
      FormWidget.encode(v!, writer.uint32(50).fork()).ldelim()
    }
    for (const v of message.chatSelectionWidget) {
      ChatSelectionWidget.encode(v!, writer.uint32(58).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Message {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMessage()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.role = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.userName = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.content = reader.string()
          continue
        case 4:
          if (tag !== 32) {
            break
          }

          message.messageType = reader.int32() as any
          continue
        case 5:
          if (tag !== 40) {
            break
          }

          message.timestampMs = longToNumber(reader.int64() as Long)
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.formWidget.push(FormWidget.decode(reader, reader.uint32()))
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.chatSelectionWidget.push(ChatSelectionWidget.decode(reader, reader.uint32()))
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Message {
    return {
      role: isSet(object.role) ? globalThis.String(object.role) : '',
      userName: isSet(object.userName) ? globalThis.String(object.userName) : '',
      content: isSet(object.content) ? globalThis.String(object.content) : '',
      messageType: isSet(object.messageType) ? messageTypeFromJSON(object.messageType) : 0,
      timestampMs: isSet(object.timestampMs) ? globalThis.Number(object.timestampMs) : 0,
      formWidget: globalThis.Array.isArray(object?.formWidget)
        ? object.formWidget.map((e: any) => FormWidget.fromJSON(e))
        : [],
      chatSelectionWidget: globalThis.Array.isArray(object?.chatSelectionWidget)
        ? object.chatSelectionWidget.map((e: any) => ChatSelectionWidget.fromJSON(e))
        : []
    }
  },

  toJSON(message: Message): unknown {
    const obj: any = {}
    if (message.role !== '') {
      obj.role = message.role
    }
    if (message.userName !== '') {
      obj.userName = message.userName
    }
    if (message.content !== '') {
      obj.content = message.content
    }
    if (message.messageType !== 0) {
      obj.messageType = messageTypeToJSON(message.messageType)
    }
    if (message.timestampMs !== 0) {
      obj.timestampMs = Math.round(message.timestampMs)
    }
    if (message.formWidget?.length) {
      obj.formWidget = message.formWidget.map(e => FormWidget.toJSON(e))
    }
    if (message.chatSelectionWidget?.length) {
      obj.chatSelectionWidget = message.chatSelectionWidget.map(e => ChatSelectionWidget.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Message>, I>>(base?: I): Message {
    return Message.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Message>, I>>(object: I): Message {
    const message = createBaseMessage()
    message.role = object.role ?? ''
    message.userName = object.userName ?? ''
    message.content = object.content ?? ''
    message.messageType = object.messageType ?? 0
    message.timestampMs = object.timestampMs ?? 0
    message.formWidget = object.formWidget?.map(e => FormWidget.fromPartial(e)) || []
    message.chatSelectionWidget =
      object.chatSelectionWidget?.map(e => ChatSelectionWidget.fromPartial(e)) || []
    return message
  }
}

function createBaseCommand(): Command {
  return {
    commandType: 0,
    commandString: '',
    images: [],
    formWidget: [],
    fileUploads: [],
    contextUpload: undefined,
    projectName: '',
    executionMode: 0,
    verificationMode: 0
  }
}

export const Command = {
  encode(message: Command, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.commandType !== 0) {
      writer.uint32(8).int32(message.commandType)
    }
    if (message.commandString !== '') {
      writer.uint32(18).string(message.commandString)
    }
    for (const v of message.images) {
      Image.encode(v!, writer.uint32(26).fork()).ldelim()
    }
    for (const v of message.formWidget) {
      FormWidget.encode(v!, writer.uint32(34).fork()).ldelim()
    }
    for (const v of message.fileUploads) {
      FileUpload.encode(v!, writer.uint32(42).fork()).ldelim()
    }
    if (message.contextUpload !== undefined) {
      ContextUpload.encode(message.contextUpload, writer.uint32(50).fork()).ldelim()
    }
    if (message.projectName !== '') {
      writer.uint32(58).string(message.projectName)
    }
    if (message.executionMode !== 0) {
      writer.uint32(64).int32(message.executionMode)
    }
    if (message.verificationMode !== 0) {
      writer.uint32(72).int32(message.verificationMode)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Command {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCommand()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.commandType = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.commandString = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.images.push(Image.decode(reader, reader.uint32()))
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.formWidget.push(FormWidget.decode(reader, reader.uint32()))
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.fileUploads.push(FileUpload.decode(reader, reader.uint32()))
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.contextUpload = ContextUpload.decode(reader, reader.uint32())
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.projectName = reader.string()
          continue
        case 8:
          if (tag !== 64) {
            break
          }

          message.executionMode = reader.int32() as any
          continue
        case 9:
          if (tag !== 72) {
            break
          }

          message.verificationMode = reader.int32() as any
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Command {
    return {
      commandType: isSet(object.commandType) ? commandTypeFromJSON(object.commandType) : 0,
      commandString: isSet(object.commandString) ? globalThis.String(object.commandString) : '',
      images: globalThis.Array.isArray(object?.images)
        ? object.images.map((e: any) => Image.fromJSON(e))
        : [],
      formWidget: globalThis.Array.isArray(object?.formWidget)
        ? object.formWidget.map((e: any) => FormWidget.fromJSON(e))
        : [],
      fileUploads: globalThis.Array.isArray(object?.fileUploads)
        ? object.fileUploads.map((e: any) => FileUpload.fromJSON(e))
        : [],
      contextUpload: isSet(object.contextUpload)
        ? ContextUpload.fromJSON(object.contextUpload)
        : undefined,
      projectName: isSet(object.projectName) ? globalThis.String(object.projectName) : '',
      executionMode: isSet(object.executionMode) ? executionModeFromJSON(object.executionMode) : 0,
      verificationMode: isSet(object.verificationMode)
        ? verificationModeFromJSON(object.verificationMode)
        : 0
    }
  },

  toJSON(message: Command): unknown {
    const obj: any = {}
    if (message.commandType !== 0) {
      obj.commandType = commandTypeToJSON(message.commandType)
    }
    if (message.commandString !== '') {
      obj.commandString = message.commandString
    }
    if (message.images?.length) {
      obj.images = message.images.map(e => Image.toJSON(e))
    }
    if (message.formWidget?.length) {
      obj.formWidget = message.formWidget.map(e => FormWidget.toJSON(e))
    }
    if (message.fileUploads?.length) {
      obj.fileUploads = message.fileUploads.map(e => FileUpload.toJSON(e))
    }
    if (message.contextUpload !== undefined) {
      obj.contextUpload = ContextUpload.toJSON(message.contextUpload)
    }
    if (message.projectName !== '') {
      obj.projectName = message.projectName
    }
    if (message.executionMode !== 0) {
      obj.executionMode = executionModeToJSON(message.executionMode)
    }
    if (message.verificationMode !== 0) {
      obj.verificationMode = verificationModeToJSON(message.verificationMode)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Command>, I>>(base?: I): Command {
    return Command.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Command>, I>>(object: I): Command {
    const message = createBaseCommand()
    message.commandType = object.commandType ?? 0
    message.commandString = object.commandString ?? ''
    message.images = object.images?.map(e => Image.fromPartial(e)) || []
    message.formWidget = object.formWidget?.map(e => FormWidget.fromPartial(e)) || []
    message.fileUploads = object.fileUploads?.map(e => FileUpload.fromPartial(e)) || []
    message.contextUpload =
      object.contextUpload !== undefined && object.contextUpload !== null
        ? ContextUpload.fromPartial(object.contextUpload)
        : undefined
    message.projectName = object.projectName ?? ''
    message.executionMode = object.executionMode ?? 0
    message.verificationMode = object.verificationMode ?? 0
    return message
  }
}

function createBaseCodePlan(): CodePlan {
  return { rawTxt: '', fileMultiSelect: undefined, svgFlows: [] }
}

export const CodePlan = {
  encode(message: CodePlan, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.rawTxt !== '') {
      writer.uint32(10).string(message.rawTxt)
    }
    if (message.fileMultiSelect !== undefined) {
      MultiSelect.encode(message.fileMultiSelect, writer.uint32(18).fork()).ldelim()
    }
    for (const v of message.svgFlows) {
      writer.uint32(26).string(v!)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CodePlan {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCodePlan()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.rawTxt = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.fileMultiSelect = MultiSelect.decode(reader, reader.uint32())
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.svgFlows.push(reader.string())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CodePlan {
    return {
      rawTxt: isSet(object.rawTxt) ? globalThis.String(object.rawTxt) : '',
      fileMultiSelect: isSet(object.fileMultiSelect)
        ? MultiSelect.fromJSON(object.fileMultiSelect)
        : undefined,
      svgFlows: globalThis.Array.isArray(object?.svgFlows)
        ? object.svgFlows.map((e: any) => globalThis.String(e))
        : []
    }
  },

  toJSON(message: CodePlan): unknown {
    const obj: any = {}
    if (message.rawTxt !== '') {
      obj.rawTxt = message.rawTxt
    }
    if (message.fileMultiSelect !== undefined) {
      obj.fileMultiSelect = MultiSelect.toJSON(message.fileMultiSelect)
    }
    if (message.svgFlows?.length) {
      obj.svgFlows = message.svgFlows
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CodePlan>, I>>(base?: I): CodePlan {
    return CodePlan.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CodePlan>, I>>(object: I): CodePlan {
    const message = createBaseCodePlan()
    message.rawTxt = object.rawTxt ?? ''
    message.fileMultiSelect =
      object.fileMultiSelect !== undefined && object.fileMultiSelect !== null
        ? MultiSelect.fromPartial(object.fileMultiSelect)
        : undefined
    message.svgFlows = object.svgFlows?.map(e => e) || []
    return message
  }
}

function createBaseMunitScenarios(): MunitScenarios {
  return { mdText: '', rawData: '' }
}

export const MunitScenarios = {
  encode(message: MunitScenarios, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.mdText !== '') {
      writer.uint32(10).string(message.mdText)
    }
    if (message.rawData !== '') {
      writer.uint32(18).string(message.rawData)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): MunitScenarios {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseMunitScenarios()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.mdText = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.rawData = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): MunitScenarios {
    return {
      mdText: isSet(object.mdText) ? globalThis.String(object.mdText) : '',
      rawData: isSet(object.rawData) ? globalThis.String(object.rawData) : ''
    }
  },

  toJSON(message: MunitScenarios): unknown {
    const obj: any = {}
    if (message.mdText !== '') {
      obj.mdText = message.mdText
    }
    if (message.rawData !== '') {
      obj.rawData = message.rawData
    }
    return obj
  },

  create<I extends Exact<DeepPartial<MunitScenarios>, I>>(base?: I): MunitScenarios {
    return MunitScenarios.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<MunitScenarios>, I>>(object: I): MunitScenarios {
    const message = createBaseMunitScenarios()
    message.mdText = object.mdText ?? ''
    message.rawData = object.rawData ?? ''
    return message
  }
}

function createBaseDataWeaveGenCodeOutput(): DataWeaveGenCodeOutput {
  return { code: '', errorMsg: '', sourceData: '', outputData: '', userMarkdownMsg: '' }
}

export const DataWeaveGenCodeOutput = {
  encode(message: DataWeaveGenCodeOutput, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.code !== '') {
      writer.uint32(10).string(message.code)
    }
    if (message.errorMsg !== '') {
      writer.uint32(18).string(message.errorMsg)
    }
    if (message.sourceData !== '') {
      writer.uint32(26).string(message.sourceData)
    }
    if (message.outputData !== '') {
      writer.uint32(34).string(message.outputData)
    }
    if (message.userMarkdownMsg !== '') {
      writer.uint32(42).string(message.userMarkdownMsg)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DataWeaveGenCodeOutput {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDataWeaveGenCodeOutput()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.code = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.errorMsg = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.sourceData = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.outputData = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.userMarkdownMsg = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DataWeaveGenCodeOutput {
    return {
      code: isSet(object.code) ? globalThis.String(object.code) : '',
      errorMsg: isSet(object.errorMsg) ? globalThis.String(object.errorMsg) : '',
      sourceData: isSet(object.sourceData) ? globalThis.String(object.sourceData) : '',
      outputData: isSet(object.outputData) ? globalThis.String(object.outputData) : '',
      userMarkdownMsg: isSet(object.userMarkdownMsg)
        ? globalThis.String(object.userMarkdownMsg)
        : ''
    }
  },

  toJSON(message: DataWeaveGenCodeOutput): unknown {
    const obj: any = {}
    if (message.code !== '') {
      obj.code = message.code
    }
    if (message.errorMsg !== '') {
      obj.errorMsg = message.errorMsg
    }
    if (message.sourceData !== '') {
      obj.sourceData = message.sourceData
    }
    if (message.outputData !== '') {
      obj.outputData = message.outputData
    }
    if (message.userMarkdownMsg !== '') {
      obj.userMarkdownMsg = message.userMarkdownMsg
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DataWeaveGenCodeOutput>, I>>(
    base?: I
  ): DataWeaveGenCodeOutput {
    return DataWeaveGenCodeOutput.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DataWeaveGenCodeOutput>, I>>(
    object: I
  ): DataWeaveGenCodeOutput {
    const message = createBaseDataWeaveGenCodeOutput()
    message.code = object.code ?? ''
    message.errorMsg = object.errorMsg ?? ''
    message.sourceData = object.sourceData ?? ''
    message.outputData = object.outputData ?? ''
    message.userMarkdownMsg = object.userMarkdownMsg ?? ''
    return message
  }
}

function createBaseDiff(): Diff {
  return {
    diffType: 0,
    aFilePath: '',
    bFilePath: '',
    aFileContent: '',
    bFileContent: '',
    patchBA: '',
    aCommitId: ''
  }
}

export const Diff = {
  encode(message: Diff, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.diffType !== 0) {
      writer.uint32(8).int32(message.diffType)
    }
    if (message.aFilePath !== '') {
      writer.uint32(18).string(message.aFilePath)
    }
    if (message.bFilePath !== '') {
      writer.uint32(26).string(message.bFilePath)
    }
    if (message.aFileContent !== '') {
      writer.uint32(34).string(message.aFileContent)
    }
    if (message.bFileContent !== '') {
      writer.uint32(42).string(message.bFileContent)
    }
    if (message.patchBA !== '') {
      writer.uint32(50).string(message.patchBA)
    }
    if (message.aCommitId !== '') {
      writer.uint32(58).string(message.aCommitId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Diff {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDiff()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.diffType = reader.int32() as any
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.aFilePath = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.bFilePath = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.aFileContent = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.bFileContent = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.patchBA = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.aCommitId = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Diff {
    return {
      diffType: isSet(object.diffType) ? diffTypeFromJSON(object.diffType) : 0,
      aFilePath: isSet(object.aFilePath) ? globalThis.String(object.aFilePath) : '',
      bFilePath: isSet(object.bFilePath) ? globalThis.String(object.bFilePath) : '',
      aFileContent: isSet(object.aFileContent) ? globalThis.String(object.aFileContent) : '',
      bFileContent: isSet(object.bFileContent) ? globalThis.String(object.bFileContent) : '',
      patchBA: isSet(object.patchBA) ? globalThis.String(object.patchBA) : '',
      aCommitId: isSet(object.aCommitId) ? globalThis.String(object.aCommitId) : ''
    }
  },

  toJSON(message: Diff): unknown {
    const obj: any = {}
    if (message.diffType !== 0) {
      obj.diffType = diffTypeToJSON(message.diffType)
    }
    if (message.aFilePath !== '') {
      obj.aFilePath = message.aFilePath
    }
    if (message.bFilePath !== '') {
      obj.bFilePath = message.bFilePath
    }
    if (message.aFileContent !== '') {
      obj.aFileContent = message.aFileContent
    }
    if (message.bFileContent !== '') {
      obj.bFileContent = message.bFileContent
    }
    if (message.patchBA !== '') {
      obj.patchBA = message.patchBA
    }
    if (message.aCommitId !== '') {
      obj.aCommitId = message.aCommitId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Diff>, I>>(base?: I): Diff {
    return Diff.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Diff>, I>>(object: I): Diff {
    const message = createBaseDiff()
    message.diffType = object.diffType ?? 0
    message.aFilePath = object.aFilePath ?? ''
    message.bFilePath = object.bFilePath ?? ''
    message.aFileContent = object.aFileContent ?? ''
    message.bFileContent = object.bFileContent ?? ''
    message.patchBA = object.patchBA ?? ''
    message.aCommitId = object.aCommitId ?? ''
    return message
  }
}

function createBaseDiffComment(): DiffComment {
  return { comment: '', filePath: '', startLineNumber: 0, endLineNumber: 0, fileContent: '' }
}

export const DiffComment = {
  encode(message: DiffComment, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.comment !== '') {
      writer.uint32(10).string(message.comment)
    }
    if (message.filePath !== '') {
      writer.uint32(18).string(message.filePath)
    }
    if (message.startLineNumber !== 0) {
      writer.uint32(24).int32(message.startLineNumber)
    }
    if (message.endLineNumber !== 0) {
      writer.uint32(32).int32(message.endLineNumber)
    }
    if (message.fileContent !== '') {
      writer.uint32(42).string(message.fileContent)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DiffComment {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDiffComment()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.comment = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.filePath = reader.string()
          continue
        case 3:
          if (tag !== 24) {
            break
          }

          message.startLineNumber = reader.int32()
          continue
        case 4:
          if (tag !== 32) {
            break
          }

          message.endLineNumber = reader.int32()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.fileContent = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DiffComment {
    return {
      comment: isSet(object.comment) ? globalThis.String(object.comment) : '',
      filePath: isSet(object.filePath) ? globalThis.String(object.filePath) : '',
      startLineNumber: isSet(object.startLineNumber)
        ? globalThis.Number(object.startLineNumber)
        : 0,
      endLineNumber: isSet(object.endLineNumber) ? globalThis.Number(object.endLineNumber) : 0,
      fileContent: isSet(object.fileContent) ? globalThis.String(object.fileContent) : ''
    }
  },

  toJSON(message: DiffComment): unknown {
    const obj: any = {}
    if (message.comment !== '') {
      obj.comment = message.comment
    }
    if (message.filePath !== '') {
      obj.filePath = message.filePath
    }
    if (message.startLineNumber !== 0) {
      obj.startLineNumber = Math.round(message.startLineNumber)
    }
    if (message.endLineNumber !== 0) {
      obj.endLineNumber = Math.round(message.endLineNumber)
    }
    if (message.fileContent !== '') {
      obj.fileContent = message.fileContent
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DiffComment>, I>>(base?: I): DiffComment {
    return DiffComment.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DiffComment>, I>>(object: I): DiffComment {
    const message = createBaseDiffComment()
    message.comment = object.comment ?? ''
    message.filePath = object.filePath ?? ''
    message.startLineNumber = object.startLineNumber ?? 0
    message.endLineNumber = object.endLineNumber ?? 0
    message.fileContent = object.fileContent ?? ''
    return message
  }
}

function createBaseDocumentInlineComment(): DocumentInlineComment {
  return { comment: '', startLineNumber: 0, endLineNumber: 0 }
}

export const DocumentInlineComment = {
  encode(message: DocumentInlineComment, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.comment !== '') {
      writer.uint32(10).string(message.comment)
    }
    if (message.startLineNumber !== 0) {
      writer.uint32(16).int32(message.startLineNumber)
    }
    if (message.endLineNumber !== 0) {
      writer.uint32(24).int32(message.endLineNumber)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DocumentInlineComment {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDocumentInlineComment()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.comment = reader.string()
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.startLineNumber = reader.int32()
          continue
        case 3:
          if (tag !== 24) {
            break
          }

          message.endLineNumber = reader.int32()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DocumentInlineComment {
    return {
      comment: isSet(object.comment) ? globalThis.String(object.comment) : '',
      startLineNumber: isSet(object.startLineNumber)
        ? globalThis.Number(object.startLineNumber)
        : 0,
      endLineNumber: isSet(object.endLineNumber) ? globalThis.Number(object.endLineNumber) : 0
    }
  },

  toJSON(message: DocumentInlineComment): unknown {
    const obj: any = {}
    if (message.comment !== '') {
      obj.comment = message.comment
    }
    if (message.startLineNumber !== 0) {
      obj.startLineNumber = Math.round(message.startLineNumber)
    }
    if (message.endLineNumber !== 0) {
      obj.endLineNumber = Math.round(message.endLineNumber)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DocumentInlineComment>, I>>(base?: I): DocumentInlineComment {
    return DocumentInlineComment.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DocumentInlineComment>, I>>(
    object: I
  ): DocumentInlineComment {
    const message = createBaseDocumentInlineComment()
    message.comment = object.comment ?? ''
    message.startLineNumber = object.startLineNumber ?? 0
    message.endLineNumber = object.endLineNumber ?? 0
    return message
  }
}

function createBaseDocumentation(): Documentation {
  return {
    flowDocMdTxt: '',
    flowDocMdHtmlPrLink: '',
    mappingSheetCsv: '',
    mappingSheetHtmlPrLink: '',
    mappingSheetMd: '',
    dwlMd: '',
    fullRepoMd: '',
    addFlowCode: '',
    addFlowSvgDiagram: '',
    migrationDocMd: ''
  }
}

export const Documentation = {
  encode(message: Documentation, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.flowDocMdTxt !== '') {
      writer.uint32(10).string(message.flowDocMdTxt)
    }
    if (message.flowDocMdHtmlPrLink !== '') {
      writer.uint32(18).string(message.flowDocMdHtmlPrLink)
    }
    if (message.mappingSheetCsv !== '') {
      writer.uint32(26).string(message.mappingSheetCsv)
    }
    if (message.mappingSheetHtmlPrLink !== '') {
      writer.uint32(34).string(message.mappingSheetHtmlPrLink)
    }
    if (message.mappingSheetMd !== '') {
      writer.uint32(42).string(message.mappingSheetMd)
    }
    if (message.dwlMd !== '') {
      writer.uint32(50).string(message.dwlMd)
    }
    if (message.fullRepoMd !== '') {
      writer.uint32(58).string(message.fullRepoMd)
    }
    if (message.addFlowCode !== '') {
      writer.uint32(66).string(message.addFlowCode)
    }
    if (message.addFlowSvgDiagram !== '') {
      writer.uint32(74).string(message.addFlowSvgDiagram)
    }
    if (message.migrationDocMd !== '') {
      writer.uint32(82).string(message.migrationDocMd)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): Documentation {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDocumentation()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.flowDocMdTxt = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.flowDocMdHtmlPrLink = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.mappingSheetCsv = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.mappingSheetHtmlPrLink = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.mappingSheetMd = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.dwlMd = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.fullRepoMd = reader.string()
          continue
        case 8:
          if (tag !== 66) {
            break
          }

          message.addFlowCode = reader.string()
          continue
        case 9:
          if (tag !== 74) {
            break
          }

          message.addFlowSvgDiagram = reader.string()
          continue
        case 10:
          if (tag !== 82) {
            break
          }

          message.migrationDocMd = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): Documentation {
    return {
      flowDocMdTxt: isSet(object.flowDocMdTxt) ? globalThis.String(object.flowDocMdTxt) : '',
      flowDocMdHtmlPrLink: isSet(object.flowDocMdHtmlPrLink)
        ? globalThis.String(object.flowDocMdHtmlPrLink)
        : '',
      mappingSheetCsv: isSet(object.mappingSheetCsv)
        ? globalThis.String(object.mappingSheetCsv)
        : '',
      mappingSheetHtmlPrLink: isSet(object.mappingSheetHtmlPrLink)
        ? globalThis.String(object.mappingSheetHtmlPrLink)
        : '',
      mappingSheetMd: isSet(object.mappingSheetMd) ? globalThis.String(object.mappingSheetMd) : '',
      dwlMd: isSet(object.dwlMd) ? globalThis.String(object.dwlMd) : '',
      fullRepoMd: isSet(object.fullRepoMd) ? globalThis.String(object.fullRepoMd) : '',
      addFlowCode: isSet(object.addFlowCode) ? globalThis.String(object.addFlowCode) : '',
      addFlowSvgDiagram: isSet(object.addFlowSvgDiagram)
        ? globalThis.String(object.addFlowSvgDiagram)
        : '',
      migrationDocMd: isSet(object.migrationDocMd) ? globalThis.String(object.migrationDocMd) : ''
    }
  },

  toJSON(message: Documentation): unknown {
    const obj: any = {}
    if (message.flowDocMdTxt !== '') {
      obj.flowDocMdTxt = message.flowDocMdTxt
    }
    if (message.flowDocMdHtmlPrLink !== '') {
      obj.flowDocMdHtmlPrLink = message.flowDocMdHtmlPrLink
    }
    if (message.mappingSheetCsv !== '') {
      obj.mappingSheetCsv = message.mappingSheetCsv
    }
    if (message.mappingSheetHtmlPrLink !== '') {
      obj.mappingSheetHtmlPrLink = message.mappingSheetHtmlPrLink
    }
    if (message.mappingSheetMd !== '') {
      obj.mappingSheetMd = message.mappingSheetMd
    }
    if (message.dwlMd !== '') {
      obj.dwlMd = message.dwlMd
    }
    if (message.fullRepoMd !== '') {
      obj.fullRepoMd = message.fullRepoMd
    }
    if (message.addFlowCode !== '') {
      obj.addFlowCode = message.addFlowCode
    }
    if (message.addFlowSvgDiagram !== '') {
      obj.addFlowSvgDiagram = message.addFlowSvgDiagram
    }
    if (message.migrationDocMd !== '') {
      obj.migrationDocMd = message.migrationDocMd
    }
    return obj
  },

  create<I extends Exact<DeepPartial<Documentation>, I>>(base?: I): Documentation {
    return Documentation.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<Documentation>, I>>(object: I): Documentation {
    const message = createBaseDocumentation()
    message.flowDocMdTxt = object.flowDocMdTxt ?? ''
    message.flowDocMdHtmlPrLink = object.flowDocMdHtmlPrLink ?? ''
    message.mappingSheetCsv = object.mappingSheetCsv ?? ''
    message.mappingSheetHtmlPrLink = object.mappingSheetHtmlPrLink ?? ''
    message.mappingSheetMd = object.mappingSheetMd ?? ''
    message.dwlMd = object.dwlMd ?? ''
    message.fullRepoMd = object.fullRepoMd ?? ''
    message.addFlowCode = object.addFlowCode ?? ''
    message.addFlowSvgDiagram = object.addFlowSvgDiagram ?? ''
    message.migrationDocMd = object.migrationDocMd ?? ''
    return message
  }
}

function createBaseAgentStreamingResponse(): AgentStreamingResponse {
  return { responseContentStream: undefined }
}

export const AgentStreamingResponse = {
  encode(message: AgentStreamingResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.responseContentStream !== undefined) {
      ResponseContentStream.encode(message.responseContentStream, writer.uint32(10).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgentStreamingResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAgentStreamingResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.responseContentStream = ResponseContentStream.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AgentStreamingResponse {
    return {
      responseContentStream: isSet(object.responseContentStream)
        ? ResponseContentStream.fromJSON(object.responseContentStream)
        : undefined
    }
  },

  toJSON(message: AgentStreamingResponse): unknown {
    const obj: any = {}
    if (message.responseContentStream !== undefined) {
      obj.responseContentStream = ResponseContentStream.toJSON(message.responseContentStream)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AgentStreamingResponse>, I>>(
    base?: I
  ): AgentStreamingResponse {
    return AgentStreamingResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AgentStreamingResponse>, I>>(
    object: I
  ): AgentStreamingResponse {
    const message = createBaseAgentStreamingResponse()
    message.responseContentStream =
      object.responseContentStream !== undefined && object.responseContentStream !== null
        ? ResponseContentStream.fromPartial(object.responseContentStream)
        : undefined
    return message
  }
}

function createBaseSpeechToTextRequest(): SpeechToTextRequest {
  return {
    isStream: false,
    audioContent: new Uint8Array(0),
    audioUri: '',
    languageCodes: [],
    model: '',
    enableAutomaticPunctuation: false,
    enableWordTimeOffsets: false,
    mimeType: '',
    audioEncoding: '',
    sampleRateHertz: 0,
    recognitionConfigJson: '',
    requestId: '',
    isLastChunk: false
  }
}

export const SpeechToTextRequest = {
  encode(message: SpeechToTextRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.isStream !== false) {
      writer.uint32(8).bool(message.isStream)
    }
    if (message.audioContent.length !== 0) {
      writer.uint32(18).bytes(message.audioContent)
    }
    if (message.audioUri !== '') {
      writer.uint32(26).string(message.audioUri)
    }
    for (const v of message.languageCodes) {
      writer.uint32(34).string(v!)
    }
    if (message.model !== '') {
      writer.uint32(42).string(message.model)
    }
    if (message.enableAutomaticPunctuation !== false) {
      writer.uint32(48).bool(message.enableAutomaticPunctuation)
    }
    if (message.enableWordTimeOffsets !== false) {
      writer.uint32(56).bool(message.enableWordTimeOffsets)
    }
    if (message.mimeType !== '') {
      writer.uint32(66).string(message.mimeType)
    }
    if (message.audioEncoding !== '') {
      writer.uint32(74).string(message.audioEncoding)
    }
    if (message.sampleRateHertz !== 0) {
      writer.uint32(80).int32(message.sampleRateHertz)
    }
    if (message.recognitionConfigJson !== '') {
      writer.uint32(90).string(message.recognitionConfigJson)
    }
    if (message.requestId !== '') {
      writer.uint32(98).string(message.requestId)
    }
    if (message.isLastChunk !== false) {
      writer.uint32(104).bool(message.isLastChunk)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpeechToTextRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSpeechToTextRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.isStream = reader.bool()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.audioContent = reader.bytes()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.audioUri = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.languageCodes.push(reader.string())
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.model = reader.string()
          continue
        case 6:
          if (tag !== 48) {
            break
          }

          message.enableAutomaticPunctuation = reader.bool()
          continue
        case 7:
          if (tag !== 56) {
            break
          }

          message.enableWordTimeOffsets = reader.bool()
          continue
        case 8:
          if (tag !== 66) {
            break
          }

          message.mimeType = reader.string()
          continue
        case 9:
          if (tag !== 74) {
            break
          }

          message.audioEncoding = reader.string()
          continue
        case 10:
          if (tag !== 80) {
            break
          }

          message.sampleRateHertz = reader.int32()
          continue
        case 11:
          if (tag !== 90) {
            break
          }

          message.recognitionConfigJson = reader.string()
          continue
        case 12:
          if (tag !== 98) {
            break
          }

          message.requestId = reader.string()
          continue
        case 13:
          if (tag !== 104) {
            break
          }

          message.isLastChunk = reader.bool()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SpeechToTextRequest {
    return {
      isStream: isSet(object.isStream) ? globalThis.Boolean(object.isStream) : false,
      audioContent: isSet(object.audioContent)
        ? bytesFromBase64(object.audioContent)
        : new Uint8Array(0),
      audioUri: isSet(object.audioUri) ? globalThis.String(object.audioUri) : '',
      languageCodes: globalThis.Array.isArray(object?.languageCodes)
        ? object.languageCodes.map((e: any) => globalThis.String(e))
        : [],
      model: isSet(object.model) ? globalThis.String(object.model) : '',
      enableAutomaticPunctuation: isSet(object.enableAutomaticPunctuation)
        ? globalThis.Boolean(object.enableAutomaticPunctuation)
        : false,
      enableWordTimeOffsets: isSet(object.enableWordTimeOffsets)
        ? globalThis.Boolean(object.enableWordTimeOffsets)
        : false,
      mimeType: isSet(object.mimeType) ? globalThis.String(object.mimeType) : '',
      audioEncoding: isSet(object.audioEncoding) ? globalThis.String(object.audioEncoding) : '',
      sampleRateHertz: isSet(object.sampleRateHertz)
        ? globalThis.Number(object.sampleRateHertz)
        : 0,
      recognitionConfigJson: isSet(object.recognitionConfigJson)
        ? globalThis.String(object.recognitionConfigJson)
        : '',
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : '',
      isLastChunk: isSet(object.isLastChunk) ? globalThis.Boolean(object.isLastChunk) : false
    }
  },

  toJSON(message: SpeechToTextRequest): unknown {
    const obj: any = {}
    if (message.isStream !== false) {
      obj.isStream = message.isStream
    }
    if (message.audioContent.length !== 0) {
      obj.audioContent = base64FromBytes(message.audioContent)
    }
    if (message.audioUri !== '') {
      obj.audioUri = message.audioUri
    }
    if (message.languageCodes?.length) {
      obj.languageCodes = message.languageCodes
    }
    if (message.model !== '') {
      obj.model = message.model
    }
    if (message.enableAutomaticPunctuation !== false) {
      obj.enableAutomaticPunctuation = message.enableAutomaticPunctuation
    }
    if (message.enableWordTimeOffsets !== false) {
      obj.enableWordTimeOffsets = message.enableWordTimeOffsets
    }
    if (message.mimeType !== '') {
      obj.mimeType = message.mimeType
    }
    if (message.audioEncoding !== '') {
      obj.audioEncoding = message.audioEncoding
    }
    if (message.sampleRateHertz !== 0) {
      obj.sampleRateHertz = Math.round(message.sampleRateHertz)
    }
    if (message.recognitionConfigJson !== '') {
      obj.recognitionConfigJson = message.recognitionConfigJson
    }
    if (message.requestId !== '') {
      obj.requestId = message.requestId
    }
    if (message.isLastChunk !== false) {
      obj.isLastChunk = message.isLastChunk
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SpeechToTextRequest>, I>>(base?: I): SpeechToTextRequest {
    return SpeechToTextRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SpeechToTextRequest>, I>>(
    object: I
  ): SpeechToTextRequest {
    const message = createBaseSpeechToTextRequest()
    message.isStream = object.isStream ?? false
    message.audioContent = object.audioContent ?? new Uint8Array(0)
    message.audioUri = object.audioUri ?? ''
    message.languageCodes = object.languageCodes?.map(e => e) || []
    message.model = object.model ?? ''
    message.enableAutomaticPunctuation = object.enableAutomaticPunctuation ?? false
    message.enableWordTimeOffsets = object.enableWordTimeOffsets ?? false
    message.mimeType = object.mimeType ?? ''
    message.audioEncoding = object.audioEncoding ?? ''
    message.sampleRateHertz = object.sampleRateHertz ?? 0
    message.recognitionConfigJson = object.recognitionConfigJson ?? ''
    message.requestId = object.requestId ?? ''
    message.isLastChunk = object.isLastChunk ?? false
    return message
  }
}

function createBaseSpeechToTextResponse(): SpeechToTextResponse {
  return {
    isStream: false,
    transcript: '',
    isFinal: false,
    confidence: 0,
    languageCode: '',
    jsonMetadata: '',
    errorMessage: ''
  }
}

export const SpeechToTextResponse = {
  encode(message: SpeechToTextResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.isStream !== false) {
      writer.uint32(8).bool(message.isStream)
    }
    if (message.transcript !== '') {
      writer.uint32(18).string(message.transcript)
    }
    if (message.isFinal !== false) {
      writer.uint32(24).bool(message.isFinal)
    }
    if (message.confidence !== 0) {
      writer.uint32(37).float(message.confidence)
    }
    if (message.languageCode !== '') {
      writer.uint32(42).string(message.languageCode)
    }
    if (message.jsonMetadata !== '') {
      writer.uint32(50).string(message.jsonMetadata)
    }
    if (message.errorMessage !== '') {
      writer.uint32(58).string(message.errorMessage)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SpeechToTextResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSpeechToTextResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.isStream = reader.bool()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.transcript = reader.string()
          continue
        case 3:
          if (tag !== 24) {
            break
          }

          message.isFinal = reader.bool()
          continue
        case 4:
          if (tag !== 37) {
            break
          }

          message.confidence = reader.float()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.languageCode = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.jsonMetadata = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.errorMessage = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SpeechToTextResponse {
    return {
      isStream: isSet(object.isStream) ? globalThis.Boolean(object.isStream) : false,
      transcript: isSet(object.transcript) ? globalThis.String(object.transcript) : '',
      isFinal: isSet(object.isFinal) ? globalThis.Boolean(object.isFinal) : false,
      confidence: isSet(object.confidence) ? globalThis.Number(object.confidence) : 0,
      languageCode: isSet(object.languageCode) ? globalThis.String(object.languageCode) : '',
      jsonMetadata: isSet(object.jsonMetadata) ? globalThis.String(object.jsonMetadata) : '',
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : ''
    }
  },

  toJSON(message: SpeechToTextResponse): unknown {
    const obj: any = {}
    if (message.isStream !== false) {
      obj.isStream = message.isStream
    }
    if (message.transcript !== '') {
      obj.transcript = message.transcript
    }
    if (message.isFinal !== false) {
      obj.isFinal = message.isFinal
    }
    if (message.confidence !== 0) {
      obj.confidence = message.confidence
    }
    if (message.languageCode !== '') {
      obj.languageCode = message.languageCode
    }
    if (message.jsonMetadata !== '') {
      obj.jsonMetadata = message.jsonMetadata
    }
    if (message.errorMessage !== '') {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SpeechToTextResponse>, I>>(base?: I): SpeechToTextResponse {
    return SpeechToTextResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SpeechToTextResponse>, I>>(
    object: I
  ): SpeechToTextResponse {
    const message = createBaseSpeechToTextResponse()
    message.isStream = object.isStream ?? false
    message.transcript = object.transcript ?? ''
    message.isFinal = object.isFinal ?? false
    message.confidence = object.confidence ?? 0
    message.languageCode = object.languageCode ?? ''
    message.jsonMetadata = object.jsonMetadata ?? ''
    message.errorMessage = object.errorMessage ?? ''
    return message
  }
}

function createBaseTextToSpeechRequest(): TextToSpeechRequest {
  return {
    isStream: false,
    text: '',
    languageCode: '',
    voiceName: '',
    audioEncoding: '',
    speakingRate: 0,
    pitch: 0,
    volumeGainDb: 0,
    sampleRateHertz: 0,
    effectsProfileId: [],
    model: '',
    synthesisConfigJson: '',
    requestId: '',
    isLastChunk: false
  }
}

export const TextToSpeechRequest = {
  encode(message: TextToSpeechRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.isStream !== false) {
      writer.uint32(8).bool(message.isStream)
    }
    if (message.text !== '') {
      writer.uint32(18).string(message.text)
    }
    if (message.languageCode !== '') {
      writer.uint32(26).string(message.languageCode)
    }
    if (message.voiceName !== '') {
      writer.uint32(34).string(message.voiceName)
    }
    if (message.audioEncoding !== '') {
      writer.uint32(42).string(message.audioEncoding)
    }
    if (message.speakingRate !== 0) {
      writer.uint32(53).float(message.speakingRate)
    }
    if (message.pitch !== 0) {
      writer.uint32(61).float(message.pitch)
    }
    if (message.volumeGainDb !== 0) {
      writer.uint32(69).float(message.volumeGainDb)
    }
    if (message.sampleRateHertz !== 0) {
      writer.uint32(72).int32(message.sampleRateHertz)
    }
    for (const v of message.effectsProfileId) {
      writer.uint32(82).string(v!)
    }
    if (message.model !== '') {
      writer.uint32(90).string(message.model)
    }
    if (message.synthesisConfigJson !== '') {
      writer.uint32(98).string(message.synthesisConfigJson)
    }
    if (message.requestId !== '') {
      writer.uint32(106).string(message.requestId)
    }
    if (message.isLastChunk !== false) {
      writer.uint32(112).bool(message.isLastChunk)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TextToSpeechRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTextToSpeechRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.isStream = reader.bool()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.text = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.languageCode = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.voiceName = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.audioEncoding = reader.string()
          continue
        case 6:
          if (tag !== 53) {
            break
          }

          message.speakingRate = reader.float()
          continue
        case 7:
          if (tag !== 61) {
            break
          }

          message.pitch = reader.float()
          continue
        case 8:
          if (tag !== 69) {
            break
          }

          message.volumeGainDb = reader.float()
          continue
        case 9:
          if (tag !== 72) {
            break
          }

          message.sampleRateHertz = reader.int32()
          continue
        case 10:
          if (tag !== 82) {
            break
          }

          message.effectsProfileId.push(reader.string())
          continue
        case 11:
          if (tag !== 90) {
            break
          }

          message.model = reader.string()
          continue
        case 12:
          if (tag !== 98) {
            break
          }

          message.synthesisConfigJson = reader.string()
          continue
        case 13:
          if (tag !== 106) {
            break
          }

          message.requestId = reader.string()
          continue
        case 14:
          if (tag !== 112) {
            break
          }

          message.isLastChunk = reader.bool()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TextToSpeechRequest {
    return {
      isStream: isSet(object.isStream) ? globalThis.Boolean(object.isStream) : false,
      text: isSet(object.text) ? globalThis.String(object.text) : '',
      languageCode: isSet(object.languageCode) ? globalThis.String(object.languageCode) : '',
      voiceName: isSet(object.voiceName) ? globalThis.String(object.voiceName) : '',
      audioEncoding: isSet(object.audioEncoding) ? globalThis.String(object.audioEncoding) : '',
      speakingRate: isSet(object.speakingRate) ? globalThis.Number(object.speakingRate) : 0,
      pitch: isSet(object.pitch) ? globalThis.Number(object.pitch) : 0,
      volumeGainDb: isSet(object.volumeGainDb) ? globalThis.Number(object.volumeGainDb) : 0,
      sampleRateHertz: isSet(object.sampleRateHertz)
        ? globalThis.Number(object.sampleRateHertz)
        : 0,
      effectsProfileId: globalThis.Array.isArray(object?.effectsProfileId)
        ? object.effectsProfileId.map((e: any) => globalThis.String(e))
        : [],
      model: isSet(object.model) ? globalThis.String(object.model) : '',
      synthesisConfigJson: isSet(object.synthesisConfigJson)
        ? globalThis.String(object.synthesisConfigJson)
        : '',
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : '',
      isLastChunk: isSet(object.isLastChunk) ? globalThis.Boolean(object.isLastChunk) : false
    }
  },

  toJSON(message: TextToSpeechRequest): unknown {
    const obj: any = {}
    if (message.isStream !== false) {
      obj.isStream = message.isStream
    }
    if (message.text !== '') {
      obj.text = message.text
    }
    if (message.languageCode !== '') {
      obj.languageCode = message.languageCode
    }
    if (message.voiceName !== '') {
      obj.voiceName = message.voiceName
    }
    if (message.audioEncoding !== '') {
      obj.audioEncoding = message.audioEncoding
    }
    if (message.speakingRate !== 0) {
      obj.speakingRate = message.speakingRate
    }
    if (message.pitch !== 0) {
      obj.pitch = message.pitch
    }
    if (message.volumeGainDb !== 0) {
      obj.volumeGainDb = message.volumeGainDb
    }
    if (message.sampleRateHertz !== 0) {
      obj.sampleRateHertz = Math.round(message.sampleRateHertz)
    }
    if (message.effectsProfileId?.length) {
      obj.effectsProfileId = message.effectsProfileId
    }
    if (message.model !== '') {
      obj.model = message.model
    }
    if (message.synthesisConfigJson !== '') {
      obj.synthesisConfigJson = message.synthesisConfigJson
    }
    if (message.requestId !== '') {
      obj.requestId = message.requestId
    }
    if (message.isLastChunk !== false) {
      obj.isLastChunk = message.isLastChunk
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TextToSpeechRequest>, I>>(base?: I): TextToSpeechRequest {
    return TextToSpeechRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TextToSpeechRequest>, I>>(
    object: I
  ): TextToSpeechRequest {
    const message = createBaseTextToSpeechRequest()
    message.isStream = object.isStream ?? false
    message.text = object.text ?? ''
    message.languageCode = object.languageCode ?? ''
    message.voiceName = object.voiceName ?? ''
    message.audioEncoding = object.audioEncoding ?? ''
    message.speakingRate = object.speakingRate ?? 0
    message.pitch = object.pitch ?? 0
    message.volumeGainDb = object.volumeGainDb ?? 0
    message.sampleRateHertz = object.sampleRateHertz ?? 0
    message.effectsProfileId = object.effectsProfileId?.map(e => e) || []
    message.model = object.model ?? ''
    message.synthesisConfigJson = object.synthesisConfigJson ?? ''
    message.requestId = object.requestId ?? ''
    message.isLastChunk = object.isLastChunk ?? false
    return message
  }
}

function createBaseTextToSpeechResponse(): TextToSpeechResponse {
  return {
    isStream: false,
    audioContent: new Uint8Array(0),
    audioEncoding: '',
    isFinal: false,
    jsonMetadata: '',
    errorMessage: ''
  }
}

export const TextToSpeechResponse = {
  encode(message: TextToSpeechResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.isStream !== false) {
      writer.uint32(8).bool(message.isStream)
    }
    if (message.audioContent.length !== 0) {
      writer.uint32(18).bytes(message.audioContent)
    }
    if (message.audioEncoding !== '') {
      writer.uint32(26).string(message.audioEncoding)
    }
    if (message.isFinal !== false) {
      writer.uint32(32).bool(message.isFinal)
    }
    if (message.jsonMetadata !== '') {
      writer.uint32(42).string(message.jsonMetadata)
    }
    if (message.errorMessage !== '') {
      writer.uint32(50).string(message.errorMessage)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TextToSpeechResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTextToSpeechResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.isStream = reader.bool()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.audioContent = reader.bytes()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.audioEncoding = reader.string()
          continue
        case 4:
          if (tag !== 32) {
            break
          }

          message.isFinal = reader.bool()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.jsonMetadata = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.errorMessage = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TextToSpeechResponse {
    return {
      isStream: isSet(object.isStream) ? globalThis.Boolean(object.isStream) : false,
      audioContent: isSet(object.audioContent)
        ? bytesFromBase64(object.audioContent)
        : new Uint8Array(0),
      audioEncoding: isSet(object.audioEncoding) ? globalThis.String(object.audioEncoding) : '',
      isFinal: isSet(object.isFinal) ? globalThis.Boolean(object.isFinal) : false,
      jsonMetadata: isSet(object.jsonMetadata) ? globalThis.String(object.jsonMetadata) : '',
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : ''
    }
  },

  toJSON(message: TextToSpeechResponse): unknown {
    const obj: any = {}
    if (message.isStream !== false) {
      obj.isStream = message.isStream
    }
    if (message.audioContent.length !== 0) {
      obj.audioContent = base64FromBytes(message.audioContent)
    }
    if (message.audioEncoding !== '') {
      obj.audioEncoding = message.audioEncoding
    }
    if (message.isFinal !== false) {
      obj.isFinal = message.isFinal
    }
    if (message.jsonMetadata !== '') {
      obj.jsonMetadata = message.jsonMetadata
    }
    if (message.errorMessage !== '') {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TextToSpeechResponse>, I>>(base?: I): TextToSpeechResponse {
    return TextToSpeechResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TextToSpeechResponse>, I>>(
    object: I
  ): TextToSpeechResponse {
    const message = createBaseTextToSpeechResponse()
    message.isStream = object.isStream ?? false
    message.audioContent = object.audioContent ?? new Uint8Array(0)
    message.audioEncoding = object.audioEncoding ?? ''
    message.isFinal = object.isFinal ?? false
    message.jsonMetadata = object.jsonMetadata ?? ''
    message.errorMessage = object.errorMessage ?? ''
    return message
  }
}

function createBaseGetIndexReposRequest(): GetIndexReposRequest {
  return { userId: 0 }
}

export const GetIndexReposRequest = {
  encode(message: GetIndexReposRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== 0) {
      writer.uint32(8).int64(message.userId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetIndexReposRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetIndexReposRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.userId = longToNumber(reader.int64() as Long)
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetIndexReposRequest {
    return { userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0 }
  },

  toJSON(message: GetIndexReposRequest): unknown {
    const obj: any = {}
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetIndexReposRequest>, I>>(base?: I): GetIndexReposRequest {
    return GetIndexReposRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetIndexReposRequest>, I>>(
    object: I
  ): GetIndexReposRequest {
    const message = createBaseGetIndexReposRequest()
    message.userId = object.userId ?? 0
    return message
  }
}

function createBaseGetIndexReposResponse(): GetIndexReposResponse {
  return { githubDetails: [] }
}

export const GetIndexReposResponse = {
  encode(message: GetIndexReposResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.githubDetails) {
      GithubDetail.encode(v!, writer.uint32(10).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetIndexReposResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetIndexReposResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.githubDetails.push(GithubDetail.decode(reader, reader.uint32()))
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetIndexReposResponse {
    return {
      githubDetails: globalThis.Array.isArray(object?.githubDetails)
        ? object.githubDetails.map((e: any) => GithubDetail.fromJSON(e))
        : []
    }
  },

  toJSON(message: GetIndexReposResponse): unknown {
    const obj: any = {}
    if (message.githubDetails?.length) {
      obj.githubDetails = message.githubDetails.map(e => GithubDetail.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetIndexReposResponse>, I>>(base?: I): GetIndexReposResponse {
    return GetIndexReposResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetIndexReposResponse>, I>>(
    object: I
  ): GetIndexReposResponse {
    const message = createBaseGetIndexReposResponse()
    message.githubDetails = object.githubDetails?.map(e => GithubDetail.fromPartial(e)) || []
    return message
  }
}

function createBaseAgentTaskRequest(): AgentTaskRequest {
  return { taskId: 0, agentRequest: undefined, runSync: false }
}

export const AgentTaskRequest = {
  encode(message: AgentTaskRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.taskId !== 0) {
      writer.uint32(8).int64(message.taskId)
    }
    if (message.agentRequest !== undefined) {
      AgentRequest.encode(message.agentRequest, writer.uint32(18).fork()).ldelim()
    }
    if (message.runSync !== false) {
      writer.uint32(24).bool(message.runSync)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgentTaskRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAgentTaskRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.taskId = longToNumber(reader.int64() as Long)
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.agentRequest = AgentRequest.decode(reader, reader.uint32())
          continue
        case 3:
          if (tag !== 24) {
            break
          }

          message.runSync = reader.bool()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AgentTaskRequest {
    return {
      taskId: isSet(object.taskId) ? globalThis.Number(object.taskId) : 0,
      agentRequest: isSet(object.agentRequest)
        ? AgentRequest.fromJSON(object.agentRequest)
        : undefined,
      runSync: isSet(object.runSync) ? globalThis.Boolean(object.runSync) : false
    }
  },

  toJSON(message: AgentTaskRequest): unknown {
    const obj: any = {}
    if (message.taskId !== 0) {
      obj.taskId = Math.round(message.taskId)
    }
    if (message.agentRequest !== undefined) {
      obj.agentRequest = AgentRequest.toJSON(message.agentRequest)
    }
    if (message.runSync !== false) {
      obj.runSync = message.runSync
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AgentTaskRequest>, I>>(base?: I): AgentTaskRequest {
    return AgentTaskRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AgentTaskRequest>, I>>(object: I): AgentTaskRequest {
    const message = createBaseAgentTaskRequest()
    message.taskId = object.taskId ?? 0
    message.agentRequest =
      object.agentRequest !== undefined && object.agentRequest !== null
        ? AgentRequest.fromPartial(object.agentRequest)
        : undefined
    message.runSync = object.runSync ?? false
    return message
  }
}

function createBaseAgentTaskResponse(): AgentTaskResponse {
  return { taskId: 0, taskStatus: 0, metadata: '' }
}

export const AgentTaskResponse = {
  encode(message: AgentTaskResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.taskId !== 0) {
      writer.uint32(8).int64(message.taskId)
    }
    if (message.taskStatus !== 0) {
      writer.uint32(16).int32(message.taskStatus)
    }
    if (message.metadata !== '') {
      writer.uint32(26).string(message.metadata)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgentTaskResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseAgentTaskResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.taskId = longToNumber(reader.int64() as Long)
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.taskStatus = reader.int32() as any
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.metadata = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): AgentTaskResponse {
    return {
      taskId: isSet(object.taskId) ? globalThis.Number(object.taskId) : 0,
      taskStatus: isSet(object.taskStatus) ? agentTaskStatusFromJSON(object.taskStatus) : 0,
      metadata: isSet(object.metadata) ? globalThis.String(object.metadata) : ''
    }
  },

  toJSON(message: AgentTaskResponse): unknown {
    const obj: any = {}
    if (message.taskId !== 0) {
      obj.taskId = Math.round(message.taskId)
    }
    if (message.taskStatus !== 0) {
      obj.taskStatus = agentTaskStatusToJSON(message.taskStatus)
    }
    if (message.metadata !== '') {
      obj.metadata = message.metadata
    }
    return obj
  },

  create<I extends Exact<DeepPartial<AgentTaskResponse>, I>>(base?: I): AgentTaskResponse {
    return AgentTaskResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<AgentTaskResponse>, I>>(object: I): AgentTaskResponse {
    const message = createBaseAgentTaskResponse()
    message.taskId = object.taskId ?? 0
    message.taskStatus = object.taskStatus ?? 0
    message.metadata = object.metadata ?? ''
    return message
  }
}

function createBaseTaskStatusAndRequestResponseTuple(): TaskStatusAndRequestResponseTuple {
  return { request: undefined, response: [], taskStatus: 0, createdTsSec: 0 }
}

export const TaskStatusAndRequestResponseTuple = {
  encode(
    message: TaskStatusAndRequestResponseTuple,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.request !== undefined) {
      AgentRequest.encode(message.request, writer.uint32(10).fork()).ldelim()
    }
    for (const v of message.response) {
      AgentStreamingResponse.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    if (message.taskStatus !== 0) {
      writer.uint32(24).int32(message.taskStatus)
    }
    if (message.createdTsSec !== 0) {
      writer.uint32(32).int64(message.createdTsSec)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): TaskStatusAndRequestResponseTuple {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseTaskStatusAndRequestResponseTuple()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.request = AgentRequest.decode(reader, reader.uint32())
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.response.push(AgentStreamingResponse.decode(reader, reader.uint32()))
          continue
        case 3:
          if (tag !== 24) {
            break
          }

          message.taskStatus = reader.int32() as any
          continue
        case 4:
          if (tag !== 32) {
            break
          }

          message.createdTsSec = longToNumber(reader.int64() as Long)
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): TaskStatusAndRequestResponseTuple {
    return {
      request: isSet(object.request) ? AgentRequest.fromJSON(object.request) : undefined,
      response: globalThis.Array.isArray(object?.response)
        ? object.response.map((e: any) => AgentStreamingResponse.fromJSON(e))
        : [],
      taskStatus: isSet(object.taskStatus) ? agentTaskStatusFromJSON(object.taskStatus) : 0,
      createdTsSec: isSet(object.createdTsSec) ? globalThis.Number(object.createdTsSec) : 0
    }
  },

  toJSON(message: TaskStatusAndRequestResponseTuple): unknown {
    const obj: any = {}
    if (message.request !== undefined) {
      obj.request = AgentRequest.toJSON(message.request)
    }
    if (message.response?.length) {
      obj.response = message.response.map(e => AgentStreamingResponse.toJSON(e))
    }
    if (message.taskStatus !== 0) {
      obj.taskStatus = agentTaskStatusToJSON(message.taskStatus)
    }
    if (message.createdTsSec !== 0) {
      obj.createdTsSec = Math.round(message.createdTsSec)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<TaskStatusAndRequestResponseTuple>, I>>(
    base?: I
  ): TaskStatusAndRequestResponseTuple {
    return TaskStatusAndRequestResponseTuple.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<TaskStatusAndRequestResponseTuple>, I>>(
    object: I
  ): TaskStatusAndRequestResponseTuple {
    const message = createBaseTaskStatusAndRequestResponseTuple()
    message.request =
      object.request !== undefined && object.request !== null
        ? AgentRequest.fromPartial(object.request)
        : undefined
    message.response = object.response?.map(e => AgentStreamingResponse.fromPartial(e)) || []
    message.taskStatus = object.taskStatus ?? 0
    message.createdTsSec = object.createdTsSec ?? 0
    return message
  }
}

function createBaseDBAgentTaskRequestResponse(): DBAgentTaskRequestResponse {
  return { originalRequest: undefined, orderedStateResponses: [], usageData: undefined }
}

export const DBAgentTaskRequestResponse = {
  encode(
    message: DBAgentTaskRequestResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.originalRequest !== undefined) {
      AgentRequest.encode(message.originalRequest, writer.uint32(10).fork()).ldelim()
    }
    for (const v of message.orderedStateResponses) {
      TaskStatusAndRequestResponseTuple.encode(v!, writer.uint32(18).fork()).ldelim()
    }
    if (message.usageData !== undefined) {
      UsageData.encode(message.usageData, writer.uint32(26).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DBAgentTaskRequestResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDBAgentTaskRequestResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.originalRequest = AgentRequest.decode(reader, reader.uint32())
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.orderedStateResponses.push(
            TaskStatusAndRequestResponseTuple.decode(reader, reader.uint32())
          )
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.usageData = UsageData.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DBAgentTaskRequestResponse {
    return {
      originalRequest: isSet(object.originalRequest)
        ? AgentRequest.fromJSON(object.originalRequest)
        : undefined,
      orderedStateResponses: globalThis.Array.isArray(object?.orderedStateResponses)
        ? object.orderedStateResponses.map((e: any) =>
            TaskStatusAndRequestResponseTuple.fromJSON(e)
          )
        : [],
      usageData: isSet(object.usageData) ? UsageData.fromJSON(object.usageData) : undefined
    }
  },

  toJSON(message: DBAgentTaskRequestResponse): unknown {
    const obj: any = {}
    if (message.originalRequest !== undefined) {
      obj.originalRequest = AgentRequest.toJSON(message.originalRequest)
    }
    if (message.orderedStateResponses?.length) {
      obj.orderedStateResponses = message.orderedStateResponses.map(e =>
        TaskStatusAndRequestResponseTuple.toJSON(e)
      )
    }
    if (message.usageData !== undefined) {
      obj.usageData = UsageData.toJSON(message.usageData)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DBAgentTaskRequestResponse>, I>>(
    base?: I
  ): DBAgentTaskRequestResponse {
    return DBAgentTaskRequestResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DBAgentTaskRequestResponse>, I>>(
    object: I
  ): DBAgentTaskRequestResponse {
    const message = createBaseDBAgentTaskRequestResponse()
    message.originalRequest =
      object.originalRequest !== undefined && object.originalRequest !== null
        ? AgentRequest.fromPartial(object.originalRequest)
        : undefined
    message.orderedStateResponses =
      object.orderedStateResponses?.map(e => TaskStatusAndRequestResponseTuple.fromPartial(e)) || []
    message.usageData =
      object.usageData !== undefined && object.usageData !== null
        ? UsageData.fromPartial(object.usageData)
        : undefined
    return message
  }
}

function createBaseConnectorKbAnnotationInputRequest(): ConnectorKbAnnotationInputRequest {
  return {
    pomDep: '',
    configCode: '',
    actionCode: '',
    actionType: '',
    actionDescription: '',
    creatorEmail: '',
    snippetDescription: ''
  }
}

export const ConnectorKbAnnotationInputRequest = {
  encode(
    message: ConnectorKbAnnotationInputRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.pomDep !== '') {
      writer.uint32(10).string(message.pomDep)
    }
    if (message.configCode !== '') {
      writer.uint32(18).string(message.configCode)
    }
    if (message.actionCode !== '') {
      writer.uint32(26).string(message.actionCode)
    }
    if (message.actionType !== '') {
      writer.uint32(34).string(message.actionType)
    }
    if (message.actionDescription !== '') {
      writer.uint32(42).string(message.actionDescription)
    }
    if (message.creatorEmail !== '') {
      writer.uint32(50).string(message.creatorEmail)
    }
    if (message.snippetDescription !== '') {
      writer.uint32(58).string(message.snippetDescription)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConnectorKbAnnotationInputRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConnectorKbAnnotationInputRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.pomDep = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.configCode = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.actionCode = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.actionType = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.actionDescription = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.creatorEmail = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.snippetDescription = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConnectorKbAnnotationInputRequest {
    return {
      pomDep: isSet(object.pomDep) ? globalThis.String(object.pomDep) : '',
      configCode: isSet(object.configCode) ? globalThis.String(object.configCode) : '',
      actionCode: isSet(object.actionCode) ? globalThis.String(object.actionCode) : '',
      actionType: isSet(object.actionType) ? globalThis.String(object.actionType) : '',
      actionDescription: isSet(object.actionDescription)
        ? globalThis.String(object.actionDescription)
        : '',
      creatorEmail: isSet(object.creatorEmail) ? globalThis.String(object.creatorEmail) : '',
      snippetDescription: isSet(object.snippetDescription)
        ? globalThis.String(object.snippetDescription)
        : ''
    }
  },

  toJSON(message: ConnectorKbAnnotationInputRequest): unknown {
    const obj: any = {}
    if (message.pomDep !== '') {
      obj.pomDep = message.pomDep
    }
    if (message.configCode !== '') {
      obj.configCode = message.configCode
    }
    if (message.actionCode !== '') {
      obj.actionCode = message.actionCode
    }
    if (message.actionType !== '') {
      obj.actionType = message.actionType
    }
    if (message.actionDescription !== '') {
      obj.actionDescription = message.actionDescription
    }
    if (message.creatorEmail !== '') {
      obj.creatorEmail = message.creatorEmail
    }
    if (message.snippetDescription !== '') {
      obj.snippetDescription = message.snippetDescription
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConnectorKbAnnotationInputRequest>, I>>(
    base?: I
  ): ConnectorKbAnnotationInputRequest {
    return ConnectorKbAnnotationInputRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConnectorKbAnnotationInputRequest>, I>>(
    object: I
  ): ConnectorKbAnnotationInputRequest {
    const message = createBaseConnectorKbAnnotationInputRequest()
    message.pomDep = object.pomDep ?? ''
    message.configCode = object.configCode ?? ''
    message.actionCode = object.actionCode ?? ''
    message.actionType = object.actionType ?? ''
    message.actionDescription = object.actionDescription ?? ''
    message.creatorEmail = object.creatorEmail ?? ''
    message.snippetDescription = object.snippetDescription ?? ''
    return message
  }
}

function createBaseConnectorKbAnnotationInputResponse(): ConnectorKbAnnotationInputResponse {
  return { result: '' }
}

export const ConnectorKbAnnotationInputResponse = {
  encode(
    message: ConnectorKbAnnotationInputResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.result !== '') {
      writer.uint32(10).string(message.result)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConnectorKbAnnotationInputResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConnectorKbAnnotationInputResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.result = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConnectorKbAnnotationInputResponse {
    return { result: isSet(object.result) ? globalThis.String(object.result) : '' }
  },

  toJSON(message: ConnectorKbAnnotationInputResponse): unknown {
    const obj: any = {}
    if (message.result !== '') {
      obj.result = message.result
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConnectorKbAnnotationInputResponse>, I>>(
    base?: I
  ): ConnectorKbAnnotationInputResponse {
    return ConnectorKbAnnotationInputResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConnectorKbAnnotationInputResponse>, I>>(
    object: I
  ): ConnectorKbAnnotationInputResponse {
    const message = createBaseConnectorKbAnnotationInputResponse()
    message.result = object.result ?? ''
    return message
  }
}

function createBaseConnectorKbAnnotationDisplayTaskRequest(): ConnectorKbAnnotationDisplayTaskRequest {
  return {}
}

export const ConnectorKbAnnotationDisplayTaskRequest = {
  encode(
    _: ConnectorKbAnnotationDisplayTaskRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConnectorKbAnnotationDisplayTaskRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConnectorKbAnnotationDisplayTaskRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(_: any): ConnectorKbAnnotationDisplayTaskRequest {
    return {}
  },

  toJSON(_: ConnectorKbAnnotationDisplayTaskRequest): unknown {
    const obj: any = {}
    return obj
  },

  create<I extends Exact<DeepPartial<ConnectorKbAnnotationDisplayTaskRequest>, I>>(
    base?: I
  ): ConnectorKbAnnotationDisplayTaskRequest {
    return ConnectorKbAnnotationDisplayTaskRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConnectorKbAnnotationDisplayTaskRequest>, I>>(
    _: I
  ): ConnectorKbAnnotationDisplayTaskRequest {
    const message = createBaseConnectorKbAnnotationDisplayTaskRequest()
    return message
  }
}

function createBaseConnectorKbAnnotationDisplayTaskTuple(): ConnectorKbAnnotationDisplayTaskTuple {
  return { pomDep: '', configKey: '', opKey: '', srcKey: '' }
}

export const ConnectorKbAnnotationDisplayTaskTuple = {
  encode(
    message: ConnectorKbAnnotationDisplayTaskTuple,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.pomDep !== '') {
      writer.uint32(10).string(message.pomDep)
    }
    if (message.configKey !== '') {
      writer.uint32(18).string(message.configKey)
    }
    if (message.opKey !== '') {
      writer.uint32(26).string(message.opKey)
    }
    if (message.srcKey !== '') {
      writer.uint32(34).string(message.srcKey)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): ConnectorKbAnnotationDisplayTaskTuple {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConnectorKbAnnotationDisplayTaskTuple()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.pomDep = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.configKey = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.opKey = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.srcKey = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConnectorKbAnnotationDisplayTaskTuple {
    return {
      pomDep: isSet(object.pomDep) ? globalThis.String(object.pomDep) : '',
      configKey: isSet(object.configKey) ? globalThis.String(object.configKey) : '',
      opKey: isSet(object.opKey) ? globalThis.String(object.opKey) : '',
      srcKey: isSet(object.srcKey) ? globalThis.String(object.srcKey) : ''
    }
  },

  toJSON(message: ConnectorKbAnnotationDisplayTaskTuple): unknown {
    const obj: any = {}
    if (message.pomDep !== '') {
      obj.pomDep = message.pomDep
    }
    if (message.configKey !== '') {
      obj.configKey = message.configKey
    }
    if (message.opKey !== '') {
      obj.opKey = message.opKey
    }
    if (message.srcKey !== '') {
      obj.srcKey = message.srcKey
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConnectorKbAnnotationDisplayTaskTuple>, I>>(
    base?: I
  ): ConnectorKbAnnotationDisplayTaskTuple {
    return ConnectorKbAnnotationDisplayTaskTuple.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConnectorKbAnnotationDisplayTaskTuple>, I>>(
    object: I
  ): ConnectorKbAnnotationDisplayTaskTuple {
    const message = createBaseConnectorKbAnnotationDisplayTaskTuple()
    message.pomDep = object.pomDep ?? ''
    message.configKey = object.configKey ?? ''
    message.opKey = object.opKey ?? ''
    message.srcKey = object.srcKey ?? ''
    return message
  }
}

function createBaseConnectorKbAnnotationDisplayTaskResponse(): ConnectorKbAnnotationDisplayTaskResponse {
  return { tasks: [] }
}

export const ConnectorKbAnnotationDisplayTaskResponse = {
  encode(
    message: ConnectorKbAnnotationDisplayTaskResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    for (const v of message.tasks) {
      ConnectorKbAnnotationDisplayTaskTuple.encode(v!, writer.uint32(10).fork()).ldelim()
    }
    return writer
  },

  decode(
    input: _m0.Reader | Uint8Array,
    length?: number
  ): ConnectorKbAnnotationDisplayTaskResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseConnectorKbAnnotationDisplayTaskResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.tasks.push(ConnectorKbAnnotationDisplayTaskTuple.decode(reader, reader.uint32()))
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): ConnectorKbAnnotationDisplayTaskResponse {
    return {
      tasks: globalThis.Array.isArray(object?.tasks)
        ? object.tasks.map((e: any) => ConnectorKbAnnotationDisplayTaskTuple.fromJSON(e))
        : []
    }
  },

  toJSON(message: ConnectorKbAnnotationDisplayTaskResponse): unknown {
    const obj: any = {}
    if (message.tasks?.length) {
      obj.tasks = message.tasks.map(e => ConnectorKbAnnotationDisplayTaskTuple.toJSON(e))
    }
    return obj
  },

  create<I extends Exact<DeepPartial<ConnectorKbAnnotationDisplayTaskResponse>, I>>(
    base?: I
  ): ConnectorKbAnnotationDisplayTaskResponse {
    return ConnectorKbAnnotationDisplayTaskResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<ConnectorKbAnnotationDisplayTaskResponse>, I>>(
    object: I
  ): ConnectorKbAnnotationDisplayTaskResponse {
    const message = createBaseConnectorKbAnnotationDisplayTaskResponse()
    message.tasks =
      object.tasks?.map(e => ConnectorKbAnnotationDisplayTaskTuple.fromPartial(e)) || []
    return message
  }
}

function createBaseRepoMetadataRequest(): RepoMetadataRequest {
  return { userId: 0, orgId: 0, codeContext: undefined, platform: 0, includeSuggestedVmArgs: false }
}

export const RepoMetadataRequest = {
  encode(message: RepoMetadataRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== 0) {
      writer.uint32(8).int64(message.userId)
    }
    if (message.orgId !== 0) {
      writer.uint32(16).int64(message.orgId)
    }
    if (message.codeContext !== undefined) {
      CodeContext.encode(message.codeContext, writer.uint32(26).fork()).ldelim()
    }
    if (message.platform !== 0) {
      writer.uint32(32).int32(message.platform)
    }
    if (message.includeSuggestedVmArgs !== false) {
      writer.uint32(40).bool(message.includeSuggestedVmArgs)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RepoMetadataRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRepoMetadataRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.userId = longToNumber(reader.int64() as Long)
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.orgId = longToNumber(reader.int64() as Long)
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.codeContext = CodeContext.decode(reader, reader.uint32())
          continue
        case 4:
          if (tag !== 32) {
            break
          }

          message.platform = reader.int32() as any
          continue
        case 5:
          if (tag !== 40) {
            break
          }

          message.includeSuggestedVmArgs = reader.bool()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RepoMetadataRequest {
    return {
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      orgId: isSet(object.orgId) ? globalThis.Number(object.orgId) : 0,
      codeContext: isSet(object.codeContext) ? CodeContext.fromJSON(object.codeContext) : undefined,
      platform: isSet(object.platform) ? integrationPlatformFromJSON(object.platform) : 0,
      includeSuggestedVmArgs: isSet(object.includeSuggestedVmArgs)
        ? globalThis.Boolean(object.includeSuggestedVmArgs)
        : false
    }
  },

  toJSON(message: RepoMetadataRequest): unknown {
    const obj: any = {}
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId)
    }
    if (message.orgId !== 0) {
      obj.orgId = Math.round(message.orgId)
    }
    if (message.codeContext !== undefined) {
      obj.codeContext = CodeContext.toJSON(message.codeContext)
    }
    if (message.platform !== 0) {
      obj.platform = integrationPlatformToJSON(message.platform)
    }
    if (message.includeSuggestedVmArgs !== false) {
      obj.includeSuggestedVmArgs = message.includeSuggestedVmArgs
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RepoMetadataRequest>, I>>(base?: I): RepoMetadataRequest {
    return RepoMetadataRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RepoMetadataRequest>, I>>(
    object: I
  ): RepoMetadataRequest {
    const message = createBaseRepoMetadataRequest()
    message.userId = object.userId ?? 0
    message.orgId = object.orgId ?? 0
    message.codeContext =
      object.codeContext !== undefined && object.codeContext !== null
        ? CodeContext.fromPartial(object.codeContext)
        : undefined
    message.platform = object.platform ?? 0
    message.includeSuggestedVmArgs = object.includeSuggestedVmArgs ?? false
    return message
  }
}

function createBaseGetEndSystemSchemaInfoRequest(): GetEndSystemSchemaInfoRequest {
  return {
    userId: 0,
    orgId: 0,
    codeContext: undefined,
    platform: 0,
    flowNames: [],
    includeSuggestedSchemaInfo: false
  }
}

export const GetEndSystemSchemaInfoRequest = {
  encode(
    message: GetEndSystemSchemaInfoRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.userId !== 0) {
      writer.uint32(8).int64(message.userId)
    }
    if (message.orgId !== 0) {
      writer.uint32(16).int64(message.orgId)
    }
    if (message.codeContext !== undefined) {
      CodeContext.encode(message.codeContext, writer.uint32(26).fork()).ldelim()
    }
    if (message.platform !== 0) {
      writer.uint32(32).int32(message.platform)
    }
    for (const v of message.flowNames) {
      writer.uint32(42).string(v!)
    }
    if (message.includeSuggestedSchemaInfo !== false) {
      writer.uint32(48).bool(message.includeSuggestedSchemaInfo)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetEndSystemSchemaInfoRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetEndSystemSchemaInfoRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.userId = longToNumber(reader.int64() as Long)
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.orgId = longToNumber(reader.int64() as Long)
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.codeContext = CodeContext.decode(reader, reader.uint32())
          continue
        case 4:
          if (tag !== 32) {
            break
          }

          message.platform = reader.int32() as any
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.flowNames.push(reader.string())
          continue
        case 6:
          if (tag !== 48) {
            break
          }

          message.includeSuggestedSchemaInfo = reader.bool()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetEndSystemSchemaInfoRequest {
    return {
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      orgId: isSet(object.orgId) ? globalThis.Number(object.orgId) : 0,
      codeContext: isSet(object.codeContext) ? CodeContext.fromJSON(object.codeContext) : undefined,
      platform: isSet(object.platform) ? integrationPlatformFromJSON(object.platform) : 0,
      flowNames: globalThis.Array.isArray(object?.flowNames)
        ? object.flowNames.map((e: any) => globalThis.String(e))
        : [],
      includeSuggestedSchemaInfo: isSet(object.includeSuggestedSchemaInfo)
        ? globalThis.Boolean(object.includeSuggestedSchemaInfo)
        : false
    }
  },

  toJSON(message: GetEndSystemSchemaInfoRequest): unknown {
    const obj: any = {}
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId)
    }
    if (message.orgId !== 0) {
      obj.orgId = Math.round(message.orgId)
    }
    if (message.codeContext !== undefined) {
      obj.codeContext = CodeContext.toJSON(message.codeContext)
    }
    if (message.platform !== 0) {
      obj.platform = integrationPlatformToJSON(message.platform)
    }
    if (message.flowNames?.length) {
      obj.flowNames = message.flowNames
    }
    if (message.includeSuggestedSchemaInfo !== false) {
      obj.includeSuggestedSchemaInfo = message.includeSuggestedSchemaInfo
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetEndSystemSchemaInfoRequest>, I>>(
    base?: I
  ): GetEndSystemSchemaInfoRequest {
    return GetEndSystemSchemaInfoRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetEndSystemSchemaInfoRequest>, I>>(
    object: I
  ): GetEndSystemSchemaInfoRequest {
    const message = createBaseGetEndSystemSchemaInfoRequest()
    message.userId = object.userId ?? 0
    message.orgId = object.orgId ?? 0
    message.codeContext =
      object.codeContext !== undefined && object.codeContext !== null
        ? CodeContext.fromPartial(object.codeContext)
        : undefined
    message.platform = object.platform ?? 0
    message.flowNames = object.flowNames?.map(e => e) || []
    message.includeSuggestedSchemaInfo = object.includeSuggestedSchemaInfo ?? false
    return message
  }
}

function createBaseSuggestedEndSystemInfo(): SuggestedEndSystemInfo {
  return { systemObjectName: '', suggestedSchemaInfo: '' }
}

export const SuggestedEndSystemInfo = {
  encode(message: SuggestedEndSystemInfo, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.systemObjectName !== '') {
      writer.uint32(10).string(message.systemObjectName)
    }
    if (message.suggestedSchemaInfo !== '') {
      writer.uint32(18).string(message.suggestedSchemaInfo)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SuggestedEndSystemInfo {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseSuggestedEndSystemInfo()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.systemObjectName = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.suggestedSchemaInfo = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): SuggestedEndSystemInfo {
    return {
      systemObjectName: isSet(object.systemObjectName)
        ? globalThis.String(object.systemObjectName)
        : '',
      suggestedSchemaInfo: isSet(object.suggestedSchemaInfo)
        ? globalThis.String(object.suggestedSchemaInfo)
        : ''
    }
  },

  toJSON(message: SuggestedEndSystemInfo): unknown {
    const obj: any = {}
    if (message.systemObjectName !== '') {
      obj.systemObjectName = message.systemObjectName
    }
    if (message.suggestedSchemaInfo !== '') {
      obj.suggestedSchemaInfo = message.suggestedSchemaInfo
    }
    return obj
  },

  create<I extends Exact<DeepPartial<SuggestedEndSystemInfo>, I>>(
    base?: I
  ): SuggestedEndSystemInfo {
    return SuggestedEndSystemInfo.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<SuggestedEndSystemInfo>, I>>(
    object: I
  ): SuggestedEndSystemInfo {
    const message = createBaseSuggestedEndSystemInfo()
    message.systemObjectName = object.systemObjectName ?? ''
    message.suggestedSchemaInfo = object.suggestedSchemaInfo ?? ''
    return message
  }
}

function createBaseGetEndSystemSchemaInfoResponse(): GetEndSystemSchemaInfoResponse {
  return { suggestedEndSystemInfo: [] }
}

export const GetEndSystemSchemaInfoResponse = {
  encode(
    message: GetEndSystemSchemaInfoResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    for (const v of message.suggestedEndSystemInfo) {
      SuggestedEndSystemInfo.encode(v!, writer.uint32(10).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): GetEndSystemSchemaInfoResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseGetEndSystemSchemaInfoResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.suggestedEndSystemInfo.push(
            SuggestedEndSystemInfo.decode(reader, reader.uint32())
          )
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): GetEndSystemSchemaInfoResponse {
    return {
      suggestedEndSystemInfo: globalThis.Array.isArray(object?.suggestedEndSystemInfo)
        ? object.suggestedEndSystemInfo.map((e: any) => SuggestedEndSystemInfo.fromJSON(e))
        : []
    }
  },

  toJSON(message: GetEndSystemSchemaInfoResponse): unknown {
    const obj: any = {}
    if (message.suggestedEndSystemInfo?.length) {
      obj.suggestedEndSystemInfo = message.suggestedEndSystemInfo.map(e =>
        SuggestedEndSystemInfo.toJSON(e)
      )
    }
    return obj
  },

  create<I extends Exact<DeepPartial<GetEndSystemSchemaInfoResponse>, I>>(
    base?: I
  ): GetEndSystemSchemaInfoResponse {
    return GetEndSystemSchemaInfoResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<GetEndSystemSchemaInfoResponse>, I>>(
    object: I
  ): GetEndSystemSchemaInfoResponse {
    const message = createBaseGetEndSystemSchemaInfoResponse()
    message.suggestedEndSystemInfo =
      object.suggestedEndSystemInfo?.map(e => SuggestedEndSystemInfo.fromPartial(e)) || []
    return message
  }
}

function createBaseStringList(): StringList {
  return { values: [] }
}

export const StringList = {
  encode(message: StringList, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.values) {
      writer.uint32(10).string(v!)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): StringList {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseStringList()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.values.push(reader.string())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): StringList {
    return {
      values: globalThis.Array.isArray(object?.values)
        ? object.values.map((e: any) => globalThis.String(e))
        : []
    }
  },

  toJSON(message: StringList): unknown {
    const obj: any = {}
    if (message.values?.length) {
      obj.values = message.values
    }
    return obj
  },

  create<I extends Exact<DeepPartial<StringList>, I>>(base?: I): StringList {
    return StringList.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<StringList>, I>>(object: I): StringList {
    const message = createBaseStringList()
    message.values = object.values?.map(e => e) || []
    return message
  }
}

function createBaseRepoMetadataResponse(): RepoMetadataResponse {
  return {
    muleAllFlowNames: [],
    muleApiFlowNames: [],
    muleEventFlowNames: [],
    entities: {},
    suggestedVmArgs: '',
    suggestedMinMuleRuntimeVersion: '',
    suggestedMvnVersion: '',
    suggestedJavaVersion: '',
    detectedPlatform: 0
  }
}

export const RepoMetadataResponse = {
  encode(message: RepoMetadataResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    for (const v of message.muleAllFlowNames) {
      writer.uint32(10).string(v!)
    }
    for (const v of message.muleApiFlowNames) {
      writer.uint32(18).string(v!)
    }
    for (const v of message.muleEventFlowNames) {
      writer.uint32(26).string(v!)
    }
    Object.entries(message.entities).forEach(([key, value]) => {
      RepoMetadataResponse_EntitiesEntry.encode(
        { key: key as any, value },
        writer.uint32(34).fork()
      ).ldelim()
    })
    if (message.suggestedVmArgs !== '') {
      writer.uint32(42).string(message.suggestedVmArgs)
    }
    if (message.suggestedMinMuleRuntimeVersion !== '') {
      writer.uint32(50).string(message.suggestedMinMuleRuntimeVersion)
    }
    if (message.suggestedMvnVersion !== '') {
      writer.uint32(58).string(message.suggestedMvnVersion)
    }
    if (message.suggestedJavaVersion !== '') {
      writer.uint32(66).string(message.suggestedJavaVersion)
    }
    if (message.detectedPlatform !== 0) {
      writer.uint32(72).int32(message.detectedPlatform)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RepoMetadataResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRepoMetadataResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.muleAllFlowNames.push(reader.string())
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.muleApiFlowNames.push(reader.string())
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.muleEventFlowNames.push(reader.string())
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          const entry4 = RepoMetadataResponse_EntitiesEntry.decode(reader, reader.uint32())
          if (entry4.value !== undefined) {
            message.entities[entry4.key] = entry4.value
          }
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.suggestedVmArgs = reader.string()
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.suggestedMinMuleRuntimeVersion = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.suggestedMvnVersion = reader.string()
          continue
        case 8:
          if (tag !== 66) {
            break
          }

          message.suggestedJavaVersion = reader.string()
          continue
        case 9:
          if (tag !== 72) {
            break
          }

          message.detectedPlatform = reader.int32() as any
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RepoMetadataResponse {
    return {
      muleAllFlowNames: globalThis.Array.isArray(object?.muleAllFlowNames)
        ? object.muleAllFlowNames.map((e: any) => globalThis.String(e))
        : [],
      muleApiFlowNames: globalThis.Array.isArray(object?.muleApiFlowNames)
        ? object.muleApiFlowNames.map((e: any) => globalThis.String(e))
        : [],
      muleEventFlowNames: globalThis.Array.isArray(object?.muleEventFlowNames)
        ? object.muleEventFlowNames.map((e: any) => globalThis.String(e))
        : [],
      entities: isObject(object.entities)
        ? Object.entries(object.entities).reduce<{ [key: string]: StringList }>(
            (acc, [key, value]) => {
              acc[key] = StringList.fromJSON(value)
              return acc
            },
            {}
          )
        : {},
      suggestedVmArgs: isSet(object.suggestedVmArgs)
        ? globalThis.String(object.suggestedVmArgs)
        : '',
      suggestedMinMuleRuntimeVersion: isSet(object.suggestedMinMuleRuntimeVersion)
        ? globalThis.String(object.suggestedMinMuleRuntimeVersion)
        : '',
      suggestedMvnVersion: isSet(object.suggestedMvnVersion)
        ? globalThis.String(object.suggestedMvnVersion)
        : '',
      suggestedJavaVersion: isSet(object.suggestedJavaVersion)
        ? globalThis.String(object.suggestedJavaVersion)
        : '',
      detectedPlatform: isSet(object.detectedPlatform)
        ? integrationPlatformFromJSON(object.detectedPlatform)
        : 0
    }
  },

  toJSON(message: RepoMetadataResponse): unknown {
    const obj: any = {}
    if (message.muleAllFlowNames?.length) {
      obj.muleAllFlowNames = message.muleAllFlowNames
    }
    if (message.muleApiFlowNames?.length) {
      obj.muleApiFlowNames = message.muleApiFlowNames
    }
    if (message.muleEventFlowNames?.length) {
      obj.muleEventFlowNames = message.muleEventFlowNames
    }
    if (message.entities) {
      const entries = Object.entries(message.entities)
      if (entries.length > 0) {
        obj.entities = {}
        entries.forEach(([k, v]) => {
          obj.entities[k] = StringList.toJSON(v)
        })
      }
    }
    if (message.suggestedVmArgs !== '') {
      obj.suggestedVmArgs = message.suggestedVmArgs
    }
    if (message.suggestedMinMuleRuntimeVersion !== '') {
      obj.suggestedMinMuleRuntimeVersion = message.suggestedMinMuleRuntimeVersion
    }
    if (message.suggestedMvnVersion !== '') {
      obj.suggestedMvnVersion = message.suggestedMvnVersion
    }
    if (message.suggestedJavaVersion !== '') {
      obj.suggestedJavaVersion = message.suggestedJavaVersion
    }
    if (message.detectedPlatform !== 0) {
      obj.detectedPlatform = integrationPlatformToJSON(message.detectedPlatform)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RepoMetadataResponse>, I>>(base?: I): RepoMetadataResponse {
    return RepoMetadataResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RepoMetadataResponse>, I>>(
    object: I
  ): RepoMetadataResponse {
    const message = createBaseRepoMetadataResponse()
    message.muleAllFlowNames = object.muleAllFlowNames?.map(e => e) || []
    message.muleApiFlowNames = object.muleApiFlowNames?.map(e => e) || []
    message.muleEventFlowNames = object.muleEventFlowNames?.map(e => e) || []
    message.entities = Object.entries(object.entities ?? {}).reduce<{ [key: string]: StringList }>(
      (acc, [key, value]) => {
        if (value !== undefined) {
          acc[key] = StringList.fromPartial(value)
        }
        return acc
      },
      {}
    )
    message.suggestedVmArgs = object.suggestedVmArgs ?? ''
    message.suggestedMinMuleRuntimeVersion = object.suggestedMinMuleRuntimeVersion ?? ''
    message.suggestedMvnVersion = object.suggestedMvnVersion ?? ''
    message.suggestedJavaVersion = object.suggestedJavaVersion ?? ''
    message.detectedPlatform = object.detectedPlatform ?? 0
    return message
  }
}

function createBaseRepoMetadataResponse_EntitiesEntry(): RepoMetadataResponse_EntitiesEntry {
  return { key: '', value: undefined }
}

export const RepoMetadataResponse_EntitiesEntry = {
  encode(
    message: RepoMetadataResponse_EntitiesEntry,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.key !== '') {
      writer.uint32(10).string(message.key)
    }
    if (message.value !== undefined) {
      StringList.encode(message.value, writer.uint32(18).fork()).ldelim()
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RepoMetadataResponse_EntitiesEntry {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseRepoMetadataResponse_EntitiesEntry()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.key = reader.string()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.value = StringList.decode(reader, reader.uint32())
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): RepoMetadataResponse_EntitiesEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : '',
      value: isSet(object.value) ? StringList.fromJSON(object.value) : undefined
    }
  },

  toJSON(message: RepoMetadataResponse_EntitiesEntry): unknown {
    const obj: any = {}
    if (message.key !== '') {
      obj.key = message.key
    }
    if (message.value !== undefined) {
      obj.value = StringList.toJSON(message.value)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<RepoMetadataResponse_EntitiesEntry>, I>>(
    base?: I
  ): RepoMetadataResponse_EntitiesEntry {
    return RepoMetadataResponse_EntitiesEntry.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<RepoMetadataResponse_EntitiesEntry>, I>>(
    object: I
  ): RepoMetadataResponse_EntitiesEntry {
    const message = createBaseRepoMetadataResponse_EntitiesEntry()
    message.key = object.key ?? ''
    message.value =
      object.value !== undefined && object.value !== null
        ? StringList.fromPartial(object.value)
        : undefined
    return message
  }
}

function createBaseDeleteRepoRequest(): DeleteRepoRequest {
  return { orgId: 0, orgName: '', repoName: '', localSyncUserId: '', localSyncDeviceId: '' }
}

export const DeleteRepoRequest = {
  encode(message: DeleteRepoRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.orgId !== 0) {
      writer.uint32(8).int64(message.orgId)
    }
    if (message.orgName !== '') {
      writer.uint32(18).string(message.orgName)
    }
    if (message.repoName !== '') {
      writer.uint32(26).string(message.repoName)
    }
    if (message.localSyncUserId !== '') {
      writer.uint32(34).string(message.localSyncUserId)
    }
    if (message.localSyncDeviceId !== '') {
      writer.uint32(42).string(message.localSyncDeviceId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteRepoRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteRepoRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.orgId = longToNumber(reader.int64() as Long)
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.orgName = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.repoName = reader.string()
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.localSyncUserId = reader.string()
          continue
        case 5:
          if (tag !== 42) {
            break
          }

          message.localSyncDeviceId = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteRepoRequest {
    return {
      orgId: isSet(object.orgId) ? globalThis.Number(object.orgId) : 0,
      orgName: isSet(object.orgName) ? globalThis.String(object.orgName) : '',
      repoName: isSet(object.repoName) ? globalThis.String(object.repoName) : '',
      localSyncUserId: isSet(object.localSyncUserId)
        ? globalThis.String(object.localSyncUserId)
        : '',
      localSyncDeviceId: isSet(object.localSyncDeviceId)
        ? globalThis.String(object.localSyncDeviceId)
        : ''
    }
  },

  toJSON(message: DeleteRepoRequest): unknown {
    const obj: any = {}
    if (message.orgId !== 0) {
      obj.orgId = Math.round(message.orgId)
    }
    if (message.orgName !== '') {
      obj.orgName = message.orgName
    }
    if (message.repoName !== '') {
      obj.repoName = message.repoName
    }
    if (message.localSyncUserId !== '') {
      obj.localSyncUserId = message.localSyncUserId
    }
    if (message.localSyncDeviceId !== '') {
      obj.localSyncDeviceId = message.localSyncDeviceId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteRepoRequest>, I>>(base?: I): DeleteRepoRequest {
    return DeleteRepoRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteRepoRequest>, I>>(object: I): DeleteRepoRequest {
    const message = createBaseDeleteRepoRequest()
    message.orgId = object.orgId ?? 0
    message.orgName = object.orgName ?? ''
    message.repoName = object.repoName ?? ''
    message.localSyncUserId = object.localSyncUserId ?? ''
    message.localSyncDeviceId = object.localSyncDeviceId ?? ''
    return message
  }
}

function createBaseDeleteRepoResponse(): DeleteRepoResponse {
  return { success: false, errorMessage: '' }
}

export const DeleteRepoResponse = {
  encode(message: DeleteRepoResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== '') {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteRepoResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteRepoResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteRepoResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : ''
    }
  },

  toJSON(message: DeleteRepoResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== '') {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteRepoResponse>, I>>(base?: I): DeleteRepoResponse {
    return DeleteRepoResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteRepoResponse>, I>>(object: I): DeleteRepoResponse {
    const message = createBaseDeleteRepoResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? ''
    return message
  }
}

function createBaseDeleteConversationRequest(): DeleteConversationRequest {
  return { uuid: '' }
}

export const DeleteConversationRequest = {
  encode(message: DeleteConversationRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.uuid !== '') {
      writer.uint32(10).string(message.uuid)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteConversationRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteConversationRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.uuid = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteConversationRequest {
    return { uuid: isSet(object.uuid) ? globalThis.String(object.uuid) : '' }
  },

  toJSON(message: DeleteConversationRequest): unknown {
    const obj: any = {}
    if (message.uuid !== '') {
      obj.uuid = message.uuid
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteConversationRequest>, I>>(
    base?: I
  ): DeleteConversationRequest {
    return DeleteConversationRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteConversationRequest>, I>>(
    object: I
  ): DeleteConversationRequest {
    const message = createBaseDeleteConversationRequest()
    message.uuid = object.uuid ?? ''
    return message
  }
}

function createBaseDeleteConversationResponse(): DeleteConversationResponse {
  return { success: false, errorMessage: '' }
}

export const DeleteConversationResponse = {
  encode(
    message: DeleteConversationResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== '') {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteConversationResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteConversationResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteConversationResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : ''
    }
  },

  toJSON(message: DeleteConversationResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== '') {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteConversationResponse>, I>>(
    base?: I
  ): DeleteConversationResponse {
    return DeleteConversationResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteConversationResponse>, I>>(
    object: I
  ): DeleteConversationResponse {
    const message = createBaseDeleteConversationResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? ''
    return message
  }
}

function createBaseDeleteWorkspaceRequest(): DeleteWorkspaceRequest {
  return { orgId: 0 }
}

export const DeleteWorkspaceRequest = {
  encode(message: DeleteWorkspaceRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.orgId !== 0) {
      writer.uint32(8).int64(message.orgId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteWorkspaceRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteWorkspaceRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.orgId = longToNumber(reader.int64() as Long)
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteWorkspaceRequest {
    return { orgId: isSet(object.orgId) ? globalThis.Number(object.orgId) : 0 }
  },

  toJSON(message: DeleteWorkspaceRequest): unknown {
    const obj: any = {}
    if (message.orgId !== 0) {
      obj.orgId = Math.round(message.orgId)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteWorkspaceRequest>, I>>(
    base?: I
  ): DeleteWorkspaceRequest {
    return DeleteWorkspaceRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteWorkspaceRequest>, I>>(
    object: I
  ): DeleteWorkspaceRequest {
    const message = createBaseDeleteWorkspaceRequest()
    message.orgId = object.orgId ?? 0
    return message
  }
}

function createBaseDeleteWorkspaceResponse(): DeleteWorkspaceResponse {
  return { success: false, errorMessage: '' }
}

export const DeleteWorkspaceResponse = {
  encode(message: DeleteWorkspaceResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== '') {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteWorkspaceResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteWorkspaceResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteWorkspaceResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : ''
    }
  },

  toJSON(message: DeleteWorkspaceResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== '') {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteWorkspaceResponse>, I>>(
    base?: I
  ): DeleteWorkspaceResponse {
    return DeleteWorkspaceResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteWorkspaceResponse>, I>>(
    object: I
  ): DeleteWorkspaceResponse {
    const message = createBaseDeleteWorkspaceResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? ''
    return message
  }
}

function createBaseDeleteAllReposInConnectionRequest(): DeleteAllReposInConnectionRequest {
  return { orgId: 0, connType: '', connectionIdentifier: '' }
}

export const DeleteAllReposInConnectionRequest = {
  encode(
    message: DeleteAllReposInConnectionRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.orgId !== 0) {
      writer.uint32(8).int64(message.orgId)
    }
    if (message.connType !== '') {
      writer.uint32(18).string(message.connType)
    }
    if (message.connectionIdentifier !== '') {
      writer.uint32(26).string(message.connectionIdentifier)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteAllReposInConnectionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteAllReposInConnectionRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.orgId = longToNumber(reader.int64() as Long)
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.connType = reader.string()
          continue
        case 3:
          if (tag !== 26) {
            break
          }

          message.connectionIdentifier = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteAllReposInConnectionRequest {
    return {
      orgId: isSet(object.orgId) ? globalThis.Number(object.orgId) : 0,
      connType: isSet(object.connType) ? globalThis.String(object.connType) : '',
      connectionIdentifier: isSet(object.connectionIdentifier)
        ? globalThis.String(object.connectionIdentifier)
        : ''
    }
  },

  toJSON(message: DeleteAllReposInConnectionRequest): unknown {
    const obj: any = {}
    if (message.orgId !== 0) {
      obj.orgId = Math.round(message.orgId)
    }
    if (message.connType !== '') {
      obj.connType = message.connType
    }
    if (message.connectionIdentifier !== '') {
      obj.connectionIdentifier = message.connectionIdentifier
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteAllReposInConnectionRequest>, I>>(
    base?: I
  ): DeleteAllReposInConnectionRequest {
    return DeleteAllReposInConnectionRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteAllReposInConnectionRequest>, I>>(
    object: I
  ): DeleteAllReposInConnectionRequest {
    const message = createBaseDeleteAllReposInConnectionRequest()
    message.orgId = object.orgId ?? 0
    message.connType = object.connType ?? ''
    message.connectionIdentifier = object.connectionIdentifier ?? ''
    return message
  }
}

function createBaseDeleteAllReposInConnectionResponse(): DeleteAllReposInConnectionResponse {
  return { success: false, errorMessage: '' }
}

export const DeleteAllReposInConnectionResponse = {
  encode(
    message: DeleteAllReposInConnectionResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== '') {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteAllReposInConnectionResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteAllReposInConnectionResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteAllReposInConnectionResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : ''
    }
  },

  toJSON(message: DeleteAllReposInConnectionResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== '') {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteAllReposInConnectionResponse>, I>>(
    base?: I
  ): DeleteAllReposInConnectionResponse {
    return DeleteAllReposInConnectionResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteAllReposInConnectionResponse>, I>>(
    object: I
  ): DeleteAllReposInConnectionResponse {
    const message = createBaseDeleteAllReposInConnectionResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? ''
    return message
  }
}

function createBaseDeleteAccountRequest(): DeleteAccountRequest {
  return { userId: 0, orgId: 0 }
}

export const DeleteAccountRequest = {
  encode(message: DeleteAccountRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.userId !== 0) {
      writer.uint32(8).int64(message.userId)
    }
    if (message.orgId !== 0) {
      writer.uint32(16).int64(message.orgId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteAccountRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteAccountRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.userId = longToNumber(reader.int64() as Long)
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.orgId = longToNumber(reader.int64() as Long)
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteAccountRequest {
    return {
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      orgId: isSet(object.orgId) ? globalThis.Number(object.orgId) : 0
    }
  },

  toJSON(message: DeleteAccountRequest): unknown {
    const obj: any = {}
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId)
    }
    if (message.orgId !== 0) {
      obj.orgId = Math.round(message.orgId)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteAccountRequest>, I>>(base?: I): DeleteAccountRequest {
    return DeleteAccountRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteAccountRequest>, I>>(
    object: I
  ): DeleteAccountRequest {
    const message = createBaseDeleteAccountRequest()
    message.userId = object.userId ?? 0
    message.orgId = object.orgId ?? 0
    return message
  }
}

function createBaseDeleteAccountResponse(): DeleteAccountResponse {
  return { success: false, errorMessage: '' }
}

export const DeleteAccountResponse = {
  encode(message: DeleteAccountResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.success !== false) {
      writer.uint32(8).bool(message.success)
    }
    if (message.errorMessage !== '') {
      writer.uint32(18).string(message.errorMessage)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): DeleteAccountResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseDeleteAccountResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.success = reader.bool()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.errorMessage = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): DeleteAccountResponse {
    return {
      success: isSet(object.success) ? globalThis.Boolean(object.success) : false,
      errorMessage: isSet(object.errorMessage) ? globalThis.String(object.errorMessage) : ''
    }
  },

  toJSON(message: DeleteAccountResponse): unknown {
    const obj: any = {}
    if (message.success !== false) {
      obj.success = message.success
    }
    if (message.errorMessage !== '') {
      obj.errorMessage = message.errorMessage
    }
    return obj
  },

  create<I extends Exact<DeepPartial<DeleteAccountResponse>, I>>(base?: I): DeleteAccountResponse {
    return DeleteAccountResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<DeleteAccountResponse>, I>>(
    object: I
  ): DeleteAccountResponse {
    const message = createBaseDeleteAccountResponse()
    message.success = object.success ?? false
    message.errorMessage = object.errorMessage ?? ''
    return message
  }
}

function createBaseKnowledgeBaseQueryRequest(): KnowledgeBaseQueryRequest {
  return { query: '', orgId: 0, userId: 0, platform: '', apiTokenId: 0, surface: '', requestId: '' }
}

export const KnowledgeBaseQueryRequest = {
  encode(message: KnowledgeBaseQueryRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.query !== '') {
      writer.uint32(10).string(message.query)
    }
    if (message.orgId !== 0) {
      writer.uint32(16).int64(message.orgId)
    }
    if (message.userId !== 0) {
      writer.uint32(24).int64(message.userId)
    }
    if (message.platform !== '') {
      writer.uint32(34).string(message.platform)
    }
    if (message.apiTokenId !== 0) {
      writer.uint32(40).int64(message.apiTokenId)
    }
    if (message.surface !== '') {
      writer.uint32(50).string(message.surface)
    }
    if (message.requestId !== '') {
      writer.uint32(58).string(message.requestId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KnowledgeBaseQueryRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseKnowledgeBaseQueryRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.query = reader.string()
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.orgId = longToNumber(reader.int64() as Long)
          continue
        case 3:
          if (tag !== 24) {
            break
          }

          message.userId = longToNumber(reader.int64() as Long)
          continue
        case 4:
          if (tag !== 34) {
            break
          }

          message.platform = reader.string()
          continue
        case 5:
          if (tag !== 40) {
            break
          }

          message.apiTokenId = longToNumber(reader.int64() as Long)
          continue
        case 6:
          if (tag !== 50) {
            break
          }

          message.surface = reader.string()
          continue
        case 7:
          if (tag !== 58) {
            break
          }

          message.requestId = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): KnowledgeBaseQueryRequest {
    return {
      query: isSet(object.query) ? globalThis.String(object.query) : '',
      orgId: isSet(object.orgId) ? globalThis.Number(object.orgId) : 0,
      userId: isSet(object.userId) ? globalThis.Number(object.userId) : 0,
      platform: isSet(object.platform) ? globalThis.String(object.platform) : '',
      apiTokenId: isSet(object.apiTokenId) ? globalThis.Number(object.apiTokenId) : 0,
      surface: isSet(object.surface) ? globalThis.String(object.surface) : '',
      requestId: isSet(object.requestId) ? globalThis.String(object.requestId) : ''
    }
  },

  toJSON(message: KnowledgeBaseQueryRequest): unknown {
    const obj: any = {}
    if (message.query !== '') {
      obj.query = message.query
    }
    if (message.orgId !== 0) {
      obj.orgId = Math.round(message.orgId)
    }
    if (message.userId !== 0) {
      obj.userId = Math.round(message.userId)
    }
    if (message.platform !== '') {
      obj.platform = message.platform
    }
    if (message.apiTokenId !== 0) {
      obj.apiTokenId = Math.round(message.apiTokenId)
    }
    if (message.surface !== '') {
      obj.surface = message.surface
    }
    if (message.requestId !== '') {
      obj.requestId = message.requestId
    }
    return obj
  },

  create<I extends Exact<DeepPartial<KnowledgeBaseQueryRequest>, I>>(
    base?: I
  ): KnowledgeBaseQueryRequest {
    return KnowledgeBaseQueryRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<KnowledgeBaseQueryRequest>, I>>(
    object: I
  ): KnowledgeBaseQueryRequest {
    const message = createBaseKnowledgeBaseQueryRequest()
    message.query = object.query ?? ''
    message.orgId = object.orgId ?? 0
    message.userId = object.userId ?? 0
    message.platform = object.platform ?? ''
    message.apiTokenId = object.apiTokenId ?? 0
    message.surface = object.surface ?? ''
    message.requestId = object.requestId ?? ''
    return message
  }
}

function createBaseKnowledgeBaseQueryResponse(): KnowledgeBaseQueryResponse {
  return { answer: '' }
}

export const KnowledgeBaseQueryResponse = {
  encode(
    message: KnowledgeBaseQueryResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.answer !== '') {
      writer.uint32(10).string(message.answer)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): KnowledgeBaseQueryResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseKnowledgeBaseQueryResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break
          }

          message.answer = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): KnowledgeBaseQueryResponse {
    return { answer: isSet(object.answer) ? globalThis.String(object.answer) : '' }
  },

  toJSON(message: KnowledgeBaseQueryResponse): unknown {
    const obj: any = {}
    if (message.answer !== '') {
      obj.answer = message.answer
    }
    return obj
  },

  create<I extends Exact<DeepPartial<KnowledgeBaseQueryResponse>, I>>(
    base?: I
  ): KnowledgeBaseQueryResponse {
    return KnowledgeBaseQueryResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<KnowledgeBaseQueryResponse>, I>>(
    object: I
  ): KnowledgeBaseQueryResponse {
    const message = createBaseKnowledgeBaseQueryResponse()
    message.answer = object.answer ?? ''
    return message
  }
}

function createBaseCancelTaskConversationRequest(): CancelTaskConversationRequest {
  return { taskId: 0, conversationId: 0 }
}

export const CancelTaskConversationRequest = {
  encode(
    message: CancelTaskConversationRequest,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.taskId !== 0) {
      writer.uint32(8).int64(message.taskId)
    }
    if (message.conversationId !== 0) {
      writer.uint32(16).int64(message.conversationId)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CancelTaskConversationRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelTaskConversationRequest()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.taskId = longToNumber(reader.int64() as Long)
          continue
        case 2:
          if (tag !== 16) {
            break
          }

          message.conversationId = longToNumber(reader.int64() as Long)
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelTaskConversationRequest {
    return {
      taskId: isSet(object.taskId) ? globalThis.Number(object.taskId) : 0,
      conversationId: isSet(object.conversationId) ? globalThis.Number(object.conversationId) : 0
    }
  },

  toJSON(message: CancelTaskConversationRequest): unknown {
    const obj: any = {}
    if (message.taskId !== 0) {
      obj.taskId = Math.round(message.taskId)
    }
    if (message.conversationId !== 0) {
      obj.conversationId = Math.round(message.conversationId)
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelTaskConversationRequest>, I>>(
    base?: I
  ): CancelTaskConversationRequest {
    return CancelTaskConversationRequest.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelTaskConversationRequest>, I>>(
    object: I
  ): CancelTaskConversationRequest {
    const message = createBaseCancelTaskConversationRequest()
    message.taskId = object.taskId ?? 0
    message.conversationId = object.conversationId ?? 0
    return message
  }
}

function createBaseCancelTaskConversationResponse(): CancelTaskConversationResponse {
  return { isSuccess: false, errMsg: '' }
}

export const CancelTaskConversationResponse = {
  encode(
    message: CancelTaskConversationResponse,
    writer: _m0.Writer = _m0.Writer.create()
  ): _m0.Writer {
    if (message.isSuccess !== false) {
      writer.uint32(8).bool(message.isSuccess)
    }
    if (message.errMsg !== '') {
      writer.uint32(18).string(message.errMsg)
    }
    return writer
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): CancelTaskConversationResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input)
    let end = length === undefined ? reader.len : reader.pos + length
    const message = createBaseCancelTaskConversationResponse()
    while (reader.pos < end) {
      const tag = reader.uint32()
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break
          }

          message.isSuccess = reader.bool()
          continue
        case 2:
          if (tag !== 18) {
            break
          }

          message.errMsg = reader.string()
          continue
      }
      if ((tag & 7) === 4 || tag === 0) {
        break
      }
      reader.skipType(tag & 7)
    }
    return message
  },

  fromJSON(object: any): CancelTaskConversationResponse {
    return {
      isSuccess: isSet(object.isSuccess) ? globalThis.Boolean(object.isSuccess) : false,
      errMsg: isSet(object.errMsg) ? globalThis.String(object.errMsg) : ''
    }
  },

  toJSON(message: CancelTaskConversationResponse): unknown {
    const obj: any = {}
    if (message.isSuccess !== false) {
      obj.isSuccess = message.isSuccess
    }
    if (message.errMsg !== '') {
      obj.errMsg = message.errMsg
    }
    return obj
  },

  create<I extends Exact<DeepPartial<CancelTaskConversationResponse>, I>>(
    base?: I
  ): CancelTaskConversationResponse {
    return CancelTaskConversationResponse.fromPartial(base ?? ({} as any))
  },
  fromPartial<I extends Exact<DeepPartial<CancelTaskConversationResponse>, I>>(
    object: I
  ): CancelTaskConversationResponse {
    const message = createBaseCancelTaskConversationResponse()
    message.isSuccess = object.isSuccess ?? false
    message.errMsg = object.errMsg ?? ''
    return message
  }
}

export interface AgentService {
  /**
   * If the stream is set as false in request, then each chunk of the streaming response would be a complete message of its own.
   * If the stream is set as True in request:
   * Each message of type IMAGE_BASE64/PR would be a complete message
   * For TEXT message, it be chunked and would have to aggregated at client side i.e
   *
   * images = []
   * pr = []
   * text_content = ""
   * for chunk in response:
   * if chunk.message_type == IMAGE_BASE64:
   * images.append(chunk.delta_content)
   * elif chunk.message_type == PR:
   * pr.append(chunk.delta_content)
   * elif chunk.message_type == TEXT:
   * text_content = text_content + chunk.delta_content
   */
  RunAgent(request: AgentRequest): Observable<AgentStreamingResponse>
  GetIndexRepos(request: GetIndexReposRequest): Promise<GetIndexReposResponse>
  SubmitAgentTask(request: AgentTaskRequest): Promise<AgentTaskResponse>
  RepoMetadata(request: RepoMetadataRequest): Promise<RepoMetadataResponse>
  GetEndSystemSchemaInfo(
    request: GetEndSystemSchemaInfoRequest
  ): Promise<GetEndSystemSchemaInfoResponse>
  ConnectorKbAnnotationInput(
    request: ConnectorKbAnnotationInputRequest
  ): Promise<ConnectorKbAnnotationInputResponse>
  ConnectorKbAnnotationDisplayTask(
    request: ConnectorKbAnnotationDisplayTaskRequest
  ): Promise<ConnectorKbAnnotationDisplayTaskResponse>
  QueryKnowledgeBase(request: KnowledgeBaseQueryRequest): Promise<KnowledgeBaseQueryResponse>
  /** Deletion APIs */
  DeleteRepo(request: DeleteRepoRequest): Promise<DeleteRepoResponse>
  DeleteConversation(request: DeleteConversationRequest): Promise<DeleteConversationResponse>
  DeleteAllReposInConnection(
    request: DeleteAllReposInConnectionRequest
  ): Promise<DeleteAllReposInConnectionResponse>
  DeleteWorkspace(request: DeleteWorkspaceRequest): Promise<DeleteWorkspaceResponse>
  DeleteAccount(request: DeleteAccountRequest): Promise<DeleteAccountResponse>
  CancelTaskConversation(
    request: CancelTaskConversationRequest
  ): Promise<CancelTaskConversationResponse>
}

export const AgentServiceServiceName = 'agents.AgentService'
export class AgentServiceClientImpl implements AgentService {
  private readonly rpc: Rpc
  private readonly service: string
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || AgentServiceServiceName
    this.rpc = rpc
    this.RunAgent = this.RunAgent.bind(this)
    this.GetIndexRepos = this.GetIndexRepos.bind(this)
    this.SubmitAgentTask = this.SubmitAgentTask.bind(this)
    this.RepoMetadata = this.RepoMetadata.bind(this)
    this.GetEndSystemSchemaInfo = this.GetEndSystemSchemaInfo.bind(this)
    this.ConnectorKbAnnotationInput = this.ConnectorKbAnnotationInput.bind(this)
    this.ConnectorKbAnnotationDisplayTask = this.ConnectorKbAnnotationDisplayTask.bind(this)
    this.QueryKnowledgeBase = this.QueryKnowledgeBase.bind(this)
    this.DeleteRepo = this.DeleteRepo.bind(this)
    this.DeleteConversation = this.DeleteConversation.bind(this)
    this.DeleteAllReposInConnection = this.DeleteAllReposInConnection.bind(this)
    this.DeleteWorkspace = this.DeleteWorkspace.bind(this)
    this.DeleteAccount = this.DeleteAccount.bind(this)
    this.CancelTaskConversation = this.CancelTaskConversation.bind(this)
  }
  RunAgent(request: AgentRequest): Observable<AgentStreamingResponse> {
    const data = AgentRequest.encode(request).finish()
    const result = this.rpc.serverStreamingRequest(this.service, 'RunAgent', data)
    return result.pipe(map(data => AgentStreamingResponse.decode(_m0.Reader.create(data))))
  }

  GetIndexRepos(request: GetIndexReposRequest): Promise<GetIndexReposResponse> {
    const data = GetIndexReposRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'GetIndexRepos', data)
    return promise.then(data => GetIndexReposResponse.decode(_m0.Reader.create(data)))
  }

  SubmitAgentTask(request: AgentTaskRequest): Promise<AgentTaskResponse> {
    const data = AgentTaskRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'SubmitAgentTask', data)
    return promise.then(data => AgentTaskResponse.decode(_m0.Reader.create(data)))
  }

  RepoMetadata(request: RepoMetadataRequest): Promise<RepoMetadataResponse> {
    const data = RepoMetadataRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'RepoMetadata', data)
    return promise.then(data => RepoMetadataResponse.decode(_m0.Reader.create(data)))
  }

  GetEndSystemSchemaInfo(
    request: GetEndSystemSchemaInfoRequest
  ): Promise<GetEndSystemSchemaInfoResponse> {
    const data = GetEndSystemSchemaInfoRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'GetEndSystemSchemaInfo', data)
    return promise.then(data => GetEndSystemSchemaInfoResponse.decode(_m0.Reader.create(data)))
  }

  ConnectorKbAnnotationInput(
    request: ConnectorKbAnnotationInputRequest
  ): Promise<ConnectorKbAnnotationInputResponse> {
    const data = ConnectorKbAnnotationInputRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'ConnectorKbAnnotationInput', data)
    return promise.then(data => ConnectorKbAnnotationInputResponse.decode(_m0.Reader.create(data)))
  }

  ConnectorKbAnnotationDisplayTask(
    request: ConnectorKbAnnotationDisplayTaskRequest
  ): Promise<ConnectorKbAnnotationDisplayTaskResponse> {
    const data = ConnectorKbAnnotationDisplayTaskRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'ConnectorKbAnnotationDisplayTask', data)
    return promise.then(data =>
      ConnectorKbAnnotationDisplayTaskResponse.decode(_m0.Reader.create(data))
    )
  }

  QueryKnowledgeBase(request: KnowledgeBaseQueryRequest): Promise<KnowledgeBaseQueryResponse> {
    const data = KnowledgeBaseQueryRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'QueryKnowledgeBase', data)
    return promise.then(data => KnowledgeBaseQueryResponse.decode(_m0.Reader.create(data)))
  }

  DeleteRepo(request: DeleteRepoRequest): Promise<DeleteRepoResponse> {
    const data = DeleteRepoRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'DeleteRepo', data)
    return promise.then(data => DeleteRepoResponse.decode(_m0.Reader.create(data)))
  }

  DeleteConversation(request: DeleteConversationRequest): Promise<DeleteConversationResponse> {
    const data = DeleteConversationRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'DeleteConversation', data)
    return promise.then(data => DeleteConversationResponse.decode(_m0.Reader.create(data)))
  }

  DeleteAllReposInConnection(
    request: DeleteAllReposInConnectionRequest
  ): Promise<DeleteAllReposInConnectionResponse> {
    const data = DeleteAllReposInConnectionRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'DeleteAllReposInConnection', data)
    return promise.then(data => DeleteAllReposInConnectionResponse.decode(_m0.Reader.create(data)))
  }

  DeleteWorkspace(request: DeleteWorkspaceRequest): Promise<DeleteWorkspaceResponse> {
    const data = DeleteWorkspaceRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'DeleteWorkspace', data)
    return promise.then(data => DeleteWorkspaceResponse.decode(_m0.Reader.create(data)))
  }

  DeleteAccount(request: DeleteAccountRequest): Promise<DeleteAccountResponse> {
    const data = DeleteAccountRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'DeleteAccount', data)
    return promise.then(data => DeleteAccountResponse.decode(_m0.Reader.create(data)))
  }

  CancelTaskConversation(
    request: CancelTaskConversationRequest
  ): Promise<CancelTaskConversationResponse> {
    const data = CancelTaskConversationRequest.encode(request).finish()
    const promise = this.rpc.request(this.service, 'CancelTaskConversation', data)
    return promise.then(data => CancelTaskConversationResponse.decode(_m0.Reader.create(data)))
  }
}

export interface SpeechToTextService {
  SpeechToText(request: Observable<SpeechToTextRequest>): Observable<SpeechToTextResponse>
}

export const SpeechToTextServiceServiceName = 'agents.SpeechToTextService'
export class SpeechToTextServiceClientImpl implements SpeechToTextService {
  private readonly rpc: Rpc
  private readonly service: string
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || SpeechToTextServiceServiceName
    this.rpc = rpc
    this.SpeechToText = this.SpeechToText.bind(this)
  }
  SpeechToText(request: Observable<SpeechToTextRequest>): Observable<SpeechToTextResponse> {
    const data = request.pipe(map(request => SpeechToTextRequest.encode(request).finish()))
    const result = this.rpc.bidirectionalStreamingRequest(this.service, 'SpeechToText', data)
    return result.pipe(map(data => SpeechToTextResponse.decode(_m0.Reader.create(data))))
  }
}

export interface TextToSpeechService {
  TextToSpeech(request: Observable<TextToSpeechRequest>): Observable<TextToSpeechResponse>
}

export const TextToSpeechServiceServiceName = 'agents.TextToSpeechService'
export class TextToSpeechServiceClientImpl implements TextToSpeechService {
  private readonly rpc: Rpc
  private readonly service: string
  constructor(rpc: Rpc, opts?: { service?: string }) {
    this.service = opts?.service || TextToSpeechServiceServiceName
    this.rpc = rpc
    this.TextToSpeech = this.TextToSpeech.bind(this)
  }
  TextToSpeech(request: Observable<TextToSpeechRequest>): Observable<TextToSpeechResponse> {
    const data = request.pipe(map(request => TextToSpeechRequest.encode(request).finish()))
    const result = this.rpc.bidirectionalStreamingRequest(this.service, 'TextToSpeech', data)
    return result.pipe(map(data => TextToSpeechResponse.decode(_m0.Reader.create(data))))
  }
}

interface Rpc {
  request(service: string, method: string, data: Uint8Array): Promise<Uint8Array>
  clientStreamingRequest(
    service: string,
    method: string,
    data: Observable<Uint8Array>
  ): Promise<Uint8Array>
  serverStreamingRequest(service: string, method: string, data: Uint8Array): Observable<Uint8Array>
  bidirectionalStreamingRequest(
    service: string,
    method: string,
    data: Observable<Uint8Array>
  ): Observable<Uint8Array>
}

function bytesFromBase64(b64: string): Uint8Array {
  if ((globalThis as any).Buffer) {
    return Uint8Array.from(globalThis.Buffer.from(b64, 'base64'))
  } else {
    const bin = globalThis.atob(b64)
    const arr = new Uint8Array(bin.length)
    for (let i = 0; i < bin.length; ++i) {
      arr[i] = bin.charCodeAt(i)
    }
    return arr
  }
}

function base64FromBytes(arr: Uint8Array): string {
  if ((globalThis as any).Buffer) {
    return globalThis.Buffer.from(arr).toString('base64')
  } else {
    const bin: string[] = []
    arr.forEach(byte => {
      bin.push(globalThis.String.fromCharCode(byte))
    })
    return globalThis.btoa(bin.join(''))
  }
}

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends globalThis.Array<infer U>
    ? globalThis.Array<DeepPartial<U>>
    : T extends ReadonlyArray<infer U>
      ? ReadonlyArray<DeepPartial<U>>
      : T extends {}
        ? { [K in keyof T]?: DeepPartial<T[K]> }
        : Partial<T>

type KeysOfUnion<T> = T extends T ? keyof T : never
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never }

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is larger than Number.MAX_SAFE_INTEGER')
  }
  if (long.lt(globalThis.Number.MIN_SAFE_INTEGER)) {
    throw new globalThis.Error('Value is smaller than Number.MIN_SAFE_INTEGER')
  }
  return long.toNumber()
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any
  _m0.configure()
}

function isObject(value: any): boolean {
  return typeof value === 'object' && value !== null
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined
}
